import React, { Component } from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import { Slider, Divider } from "antd";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';

import { fetchPrediction } from "./fetchPrediction";



const seq = `>chr1
GTACACTGATCACGTGGCTGATCATGCACAAATCCCATTGCATATCATGCTCTGATCAGG
TTGCTATCATGTACTGATCACTTGGCTGATCATACACTGATCACATGACTGATCATGCAC
TGATCACGTGCCTGATCATGCACTGATCCCGTGGCAGATCATGCACTGATCACGTGCAGA
TCATGCACTCATCATGTGGCTGATCATACAATGATCACGTGGCTGATCATGCACTGATCA
CATGTATGATCGTACACTGATCACGTGGCTGATCATGCACAAATCCCATTGCATATTCAT
GCTCTGATCAGGTTGCTATCATGTACTGATCACGTGGCTGATCATACACTGATCACAATG
ACTGATCATGCACTGATCACGTGCCTGATCATGCACTGATCCCGTGGGGCTGATCTTGCA
CTGATCACGTGGCTGATAATGGCACTGATCACTTGACTGATCATGCACTGATCACGTCTC
TTATCATGCACTACTCACGTGACTGATCATGGACTGATCACGTGACTGATCATGCACTGA
TCATGAGCCTGATCATGCACTGATCACGGGCCTGTTCATGCACTGATCACGTGGCTGATC
CTGCACTGATCACGAGGCTGATCATACACTGATCACGTGACTGTGCATGCAATGATCACT
TGGCTGATCATGTACTGATCACGTGGCTGATCATGCACTGATCACATGACTGAGTTGCAC
TGATCACATAGCTATCATGCACTGATCACGTGACTTCGCATGCCATGATCACGTGACTGA
TCATGCACTGGTCCCGTGGCTATCATGCACTGATAATGTGGCTTATCATACATTGATCAC
CTAAATAATCATGCCACTGATCACGTGGCAATCTTGCTCTGATCACGTGGTTGATCAGGC
ACTGATCACTTAGCTATCATGCACTGATCACATGAACTGCGCAAGAACTGATCACTTAGA
TATCATACACAGGACACGTGACAGATCATGCACTGAATCACGTGACTGATCATGCACTGA
TCTGGTGGCTATCATGCACTGATCCCGTGGCTGATCTTGCACTGATCACGTGGCTTGATA
ATGCACTGATCACTTGACTGATCATGCACTGATCACGTCTCTTATCATGCCACTACTCAC
GTGACTGATCATGGACTGATCACGTGACTGATCATGCACTGATCATGAGCCCTGATCATG
CACTGATCACGGGCCTGTTCATGCACTGATCACGTGGCTGATCCTGCACTTGATCACGAG
GCTGATCATACACTGATCACGTGACTGTGCATGCAATGATCACTTGGCTGATCATGTACT
GATCACGTAGCTGATCATGCTCTGATCACGTGACTGATTATGCACTGATCACATAGCTAT
CATGCACTGATCACATGACTTCGCATGCCATGATCACGTGACTGATCATGCACTGATCAC
GTGGCTATCATGCACTGATAATGTGGCTTATCATACATTGATCACCTAAATATCATGCAC
TGATCACGTGGCAATCTTGCTCTGATCACGTGGTTGATCAGGCACTGATCACTTAGCTAT
CATGCACTGATCACATGACTGCGCAAGAACTGATCACTTAGATATCATACACAGGACACG
TGACAGATCATGCACTGATCACGTGACTGATCATGCACTGATCTGGTGCTATCATGCATT
GATCACGTGGTTGATCATACACTGATCACGTGACTGATCATGCACTGATCACCTGGCTAT
CATGCACTAATCACGTAGCTGATCTGGAACAGATCACGTGACTAATCATGCAGTGATCAC
GTCGCTATCATGCAATGATCTCGAGATTGCGCATGCACTGATCATATGGATGATCACACA
CTGATCACGTGACAGATCATGCACTGAACACGTGACTTATAATGCACTGATCACGTGACT
GCACATGCACTGATCATGTGACTGAGCATGCACTGATCACGTAGCTGATCATGCACTGAT
TCACGAAGTTGATCATACACTGATCATGTGACTGAGCATGCACTGACCACGTAGCTGATC
ATGCACTGATCACGAAGTTGATCATACACTGATCACGTGAGTGTGCATGCACTGATCACG
TGGCGGATAATGCAATGATCACGTGGCTGATCATGCACTGATCACGTAGCTCTCATGCAC
TGATCACATGTCAACCATGCCCGGATCCCGTGGCTGATCATGCACTGATCGCCTGACTGA
TCAGGCACTAGTCACCTGGCTATCATGCACTAATCACGTGGCTGTTCATACACTGACCAC
GTGACTGATCATGCACTGATCTGGTGGCTATCATGCATTGATCACGTGTTTGATCTTACA
CTGATTCACGTGACTGATCATGCACTGATCACCTGGCTTTCATGCACTAATCACGTAGCT
GATCTGGAACAGATCACGTGACTAATCATGCAGTGATCACGTCGCTATCATGCAATGATC
TCGAGATTGCGCATGCACTGATCATATGGATGATCACACACTGATCACGTGACAGATCAT
GCACTGATCACGTGACTTATCATGCACTGATCACGAGACTGCACATGCACTGATCATGTG
ACTGAAGCATGCACTGATCATGTAGCTGATCATGCACTGATCACGAAGTTGATCATCACT
GATCATGTGACTGAGCATGCACTGATCACGTAGCTGATCATGCACTGATCACGAAGTTGA
TCATACACTGATCACGTGAGTGTGCATGCACTGATCACGTGGCGGATAATGCAATGTTCA
CGTAGCTCTCATGCACTGATCACATGTCAATCACGCCCGGATCCCGTGGCTGATCATGCA
CTGATCTCGAAGCTGATCATACACTGATCACGTGAGTGTGCATGCAATGATAACATGGCT
GATTATGCAATTATCACGTGGCTTATCATACACTGATCACGTGGCTGATCATGCACTAAT
CACGTTTTGGATGATGCACTGGTCACGTGGCTGATCATACACTAATCACATGACTGATCA
TGCACTAATCACGTTGTGGATCATGCACTGATCACGTGGCTGTTCTTGCACTTATCACGT
GGCTGATCATACAGTGATTACATGACTGATCATGCACTAATCACGATGTGGATCATGCAC
TGATCACATGAATGTGCATGCATTGATCATGTGGCTGATCATGCACTGATCACGTGGCTG
ATCATGCACTGATCACGAAGCTGATATTACACTGATCACAGGACTGTGCATGCACTGATC
ATGTGGCTGATCATGCACTGATCATGTGGCTGATGATACACTGATCACGTGGCTGATCGT
ACTCTGAACACGAAGCTGAAAATACACTGATCACGAGACTGCATGCACTGATCACTTGAC
TGCGCCTGCACTGATCACGTGGATGATAATACGCTGATCACTTGACTGCTTATGCACTAA
AAAAATGGCTGATCATGCACTGATCACATGACTGATCATGCACTGATCACGTGACTACCA
TGCACTGATCACTTGATTGTGCATGCAATAATCACGTGGATGATCACGCATTTATCATGT
GGCTGATCATGCACTAATCACATGGCGGAACATGAACTGATCACGTGACTTAGCATGCAG
TGATCTCGTGTCTGAATGGTGCTGATCATGTGACTAAACAAGAACTGATCACGTGGCTAT
AATGCACTGATCACGTAACTGCACATGCACTGATCATGTGACTGAGCATGCACTAATCAT
GTAGCTGATCATGCACTGATCACGAAGTTGATCATACACTGATCATGTGACTGAGCATGC
ACTGACCACGTAGCTGATCATGCACTGATCACGTTGCGTATCATGCACTGATCACATGAC
GGCGCATGAACTGATCACGTGGATATTATACACTGATCAAGTGACAAATCATGCACTAAT
CACGTGACTGATCATGCACTGATCACGTGGCTATCATGCACTGATCACGTGACTGATCAT
GCACTTGACACGTCGCTATCATGCACTGATCACGTGGCTGTTCATACAGTGATCACGTGA
CTGATCATGCACTGATCCCGTGGCTGATCATGCACTGATCACGTTGCAGATCATGCACTC
ATCACGTGGCTGATCATACAATGATCACGTGGCTGATCATGCACTAATCACATGTGTGAT
CGTACACTGATCACGTGGCTGATCATGCACAAATCCCATTGCATATCATGCTCTGATCAG
GTTGCTATCATGTACTGATCACTTGGCTGATCATACACTGATCACATGACTGATCATGCA
CTGATCACGTGCCTGATCATGCACTGATCCCGTGGCAGATCATGCACTGATCACGTGCAG
ATCATGCACTCATCATGTGGCTGATCATACAATGATCACGTGGCTGATCATGCACTGATC
ACATGTATGATCGTACACTGATCACGTGGCTGATCATGCACAAATCCCATTGCATATCAT
GCTCTGATCAGGTTGCTATCATGTACTGATCACGTGGCTGATCATACACTGATCACATGA
CTGATCATGCACTGATCACGTGCCTGATCATGCACTGATCCCGTGGCTGATCTTGCACTG
ATCACGTGGCTGATAATGCACTGATCACTTGACTGATCATGCACTGATCACGTCTCTTAT
CATGCACTACTCACGTGACTGATCATGGACTGATCACGTGACTGATCATGCACTGATCAT
GAGCCTGATCATGCACTGATCACGGGCCTGTTCATGCACTGATCACGTGGCTGATCCTGC
ACTGATCACGAGGCTGATCATACACTGATCACGTGACTGTGCATGCAATGATCACTTGGC
TGATCATGTACTGATCACGTGGCTGATCATGCACTGATCACATGACTGATTATGCACTGA
TCACATAGCTATCATGCACTGATCACATGACTTCGCATGCCATGATCACGTGACTGATCA
TGCACTGGTCCCGTGGCTATCATGCACTGATAATGTGGCTTATCATACATTGATCACCTA
AATAATCATGCACTGATCACGTGGCAATCTTGCTCTGATCACGTGGTTGATCAGGCACTG
ATCACTTAGCTATCATGCACTGATCACATGACTGCGCAAGAACTGATCACTTAGATATCA
TACACAGGACACGTGACAGATCATGCACTGATCACGTGACTGATCATGCACTGATCTGGT
GGCTATCATGCACTGATCCCGTGGCTGATCTTGCACTGATCACGTGGCTGATAATGCACT
GATCACTTGACTGATCATGCACTGATCACGTCTCTTATCATGCACTACTCACGTGACTGA
TCATGGACTGATCACGTGACTGATCATGCACTGATCATGAGCCTGATCATGCACTGATCA
CGGGCCTGTTCATGCACTGATCACGTGGCTGATCCTGCACTGATCACGAGGCTGATCATA
CACTGATCACGTGACTGTGCATGCAATGATCACTTGGCTGATCATGTACTGATCACGTAG
CTGATCATGCTCTGATCACGTGACTGATTATGCACTGATCACATAGCTATCATGCACTGA
TCACATGACTTCGCATGCCATGATCACGTGACTGATCATGCACTGATCACGTGGCTATCA
TGCACTGATAATGTGGCTTATCATACATTGATCACCTAAATAATCATGCACTGATCACGT
GGCAATCTTGCTCTGATCACGTGGTTGATCAGGCACTGATCACTTAGCTATCATGCACTG
ATCACATGACTGCGCAAGAACTGATCACTTAGATATCATACACAGGACACGTGACAGATC
ATGCACTGATCACGTGACTGATCATGCACTGATCTGGTGGCTATCATGCATTGATCACGT
GGTTGATCATACACTGATCACGTGACTGATCATGCACTGATCACCTGGCTATCATGCACT
AATCACGTAGCTGATCTGGAACAGATCACGTGACTAATCATGCAGTGATCACGTCGCTAT
CATGCAATGATCTCGAGATTGTGCATGCACTGATCATATGGATGATCACACACTGATCAC
GTGACAGATCATGCACTGAACACGTGACTTATAATGCACTGATCACGTGACTGCACATGC
ACTGATCATGTGACTGAGCATGCACTGATCACGTAGCTGATCATGCACTGATCACGAAGT
TGATCATACACTGATCATGTGACTGAGCATGCACTGACCACGTAGCTGATCATGCACTGA
TCACGAAGTTGATCATACACTGATCACGTGAGTGTGCATGCACTGATCACGTGGCGGATA
ATGCAATGATCACGTGGCTGATCATGCACTGATCACGTAGCTCTCATGCACTGATCACAT
GTCAACCATGCCCGGATCCCGTGGCTGATCATGCACTGATCGCCTGACTGATCAGGCACT
AGTCACCTGGCTATCATGCACTAATCACGTGGCTGTTCATACACTGACCACGTGACTGAT
CATGCACTGATCTGGTGGCTATCATGCATTGATCACGTGTTTGATCTTACACTGATCACG
TGACTGATCATGCACTGATCACCTGGCTTTCATGCACTAATCACGTAGCTGATCTGGAAC
AGATCACGTGACTAATCATGCAGTGATCATGTCGCTATCATGCAATGATCTCGAGATTGC
GCATGCACTGATCATATGGATGATCACACACTGATCACGTGACAGATCATGCACTGATCA
CGTGACTTATCATGCACTGATCACGAGACTGCACATGCACTGATCATGTGACTGAGCATG
CACTGATCATGTAGCTGATCATGCACTGATCACGAAGTTGATCATACACTGATCATGTGA
CTGAGCATGCACTGATCACGTAGCTGATCATGCACTGATCACGAAGTTGATCATACACTG
ATCACGTGAGTGTGCATGCACTGATCACATGGCGGATAATGCAATGTTCACGTGGCTGAT
CATGCACTGATCACGTAGCTCTCATGCACTGATCACATGTCAATCACGCCCGGATCCCGT
GGCTGATCATGCACTGATCTCGAAGCTGATCATACACTGATCACGTGAGTGTGCATGCAA
TGATAACATGGCTGATTATGCAATTATCACGTGGCTTATCATACACTGATCACGTGGCTG
ATCATGCACTAATCACGTTTTGGATGATGCACTGGTCACGTGGCTGATCATACACTAATC
ACATGACTGATCATGCACTAATCACGTTGTGGATCATGCACTGATCACGTGGCTGTTCTT
GCACTTATCACGTGGCTGATCATACAGTGATTACATGACTGATCATGCACTAATCACGAT
GTGGATCATGCACTGATCACATGAATGTGCATGCATTGATCATGTGGCTGATCATGCACT
GATCACGTGGCTGATCATGCACTGATCACGAAGCTGATATTACACTGATCACAGGACTGT
GCATGCACTGATCATGTGGCTGATCATGCACTGATCATGTGGCTGATGATACACTGATCA
CGTGGCTGATCGTACTCTGAACACGAAGCTGAAAATACACTGATCACGAGACTGCATGCA
CTGATCACTTGACTGCGCCTGCACTGATCACGTGGATGATAATACGCTGATCACTTGACT
GCTTATGCACTAAAAAAATGGCTGATCATGCACTGATCACATGACTGATCATGCACTGAT
CACGTGACTGATCATGCATAGATCACGTGACTACCATGCACTGATCACTTGATTGTGCAT
GCAATAATCACGTGGATGATCACGCATTTATCATGTGGCTGATCATGCACTAATCACATG
GTGGAACATGAACTGATCACGTGACTTAGCATGCAGTGATCTCGTGTCTGAATGGTGCTG
ATCATGTGACTAAACAAGAACTGATCACGTGGCTATAATGCACTGATCACATGACTGCGC
ATGCACTGATCATGTGGATGATAATACACTGATGACGTTACTGATGAGGCACTGATCACG
TGACTGATCATTCACTGATCACGTGGCTATTATGCACTGATCACGGGACTGCACATGCAG
TGTTCACGTAATTGTAGACAATGATCACGTGGCTATCATGCACTGATCACGTGTCTATCA
TGCACTGAACACGTGGCTGATCAAACACTGATCACGTGGCTGATCATGCACTCATCACGT
GGCTGATCATACGATGATCACGTGGCTGATCATGCACTTATCACATGTATGATCGTACAC
TGATCACGTGGCTGATCATGCACAAATCCCATTGCATATCATGCTCTGATCAGGTTGCTA
TCATGTACTGATCACGTGGCTGATCATACAGTGATCACGTGACTGACCATGCACTGATTA
CGTGGCTATCATGCACTGATCACGTGGCTGATCATGCACTGTTAACCTGGCTATAATACA
CTGATCTCGTGACTGATCATGCATTCCTCACATGCCTGATCATGCACTGATCACGTGGCT
GATCTTGCACTGATCACGTGGCTGATAATGCACTGATCACTTGACTGATCATGCACTGAT
CACGTGTCTGATCATGCACTACTCACGTGACTGATCATGGACTGATCACGTGAATGATCA
TGCACTGATCATGAGCCTGATCATGCACTGAACACGGGCCTGTTCATGCACTGATCACGT
GGCTGATCCTGCACTGATCACGAGGCTGATCATACACTGATCACGTGACTGTGCATGCAA
TGATCACTTGGCTGATCATATACTGATCACGTGGCTGATCATGCACTGATCACGTGACTG
ATCATGCACTGATATGGTGGCTATCATGCATTGATCACGTGGTTGATCATACACTGATCA
CGTGACTGATCATGCACTGATCACCTGGCTATCATGCACTAATCACGTAGCTGATCTGGA
ACAGATCACGTGTGTAATCATGCAGTGATCACGTCGCTATCATGCAATGATCTCGAGATT
GCGCATGCACTGATCATATGGATGATCACACACTGATCACGTGACAGATCATGCACTGAA
CACGTGACTTATAATGCACTGATCACGTGACTGCACATGCACTGATCATGTGACTGAGCA
TGCACTGATCACGTAGCTGATCATGCACTGATCACGAAGTTGATCATACACTGATCACGT
GAGTGTGCATGCACTGATCACGTGGCGGATAATGCAATGTTCACGTGGCTGATCATGCAC
TGATCACGTAGCTCTCATGCACTGATCACATGTCAATCACGCCCGGATCCCGTGGCTGAT
CATGCACTGATCTCGAAGCTGATCATACACTGATCACGTGAGTGTGCATGCAATGATAAC
ATGGCTGATTATGCAATTATCACGTGGCTTATCATACACTGATCACGTGGCTGATCATGC
ACTAATCACGTTTTGGATGATGCACTGGTCACGTGGCTGATCATACACTAATCACATGAC
TGATCATGCACTAATCACGTTGTGGATCATGCACTGATCACGTGGCTGTTCTTGCACTTA
TCACGTGGCTGATCATACAGTGATCACATGACTGATCATGCACTAATCACGATGTGGATC
ATGCACTGATCACATGAATGTGCATGCATTGATCATGTGGCTGATCATGCACTGATCACG
TGGCTGATCATGCACTGATCACGAAGCTGATATTACACTGATCACAGGACTGTGCATGCA
CTGATCATGTGGCTGATCATGCACTGATCATGTGGCTGATGATACACTGATCACGTGGCT
GATCGTACTCTGAACATGAAGCTGAAAATACACTGATCACGAGACTGCATGCACTGATCA
CTTGACTGCGCCTGCACTGATCACGTGGATGATAATACGCTGATCACTTGACTGCTTATG
CACTAAAAAAATGGCTGATCATGCACTGATCACATGACTGATCATGCACTGATCACGTGA
CTGATCATGCATAGATCACGTGACTACCATGCACTGATCACTTGATTGTGCATGCAATAA
TCACGTGGATGATCACGCATTTATCATGTGGCTGATCATGCACTAATCACATGGCGGAAC
ATGAACTGATCACGTGACTTAGCATGCAGTGATCTCGTGTCTGAATGGTGCTGATCATGT
GACTAAACAAGAACTGATCACGTGGCTATAATGCACTGATCACGTAACTGCACATGCACT
GATCATGTGACTGAGCATGCACTAATCATGTAGCTGATCATGCACTGATCACGAAGTTGA
TCATACACTGATCATGTGACTGAGCATGCACTGACCACGTAGCTGATCATGCACTGATCA
CGTTGCGTATCATGCACTGATCACATGACGGCGCATGAACTGATCACGTGGATATTATAC
ACTGATCAAGTGACAAATCATGCACTAATCACGTGACTGATCATGCACTGATCACGTGGC
TATCATGCACTGATCACGTGACTGATCATGCACTTGACACGTCGCTATCATGCACTGATC
ACGTGGCTGTTCATACAGTGATCACGTGACTGATCATGCACTGATCCCGTGGCTGATCAT
GCACTGATCACGTTGCAGATCATGCACTCATCACGTGGCTGATCATACAATGATCACGTG
GCTGATCATGCACTGATCACATGTGTGATCGTACACTGATCACGTGGCTGATCATGCACA
AATCCCATTGCATATCATGCTCTGATCAGGTTGCTATCATGTACTGATCACTTGGCTGAT
CATACACTGATCACATGACTGATCATGCACTGATCACGTGCCTGATCATGCACTGATCCC
GTGGCAGATCATGCACTGATCACGTGCAGATCATGCACTCATCATGTGGCTGATCATACA
ATGATCACGTGGCTGATCATGCACTGATCACATGTATGATCGTACACTGATCACGTGGCT
GATCATGCACAAATCCCATTGCATATCATGCTCTGATCAGGTTGCTATCATGTACTGATC
ACGTGGCTGATCATACACTGATCACATGACTGATCATGCACTGATCACGTGCCTGATCAT
GCACTGATCCCGTGGCTGATCTTGCACTGATCACGTGGCTGATAATGCACTGATCACTTG
ACTGATCATGCACTGATCACGTCTCTTATCATGCACTACTCACGTGACTGATCATGGACT
GATCACGTGACTGATCATGCACTGATCATGAGCCTGATCATGCACTGATCACGGGCCTGT
TCATGCACTGATCACGTGGCTGATCCTGCACTGATCACGAGGCTGATCATACACTGATCA
CGTGACTGTGCATGCAATGATCACTTGGCTGATCATGTACTGATCACGTGGCTGATCATG
CACTGATCACATGACTGATTATGCACTGATCACATAGCTATCATGCACTGATCACATGAC
TTCGCATGCCATGATCACGTGACTGATCATGCACTGGTCCCGTGGCTATCATGCACTGAT
AATGTGGCTTATCATACATTGATCACCTAAATAATCATGCACTGATCACGTGGCAATCTT
GCTCTGATCACGTGGTTGATCAGGCACTGATCACTTAGCTATCATGCACTGATCACATGA
CTGCGCAAGAACTGATCACTTAGATATCATACACAGGACACGTGACAGATCATGCACTGA
TCACGTGACTGATCATGCACTGATCTGGTGGCTATCATGCACTGATCCCGTGGCTGATCT
TGCACTGATCACGTGGCTGATAATGCACTGATCACTTGACTGATCATGCACTGATCACGT
CTCTTATCATGCACTACTCACGTGACTGATCATGGACTGATCACGTGACTGATCATGCAC
TGATCATGAGCCTGATCATGCACTGATCACGGGCCTGTTCATGCACTGATCACGTGGCTG
ATCCTGCACTGATCACGAGGCTGATCATACACTGATCACGTGACTGTGCATGCAATGATC
ACTTGGCTGATCATGTACTGATCACGTAGCTGATCATGCTCTGATCACGTGACTGATTAT
GCACTGATCACATAGCTATCATGCACTGATCACATGACTTCGCATGCCATGATCACGTGA
CTGATCATGCACTGATCACGTGGCTATCATGCACTGATAATGTGGCTTATCATACATTGA
TCACCTAAATAATCATGCACTGATCACGTGGCAATCTTGCTCTGATCACGTGGTTGATCA
GGCACTGATCACTTAGCTATCATGCACTGATCACATGACTGCGCAAGAACTGATCACTTA
GATATCATACACAGGACACGTGACAGATCATGCACTGATCACGTGACTGATCATGCACTG
ATCTGGTGGCTATCATGCATTGATCACGTGGTTGATCATACACTGATCACGTGACTGATC
ATGCACTGATCACCTGGCTATCATGCACTAATCACGTAGCTGATCTGGAACAGATCACGT
GACTAATCATGCAGTGATCACGTCGCTATCATGCAATGATCTCGAGATTGCGCATGCACT
GATCATATGGATGATCACACACTGATCACGTGACAGATCATGCACTGAACACGTGACTTA
TAATGCACTGATCACGTGACTGCACATGCACTGATCATGTGACTGAGCATGCACTGATCA
CGTAGCTGATCATGCACTGATCACGAAGTTGATCATACACTGATCATGTGACTGAGCATG
CACTGACCACGTAGCTGATCATGCACTGATCACGAAGTTGATCATACACTGATCACGTGA
GTGTGCATGCACTGATCACGTGGCGGATAATGCAATGATCACGTGGCTGATCATGCACTG
ATCACGTAGCTCTCATGCACTGATCACATGTCAACCATGCCCGGATCCCGTGGCTGATCA
TGCACTGATCGCCTGACTGATCAGGCACTAGTCACCTGGCTATCATGCACTAATCACGTG
GCTGTTCATACACTGACCACGTGACTGATCATGCACTGATCTGGTGGCTATCATGCATTG
ATCACGTGTTTGATCTTACACTGATCACGTGACTGATCATGCACTGATCACCTGGCTTTC
ATGCACTAATCACGTAGCTGATCTGGAACAGATCACGTGACTAATCATGCAGTGATCATG
TCGCTATCATGCAATGATCTCGAGATTGCGCATGCACTGATCATATGGATGATCACACAC
TGATCACGTGACAGATCATGCACTGATCACGTGACTTATCATGCACTGATCACGAGACTG
CACATGCACTGATCATGTGACTGAGCATGCACTGATCATGTAGCTGATCATGCACTGATC
ACGAAGTTGATCATACACTGATCATGTGACTGAGCATGCACTGATCACGTAGCTGATCAT
GCACTGATCACGAAGTTGATCATACACTGATCACGTGAGTGTGCATGCACTGATCACGTG
GCGGATAATGCAATGTTCACGTGGCTGATCATGCACTGATCACGTAGCTCTCATGCACTG
ATCACATGTCAATCACGCCCGGATCCCGTGGCTGATCATGCACTGATCTCGAAGCTGATC
ATACACTGATCACGTGAGTGTGCATGCAATGATAACATGGCTGATTATGCAATTATCACG
TGGCTTATCATACACTGATCACGTGGCTGATCATGCACTAATCACGTTTTGGATGATGCA
CTGGTCACGTGGCTGATCATACACTAATCACATGACTGATCATGCACTAATCACGTTGTG
GATCATGCACTGATCACGTGGCTGTTCTTGCACTTATCACGTGGCTGATCATACAGTGAT
TACATGACTGATCATGCACTAATCACGATGTGGATCATGCACTGATCACATGAATGTGCA
TGCATTGATCATGTGGCTGATCATGCACTGATCACGTGGCTGATCATGCACTGATCACGA
AGCTGATATTACACTGATCACAGGACTGTGCATGCACTGATCATGTGGCTGATCATGCAC
TGATCATGTGGCTGATGATACACTGATCACGTGGCTGATCGTACTCTGAACACGAAGCTG
AAAATACACTGATCACGAGACTGCATGCACTGATCACTTGACTGCGCCTGCACTGATCAC
GTGGATGATAATACGCTGATCACTTGACTGCTTATGCACTAAAAAAATGGCTGATCATGC
ACTGATCACATGACTGATCATGCACTGATCACGTGACTGATCATGCATAGATCACGTGAC
TACCATGCACTGATCACTTGATTGTGCATGCAATAATCACGTGGATGATCACGCATTTAT
CATGTGGCTGATCATGCACTAATCACATGGTGGAACATGAACTGATCACGTGACTTAGCA
TGCAGTGATCTCGTGTCTGAATGGTGCTGATCATGTGACTAAACAAGAACTGATCACGTG
GCTATAATGCACTGATCACATGACTGCGCATGCACTGATCATGTGGATGATAATACACTG
ATGACGTTACTGATGAGGCACTGATCACGTGACTGATCATTCACTGATCACGTGGCTATT
ATGCACTGATCACGGGACTGCACATGCAGTGTTCACGTAATTGTAGACAATGATCACGTG
GCTATCATGCACTGATCACGTGTCTATCATGCACTGAACACGTGGCTGATCAAACACTGA
TCACGTGGCTGATCATGCACTCATCACGTGGCTGATCATACGATGATCACGTGGCTGATC
ATGCACTGATCACATGTATGATCGTACACTGATCACGTGGCTGATCATGCACAAATCCCA
TTGCATATCATGCTCTGATCAGGTTGCTATCATGTACTGATCACGTGGCTGATCATACAG
TGATCACGTGACTGACCATGCACTGATTACGTGGCTATCATGCACTGATCACGTGGCTGA
TCATGCACTGTTAACCTGGCTATAATACACTGATCTCGTGACTGATCATGCATTCCTCAC
ATGCCTGATCATGCACTGATCACGTGGCTGATCTTGCACTGATCACGTGGCTGATAATGC
ACTGATCACTTGACTGATCATGCACTGATCACGTGTCTGATCATGCACTACTCACGTGAC
TGATCATGGACTGATCACGTGACTGATCATGCACTGATCATGAGCCTGATCATGCACTGA
ACACGGGCCTGTTCATGCACTGATCACGTGGCTGATCCTGCACTGATCACGAGGCTGATC
ATACACTGATCACGTGACTGTGCATGCAATGATCACTTGGCTGATCATATACTGATCACG
TGGCTGATCATGCACTGATCACGTGACTGATCATGCACTGATATGGTGGCTATCATGCAT
TGATCACGTGGTTGATCATACACTGATCACGTGACTGATCATGCACTGATCACCTGGCTA
TCATGCACTAATCACGTAGCTGATCTGGAACAGATCACGTGTGTAATCATGCAGTGATCA
CGTCGCTATCATGCAATGATCTCGAGATTGCGCATGCACTGATCATATGGATGATCACAC
ACTGATCACGTGACAGATCATGCACTGAACACGTGACTTATAATGCACTGATCACGTGAC
TGCACATGCACTGATCATGTGACTGAGCATGCACTGATCACGTAGCTGATCATGCACTGA
TCACGAAGTTGATCATACACTGATCACGTGAGTGTGCATGCACTGATCACGTGGCGGATA
ATGCAATGTTCACGTGGCTGATCATGCACTGATCACGTAGCTCTCATGCACTGATCACAT
GTCAATCACGCCCGGATCCCGTGGCTGATCATGCACTGATCTCGAAGCTGATCATACACT
GATCACGTGAGTGTGCATGCAATGATAACATGGCTGATTATGCAATTATCACGTGGCTTA
TCATACACTGATCACGTGGCTGATCATGCACTAATCACGTTTTGGATGATGCACTGGTCA
CGTGGCTGATCATACACTAATCACATGACTGATCATGCACTAATCACGTTGTGGATCATG
CACTGATCACGTGGCTGTTCTTGCACTTATCACGTGGCTGATCATACAGTGATCACATGA
CTGATCATGCACTAATCACGATGTGGATCATGCACTGATCACATGAATGTGCATGCATTG
ATCATGTGGCTGATCATGCACTGATCACGTGGCTGATCATGCACTGATCACGAAGCTGAT
ATTACACTGATCACAGGACTGTGCATGCACTGATCATGTGGCTGATCATGCACTGATCAT
GTGGCTGATGATACACTGATCACGTGGCTGATCGTACTCTGAACATGAAGCTGAAAATAC
ACTGATCACGAGACTGCATGCACTGATCACTTGACTGCGCCTGCACTGATCACGTGGATG
ATAATACGCTGATCACTTGACTGCTTATGCACTAAAAAAATGGCTGATCATGCACTGATC
ACATGACTGATCATGCACTGATCACGTGACTGATCATGCATAGATCACGTGACTACCATG
CACTGATCACTTGATTGTGCATGCAATAATCACGTGGATGATCACGCATTTATCATGTGG
CTGATCATGCACTAATCACATGGCGGAACATGAACTGATCACGTGACTTAGCATGCAGTG
ATCTCGTGTCTGAATGGTGCTGATCATGTGACTAAACAAGAACTGATCACGTGGCTATAA
TGCACTGATCACGTAACTGCACATGCACTGATCATGTGACTGAGCATGCACTAATCATGT
AGCTGATCATGCACTGATCACGAAGTTGATCATACACTGATCATGTGACTGAGCATGCAC
TGACCACGTAGCTGATCATGCACTGATCACGTTGCGTATCATGCACTGATCACATGACGG
CGCATGAACTGATCACGTGGATATTATACACTGATCAAGTGACAAATCATGCACTAATCA
CGTGACTGATCATGCACTGATCACGTGGCTATCATGCACTGATCACGTGACTGATCATGC
ACTTGACACGTCGCTATCATGCACTGATCACGTGGCTGTTCATACAGTGATCACGTGACT
GATCATGCACTGATCCCGTGGCTGATCATGCACTGATCACGTTGCAGATCATGCACTCAT
CACGTGGCTGATCATACAATGATCACGTGGCTGATCATGCACTGATCACATGTGTGATCG
TACACTGATCACGTGGCTGATCATGCACAAATCCCATTGCATATCATGCTCTGATCAGGT
TGCTATCATGTACTGATCACTTGGCTGATCATACACTGATCACATGACTGATCATGCACT
GATCACGTGCCTGATCATGCACTGATCCCGTGGCAGATCATGCACTGATCACGTGCAGAT
CATGCACTCATCATGTGGCTGATCATACAATGATCACGTGGCTGATCATGCACTGATCAC
ATGTATGATCGTACACTGATCACGTGGCTGATCATGCACAAATCCCATTGCATATCATGC
TCTGATCAGGTTGCTATCATGTACTGATCACGTGGCTGATCATACACTGATCACATGACT
GATCATGCACTGATCACGTGCCTGATCATGCACTGATCCCGTGGCTGATCTTGCACTGAT
CACGTGGCTGATAATGCACTGATCACTTGACTGATCATGCACTGATCACGTCTCTTATCA
TGCACTACTCACGTGACTGATCATGGACTGATCACGTGACTGATCATGCACTGATCATGA
GCCTGATCATGCACTGATCACGGGCCTGTTCATGCACTGATCACGTGGCTGATCCTGCAC
TGATCACGAGGCTGATCATACACTGATCACGTGACTGTGCATGCAATGATCACTTGGCTG
ATCATGTACTGATCACGTGGCTGATCATGCACTGATCACATGACTGATTATGCACTGATC
ACATAGCTATCATGCACTGATCACATGACTTCGCATGCCATGATCACGTGACTGATCATG
CACTGGTCCCGTGGCTATCATGCACTGATAATGTGGCTTATCATACATTGATCACCTAAA
TAATCATGCACTGATCACGTGGCAATCTTGCTCTGATCACGTGGTTGATCAGGCACTGAT
CACTTAGCTATCATGCACTGATCACATGACTGCGCAAGAACTGATCACTTAGATATCATA
CACAGGACACGTGACAGATCATGCACTGATCACGTGACTGATCATGCACTGATCTGGTGG
CTATCATGCACTGATCCCGTGGCTGATCTTGCACTGATCACGTGGCTGATAATGCACTGA
TCACTTGACTGATCATGCACTGATCACGTCTCTTATCATGCACTACTCACGTGACTGATC
ATGGACTGATCACGTGACTGATCATGCACTGATCATGAGCCTGATCATGCACTGATCACG
GGCCTGTTCATGCACTGATCACGTGGCTGATCCTGCACTGATCACGAGGCTGATCATACA
CTGATCACGTGACTGTGCATGCAATGATCACTTGGCTGATCATGTACTGATCACGTAGCT
GATCATGCTCTGATCACGTGACTGATTATGCACTGATCACATAGCTATCATGCACTGATC
ACATGACTTCGCATGCCATGATCACGTGACTGATCATGCACTGATCACGTGGCTATCATG
CACTGATAATGTGGCTTATCATACATTGATCACCTAAATAATCATGCACTGATCACGTGG
CAATCTTGCTCTGATCACGTGGTTGATCAGGCACTGATCACTTAGCTATCATGCACTGAT
CACATGACTGCGCAAGAACTGATCACTTAGATATCATACACAGGACACGTGACAGATCAT
GCACTGATCACGTGACTGATCATGCACTGATCTGGTGGCTATCATGCATTGATCACGTGG
TTGATCATACACTGATCACGTGACTGATCATGCACTGATCACCTGGCTATCATGCACTAA
TCACGTAGCTGATCTGGAACAGATCACGTGACTAATCATGCAGTGATCACGTCGCTATCA
TGCAATGATCTCGAGATTGCGCATGCACTGATCATATGGATGATCACACACTGATCACGT
GACAGATCATGCACTGAACACGTGACTTATAATGCACTGATCACGTGACTGCACATGCAC
TGATCATGTGACTGAGCATGCACTGATCACGTAGCTGATCATGCACTGATCACGAAGTTG
ATCATACACTGATCATGTGACTGAGCATGCACTGACCACGTAGCTGATCATGCACTGATC
ACGAAGTTGATCATACACTGATCACGTGAGTGTGCATGCACTGATCACGTGGCGGATAAT
GCAATGATCACGTGGCTGATCATGCACTGATCACGTAGCTCTCATGCACTGATCACATGT
CAACCATGCCCGGATCCCGTGGCTGATCATGCACTGATCGCCTGACTGATCAGGCACTAG
TCACCTGGCTATCATGCACTAATCACGTGGCTGTTCATACACTGACCACGTGACTGATCA
TGCACTGATCTGGTGGCTATCATGCATTGATCACGTGTTTGATCTTACACTGATCACGTG
ACTGATCATGCACTGATCACCTGGCTTTCATGCACTAATCACGTAGCTGATCTGGAACAG
ATCACGTGACTAATCATGCAGTGATCACGTCGCTATCATGCAATGATCTCGAGATTGCGC
ATGCACTGATCATATGGATGATCACACACTGATCACGTGACAGATCATGCACTGATCACG
TGACTTATCATGCACTGATCACGAGACTGCACATGCACTGATCATGTGACTGAGCATGCA
CTGATCATGTAGCTGATCATGCACTGATCACGAAGTTGATCATACACTGATCATGTGACT
GAGCATGCACTGATCACGTAGCTGATCATGCACTGATCACGAAGTTGATCATACACTGAT
CACGTGAGTGTGCATGCACTGATCACGTGGCGGATAATGCAATGTTCACGTAGCTCTCAT
GCACTGATCACATGTCAATCACGCCCGGATCCCGTGGCTGATCATGCACTGATCTCGAAG
CTGATCATACACTGATCACGTGAGTGTGCATGCAATGATAACATGGCTGATTATGCAATT
ATCACGTGGCTTATCATACACTGATCACGTGGCTGATCATGCACTAATCACGTTTTGGAT
GATGCACTGGTCACGTGGCTGATCATACACTAATCACATGACTGATCATGCACTAATCAC
GTTGTGGATCATGCACTGATCACGTGGCTGTTCTTGCACTTATCACGTGGCTGATCATAC
AGTGATTACATGACTGATCATGCACTAATCACGATGTGGATCATGCACTGATCACATGAA
TGTGCATGCATTGATCATGTGGCTGATCATGCACTGATCACGTGGCTGATCATGCACTGA
TCACGAAGCTGATATTACACTGATCACAGGACTGTGAATGCACTGATCATGTGGCTGATC
ATGCACTGATCATGTGGCTGATGATACACTGATCACGTGGCTGATCGTACTCTGAACACG
AAGCTGAAAATACACTGATCACGAGACTGCATGCACTGATCACTTGACTGCGCCTGCACT
GATCACGTGGATGATAATACGCTGATCACTTGACTGCTTATGCACTAAAAAAATGGCTGA
TCATGCACTGATCACATGACTGATCATGCACTGATCACGTGACTACCATGCACTGATCAC
TTGATTGTGCATGCAATAATCACGTGGATGATCACGCATTTATCATGTGGCTGATCATGC
ACTAATCACATGGCGGAACATGAACTGATCACGTGACTTAGCATGCAGTGATCTCGTGTC
TGAATGGTGCTGATCATGTGACTAAACAAGAACTGATCACGTGGCTATAATGCACTGATC
ACGTAACTGCACATGCACTGATCATGTGACTGAGCATGCACTAATCATGTAGCTGATCAT
GCACTGATCACGAAGTTGATCATACACTGATCATGTGACTGAGCATGCACTGACCACGTA
GCTGATCATGCACTGATCACGTTGCGTATCATGCACTGATCACATGACGGCGCATGAACT
GATCACGTGGATATTATACACTGATCAAGTGACAAATCATGCACTAATCACGTGACTGAT
CATGCACTGATCACGTGGCTATCATGCACTGATCACGTGACTGATCATGCACTTGACACG
TCGCTATCATGCACTGATCACGTGGCTGTTCATACAGTGATCACGTGACTGATCATGCAC
TGATCCCGTGGCTGATCATGCACTGATCACGTTGCAGATCATGCACTCATCACGTGGCTG
ATCATACAATGATCACGTGGCTGATCATGCACTAATCACATGTGTGATCGTACACTGATC
ACGTGGCTGATCATGCACAAATCCCATTGCATATCATGCTCTGATCAGGTTGCTATCATG
TACTGATCACTTGGCTGATCATACACTGATCACATGACTGATCATGCACTGATCACGTGC
CTGATCATGCACTGATCCCGTGGCAGATCATGCACTGATCACGTGCAGATCATGCACTCA
TCATGTGGCTGATCATACAATGATCACGTGGCTGATCATGCACTGATCACATGTATGATC
GTACACTGATCACGTGGCTGATCATGCACAAATCCCATTGCATATCATGCTCTGATCAGG
TTGCTATCATGTACTGATCACGTGGCTGATCATACACTGATCACATGACTGATCATGCAC
TGATCACGTGCCTGATCATGCACTGATCCCGTGGCTGATCTTGCACTGATCACGTGGCTG
ATAATGCACTGATCACTTGACTGATCATGCACTGATCACGTCTCTTATCATGCACTACTC
ACGTGACTGATCATGGACTGATCACGTGACTGATCATGCACTGATCATGAGCCTGATCAT
GCACTGATCACGGGCCTGTTCATGCACTGATCACGTGGCTGATCCTGCACTGATCACGAG
GCTGATCATACACTGATCACGTGACTGTGCATGCAATGATCACTTGGCTGATCATGTACT
GATCACGTGGCTGATCATGCACTGATCACATGACTGATTATGCACTGATCACATAGCTAT
CATGCACTGATCACATGACTTCGCATGCCATGATCACGTGACTGATCATGCACTGGTCCC
GTGGCTATCATGCACTGATAATGTGGCTTATCATACATTGATCACCTAAATAATCATGCA
CTGATCACGTGGCAATCTTGCTCTGATCACGTGGTTGATCAGGCACTGATCACTTAGCTA
TCATGCACTGATCACATGACTGCGCAAGAACTGATCACTTAGATATCATACACAGGACAC
GTGACAGATCATGCACTGATCACGTGACTGATCATGCACTGATCTGGTGGCTATCATGCA
CTGATCCCGTGGCTGATCTTGCACTGATCACGTGGCTGATAATGCACTGATCACTTGACT
GATCATGCACTGATCACGTCTCTTATCATGCACTACTCACGTGACTGATCATGGACTGAT
CACGTGACTGATCATGCACTGATCATGAGCCTGATCATGCACTGATCACGGGCCTGTTCA
TGCACTGATCACGTGGCTGATCCTGCACTGATCACGAGGCTGATCATACACTGATCACGT
GACTGTGCATGCAATGATCACTTGGCTGATCATGTACTGATCACGTAGCTGATCATGCTC
TGATCACGTGACTGATTATGCACTGATCACATAGCTATCATGCACTGATCACATGACTTC
GCATGCCATGATCACGTGACTGATCATGCACTGATCACGTGGCTATCATGCACTGATAAT
GTGGCTTATCATACATTGATCACCTAAATAATCATGCACTGATCACGTGGCAATCTTGCT
CTGATCACGTGGTTGATCAGGCACTGATCACTTAGCTATCATGCACTGATCACATGACTG
CGCAAGAACTGATCACTTAGATATCATACACAGGACACGTGACAGATCATGCACTGATCA
CGTGACTGATCATGCACTGATCTGGTGGCTATCATGCATTGATCACGTGGTTGATCATAC
ACTGATCACGTGACTGATCATGCACTGATCACCTGGCTATCATGCACTAATCACGTAGCT
GATCTGGAACAGATCACGTGACTAATCATGCAGTGATCACGTCGCTATCATGCAATGATC
TCGAGATTGCGCATGCACTGATCATATGGATGATCACACACTGATCACGTGACAGATCAT
GCACTGAACACGTGACTTATAATGCACTGATCACGTGACTGCACATGCACTGATCATGTG
ACTGAGCATGCACTGATCACGTAGCTGATCATGCACTGATCACGAAGTTGATCATACACT
GATCATGTGACTGAGCATGCACTGACCACGTAGCTGATCATGCACTGATCACGAAGTTGA
TCATACACTGATCACGTGAGTGTGCATGCACTGATCACGTGGCGGATAATGCAATGATCA
CGTGGCTGATCATGCACTGATCACGTAGCTCTCATGCACTGATCACATGTCAACCATGCC
CGGATCCCGTGGCTGATCATGCACTGATCGCCTGACTGATCAGGCACTAGTCACCTGGCT
ATCATGCACTAATCACGTGGCTGTTCATACACTGACCACGTGACTGATCATGCACTGATC
TGGTGGCTATCATGCATTGATCACGTGTTTGATCTTACACTGATCACGTGACTGATCATG
CACTGATCACCTGGCTTTCATGCACTAATCACGTAGCTGATCTGGAACAGATCACGTGAC
TAATCATGCAGTGATCATGTCGCTATCATGCAATGATCTCGAGATTGCGCATGCACTGAT
CATATGGATGATCACACACTGATCACGTGACAGATCATGCACTGATCACGTGACTTATCA
TGCACTGATCACGAGACTGCACATGCACTGATCATGTGACTGAGCATGCACTGATCATGT
AGCTGATCATGCACTGATCACGAAGTTGATCATACACTGATCATGTGACTGAGCATGCAC
TGATCACGTAGCTGATCATGCACTGATCACGAAGTTGATCATACACTGATCACGTGAGTG
TGCATGCACTGATCACGTGGCGGATAATGCAATGTTCACGTGGCTGATCATGCACTGATC
ACGTAGCTCTCATGCACTGATCACATGTCAATCACGCCCGGATCCCGTGGCTGATCATGC
ACTGATCTCGAAGCTGATCATACACTGATCACGTGAGTGTGCATGCAATGATAACATGGC
TGATTATGCAATTATCACGTGGCTTATCATACACTGATCACGTGGCTGATCATGCACTAA
TCACGTTTTGGATGATGCACTGGTCACGTGGCTGATCATACACTAATCACATGACTGATC
ATGCACTAATCACGTTGTGGATCATGCACTGATCACGTGGCTGTTCTTGCACTTATCACG
TGGCTGATCATACAGTGATTACATGACTGATCATGCACTAATCACGATGTGGATCATGCA
CTGATCACATGAATGTGCATGCATTGATCATGTGGCTGATCATGCACTGATCACGTGGCT
GATCATGCACTGATCACGAAGCTGATATTACACTGATCACAGGACTGTGCATGCACTGAT
CATGTGGCTGATCATGCACTGATCATGTGGCTGATGATACACTGATCACGTGGCTGATCG
TACTCTGAACACGAAGCTGAAAATACACTGATCACGAGACTGCATGCACTGATCACTTGA
CTGCGCCTGCACTGATCACGTGGATGATAATACGCTGATCACTTGACTGCTTATGCACTA
AAAAAATGGCTGATCATGCACTGATCACATGACTGATCATGCACTGATCACGTGACTGAT
CATGCATAGATCACGTGACTACCATGCACTGATCACTTGATTGTGCATGCAATAATCACG
TGGATGATCACGCATTTATCATGTGGCTGATCATGCACTAATCACATGGCGGAACATGAA
CTGATCACGTGACTTAGCATGCAGTGATCTCGTGTCTGAATGGTGCTGATCATGTGACTA
AACAAGAACTGATCACGTGGCTATAATGCACTGATCACATGACTGCGCATGCACTGATCA
TGTGGATGATAATACACTGATGACGTTACTGATGAGGCACTGATCACGTGACTGATCATT
CACTGATCACGTGGCTATTATGCACTGATCACGGGACTGCACATGCAGTGTTCACGTAAT
TGTAGACAATGATCACGTGGCTATCATGCACTGATCACGTGTCTATCATGCACTGAACAC
GTGGCTGATCAAACACTGATCACGTGGCTGATCATGCACTCATCACGTGGCTGATCATAC
GATGATCACGTGGCTGATCATGCACTGATCACATGTATGATCGTACACTGATCACGTGGC
TGATCATGCACAAATCCCATTGCATATCATGCTCTGATCAGGTTGCTATCATGTACTGAT
CACGTGGCTGATCATACAGTGATCACGTGACTGACCATGCACTGATTACGTGGTTATCAT
GCACTGATCACGTGGCTGATCATGCACTGTTAACCTGGCTATAATACACTGATCTCGTGA
CTGATCATGCATTCTTCACATGCCTGATCATGCACTGATCACGTGGCTGATCTTGCACTG
ATCACGTGGCTGATAATGCACTGATCACTTGACTGATCATGCACTGATCACGTGTCTGAT
CATGCACTACTCACGTGACTGATCATGGACTGATCACGTGACTGATCATGCACTGATCAT
GAGCCTGATCATGCACTGAACACGGGCCTGTTCATGCACTGATCACGTGGCTGATCCTGC
ACTGATCACGAGGCTGATCATACACTGATCACGTGACTGTGCATGCAATGATCACTTGGC
TGATCATGTACTGGTCACGTGGCTGATCATGCACTGATCACGTGACTGATCATGCACTGA
TATGGTGGCTATCATGCATTGATCACGTGGTTGATCATACACTGATCACATGTGTGATCG
TACACTGATCACGTGGCTGATCATGCACAAATCCCATTGCATATCATGCTCTGATCAGGT
TGCTATCATGTACTGATCACTTGGCTGATCATACAATGATCACATGACTGATCATGCACT
GATCACGTGCCTGATCATGCACTGATCCCGTGGCAGATCATGCACTGATCACGTGCAGAT
CATGCACTCATCATGTGGCTGATCATACAATGATCACGTGGCTGATCATGCACTGATCAC
ATGTATGATCGTACACTGATCACGTGGCTGATCATGCACAAATCCCATTGCATATCATGC
TCTGATCAGGTTGCTATCATGTACTGATCACGTGGCTGATCATACACTGATCACATGACT
GATCATGCACTGATCACGTGCCTGATCATGCACTGATCCCGTGGCTGATCTTGCACTGAT
CACGTGGCTGATAATGCACTGATCACTTGACTGATCATGCACTGATCACGTCTCTTATCA
TGCACTACTCACGTGACTGATCATGGACTGATCACGTGACTGATCATGCACTGATCATGA
GCCTGATCATGCACTGATCACGGGCCTGTTCATGCACTGATCACGTGGCTGATCCTGCAC
TGATCACGAGGCTGATCATACACTGATCACGTGACTGTGCATGCAATGATCACTTGGCTG
ATCATGTACTGATCACGTGGCTGATCGTGCACTGATCACATGACTGATTATGCACTGATC
ACATAGCTATCATGCACTGATCACATGACTTCGCATGCCATGATCACGTGACTGATCATG
CACTGGTCCCGTGGCTATCATGCACTGATAATGTGGCTTATCATACATTGATCACCTAAA
TAATCATGCACTGATCACGTGGCAATCTTGCTCTGATCACGTGGTTGATCAGGCACTGAT
CACTTAGCTATCATGCACTGATCACATGACTGCGCAAGAACTGATCACTTAGATATCATA
CACAGGACACGTGACAGATCATGCACTGATCACGTGACTGATCATGCACTGATCTGGTGG
CTATCATGCATTGATCACGTGGTTGATCATACACTGATCACGTGACTGATCATGCACTGA
TCACCTGGCTATCATGCACTAATCACGTAGCTGATTTGGAACAGATCACGTGACTAATCA
TGCAGTGATCACGTCGCTATCATGCAATGATCTCGAGATTGCGCATGCACTGATCATATG
GATGATCACACACTGATCACGTGACAGATCATGCACTGAACACGTGACTTATAATGCACT
GATCACGGGACTGCACATGCACTGATCATGTGACTGAGCATGCACTGATCACGTAGCTGA
TCATGCACTGATCACGAAGTTGATCATACACTGATCATGTGACTGAGCATGCACTGACCA
CGTAGCTGATCATGCACTGATCACGAAGTTGATCATACACTGATCACGTGAGTGTGCATG
CACTGATCACGTGGCGGATAATGCACTGATCACGAAGTTGAGCATACACTGATCATGTGA
CTGAGCATGCACTGATCACGTAGCTGATCATGCACTGATCACGAAGTTGATCATACACTG
ATCACGTGAGTGTGCATGCACTGATCACGTGGCGGATAATGCAATGATCACGTGGCTGAT
CATGCACTGATCACGTAGCTCTCATGCACTGATCACATGTCAACCATGCCCGGATCCCGT
GGCTGATCATGCACTGATCGCCTAACTGATCATGCACTAGTCACCTGGCTATCATGCACT
AATCACGTGGCTGTTCATACACTGACCACGTGACTGATCATGCACTGATCTGGTGGCTAT
CATGCATTGATCACGTGTTTGATCTTACACTGATCACGTGACTGATCATGCACTGATCAC
CTGGCTTTCATGCACTAATCACGTAGCTGATCTGGAACAGATCACGTGACTAATCATGCA
GTGATCACGTCGCTATCATGCAATGATCTCGAGATTGCGCATGCACTGATCATATGGATG
ATCACACACTGATCACGTGACAGATCATGCACTGATAACGTGACTTAACATGCACTGATC
ACGAGACTGCACATGCACTGATCATGTGACTGAGCATGCACTGTTCATGTAGCTGATCAT
ACACTGATCACGAAGTTGATCATACACTGATCATGTGACTGAGCATGCACTGATCACGTA
GCTGATCATGCACTGATCACGAAGTTGATCATACACTGATCACGTGAGTGTGCATGCACT
GATCACGTGGCGGATAATGCAATGTTCACGTGGCTGATCATGCACTGATCACGTAGCTCT
CATGCACTGATCACATGTCAATCATGCCCGGATCCCGTGGCTGATCATGCACTGATCTCG
AAGCTGATCATACACTGATCACGTGAGTGTGCATGCAATGATCACATGGCTGATTATGCA
CTGATCACGTGGCTGAACATGCTCTGATCCCGTGGGTGATCATGCACTTATCACGTGGCT
TATCATACACTGATCACGTGGCTGATCATGCACTAATCACGTTGTGGATGATGCACTGGT
CACGTGGCTGATCATACACTGATCACATGACTGATCATGCACTAATCACGTTGTGGATCA
TGCACTGATCACGTGGCTGATAATACACTGATTACGTGGCTGATCATACACTGATCACGT
GGCTGATCATGCACTGATCACGTGGCTGATCATGCACTAATCACCTTGTGGATCATGCAC
TGATTACGTGGCAGATCATACACTGATCACATGACTGATTATGCACTGATCACGTGCCTG
ATCATGCACTGATCACGTGGCTGATCATGCACTGATCACGAAGCTGATCATCCAATGATC
ACTTGACTGTGCATGCGCTCATCACGTGGCTGAGCATGCACTGATCACGTGGCTGATCAT
ACACTGATCACGTGGCTGATCATACATTAATCACATTGCAGATATGCACTCATCACGTGG
CTGATCATACAATGATCACGTGGCTGATCATGCACTAATCACATGTATGATTGTACACTG
ATCAGGTGGCTGATCATGCACAAATCCCATTGCGTATCATGCTCTGATCAGGTTGCTATC
ATGTACTGATCACGTGGCTGATCATACAGTGATCACGTGACTGACCATGCACTGATTACG
TGGCTATCAGGCACTGATCACGTGGCTGATCATGCACTGTTAACCTGGCTATAATACACT
GATCTCGTGACTGATCATGCATTCTTCACGTGCCTGATCATGCACTGATCACGTGGCTGG
TCCTGCACTGATCACGTGGCTCATAATGCACTGATCACTTGACTGATCATGCACTGATCA
CGTGTCTGATCATGCACTACTCACGTGACTGATCATGGACTGATCTCGTGACTGATCATG
CACTGATCATGAGCCTGATCATGCACTGAACACGGGCCTGTTCATGCACTGATCACGTGG
CTGATCCTGCACTGATCACGAGGCTGATCATACACTGATCCCGTGACTGTGCATGCAATG
ACCACTTGGCTGATCATGTACTCATCACGTGGATGATCATGAACTGATAACCTGGCTATC
ATCCACTGATCACGTGAGTGATCATGCACTCTTCACGTGCATGATCATGCACTGATCACT
TGTCTTAGCATGCACTAACCATGTTGCTGATCATGCAATGATCAGGTGGCTATCATGCAC
TGTTTACCTGGCTGATCATGCACTGATCACATGGCTGTAATACACTGACCACTTGACTGT
GCATGCACTGATCATGTGGATGATTATACACTGATCACGTGACTGATCATGCACTGATCA
TGTGTGTGATCATGCACTGATAAAGTGCTTGATCATGCACTGATCACGTGGCTGAGCATA
CAGTGATTACATGACTGATCTTGCACTAATCATGTTGTGGATCATGCACTGATCACGTGA
CTGATCATGCACTAGTCACGTGGCTATCATGCACTGATCACGTGGCTGATCATACACTGA
TCACGTGTCTGATCATGCACTGATCACGTGCCTGATCATGCACTGATTGCGTAACTTCGC
ATGCAGTGATCTCATGTCTGAATTGTGCTGATCATGTGACTAATCAAGAACTGATCACGT
GGCTATAATGCACTGATCACGTGACTGCGCACGCACTGAAAATATGGATGACCATACACT
GATCACGTCACTGATCACGCACTGATCACGTGACTGATAATGCACTGATCACGTGGCTGA
TCATGCACTGATCACGTGGCTGATCATGCACTGATCACGTGGGTTATCATGAACTGATCA
CGTGGCTTATCATACACTGCTCACGTGGCTGATCATGCACTAATCACGTTGTGGATGATG
CACTGATCACGTGGCTGATCATACACTGATCACGTGGGTGATCATGAACTGATCACGTGG
CTGATCATACACTGATCACATGAATGATCATGCACTAATCACGTTGTGGACCATGCACTG
ATCACTTGGCTGATCAGGCACTGATCACGTGGCTGATCATACTCTGAACACGAAGCTGAA
AATACAGTGATCACGTGACTGCATGCACTGATCACATGGCTATCATGCACTGATCACGTG
TCTATCATGGACTGATCACGTGACTGCGCATTAACTGGACACATACCTGTTCATGCACTT
TTTACGTGGCTATCATGCACTGATCACGTGGCTTATCATGCATTGGTCACGTGACTGATC
ATGCACTGATCACGTTGCGTATCATGCACTGATCACATGACGGCGCATGAACTGATCACG
TGGATATTATACACTGATCAAGCGACAAATCATGCACTAATCACGTGACTGCTCATGCCC
TGATCACGTGGCTATCATGCTCTGATCACGTGGCTGATCATGCACTGATCACGTGGCTGT
TCATACAGTGATCACGTGACTGATCATGCACTGATCACGTGCCTGATCATGAACTGATCA
CGAAGCTGATCATACTCCAATCACGTGAGTGTGCATGCACTGATCACGTGGCTGATCATG
CACTAATCACGTTGTGGATGATGCACTGATCACGTGGCTGATCATACACTGATCACATGA
CTGATCATGAACTAATCACGTTGTGGATCATGCACTGATCACGTGGCTGTTCTTGCACTT
ATCACATGGCTGATCATACAGTGATTACATGACTGATCATGCACTAATCACGTTGTGGAT
CATGCACTGATCACATGAATGTGCATGCATTGATCATGTGGCTGATCATGCACTGATCAC
GTGGCTGATCATGCACTGATCTCGAAGCTGATCATACTCCAATCACGTGAGTGTGCATGC
ACTGATCACGTGGCTGATCATGCACTAATCACGTTGTGAATGATGCACTGATCACGTGGC
TGATCATACACTGATCTCATGACTGATCATGAACTAATCACGTTGTGGACCATGCACTGA
TCACATGACTGTTCTTGCACTTATCACGTGGCTGATCATACAGTGATTACATGACTGATC
ATGCACTAATCACGTTGTGGATCATGCACTGATCACATGAATGTGCATGCATTGATCATG
TGGCTGATCATGCACTGATCATGTGGCTGATCATGCACTGATCATATGGCTGATGATACA
CTGATCACGTGGCTGATCAGGCACTGATCACGTGGCTGATCGTACTCTGAACACGAAGCT
GAAAATACGCTGATCACGAGACTGCATGCACTGATCACTTGACTGCCCATGCACTGATCC
CGTGGATGATAATACGCTGATCACTTGACTGCTTATGCACTAAAAAAATGGCTGATCTTG
CACTGATCACATGACTGATCATGCACTGATCACGTGACTGATCATGCATAGATCACGTGA
CTACCATGCACTGATCACTTGATTGTGCATGCAATAATCACGTGGATGATCACGCATTTA
TCATGTGGCTGATCATGCACTAATCACATGGCGGAACATGAACTGATCACGTGACTTAGC
ATGCAGTGATCTCGTGTCTGAATGGTGCTGATCATGTGACTAAACAAGAACTGATCACGT
GGCTATAATGCACTGATCACGTGACTGCGCATGCACTGATCATGTGGATGATAATACACT
GATGACGTTACTGATGAGGCACTGATCACGTGACTGATCATTCACTGATCACGTGGCTAT
TATGCACTGATCACGGGACTGCACATGCAGTGTTCACGTAATTGTAGACAATGATCACGT
GGCTATCATGCACTGATAACGTGTCTATCATGCACTGAACACGTGGCTGATCAAACACTG
ATCACGTGGCTGATCATGCACTGAACACGTGGCTGATCAAACACTGATCACGTGGCTGAT
CATGCACTCATCACGTGGCTGATCATACAATGATCACGTGGCTGATCATGCACTGATCAC
ATGTATGATCGTACACTGATCACGTGGCTGATCATGCACAAATCCCATTGCATATCATGC
TCTGATCAGGTTGCTATCATGTACTGATCACGTGGCTGATCATACAGTGATCACGTGACT
GACCATGCACTGATTACGTGGCTATCATGCACTGATCACGTGGCTGATCATGCACTGTTA
ACCTGGCTATAATACACTGATCTCTTGACTGATCATGCATTCTTCACATGCCTGATCATG
CACTGATCACGTGGCTGATCTTGCACTGATCACGTGGCGGATAATGCACTGATCACTTGA
CTGATCATGCACTGATCTCGTTGCGTATCATGCACTGATCACATGACGGTGCATGAACTG
ATCACGTGAACATTATACACTGATCAAGTGACAGATCATGTACTAATCACGTGACTGATC
ATGCACTGATCACGTGGCTATCATGCACTGATCACGTGGCTGATCTTGCACTGATCACTT
GACTGATCATGCACTGATCACGTGTCTGATCATGCACTACTCACGTGACTGATCATGGAC
TGATCACGTGACTGATCATGCCCTGATCATGAGCCTGATCATGCACTGATCACGGGCCTG
TTCATGCACTGATCACGTGGGTGATCCTGCACTGATCACGAGGCTGATCATACACTGATC
ACGTGACTGTGCATGCAATGATCACTTGGCTGATCATGTACTGATCACGTGGCTGATCAT
GCACTGATCACGTGACTGATTATGCACTGATCACATAGCTATCATGCACTGATCACATGA
CTTCGCATGCCATGATCACGTGACTGATCATGCACTGGTCCCGTGGCTATCATGCACAGA
TAATGTGGCTTATCATACATTGATCACCTAAATAATCATGCACTGATTACGTGGCAATCT
TGCTCTGATCACGTGGTTGATCAGGCACTGATCACTTAGCTATCATGCACTGATCACATG
ACTGCGCAAGAACTGATCACTTAGATATCATACACAGGACACGTGACAGATCATGCACTG
ATCACGTGACTGATCATGCACTGATCTGGTGGCTATCATGCATTGATCACGTGGTTGATC
ATACACTGATCACGTGACTGATCATGCACTGATCACCTGGCTATAATGCACTAATCACGT
AGCTGATCTGGAACAGATCACGTGACTAATCATGCAGTGATCACGTCGCTATCATGCAAT
GATCTCGAGATTGCGCATGCACTGATCGTTTGGATGATCACACACTGATCACGTGACAGA
TCATGCACTGAACACGTGACTTATCATGCAATGATCTCGTGACTGATCATGCATTCCTCA
CGTGCCTGATCATGCACTGATCACGTGGCTGATAATGCACTGATCACTTGACTGATCATG
CACTGATCACGTCTCTGATCATGCACTACTCACGTGACTGATCATGGACTGATCACGTGA
CTGATCATGCACTGATCATGAGCCTGATCATGCACTGATCACGGGCCTGTTCATACACTG
ATCACGTGGCTGATCCTGCACTGATTACGAGGCTGATCATACACTGATCACGTGACTGTG
CATGCAATGATCACTTGGCTGATCATGTACTGATCACGTGGCTGATCTTGCACTGATAAC
CTGGCTATCATCCACTGATCACGTGAGTGATCATGCACTCTTCACGTGCATGATCATGCA
CTGATCACGTGTCTTAGCATGCACTAACCATGTTGCTGATCATGCAATGATCAGGTGGCT
ATCATGCACTGTTTACCTGGCTGATCATGCACTGATCACATGGCTGTAATACACTGGCCA
CTTGACTGTGCATGCAATGATCATGTGGATGATTATACAGTGATCACGTGACTGATCATG
CACTGATCATGTGTCTCATCATGCACTGATAAAGTGCTTGATCATGCACTGATCACGTGG
CTGAGCATACAGTGATTACATGACTGATCATGCACTAATCACGTTGTGGATCATGCACTG
ACCACGTGACTGATCATGCACTAGTCACGTGGCTATCATGCACTGATCACGTGGCTGATC
ATACACTGATCTCGTGCCTGATCATGCACTGATCACGTGCCTTATCATGCACTGATTGCA
TAACTTAGCATGCAGTGATCTGGTGTCTGAAATGTGCTGATCATGTGACTAATTAAGAAC
TGATCACGTGGCTATAATGCACTGATCACATGACTGGGCACGCACTGAAAATATGGATGA
CCATACACTGATCACGTCATTGATCACGCACTGATCACGTGACTGATCATGCACTGATCA
CGAAGCTGATCATACTCTGATCACGTGAGTGTGCATGCACTGATCACGTGGGTGATTATG
AACTGATCACGTGGCTTATCATACACTGCTCACATGGCTGATCATGCACTAATCACGTTG
TGGATGATGCACTGATCACGTGGCTGATCATACACTGATCACGTGGGTGATCATGAACTG
ATCACGTGGCTGATCATACACTGATCACATGAATGATCATGCACTAATCACGTTGTGGAT
CATGCACTGATCACGTGGCTGATCATACACTGATCACGTGGCTGATTTTGCACTTATCAC
GTGGCTGATCATACAGTGATTACATGAATGATCATGCACTAATCACGTTGTAGATTATGC
ACTGATCACATGACTGTGCATGTATTGATCACGTGGCTGATCATGCAATGAACACGTGGC
TGATCATACACTGATCACATTACTGATCATGCACTATTCACGTGCCTGATCATTCACTGA
TCACGTGGCTGATCATGCACTGATCACGAAGCTGATCATACCCTGATCACATAACTGTGC
ATGCACTGATCACGTGGCTGATCATACACTGGGCACGTGGCTGAACATACTCTGATCACG
TGGCTGATCAGGCACTGATCACGTGGCTGATCATACTCTGAACATGAAGCTGAAAATACA
CTTATCACGTGACCGCATGCACTGATCACATGGCTATCATGCACTGATCACGTGTTTATC
ATGCACTGATCACGTGACTGCACATTAACTGAACACATACCTGTTCATGCACTGTTTACG
TGGCTATCATGCACTGATCACATGGCTGATCATGCACTGATCACAAAGCTGATCATACTC
TGATCACGTGAGTGTGCATGCACTGATCACGTGGCTGATCATGCATTAATCACGTGACTG
ATCATGCACTAATCTCATTGCGTATCATGCACTGATCACATGACGGTGCATGAACTGATC
ACGTGAATATTATACACTGATCAAGTGACAGATCATGTACTAATCACGTGACTGATCATG
CACTGATCACGTGGCTATCATGCACTGATCACGTGGCTGATAATGCACTGATCACTTGAC
TGATCATGCACTAATCACATGTCTGATCATGCACTACTCACGTGACTGATCATGGACTGA
TCACGTGACTGATCATGCACTGATCATGAGCCTGATCATGCACTGATCACGGGCCTGTTC
ATGCACTGATCACGTGGCTGATCCTGCACTGATCACGAGGCTGATCATACACTGATCACG
TGACTGTGCATGCAATGATCACTTGGCTGATCATATACTGATCACGTGGCCGATCATGCA
CTGATAACCTGGCTATCATCCACTGATCACGTGAGTGATCATGCACCCTTCACGTGCATG
ATCATGCACTGATCACGTGTCTTAGCATGCACTAACCATGTTGCTGATCATGCAATGGTC
AGGTGGCTATCATGCACTGTTTACCTGGCTGATCATGCACTGATCACATGGCTGTAATAC
ACTGGCCACTTGACTGTGCATGCACTGATCATGTGGATGATTATACACTGATCACGTGAC
GGATCATGCACTGATCATGTGTCTGATCATGCACTGATAAAGTGCTTGATCATGCACTGA
TCACGTGGCTGAGCATACAGTGATTACATGACTGATCATGCACTAATCACGTTGTAGATC
ATGCACTGATCACGTGACTGATCATGCACTAGTCACGTGGCTATCATGCACTGATCACGT
GGCTGATCATACACTGATCACGTGGCTGATCATGCACTGATCACGTGCCTGATCATGCAC
TGATTGCGTAATTTAGCATGCAGTGATCTCGTGTCTGAATTGTGCTGATCATGTGACTAA
TCAAGAACTGATCACGTGGCTATAATGCACTGATCACGTGACTGCGCACGCATTGAAAAT
ATGGATGACAATACACTGATCACGTCACTGATCAGGCACTGATCACGTGACTGATCATGC
ACTGATCACGTGGCTGATCATGCACTGATCACAAAGCTGATCATACTCTGATCACGTGAG
TGTGCATGCACTGATCACGTGGCTGATCATGCACTGATCACGTGGCTGATCATGCACTGA
TCACGTGGGTGATCATGAACTGATCACGTGGCTTATCATACACTGCTCACGTGGCTGATC
ATGCACTAATCACGTTGTGGATGATGCACTGATCACATGGCTGATCATACACTGATCACG
TGGGTGATAACGAACTGATCAAGTGGCTGATCATACACTGATCACATGAATGATCATGCA
TTAATCACTTTGTGGACCATGCACTGATCACTTGGCTGATCAGGCACTGATCACGTGGCT
GATCATACTCTGAACACGAAGCTGAAAATACAGTGATCACGTGACTGCATGCACTGATCA
CATGGCTATCATGCACTGATCACGTGTCTATCATGGACTGATCACGTGACTGCGCATTAA
CTGAACACATACCTGTTCATGCACTGTTTACGTGGCTATCATGCACTGATCACGTGGCTG
ATCATGCATTGGTCACGTGGCTGATACTGCACTGATCACGTGGCTGATAATGCACTGATC
ACTTGACTGATCATGCACTGATCACGTCTCTGATCATGCACTACTCACGTGACTGATCAT
GGACTGATCACGTGACTGATCATGCACTGATCATGAGCCTGATCATGCACTGATCACGGG
CCTGTTCATGCACTGATCACGTGGCTGATCCTGCACTGATCACGAGGCTGATCATACACT
GATCACGTGACTGTGCATGCAATGATCACTTGGCTGATCATGTACTGATCACGTGGCTGA
TCTTGCACTGATAACCTGGCTATCATCCACTGATCACGTGAGTGATCATGCACTCTTCAC
GTGCATGATCATGCACTGATCACGTGTCTTAGCATGCACTAACCATGTTGCTGATCATGC
AATGATCAGGTGGCTATCATGCACTGTTTACCTGGCTGATCATGCACTGATCACATGGCT
GTAATACACTGGCCACTTGACTGTGCATGCAATGATCATGTGGATGATTATACAGTGATC
ACGTGACTGATCATGCACTGATCATGTGTCTCATCATGCACTGATAAAGTGCTTGATCAT
GCACTGATCACGTGGCTGAGCATACAGTGATTACATGACTGAACATGCACTAATCACGTT
GTGGATCATGCACTGACCACGTGACTGATCATGCACTAGTCACGTGGCTATCATGCACTG
ATCACGTGGCTGATCATACACTGATCACGTGCCTGATCATGCACTGATCACGTGCCTGAT
CATGCACTGATTGCATAACTTAGCATGCAGTGATCTCGTGTCTGAAATGTGCTGATCATG
TGACTAATTAAGAACTGATCACGTGGCTATAATGCACTGATCACATGACTGGGCACGCAC
TGAAAATATGGATGACCATACACTGATCACGTCATTGATCACGCACTGATCACGTGACTG
ATCATGCACTGATCACGAAGCTGATCATACTCTGATCACGTGAATGTGCATGCACTGATC
ACGTGGGTGATTATGAACTGATCACGTGGCTTATCATACACTGCTCACGTGGCTGATCAT
GCACTAATCACGTTGTGGATGATGCACTGATCACGTGGCTGATCATACACTGATCACGTG
GGTGATCATGAACTGATCACGTGGCTGATCATACACTGATCACATGAATGATCATGCACT
AATCACGTTGTGGATCATGCACTGATCACGTGGCTGATCATACACTGATCACGTGGCTGA
TTTTGCACTTATCACGTGGCTGATCATACAGTGATTACATGAATGATCATGCACTAATCA
CGTTGTAGATTATGCACTGATCACATGACTGTGCATGTATTGATCACGTGGCTGATCATG
CAATGAACCCGTGGCTGATCATACACTGATCACATTACTGATCATGCACTATTCACGTGC
CTGATCATTCACTGATCACGTGGCTGATCATGCACTGATCACGAAGCTGATCATACCCTG
ATCACATAACTGTGCATGCACTGATCACGTGGCTGATCATGCACTGATCATGTGGCTGAT
CATACACTGGGCACGTGGCTGAACATACTCTGATCACGTGGCTGATCAGTCACTGATCAC
GTGGCTGATCATACTCTGAACATGAAGCTGAAAATACACTTATCACGTGACCACATGCAC
TGATCACATGGCTATCATGCACTGATCACGTGTTTATCATGCACTGATCACGTGACTGCA
CATTAACTGAACACATACCTGTTCATGCACTGTTTACGTGGCTATCATGCACTGATCACA
TGGCTGATCATGCACTGATCACAAAGCTGATCATACTCTGATCACGTGAGTGTGCATGCA
CTGATCACGTGGCTGATCATGCATTAATCACGTGACTGATCATGCACTATTCTCATTGCG
TATCATGCACTGATCACATGACGGTGCATGAACTGATCACGTGAATATTATACACTGATC
AAGTGATAGATCATGTACTAATCACGTGACTGATCATGCACTGATCACGTGGCTATCATG
CACTGATCACGTGGCTGATAATGCACTGATCACATGACTGATCATGCATTAATCACGTTG
TGGATCATGCACTGATCATATGGCTGATAATACACTGATTACGTGGCTGATCATACACTG
ATCACGTGGCTGATCATGCACTGATCACGTGGCTGATCATACTCTGATCACGTGGATGAT
CATACACTGATCACGTGACTGCATATGCACTGATCACGTGACTGATCAGGCACTGATCAC
GTGGCTATCATGCACTGATAATGTGACTGTGCATGCACTAATCACGTGGATGATTATGCA
CTGATCACGTGGCTGAGCATACAGTGATCACGTGACTGTGCATGAACTGATCACTTGGCT
GATCATGCACTGATCACGTGACTGCACATGCACTGATCACGTGGCTGATCATACTGTGAT
CAAGTGGCTGATAATGCACTGATTACGTGGCTGATCATGCACAGATCACGTAGCTATCAT
GTGCCGATTACATGGCGATCATGCCCTGTCCCGTGGCTGATCATGCACTGATCGCGTGAC
TGATCATGCACTAGTCACTTGGCTATCATGCACTGATCAGGTGGCTGATATGCACTGATC
ACGTGGCTGATATGCACTGATCACGTGGCTGATCATGAACTGATCACGAAGCTGATCATG
CACTGATCACGTGTCTTAGCATGCACTAACCATGTTGCTGATCATGCAATGGTCATGTGG
CTATCATGCACTGTTTACCTGGCTGATCATGCACTGATCACATGGCTGTAATACACTGGC
CACTTGACTGTGCATGCACTGATCATGTGGATGATTATACACTGATCACGTGACGGATCA
TGCACTGATCATGTGTCTGATCATGCACTGATAAAGTGCTTGATCATGCACTGATCACGT
GTCTGAGCATACAGTGATTACATGACTGATCATGCACTAATCACGTGACTGATCATGCAC
TGATCACGTGGCTGATCATGCACTGATCACAAAGCTGATCATACTCTGATCACGTGAGTG
TGCATGCACTGATCACGTGGCTGATCATGCACTGATCACGTGGCTGATCATGCACTGATA
ACGTGGCTTATCATACACTGCTCACGTGTCTGATCATTCACTAATCACGTTGTGGATGAT
GCACTAATCACGTTGTGGATGATGCACTGATCACTTGGCTGATCAGGCACTGATCACGTG
GCTGATCATACTCTGAACACGAAGCTGAAAATACACTGATCACGTGACTGCATGCACTGA
TCACATGGCTATCATGCACTGATCACGTGTCTATCATGGACTGATCACGTGACTGCGCAT
TAACTGAACACATACCTGTTCATGCACTGTTTACGTGGCTTTCATGCACTGATCACGTGG
CTTATCATGCATTGGTCACGTGACTGATCATGCACTGATCACGTTGCGAATCATGCACTG
ATCACATGACGGTGCATGAACTGATCACGTGGATATTATACACTGATCAAGCGACAAATC
ATGCACTAATCACGTGACTGATCATGCACTGATCACGTGGCTATCATGCACTGATCACGT
GGCTGATCATGCACTGATCACGTGGCTGTTCATACAGTGATCACGTGACTGATCATGCAC
TGATCACGTGCCTGATCATGCACTGATCACGAAGCTGATCATACTCCAATCACGTGAGTG
TGCATGCACTGATCACGTGGCTGATCATGCACTAATCACGTTGTGGATGATGCACTGATC
ACGTGGCTGCTCATACACTGATCACATGACTGATCATGAACTAATCACGTTGTGGATCAT
GCACTGATCACGTGGCTGTTCTTGCACTTATCACGTGGCTGATCATACAGTGATTACATG
ACTGATCATGCACTAATCACGTTGTGGATCATGCACTGATCAAATGAATGTGCATGCATT
GATCACGTGGCTGATCATGCACTGATCACGAAGCTGATATTACACTGATCACAGGACTGT
GCATGCACTGATCATGTGGCTGATCATGCACTGATCATGTGGCTGATGATACACTGATCA
CGTGGCTCATCAGGCACTGATCACGTGGCTGATCGTACTCTGAACACGAAGCTTAAAATA
CACTGATCACAAGACTGCATGCACTGATCTCTTGACTGCGCATGCACTGATCACGTGGAT
GATAATACGCTGATCACTTGACTGCTTATGCACTAAAAAAATGGCTGATCATGCACTGAT
CACATGACTGATCATGCACTGATCACGTGACTGATCATGCATAGATCACGTGACTACCAT
GCATTGATCACTTGATTGTGCATGCAATAATCACGTGGATGATCACGCATTTATAATGTG
GCTGATCATGCACTAATCACATGGCGGAACATGAACTGGTCACGTGACTTAGCATGCAGT
GATCTCGTGTCTGAATGGTGCTGATCATGTGACTAAACAAGAACTGATCACGTGGCTATA
ATGCACTGATCACGTGACTGCGCATGCACTGATCATGTGGATGATAATACACTGATGACG
TTACTGATGAGGCACTGATCACATGACTGATCATTCACTGATCACGTGGCTATTATGCAC
TGATCATGGGCCTGCACATGCAGTGTTCACGTAATTGTAGACAATGATCACGTGGCTATC
ATGCACTGATAACGTGTCTATCATGCACCGAACACGTGGCTGATCAAACACTGATCACGT
GGCTGATCATGCACTGAACACGTGGCTGATCAAACACTGATCACGTGGCTGATCATGCAC
TCATCACGTGGCTGATCATACAATGATCACGTGGCTGATCATGCACTGATCACATGTATG
ATCGTACACTGATCACGTGGCTGATCATGCACAAATCCCATTGCATATCATGCTCTGATC
AGGTTGCTATCATGTACTGATCACGTGGCTGATCATACAGTGATCACGTGACTGACCATG
CACTGATCACGTGGCTGATCATGCACTGTTAACCTGGCTATAATACACTGATCTCTTGAC
TGATCATGCATTCTTCACATGCCTGATCATGCACTGATCACGTGGCTGATCTTGCACTGA
TCACGTGGCGGATAATGCACTGATCACTTGACTGATCATGCACTGATCTCATTGCGTATC
ATGCACTGATCACATGACGGTGCATGAACTGATCACGTGAACATTATACACTGATCAAGT
GACAGATCATGTACTAATCACGTGACTGATCATGCACTGATCACGTGGCTATCATGCACT
GATCACGTGGCTGATCTTGCACTGATCACTTGACTGATCATGCACTGATCACGTGTCTGA
TCATGCACTACTCACGTGACTGATCATGGACTGATCACGTGACTGATCATGCACTGATCA
TGAGCCTGATCATGCACTGATCACGGGCCTGTTCATGCACTGATCACGTGGGTGATCCTG
CACTGATCACGAGGCTGATCATACACTGATCACGTGACTGTGCATGCAATGATCACTTGG
CTGATCATGTACTGATCACGTGGCTGATCATGCACTGATCACGTGACTGATTATGCACTG
ATCACATAGCTATCATGCACTGATCACATGACTTCGCATGCCATGATCACGTGACTGATC
ATGCACTGGTCCCGTGGCTATCATGCACTGATAATGTGGCTTATCATACATTGATCACCT
AAATAATCATGCACTGATCACGTGGCAATCTTGCTCTGATCACGTGGTTGATCAGGCACT
GATCACTTAGCTATCATGCACTGATCACATGACTGCGCAAGAACTGATCACTTAGATATC
ATACACAGGACACGTGACAGATCATGCACTGATCACGTGACTGATCATGCACTGATCTGG
TGGCTATCATGCATTGATCACGTGGTTGATCATACACTGATCACATGACTGATCATGCAC
TGATCACCTGGCTATCATGCACTAATCACTTAGCTGATCTGGAACAGATCACGTGACTAA
TCATGCAGTGCTCACGTCGCTATCATGCAATGATCTCCAGATTGCGCATGCACTGATCAT
ATGGATGATCACACACTGATAACGTGACAGATCATGCACTGAACACGTGACTTACCATGC
ACTGATCTCGTGACTGATCATGCATTCCTCACGTGCCTGATCATGCACTGATCACGTGGC
TGATACTGCACTGATCACGTGGCTGATAATGCACTGATCACTTGACTGATCATGCACTGA
TCACGTCTCTGATCATGGACTGATCACGTGACTGATCATGGACTGATCACGTGACTGATC
ATGCACTGATCATGAGCCTGATCATGCACTGATCATGGGCCTGTACATGCACTGATCACG
AGGCTGATCCAGCACTGATCACGTGACTGTGCATGCAATGATCACTTGGCTGATCATGTA
CTGATCACGTGGCTGAACTTGCACTGATCACGTGGCTGATCTTGCACTGATAACCTGGCT
ATCATCCACTGATCACGTGAGTGATCATGCACTCTTCACGTGCATGATCATGCACTGATC
ACGTGTCTTAGCATGCACTAACCATGTTGCTGATCATGCAATGGTCACGTGGCTATCATG
CACTGTTTACCTGGCTGATCATGCACTGATCACATGGCTGTAATACACTGACCACTTGAC
TGTGCATGCACTGATCATGTGGATGATTATACACTGATCACGTGACTGATCATGCACTGA
TCATGTGTCTGATCATGCACTGATAAAGTGGTTGATCATGCACTGATCACGTGGCTGAGC
ATACAGTGATTACATGACTGATCATGCACTAATCACGTTGTGCATCATGCACTGATCACG
TGACTGATCATGCACTAGTCACGTGGTATCATGCACTGATCACGTGGCTGATCATACACT
GATCACGTGCCTGATCATGCACTGATCACGTGCCTGATCATGCACTGATTGCATAACTTA
GCATGCAGTGATCTCGTGTCTGAAATGTGCTGATCATGTGACTAATTAAGAACTGATCAC
GTGGCTATAATGCACTGATCACGTGACTGGGCACGCACTGAAAATATGGATGACCATACA
CTGATCACGTCACTGATCACGCAGTGATCACGTGACTGATCATGCACTGATCACGAAGCT
GATCATACTCTGATCACGTGAGTGTGCATGCACTGATCACGTGGGTGATTATGAAATGAT
CACGTGGCTTATCATACACTGCTCACGTGGCTGATCATGCACTAATTACGTTGTGGATGA
TGCACTGATCACGTGGCTGATCATACACTGATCACGTGGATGATCATGAACTGATCACGT
GGCTGATCATACACTGATCACATGAATGATCATGCACTAATCACGTTGTAGATTATGCAC
TGATCACATGACTGTGCATGTATTGATCACGTGGCTGATCATGCAATGAACACGTGGCTG
ATCATACACTGATCACATTACTGATCATGCACTATTCACGTGCCTGATCATTCACTGATC
ACGTGGCTGATCATCCACTGATCACGAAGCTGATCATACCCTGATCACATAACTGTGCAT
GCACTGATCAGGTGGCTGATCATGCACTGATCATGTGGCTGATCATACACTGGTCACGTG
GCTGCACATACTCTGATCACGTGGCTGATCAGGCACTGATCACGTGGCTGATCATACTCT
GAACATGAAGCTTAAAATACACTGATCACGAGACTGCATGCACTGATCACTTGACTGCGC
ATGCACTGATCACGTGGATGATAATACGCTGATCACTTGACTGCTTATGCACTAAAAAAA
TGGCTGATCATGCACTGATCACATGACTGATCATGCACTGATCACGTGACTGATCATGCA
TAGATCACGTGACTACCATGCACTGATCACTTGATTGTGCATGCAATAATCACGTGGATG
ATCACGCATTTATCATGTGGCTGATCATGCACTAATCACATGGCGGAACATGAACTGATC
ACGTGACTTAGCATGCAGTGATCTCGTGTCTGAATGGTGCTGATCATGTGACTAAACAAG
AACTGATCACGTGGCTATAATGCACTGATCACGTGACTGCGCATGCACTGATCATGTGGA
TGATAATACACTGATGACGTTACTGATGAGGCACTGATCACGTGACTGATCATTCACTGA
TCACGTGGCTATTATGCACTGATCACGGGACTGCACATGCAGTGTTCACGTAATTGTAGA
CAATGATCACGTGGCTATCATGCACTGATAACGTGTCTATCATGCACTGAACACGTGGCT
GATAAAACACTGATCACGTGGCTGATCGTGCACTGAACACGTGGCTGATCAAACACTGAT
CACGTGGCTGATCATGCACTCATCACGTGGCTGATGATACAATGATCACGTGGCTGATCA
TGCACTGATCACATGTATGATCGTACACTGATCACGTGGCTGATCATGCACAAATCCCAT
TGCATATCATGCTCTGATCAGGTTGCTATCATGTACTGATCACGTGGCTGAGCATACAGT
GATCACGTGACTGACCATGCACTGATTACGTGGCTATCATGCACTGATCACGTGGCTGAT
CATGCACTGTTAACCTGGCTATAATACACTGATCTCTTGACTGATCATGCATTCTTCACA
TGCCTGATAATGCACTGATCACATGACGGTGCATGAACTGATCACGTGAACATTATACAC
TGATCAAGTGACAGATCATGTACTAATCACGTGACTGATCATGCACTGATCACGTGGCTA
TCATGCACTGATCAAGTGGCTGATAATGCACTGATCACTTGACTGATCATGCACTGATCA
CGTGTCTGATCATGCACTACTCACGTGACTGATCATGGAGTGATCACGTGACTGATCATG
CACTGATCATGAGCCTGATCATGCACTGATCACGGGCCTGTTCATGCACTGATCACGTGG
CTTATCCTGCACTGATCTCGAGGCTGATCATACACTGATCACGTGACTGTGCATGCAATG
ATTACTTGGCTGATCATGTACTGATCACGTGGCTGATCATGCACTGATCACGTGACTGAT
TATGCACTGATCACATAGCTATCATGCACTGATCACATGACTTCGCATGCCATGATCACG
TGACTGATCATGCACTGGTCTCGTGGCTATCATGCACTGATAATGTGGCTTATCATACAT
TGATCACCTAAATAATCATGCACTGATCACGTGGCAATCTTGCTCTGATCACGTGGTTGA
TCAGGCACTGATCACTTAGCTATCATGTACTGATCACATGACTGCGCAAGAACTGATCAC
TTAGATATCATACACAGGACACGTGACAGATCATGCACTGATCACGTGACTGATCATGCA
CTGATCTGGTGGCTCTCATGCATTGATCACGTGGTTGATCATACACTGATCACGTGACTG
ATCATGCACTGATCACCTGGCTATCGTGCACTAATCACGTAGCTGATCTGGAACGGATCA
CGTGACTAATCATGCAGTGATCACGTCGCTATCATGCAATGATCTCGAGATTGCGCATGC
ACTGATCATATGGATGATCACACACTGATAACGTGACAGATCATGCACTGAACACGTGAC
TTATCATGCACTGATCTCGTGACTGATCATGCATTCCTCACGTGCCTGATCATGCACTGA
ACACGTGGCTGATACTGCACTGATCACGTGGCTGATAATGCACTGATCACTTGACTGATC
ATGCACTGATCACGTCTCTGATCATGCACTACTCACGTGACTGATCATGGACTGATCACG
TGACTGATCATGCACTGATCATTAGCCTGATTATGCACTGATCACGGGCCTGTTCATGCA
CTGATCACGTGGCTGATCCTGCCCTGATCACGAGGCTGATCATACACTGATCACGTGACT
GTGCATGCAATGATCACTTGGCTGATCATGTACTGATTACGTGGCTGAACTTGCACTGAT
AACCTGGCTATCATCCACTGATCACGTGAGTGATCATGCACTCTTCACGTGCATGATCAT
GCACTGATCACGTGTCTTAGCATGCACTAACCATGTTGCTGATCATGCAATGGTCAGGTG
GCTATCATGCACTGTTTACCTGGCTGATTATGCACTGATCACAAGGCTGTAATACACTGA
CCACTTGACTGTGTATGCACTGATCATGTGGATGATTATACACTGATCACGTGACGGATC
ATGCACTGATCATGTGTCTGATCATGCACTGATAAAGTGGTTGATCATGCACTGATCACG
TGGCTGAGCATACAGTGATTACATGACTGATCATGCACTAATCACGTTGTGCATCATGCA
CTGATCACGTGACTGGCCATGCACTAGTCACGCGGCTATCATGCACTGATCACATGGCTG
ATCATGCACTGATTGCATAACTTAGCATGCAGTGATCTCGTGTCTGAAATATGCTGATCA
TGTGACTAATCAAGAACTGATCACGTGGCTATAATGCACTGATCACGTGACTGGGCACGC
ACTGAAAATATGGATGACCATACACTGATCACGTCACTGATCAGGCACTGATCACGTGAC
TGATCATGCACTGAAAACGAAGCTGATCATACTCTGATCACGTGAGTGTGCATGCACTGA
TCACGTGGGTGATTATGAACTGATCACGTGGCTTATCATACACTGCTCACGTGGCTGATC
ATGCACTAATCACGTTGTGGATGATGCACTGATCACGTGGCTGATCATACACTGATCACG
TGGGTGATCATGAACTGATCACGGGGCTGATCATACACTGATCACATGAATGATCATGCA
CTAATCACGTTGTGGATCATGCACTGATCACATGGCTGATCATGCACTGATCACGTGGCT
GATCTTGCACTGATCACGTGGCTGATCGTACAGTGATTACATGAATGATCATGCACTAAT
CACGTTGTAGATTATGCACTGATCACATGACTGTGCATGTATTGATCACGTGGCTGATCA
TGCAATGAACACGTGGCTGATCATACACTGATCACATTACTGATCATGCACTATTCACGT
GCCTGATCATTCACTGATCACGTGGCTGATCATGCACTGATCACGAAGCTGATCATACCC
TGAACACATAACTGTGCATGCACTGATCACGTGGCTGATCATGCACTGATCATGTGGCTG
ATCATACACTGGTCACGTGGCTGAACATATTCTGATCACGTGGCTGATCAGGCACTGATC
ACGTGGCTGATCATACTCTGAACATGAAGCTGAAAATACACTTATCACGTGACCGCATGC
ACTGATCACGTGGCTTATCATGCATTGGTCACGTGACTGATCATGCACTGATCACGTTGC
GAATCATGCACTGATCACATGACGGTGCATGAACTGATCACGTGGATATTATACACTGAT
CAAGCGACAAATCATGCACTAATCACGTGACTGATCATGCACTGATCACGTGGCTATCAT
GCACTGATCACGTGGCTGATCATGCACTGATCACGTGGCTGTTCATACAGTGATCACGTG
ACTGATCATGCACTGATCACGTGCCTGATCATGCACTGATCACGAAGCTGATCATACTCC
AATCACGTGAGTGTGCATGCACTGATCACGTGGCTGATCATGCACTAATCACGTTGTGGA
TGATGCACTGATCACGTGGCTGATCATACACTGATCACATGACTGATCATGAACTAATCA
CGTTGTGGATCATGCACTGATCACGTGGCTGTTCTTGCACTTATCACGTGGCTGATCATA
CAGTGATTACATGACTGATCATGCACTAATCACGTTGTGGATCATGCACTGATCACATGA
ATGTGCATGCATTGATCATGTGGCTGATCATGCACTGATCACGTGGCTGATCATGCACTG
ATCACGAAGCTGATATTACACTGATCACAGGACTGTGCATGTACTGATCATGTGGCTGAT
CATGCACTGATCATGTGGCTGATGATACACTGATCACGTGGCTGATCAGGCACTGATCAC
GTGGCTGATCGTACTCTGAACATGAAGCTTAAAATACAGTGATCACGAGACTGCATGCAC
TGATCACTTGACTGCGCATGCACTGATCACGTGGATGATAATACGCTGATCACTTGACTG
CTTATGCACTAAAAAAATGGCTGATCATGCACTGATCACATGACTGATCATGCACTGATC
ACGTGACTGATCATGCATAGATCACGTGACTACCATGCACTGATCACTTGATTGTGCATG
CAATAATCACGTGGATGATCACGCATTTATCATGTGGCTGATCATGCACTAATCACATGG
CGGAACATGAACTGATCACGTGACTTAGCATGCAGTGATCTCGTGTCTGAATGGTGCTGA
TCATGTGACTAAACAAGAACTGATCACGTGGCTATAATGCACTGATCACGTGACTGCGCA
TGCACTGATGACGTGGCTATCATGCCCTGCTAACTAGGCTGATCATGCAATGATCACATA
GCTACCATGTACTGGTCACGTGACTGATCATGCAATGTTCACGTAATTGATCATGCACTG
ATCACGTGGCTGATCATGCACTGATCGCATGACTGATCATGCACTAGTCACCTGGCTATC
ATGCCTAATCCCGTGGCTGATCATACACTGACCATGTGACTGATCATGCACTGATTTCGT
TGCGTATCATGCACTGATCACATGACGGTGCATGAACCGATCACGTGAATATTATACACT
GATCAAGTGACAGATCATGTACTAATCACGTGACTGATCATGCACTGATCACGTGGCTAT
CATGCACTGATCACGCGGCTGATAATGCACTGATCACTTGACTGATCATGCACTGATCAC
ATGTCTGATTATGCACTACTCACGTGACTGATCATGGACTGATCACGTGGCTGATCATGC
ACTGATCTCGAAGCTGATCATACACTGATCACGTGAGTGTGCATGCAATGATCACATGGC
TGATCATGCACTGATCATGTGGCTGAACATGCTCTGATCCCGTGGGTGATCATGCACTTA
TCACGTGGCTTATCATACACTGATCACGTGGCTGATCATGCACTAATCACGTTGTGGATG
ATGCACTGGTCACGTGGCTGATCATACACTGATCACATGACTGATCATGCATTAATCACG
TTGTGGATCATGCACTGATCATGTGGCTGATAATACACTGATTACGTGGCTGATCATACA
CTGATCACGTGGCTGATCATGCACTGATCACGTGGCTGATCATACTCTGATCACGTGGAT
GATCATACACTGATCACGTGACTGCATATGCACTGATCACGTGACTGATCAGGCACTGAT
CAGGTGGCTATCATGCACTGATTACGTGGCTTATCATACATTAATCACGTAACTAAATAT
GCACTGAACACGAAGCCTATCATACACTTATAATATGACTGTGCATGCACTAATCACGTG
GATGATCATGCACTGATCACGTGGCTGAGCATACAGTGATCACGTGACTGTGCATGAACT
GATCACTTGGCTGATCATGCACAGATCACGTGACTGCACATGCACTGATCACGTGGCTGA
TCATACTGTGATCAAGTGGCTGATAATGCACTGATTACGTGGCTGATCATGCACAGATCA
CGTAGCTATCATGTGCCGATCACATGGCGATCATGCCCTGTCCCGTGGCTGATCATGCAC
TGATCGCGTGACTGATCATGCACTAGTCACTAGGCTATCATGCACTGATCAGGTGGCTGA
TATGCACTGATCACGTGGCTGATATGCACTGATCACGAGGCTGATCATGCACTGATCACG
AAGCTGATCATGCACTGATCACGTGTCTTAGCATGCACTAACCATGTTGCTGATCATGCA
ATGGACAGGTGGCTATCATGCACTGTTTACCTGGCTGATCATGCACTGATCACATGGCTG
TAATACACTGGCCACTTGACTGTGCATGCACTGATCATGTGGATGATTATACACTGATCA
CGTGACTGATCATGCACTGATCATGTGTCTGATCATGCACTGATAAAGTGCTTGATCATG
CACTGATCACGGGGCTGAGCATACAGTGATTACATGACTGATCATGCACTAATCACGTTG
TGGATCATGTACTGATCACGTGACTGATCATGCACTAGTCACGTGGCTATCATGCACTGA
TCACGTGGCTGATCATACACTGATCACGTGGCTGATCATGCACTGATCACGTGCCTGATC
ATGCACTGATTGCGTAATTTAGCATGCAGTGATCTCGTGTCTGAATTGTGCTGATCATGT
GACTAATCAAGAACTGATCACGTGGCTATAATGCACTGATCACGTGACTGCGCACGCACT
GAAAATATGGATGACCATACACTGATCACGTCACTGATCAGGCACTGATCACGTGACTGA
TCATGCACTGATCACGTGGCTGATCATGCACTGATCACCAAGCTGATCATACTCTGATCA
CGTGACTGATCATGCACTGATCACATGGCTGATCATGCACTGATCACGTGGCTGATCATG
CACTGATCACGTGGGTGATCATGAACTGATCACGTGGCTTATCATACACTGCTCACGTGG
CTGATCATGCACTAATCACGTTGTGGATGATGCACTGATCACATGGCTGATCATACACTG
ATCACGTGGGTGATCATGAACTGATCAAGTGGCTGATCATACACTGATCACATGAATGAT
CATGCACTAATCACGTTGTGGACCATGCACTGATCACTTGGCTGATCAGGCACTGATCAC
GTGGCTGATCATACTCTGAACACGAAGCTGAAAATACAGTGATCACGTGACTGCATGCAC
TGATCACATTGCTATCATGCACTGATCACGTGTCTATCATGGACTGATCACGTGACTGGG
CATTAACTGAACACATACCTGTTCATGCACTGTTTACGTGGCTTTCATGCACTGATCACG
TAGCTTAACATGCATTGGTCACGTGACTGATCATGCACTGATCACGTTGCGTATCATGCA
CTGATCACATGACGGCGCATGAACTGATCACGTGGATATTATACACTGATCAAGCGACAA
ATCATGCACTAATCACGTGACTGATCATGCACTGATCACGTGGCTGATCATGCACTGATC
ACGTGGCTGTTCATACAGTGATCACGTGACTGATCATGCACTGATCACGTGCCTGATCAT
GCACTGATCACGAAGCTGATCATACTCCAATCACGTGAGTGTGCATGCACTGATCACGTG
GCTGATCATGCACTAATCACGTTGTGGATGATGCACTGATCACGTGGCTGATCATACACT
GATCACATGACTGATCATGAACTAATCACGTTGTGGATCATGCACTGATCACGTGGCTGT
TCTTGCACTTATCACGTGGCTGATCATACAGTGATTACATGACTGATCATGCACTAATCA
CGTTGTGGATCATGCACTGATCACATGAATGTGCATGCATTGATCATGTGGCTGATCATG
CACTGATCACGTGGCTGATCATGCACTGATCACGAAGCTGATATTACACTGATCACAGGA
CTGTGCATGTACTGATCATGTGGCTGATCATGCACTGATCATGTGGCTGATGATACACTG
ATCACGTGGCTGATCAGGCACTGATCACGTGGCTGATCGTACTCTGAACATGAAGCTTAA
AATACAGTGATCACGAGACTGCATGCACTGATCACTTGACTGCGCATGCACTGATCACGT
GGATGATAATACGCTGATCACTTGACTGCTTATGCACTAAAAAAATGGCTGATCATGCAC
TGATCACATGACTGATCATGCACTGATCACGTGACTGATCATGCATAGATCACGTGACTA
CCATGCACTGATCACTTGATTGTGCATGCAATAATCACGTGGATGATCACGCATTTATCA
TGTGGCTGATCAGGCACTAATCACATGGCGGAACATGAACTGATCACGTGACTTAGCATG
CAGTGATCTCGTGTCTGAATGGTGCTGATCATGTGACTAAACAAGAACTGATCACGTGGC
TATAATGCACTGATCACGTGACTGCGCATGCACTGATGACGTGGCTATCATGCCCTGCTA
ACTAGGCTGATCATGCAATGATCACATAGCTACCATGTACTGGTCACGTGACTGATCATG
CAATGTTCACGTAATTGATCATGCACTGATCACGTGGCTGATCATGCACTGATCGCATGA
CTGATCATGCACTAGTCACCTGGCTATCATGCCTAATCCCGTGGCTGATCATACACTGAC
CATGTGACTGATCATGCACTGATTTCGTTGCGTATCATGCACTGATCACATGACGGTGCA
TGAACCGATCACGTGAATATTATACACTGATCAAGTGACAGATCATGTACTAATCACGTG
ACTGATCATGCACTGATCACGTGGCTATCATGCACTGATCACGCGGCTGATAATGCACTG
ATCACTTGACTGATCATGCACTGATCACATGTCTGATTATGCACTACTCACGTGACTGAT
CATGGACTGATCACGTGGCTGATCATGCACTGATCTCGAAGCTGATCATACACTGATCAC
GTGAGTGTGCATGCAATGATCACATGGCTGATCATGCACTGATCATGTGGCTGAACATGC
TCTGATCCCGTGGGTGATCATGCACTTATCACGTGGCTTATCATACACTGATCACGTGGC
TGATCATGCACTAATCACGTTGTGGATGATGCACTGGTCACGTGGCTGATCATACACTGA
TCACATGACTGATCATGCATTAATCACGTTGTGGATCATGCACTGATCATGTGGCTGATA
ATACACTGATTACGTGGCTGATCATACACTGATCACGTGGCTGATCATGCACTGATCACG
TGGCTGATCATACTCTGATCACGTGGATGATCATACACTGATCACGTGACTGCATATGCA
CTGATCACGTGACTGATCAGGCACTGATCAGGTGGCTATCATGCACTGATTACGTGGCTT
ATCATACATTAATCACGTAACTAAATATGCACTGAACACGAAGCCTATCATACACTTATA
ATATGACTGTGCATGCACTAATCACGTGGATGATCATGCACTGATCACGTGGCTGAGCAT
ACAGTGATCACGTGACTGTGCATGAACTGATCACTTGGCTGATCATGCACAGATCACGTG
ACTGCACATGCACTGATCACGTGGCTGATCATACTGTGATCAAGTGGCTGATAATGCACT
GATTACGTGGCTGATCATGCACAGATCACGTAGCTATCATGTGCCGATCACATGGCGATC
ATGCCCTGTCCCGTGGCTGATCATGCACTGATCGCGTGACTGATCATGCACTAGTCACTA
GGCTATCATGCACTGATCAGGTGGCTGATATGCACTGATCACGTGGCTGATATGCACTGA
TCACGAGGCTGATCATGCACTGATCACGAAGCTGATCATGCACTGATCACGTGTCTTAGC
ATGCACTAACCATGTTGCTGATCATGCAATGGACAGGTGGCTATCATGCACTGTTTACCT
GGCTGATCATGCACTGATCACATGGCTGTAATACACTGGCCACTTGACTGTGCATGCACT
GATCATGTGGATGATTATACACTGATCACGTGACTGATCATGCACTGATCATGTGTCTGA
TCATGCACTGATAAAGTGCTTGATCATGCACTGATCACGGGGCTGAGCATACAGTGATTA
CATGACTGATCATGCACTAATCACGTTGTGGATCATGTACTGATCACGTGACTGATCATG
CACTAGTCACGTGGCTATCATGCACTGATCACGTGGCTGATCATACACTGATCACGTGGC
TGATCATGCACTGATCACGTGCCTGATCATGCACTGATTGCGTAATTTAGCATGCAGTGA
TCTCGTGTCTGAATTGTGCTGATCATGTGACTAATCAAGAACTGATCACGTGGCTATAAT
GCACTGATCACGTGACTGCGCACGCACTGAAAATATGGATGACCATACACTGATCACGTC
ACTGATCAGGCACTGATCACGTGACTGATCATGCACTGATCACGTGGCTGATCATGCACT
GATCACCAAGCTGATCATACTCTGATCACGTGACTGATCATGCACTGATCACATGGCTGA
TCATGCACTGATCACGTGGCTGATCATGCACTGATCACGTGGGTGATCATGAACTGATCA
CGTGGCTTATCATACACTGCTCACGTGGCTGATCATGCACTAATCACGTTGTGGATGATG
CACTGATCACATGGCTGATCATACACTGATCACGTGGGTGATCATGAACTGATCAAGTGG
CTGATCATACACTGATCACATGAATGATCATGCACTAATCACGTTGTGGACCATGCACTG
ATCACTTGGCTGATCAGGCACTGATCACGTGGCTGATCATACTCTGAACACGAAGCTGAA
AATACAGTGATCACGTGACTGCATGCACTGATCACATTGCTATCATGCACTGATCACGTG
TCTATCATGGACTGATCACGTGACTGGGCATTAACTGAACACATACCTGTTCATGCACTG
TTTACGTGGCTTTCATGCACTGATCACGTAGCTTATCATGCATTGGTCACGTGACTGATC
ATGCACTGATCACGTTGCGTATCATGCACTGATCACATGACGGCGCATGAACTGATCACG
TGGATATTATACACTGATCAAGCGACAAATCATGCACTAATCACGTGACTGATCATGCAC
TGATCACGTGGCTGATCATGCACTGATCACGTGGCTGTTCATACAGTGATCACGTGACTG
ATCATGCACTGATCACGTGCCTGATCATGCACTGATCACGAAGCTGATCATACTCCAATC
ACGTGAGTGTGCATGCACTGATCACGTGGCTGATCATGCACTAATCACGTTGTGGATGAT
GCACTGATCACGTGGCTGATCATACACTGATCACATGACTGATCATGAACTAATCACGTT
GTGGATCATGCACTGATCACGTGGCTGTTCTTGCACTTATCACGTGGCTGATCATACAGT
GATTACATGACTGATCATGCACTAATCACGTTGTGGATCATGCACTGATCACATGAATGT
GCATGCATTGATCATGTGGCTGATCATGCACTGATCACGTGGCTGATCATGCACTGATCA
CGAAGCTGATATTACACTGATCACAGGACTGTGCATGTACTGATCATGTGGCTGATCATG
CACTGATCATGTGGCTGATGATACACTGATCACGTGGCTGATCAGGCACTGATCACGTGG
CTGATCGTACTCTGAACATGAAGCTTAAAATACAGTGATCACGAGACTGCATGCACTGAT
CACTTGACTGCGCATGCACTGATCACGTGGATGATAATACGCTGATCACTTGACTGCTTA
TGCACTAAAAAAATGGCTGATCATGCACTGATCACATGACTGATCATGCACTGATCACGT
GACTGATCATGCATAGATCACGTGACTACCATGCACTGATCACTTGATTGTGCATGCAAT
AATCACGTGGATGATCACGCATTTATCATGTGGCTGATCATGCACTAATCACATGGCGGA
ACATGAACTGATCACGTGACTTAGCATGCAGTGATCTCGTGTCTGAATGGTGCTGATCAT
GTGACTAAACAAGAACTGATCACGTGGCTATAATGCACTGATCACGTGACTGCGCATGCA
CTGATCATGTGGATGATAATACACTGATGACGTTACTGATGAGGCACTGATCACGTGACT
GATCATTCACTGATCACGTGGCTATTATGCACTGATCACGGGACTGCACATGCAGTGTTC
ACGTAATTGTAGACAATGATCACGTGGCTATCATGCACTGATAACGTGTCTATCATGCAC
TGAACACGTGGCTGATCAAATACTGATCACGTGGCTGATCGTGCACTGAACACGTGGCTG
ATCAAACACTGATCACGTGGCTGATCATGCACTCATCACGTGGCTGATGATACAATGATC
ACGTGGCTGATCATGCACTGATCACATGTATGATCGTACACTGATCACGTGGCTGATCAT
GCACAAATCCCATTGCATATCATGCTCTGATCAGGTTGCTATCATGTACTGATCACGTGG
CTGAGCATACAGTGATCACGTGACTGACCATGCACTGATTACGTGGCTATCATGCACTGA
ACACGTGGCTGATCATGCACTGTTAACCTGGCTATAATACACTGATCTCTTGACTGATCA
TGCATTCTTCACATGCCTGATCATGCACTGATCACGTGGCTGATCTTGCACTGATCACGT
GGCTGATAATGCACTGATCACTTGACTGATCATGCACTAATCTCGTTGTGTATCATGCAC
TGATCACATGACGGTGCATGAACTGATCACGTGAACATTATACACTGATCAAGTGACAGA
TCATGTACTAATCACGTGACTGATCATGCACTGATCACGTGGCTATCATGCACTGATCAC
GTGGCTGATAATGCACTGATCACTTGACTGATCATGCACTGATCACGTGTCTGATCATGC
ACTACTCACGTGACTGATCATGGACTGATCACGTGACTGATCATGCACTGATCATGAGCC
TGATCATGCACTGATCACGGGCCTGTTCATGCACTGATCACGTGGCTGATCCTGCACTGA
TCTCGAGGCTGATCATACACTGATCACGTGACTGTGCATGCAATGATTACTTGGCTGATC
ATGTACTGATCACGTGGCTGATCATGCACTGATCACGTGACTGATTATGCACTGATCACA
TAGCTATCATGCACTGATCACATGACTTCGCATGCCATGATCACGTGACTGATCATGCAC
TGGTCCCATGGCTATCATGCACTGATAATGTGGCTTATCATACATTGATCACCTAAATAA
TCATGCACTGATCACGTGGCAATCTTGCTCTGATCACGTGGTTGATCAGGCACTGATCAC
TTAGCTATCATGCACTGATCACATGACTGCGCAAGAACTGATCACTTAGATATCATACAC
AGGACACGTGACAGATCATGCACTGATCACGTGACTGATCATGCACTGATCTGGTGGCTA
TCATGCATTGATCACGTGGTTGATCATACACTGATCACGTGACTGATCATGCACTGATCA
CCTGGCTATCGTGCACTAATCACGTAGCTGATCTGGAACGGATCACGTGACTAATCATGC
AGTGATCACGTCGCTATCATGCAATGATGTCGAGATTGCGCATGCACTGATCATATGGAT
GATCACACACTGATCACGTGACAGATCATGCACTGAACACGTGACTTACCATGCACTGAT
CTCGTGACTGATCATGCATTCCTCACGTGCATGATCATGCACTGAACACGTGGCTGATAC
TGCACTGATCACGTGGCTGATAATGCACTGATCACTTGACTGATCATGCACTGATCACGT
CTCTGATCATGCACTACTCACGTGACTGATCATGGACTGATCACGTGACTGATCATGCAC
TGATCATGAGCCTGATTATGCACTGATCACGGGCCTGTTCATGCACTGATCACGTGGCTG
ATCCTGCCCTGATCACGAGGCTGATCATACACTGATCACGTGACTGTGCATGCAATGATC
ACTTGGCTGATCATGTACTGATTACGTGGCTGAACTTGCACTGATAACCTGGCTATCATC
CACTGATCACGTGAGTGATCATGCACTCTTCACGTGCATGATCATGCACTGATCACGTGT
CTTAGCATGCACTAACCATGTTGCTGATCATGCAATGGTCAGGTGGCTATCATGCACTGT
TTACCTGGCTGATCATGCACTGATCACATGGCTGTAATACACTGACCACTTGACTGTGTA
TGCACTGATCATGTGGATGATTATACACTGATCACGTGACTGATCATGCACTGATCATGT
GTCTGATCATGCACTGATAAAGTGGTTGATCATGCACTGATCACGTGGCTGAGCATACAG
TGATTACATGACTGATCATGCACTAATCACGTTGTGCATCATGCACTGATCACGTGACTG
ATCATGCACTAGTCACGCGGCTATCATGCACTGATCACGTGGCTGATCATACACTGATCA
CGTGCCTGATCATGCACTGATTGCATAACTTAGCATGCAGTGATCTCGTGTCTGAAATAT
GCTGATCATGTGACTAATCAAGAACTGATCACGTGGCTATAATGCACTGATCACGTGACT
GCACATGCACTGATCACGTGGCTGATCATACTGTGATCAAGTGGCTGATAATGCACTGAT
TACGTGGCTGATCATGCACAGATCACGTAGCTATCATGTGCCGATCACATGGCGATCATG
CCCTGTCCCGTGGCTGATCATGCACTGATCGCGTGACTGATCATGCACTAGTCACTAGGC
TATCATGCACTGATCAGGTGGCTGATATGCACTGATCACGTGGCTGATATGCACTGATCA
CGAGGCTGATCATGCACTGATCACGAAGCTGATCATGCACTGATCACGTGTCTTAGCATG
CACTAACCATGTTGCTGATCATGCAATGGACAGGTGGCTATCATGCACTGTTTACCTGGC
TGATCATGCACTGATCACATGGCTGTAATACACTGGCCACTTGACTGTGCATGCACTGAT
CATGTGGATGATTATACACTGATCACGTGACTGATCATGCACTGATCATGTGTCTGATCA
TGCACTGATAAAGTGCTTGATCATGCACTGATCACGGGGCTGAGCATACAGTGATTACAT
GACTGATCATGCACTAATCACGTTGTGGATCATGTACTGATCACGTGACTGATCATGCAC
TAGTCACGTGGCTATCATGCACTGATCACGTGGCTGATCATACACTGATCACGTGGCTGA
TCATGCACTGATCACGTGCCTGATCATGCACTGATTGCGTAATTTAGCATGCAGTGATCT
CGTGTCTGAATTGTGCTGATCATGTGACTAATCAAGAACTGATCACGTGGCTATAATGCA
CTGATCACGTGACTGCGCACGCACTGAAAATATGGATGACCATACACTGATCACGTCACT
GATCAGGCACTGATCACGTGACTGATCATGCACTGATCACGTGGCTGATCATGCACTGAT
CACCAAGCTGATCATACTCTGATCACGTGACTGATCATGCACTGATCACATGGCTGATCA
TGCACTGATCACGTGGCTGATCATGCACTGATCACGTGGGTGATCATGAACTGATCACGT
GGCTTATCATACACTGCTCACGTGGCTGATCATGCACTAATCACGTTGTGGATGATGCAC
TGATCACATGGCTGATCATACACTGATCACGTGGGTGATCATGAACTGATCAAGTGGCTG
ATCATACACTGATCACATGAATGATCATGCACTAATCACGTTGTGGACCATGCACTGATC
ACTTGGCTGATCAGGCAGTGATCACGTGGCTGATCATACTCTGAACACGAAGCTGAAAAT
ACAGTGATCACGTGACTGCATGCACTGATCACATTGCTATCATGCACTGATCACGTGTCT
ATCATGGACTGATCACGTGACTGGGCATTAACTGAACACATACCTGTTCATGCACTGTTT
ACGTGGCTTTCATGCACTGATCACGTAGCTTAACATGCATTGGTCACGTGACTGATCATG
CACTGATCACGTTGCGTATCATGCACTGATCACATGACGGCGCATGAACTGATCACGTGG
ATATTATACACTGATCAAGCGACAAATCATGCACTAATCACGTGACTGATCATGCACTGA
TCACGTGGCTGATCATGCACTGATCACGTGGCTGTTCATACAGTGATCACGTGACTGATC
ATGCACTGATCACGTGCCTGATCATGCACTGATCACGAAGCTGATCATACTCCAATCACG
TGAGTGTGCATGCACTGATCACGTGGCTGATCATGCACTAATCACGTTGTGGATGATGCA
CTGATCACGTGGCTGATCATACACTGATCACATGACTGATCATGAACTAATCACGTTGTG
GATCATGCACTGATCACGTGGCTGTTCTTGCACTTATCACGTGGCTGATCATACAGTGAT
TACATGACTGATCATGCACTAATCACGTTGTGGATCATGCACTGATCACATGAATGTGCA
TGCATTGATCATGTGGCTGATCATGCACTGATCACGTGGCTGATCATGCACTGATCACGA
AGCTGATATTACACTGATCACAGGACTGTGCATGTACTGATCATGTGGCTGATCATGCAC
TGATCATGTGGCTGATGATACACTGATCACGTGGCTGATCAGGCACTGATCACGTGGCTG
ATCGTACTCTGAACATGAAGCTTAAAATACAGTGATCACGAGACTGCATGCACTGATCAC
TTGACTGCGCATGCACTGATCACGTGGATGATAATACGCTGATCACTTGACTGCTTATGC
ACTAAAAAAATGGCTGATCATGCACTGATCACATGACTGATCATGCACTGATCACGTGAC
TGATCATGCATAGATCACGTGACTACCATGCACTGATCACTTGATTGTGCATGCAATAAT
CACGTGGATGATCACGCATTTATCATGTGGCTGATCATGCACTAATCACATGGCGGAACA
TGAACTGATCACGTGACTTAGCATGCAGTGATCTCGTGTCTGAATGGTGCTGATCATGTG
ACTAAACAAGAACTGATCACGTGGCTATAATGCACTGATCACGTGACTGCGCATGCACTG
ATCATGTGGATGATAATACACTGATGACGTTACTGATGAGGCACTGATCACGTGACTGAT
CATTCACTGATCACGTGGCTATTATGCACTGATCACGGGACTGCACATGCAGTGTTCACG
TAATTGTAGACAATGATCACGTGGCTATCATGCACTGATAACGTGTCTATCATGCACTGA
ACACGTGGCTGATCAAATACTGATCACGTGGCTGATCGTGCACTGAACACGTGGCTGATC
AAACACTGATCACGTGGCTGATCATGCACTCATCACGTGGCTGATCATACAATGATCACG
TGGCTGATCATGCACTGATCACATGTATGATCGTACACTGATCACGTGGCTGATCATGCA
CAAATCCCATTGCATATCATGCTCTGATCAGGTTGCTATCATGTACTGATCACGTGGCTG
AGCATACAGTGATCACGTGACTGACCATGCACTGATTACGTGGCTATCATGCACTGAACA
CGTGGCTGATCATGCACTGTTAACCTGGCTATAATACACTGATCTCTTGACTGATCATGC
ATTCTTCACATGCCTGATCATGCACTGATCACGTGGCTGATCTTGCACTGATCACGTGGC
TGATAATGCACTGATCACTTGACTGATCATGCACTAATCTCGTTGTGTATCATGCACTGA
TCACATGACGGTGCATGAACTGATCACGTGAACATTATACACTGATCAAGTGACAGATCA
TGTACTAATCACGTGACTGATCATGCACTGATCACGTGGCTATCATGCACTGATCACGTG
GCTGATAATGCACTGATCACTTGACTGATCATGCACTGATCACGTGTCTGATCATGCACT
ACTCACGTGACTGATCATGGACTGATCACGTGACTGATCATGCACTGATCATGAGCCTGA
TCATGCACTGATCACGGGCCTGTTCATGCACTGATCACGTGGCTGATCCTGCACTGATCT
CGAGGCTGATCATACACTGATCACGTGACTGTGCATGCAATGATTACTTGGCTGATCATG
TACTGATCACGTGGCTGATCATGCACTGATCACGTGACTGATTATGCACTGATCACATAG
CTATCATGCACTGATCACATGACTTCGCATGCCATGATCACGTGACTGATCATGCACTGG
TCCCATGGCTATCATGCACTGATAATGTGGCTTATCATACATTGATCACCTAAATAATCA
TGCACTGATCACGTGGCAATCTTGCTCTGATCACGTGGTTGATCAGGCACTGATCACTTA
GCTATCATGCACTGATCACATGACTGCGCAAGAACTGATCACTTAGATATCATACACAGG
ACACGTGACAGATCATGCACTGATCACGTGACTGATCATGCACTGATCTGGTGGCTATCA
TGCATTGATCACGTGGTTGATCATACACTGATCACGTGACTGATCATGCACTGATCACCT
GGCTATCGTGCACTAATCACGTAGCTGATCTGGAACGGATCACGTGACTAATCATGCAGT
GATCACGTCGCTATCATGCAATGATGTCGAGATTGCGCATGCACTGATCATATGGATGAT
CACACACTGATCACGTGACAGATCATGCACTGAACACGTGACTTACCATGCACTGATCTC
GTGACTGATCATGCATTCCTCACGTGCATGATCATGCACTGATCACGTGGCTGATAATGC
ACTGATCACTTGACTGATCATGCACTGATCACGTCTCTGATCATGCACTACTCACGTGAC
TGATCATGGACTGATCACGTGACTGATCATGCACTGATCATGAGCCTGATTATGCACTGA
TCACGGGCCTGTTCATGCACTGATCACGTGGCTGATCCTGCCCTGATCACGAGGCTGATC
ATACACTGATCACGTGACTGTGCATGCAATGATCACTTGGCTGATCATGTACTGATTACG
TGGCTGAACTTGCACTGATAACCTGGCTATCATCCACTGATCACGTGAGTGATCATGCAC
TCTTCACGTGCATGATCATGCACTGATCACGTGTCTTAGCATGCACTAACCATGTTGCTG
ATCATGCAATGGTCAGGTGGCTATCATGCACTGTTTACCTGGCTGATCATGCACTGATCA
CATGGCTGTAATACACTGACCACTTGACTGTGTATGCACTGATCATGTGGATGATTATAC
ACTGATCACGTGACTGATCATGCACTGATCATGTGTCTGATCATGCACTGATAAAGTGGT
TGATCATGCACTGATCACGTGGCTGAGCATACAGTGATTACATGACTGATCATGCACTAA
TCACGTTGTGCATCATGCACTGATCACGTGACTGATCATGCACTAGTCACGCGGCTATCA
TGCACTGATCACGTGGCTGATCATACACTGATCACGTGCCTGATCATGCACTGATTGCAT
AACTTAGCATGCAGTGATCTCGTGTCTGAAATATGCTGATCATGTGACTAATCAAGAACT
GATCACGTGGCTATAATGCACTGATCACGTGACTGGGCACGCACTGAAAATATGGATGAC
CATACACTGATCACGTCACTGATCAGGCACTGATCACGTGACTGATCATGCACTGATCAC
GAAGCTGATCATACTCTGATCACGTGAGTGTGCATGCACTGATCACGTGGGTGATTATGA
ACTGATCACGTGGCTTATCATACACTGCTCACGTGGCTGATCATGCACTAATCACGTTGT
GGATGATGCACTGATCACGTGGCTGATCATACACTGATCACGTGGGTGATCATGAACTGA
TCACGGGGCTGATCATACACTGATCACATGAATGATCATGCACTAATCACGTTGTGGATC
ATGCACTGATCACATGGCTGATCATGCACTGATCACGTGGCTGATCTTGCACTTATCACG
TGGCTGATCGTACAGTGATTACATGAATGATCATGCACTAATCACGTTGTAGATTATGCA
CTGATCACATGACTGTGCATGTATTGATCACGTGGCTGATCATGCAATGAACACGTGGCT
GATCATACACTGATCACATTACTGATCATGCACTATTCACGTGCCTGATCATTCACTGAT
CACGTGGCTGATCATGCACTGATCACGAAGCTGATCATACCCTGATCACATAACTGTGCA
TGCACTGATCACGTGGGTGATCATGCACTGATCATGTGGCTGATCATACACTGGGCACGT
GGCTGAACATATTCTGATCACGTGGCTGATCAGGCACTGATCACGTGGCTGATCATACTC
TGAACATGAAGCTGAAAATACACTTATCACGTGACCGCATGCACTGATCACATGGCTATC
ATGCACTGATCACGTGTTTATCATGCACTGATCACGTGACTGCACATTAACTGAACACAT
ACCTGTTCATGCACTGTTTACGTGGCTATCATGCACTGATCACATGGCTGATCATGCACT
GATCACAAAGCTGATCATACTCTGATCACGTGAGTGTGCATGCACTGATCACGTGGCTGA
TCATGCATTAATCACGTGACTGATCATGCACTAATCTCATTGCGTATCATGCACTGATCA
CATGACGGTGCATGAACTGATCACGTGAATATTATACACTGATCAAGTGACAGATCATGT
ACTAATCACGTGACTGATCATGCACTGATCACGTGGCTATCATGCACTGATCACGTGGCT
GATAATGCACTGATCACTTGACTGATCATGCACTAATCACATGTCTGATCATGCACTACT
CACGTGACTGATCATGGACTGATCACGTGACTGATCATGCACTGATCATGAGCCTGATCA
TGCACTGATCACGGGCCTGTTCATGCACTGATCACGTGGCTGATCATGCACTAATCACGT
TGTGGATGATGCACTTATCACGAGGCTGATCATACACTGATCACGTGACTGTGCATGCAA
TGATCACTTGGCTGAACATATACTGATCACGTGGCCGATCATGCACTGATAACCTGGCTA
TCATCCACTGATCACGTGAGTGATCATGCACCCTTCACATGCATGATCATGCACTGATCA
CGTGTCTTAGCATGCACTAACCATGTTACTGATCATGCAATGGTCAGGTGGCTCTCATGC
ACTGTTTACCTGGCTGATCATGCACTGATCACATGGCTGTAATACACTGGCCACTTGACT
GTGCATGCACTGATCATGTGGATGATTATACACTGATCACGTGACTGATCATGCACTGAT
CATGTGTCTGATCATGCACTGATAAAGTACTTGATCATGCACTGATCACGTGGCTGAGCA
TACAGTGATTACATGACTGATCATGCACTAATCACGTTGTAGATCATGCACTGATCACGT
GACTGATCATGCACTAGTCACGTGGCTATCATGCACTGATCACGTGGCTGATCATACACT
GATCACGTGGCTGATCATGCACTGATCACGTGCCTGATCATGCACTGATTGCGTAATTTA
GCATGCAGTGATCTCGTGTCTGAATTGTGCTGATCATGTGACTAATCAAGAACTGATCAC
GTGGCTATAATGCACTGATCACGTGACTGCACACGCATTGAAAATACGGATGACCATACA
CTGATCACGTCACTGATCAGGCACTGATCACGTGACTGATCATGCACTGATCACGTGGCT
GATCATGCACTGATCACAAAGCTGATCATACTCTGATCACGTGAGTGTGCATGCACTGAT
CACGTGGCTGATCATGCACTGATCACGTGGCTGATCATGCACTGATCACGTGGGTGATCA
TGAACTGATCACGTGGCTTATCATACACTGCTCACGTGGCTGATCATGCACTAATCACGT
TGTGGATGATGCACTGATCACATGGCTGATCATACACTGATCACGTGGGTGATAATGAAC
TGATCAAGTGGCTGATCATACACTGATCACATGAATGATCATGCACTAATCACTTTGTGG
ACCATGCACTGATCACTTGGCTGATCAGGCACTGATCACGTGGCTGATCATACTCTGAAC
ACGAAGCTGAAAATACAGTGATCACGTGACTGCATGCACTGATCACATGGCTATCATGCA
CTGATCACGTGTCTATCATGGACTGATCACGTGACTGCGCATTAACTGAACACATACCTG
TTCATGCACTGTTTAGGTGGCTTTCCTGCACTGATCACGTGGCTTATCATGCATTGGTCA
CGTGACTGATCATGCACTGATCACGTTGCGTATCATGCACTGATCACATGACGGCGCATG
AACTGATCACGTGGATATTATACACTGATCAAGCGACAAATCATGCACTAATCACGTGAC
TGATCATGCACTGATCACGTGGCTATCATGCACTGATCACGTGGCTGATCATGCACTGAT
CACGTGGCTGTTCATACAGTGATCACGTGGCTGATCATGCACTGATCACATGACTGATCA
TGAACTAATCACGTTGTGGATCATGCACTGATCACATGAATGTGCATGCATTGATCATGT
GGTTGATCATGCACTGATCACGTGGCTGATCATGCACTGATCACGAAGCTGATATTACAC
TGATCACAGGACTGTGCATGCACTGATCATGTGGCTGATCATGCACTGATCATGTGGCTG
ATGATACACTGATCACGTGGCTGATCAGGCACTGATCACGTGGCTGATCGTACTCTGAAC
ACGAAGCTTAAAATACACTGATCACGAGACTGCATGCACTGATCACTTGACTGCGCATGA
ACTGATCACGTGGATATCATACACTGATCAAGTGACAGATCATGCACTGATCAGTTGACT
GATCATGCACTGATCACGTGGCTATCATGCACTGATCACGTGCCTGATCATGCCCTAATC
AGGTTGTGGATCATGCACTGATCACGTGGCTGATCATACACAGCTCAAGGAAGTGATCAT
GCAATGATCACGTGGCTATCATGCACTGCTCACGTGGTTGATCATGCAATGTTCACGTAG
CTACAATGTACTGGTCACGTGACTGATCATGCACTGATCACGAAATTGATCATGCACTGT
TCACGTGGATCATCATGCACTGATCACGTGACTGTTCATGCACTGATCACGTGACTGATC
ATGCACTGATCACGTGGCTATCATGCACTGATCACGTGGCTGATCATACACTGATCACGT
GCCTGGTCATGCACAGATCACGTGACTAATCATGAACTGATCACGTGGCTATAATGCAAT
GATCACGTGGATATCATACACTGATCCCGTGCCTGTCATGCACAGATCACGTGACTAATC
ATGAACTGATCACGTGGGTATCAGGCACTGATCACGTGGATATCATGCACTGCTCACGTG
GCTGAACATGCAATGATCACGTAGCTACCATGTACTGGTCACGTGACTGATCATGCACTG
ATCACGTAATTGATCATGCACTGATCACGTGGCTGATCATGCACTGATCATGTGACTGAT
CATGCACTGATCACGTGACTGATCTCATGCACTGATCATGTGACTGATCATGCACTGATC
ACGTGACTGATCATGCACTGATCACGTGGTTATCATGCACTGATCACTTGGCTGATCATA
CACTGATCGCGTGCCTGATCATTCACAGATCACGTGATTAATCATGAACTGATCACGTGG
CTATCCTGCACTGATCACGTGTATATGACACACTGATCACGTGGATGATCATACCCCTAT
CACGTGACTGATCATGATAATGCACTGATCACGTGGCTGATCCTACACTGACCATATGGC
GGATTATGCACTGATCACGTGGCTGATCATGCACTGATCACGTGGCTGATCATGCACTGA
TCACGTGGCTGATCATGCACTGATCACGTGGATGATCCTGCAATGATCACGTGACTGAAT
ATGAACTGATTGCGTAGCTATCATGCACTGATCGCATGACTTCGCATGCCATGATCACGT
GACTGATCATGCACTGATCAGGTGGCTATCATGCACTGATCACGTGGCTAATCATACATT
GATCACGTAACTAACCATGCACTGATCACTTGACAATCTTGCACTGATCACGTGGCTGAT
CACGCACTGATCACGTAGTTATCATGCACTGATCACATGACTGCGCATGAACTGATCACG
TGGATATCATACACTGATCAAGTGACAGATCATGCACTGCTCAGTTGACTGATCATGCAC
TGATCACGTGGCTATCATGCACTGATCACGTGCCTGATCATGCACTAATCAGGTTGTGGA
TCATGCACTGATCACGTGGCTGATCATACACAGCTCAAGGAAGTGATCATGCAATGATCA
CGTGGCTATCATGCACGGCTCACGTGGTTGATCCTGCAATGGTCACGTAGCTACAATGTA
CTGGTCACGTGACTGATCATGCACTGATCACGAAATTGATCATGCACTGTTCACGTGGAT
CATCATGCACTGATCACGTGACTGGTCATGCACTGATCACGTGACTGATCATGCACTGAT
CACGTGGCTATCATGCACTGATCACGTGGCTGATCATACACTGATCACGTGCCTGGTCAT
GCACAGATCACGTGACTAATCATGAACTGATCACGTGGCTATAATGCAATGATCACGTGG
ATATCATACACTGATCACGTGCCTGTCATGCACAGATCACGTGACTAATCATGAACTGAT
CACGTGGGTATCAGGCACTGATCACGTGGATATCATGCACTGCTCACGTGGCTGAACATG
CAATGATCACGTAGCTACCATGTACTGGTCACGTGACTGATCATGCACTGATCTCGTAAT
TGATCATGCACTGACCACGTGACTGATCATGCACTGATGACGTGGCTATCATGCCCTGCT
CACTAGGCTGATCATGCAATGATCACATAGCTACCATGTACTGGTCACGTGACTGATCAT
GCAATGATCACGTGGTTATCATGCACTGATCACGTGGCTGATCATGCGCTGATCGTGTGA
CTGATCACGCACTGATCAAGTGACTGATCATGCACTGATCACGTGGTTATCATGCACTGA
TCACGTGGCTGATCATACACTGATCGAGTGCCTGATCATTCACAGATCACGTGATTAATC
ATGAACTGATCACCTGGCTATCCTGCACTGATCACGTGGATATCACACACTGATCACGTG
GATGATCATACCCCTATCACGTGACTGATCATGATAATGCACTGATCACTTGGCTGATCC
TACACTGATCATATGGCTGATTATGCACTGATCACGTGGCTGATCATGCACTGATCACAT
GGCTGATCATACACTGATCGCGTGCCTGATCATTCACAGATCACGTGATTAATCATGAAC
TGATTACATGGCTATCCTGCACTGATCACGTGGAAATGACACACTGATCACGTGGATGGT
CATACCCCTATCACGTGACTGATCATGATAATGCACTGATCACGTGGTTGATCCTACACT
GATCATATGGCTGATTATGCACTGATCACGTGGCTGATCATGCACTGATCACATGACTGC
GCATGAACTGATCACGTGGATATCATACACTGATCAAGTGACAGATCATGCACTGCTCAG
TTGACTGATCATGCACTGAACACGTGGCAATCATGCACTGACCACGTGCCTGATCATGCA
CTAATCAGGTTGTGGATCATGCACTGATCACGTGGCTGATCATACACAGCTCAAGGAAGT
GATCATGCAATGATCACGTGGCTATCATGCACTGATCACGTGGCTGATCCTACACTGATC
ATATGGCTGATTATGCACTGATCACGTGGCTGATCATGCACTGATCACATGACTGCGCAT
GAACTGATCACGTGGATATCATACACTGATCAAGTGACAGATCATGCACTGATCACGTGG
TTATCATGCACTGATCACGTGGCTGATCATACACTGATCACGTGCCTGATCATTCACAGA
TCACGTGATTAATCATGAACTGATCACGTGACTATCCTGCACTAATCACGTGGATATCAC
ACACTGATCACTTGGATGATCATACCCCTATCACGTGACTGATCATGTTAATGCACTGAT
CACGTGGCTGATCATGCACTGATCACGTGGCTGATCATGCACTGATCACGTGGCTGATCC
TACACTGATCATATGGCTGATCATGCACTGATCACGTACATGATCATGCACTGATCATTT
GGCTGATCATACACTGATCTTGTGACTGCGCATGCACTGATCACGTGACTAATCTTTCAC
TGATCACATGGCTATCATGCACTGATCATGTGTCTATCATGCACTGATCACGTGACTGCA
CATGAACTGATCACTTACCTTTTCATGCACTGATTACCTGGCTATCATGCACTGATCACG
TGGATGATCATGCACTGATCACATGACTGCGCATGCCATGATCATGTGACTCATCATGCA
CTGATCACGTGCCTATCATGCACTGATAACGTGGCTGATCATGCACTGATCAGGTGACTG
ATTATGCACTGATCGCGTAGCTATCACGCACTGATCACGTGACTGATCATGCACTGATCA
CGTGGCTATCATGGACTGATCATGTGGCTAATCATACATTGATCACCTAAATAATCATGC
ACTGATCACGGGGCGATATTGCACTGATCACGTGGCTTATCAGGCACTGATAACTTACCT
ATCATGCACTGATCACATGACTGGGCAAGAACTTATCACGTGGATATCATACACTGGACA
TGTGACAGATAACGCACTGACCACGTGACTGATCATGCACTGATCACGTGGCGATCATGC
ACTAATCACGTGGATATCACACACTGATCACTTGGATGATCATACCCCTATCACGTGACT
GATCATGTTAATGCACTGATCACGTGGCTGATCATGCACTGATCACGTGGCTGATCATGC
ACTGATCACGTGGCTGATCCTACACTGATCATATGGCTGATCATGCACTGATCACGTACA
TGATCATGCACTGATCATTTGGCTGATCATACACTGATCTTGTGACTGCGCATGCACTGA
TCACGTGACTAATCTTTCACTGATCACATGGCTATCATGCACTGATCATGTGTCTATCAT
GCACTGATCACGTGACTGCACATGAACTGATCACTTACCTTTTCATGCACTGATTACCTG
GCTATCATGCACTGATCACGTGGATGATCATGCACTGATCACATGACTGATTCGGCAATG
ATCACGTAGCTATAATACACTGATCACATGACTGCGCATGCCATGATCATGTGACTCATC
ATGCACTGATCACGTGCCTATCATGCACTGATAACGTGGCTGATCATGCACTGATCAGGT
GACTGATTATGCACTGATCGCGTAGCTATCACGCACTGATCACGTGACTGATCATGCACT
GATCACGTGGCTATCATGGACTGATCATGTGGCTAATCATACATTGATCACCTAAATAAT
CATGCACTGATCACGGGGCGATATTGCACTGATCACGTGGCTTATCAGGCACTGATAACT
TACCTATCATGCACTGATCACATGACTGGGCAAGAACTTATCACGTGGATATCATACACT
GGACATGTGACAGATAACGCACTGACCACGTGACTGATCATGCACTGATCACGTGGCGAT
CATGCACTGATCCCGTGGCTATCATGCACTGATCCCTTGGCTATCATGCACTGATCACCT
GACTGATCATGCACTGATCAAGTGGCTATCATGCACTGATCACGTGGCTAGCATGCAATG
ATCACCTGAATGATCATGCAGTGATCACGTCGCTATCCTGCACGGATGTCGAGATTGGGC
ATGCACTGGTCATGAGGATGATCATACACTGGTCACGTACAGATCATGCACTGATTACGT
GTCTATCATGCACTGATCACGTGGCTGATCCTGCAATGATCACGTGACTGAATATGAACT
GATTGCGTAGCTATCATGCACTGATCGCATGACTTCGCATGCCATGATCACGTGACTGAT
CATGCACTGATCAGGTGGCTATCATGCACTGATCACGTGGCTAATCATACATTGATCACG
TAACTAACCATGCACTGATCACTTGACAATCTTGCACTGATCACGTGGCTGATCACGCAC
TGATCACGTAGTTATCATGCACTGATCACATGACTGCGCATGAACTGATCACGTGGATAT
CATACACTGATCAAGTGACAGATCATGCACTGCTCAGTTGACTGATCATGCACTGATCAC
GTGGCTATCATGCACTGATCACGTGCCTGATCATGCACTAATCAGGTTGTGGATCATGCA
CTGATCACGTGGCTGATCATACACAGCTCAAGGAAGTGATCATGCAATGATCACGTGGCT
ATCATGCACGGCTCACGTGGTTGATCCTGCAATGGTCACGTAGCTAAAATGTACTGGTCA
CGTGACTGATCATGCACTTATCACGAAATTGATCATGCACTGTTCACGTGGATCATCATG
CACTGATCACGTGACTGGTCATGCACTGATCACGTGACTGGTCATGCACTGATCACGTGG
CTATCATGCACTGATCACGTGGCTGATCATACACTGATCACGTGCCTGGTCATGCACAGA
TCACGTGACTAATCATGAACTGATCACGTGGGTATCAGGCACTGATCACGTGGATATCAT
GCACTGCTCACGTGGCTGAACATGCAATGATCACGTAGCTACCATGTACTGGTCACGTGA
CTGATCATGCACTGATCACGTAGTTATCATGCACTGATCACATGACTGCGCATGAACTGA
TCACGTGGATATCATACACTGATCAAGTGACAGATCATGCACTGCTCAGTTGACTGATCA
TGCACTGATCACGTGGCTATCATGCACTGATCACGTGCCTGATCATGCACTAATCAGGTT
GTGGATCATGCACTGATCACGTGGCTGATCATACACAGCTCAAGGAAGTGATCATGCAAT
GATCACGTGGCTATCATGCACGGCTCACGTGGTTGATCCTGCAATGGTCACGTAGCTAAA
ATGTACTGGTCACGTGACTGATCATGCACTTATCACGAAATTGATCATGCACTGTTCACG
TGGATCATCATGCACTGATCACGTGACTGGTCATGCACTGATCACGTGACTGGTCATGCA
CTGATCACGTGGCTATCATGCACTGATCACGTGGCTGATCATACACTGATCACGTGCCTG
GTCATGCACAGATCACGTGACTAATCATGAACTGATCACGTGGGTATCAGGCACTGATCA
CGTGGATATCATGCACTGCTCACGTGGCTGAACATGCAATGATCACGTAGCTACCATGTA
CTGGTCACGTGACTGATCATGCACTGATCACGTAATTGATCATGCACTGACCACGTGACT
GATCATGCACTGATGACGTGGCTATCATGCCCTGCTCACTAGGCTGATCATGCAATGATC
ACATAGCTACCATGTACTGGTCACGTGACTGATCATGCAATGATCACGTAATTGATCATG
CACTGATCACGTGGCTGATCATGCGCTGATCGTGTGACTGATCATGCACTGATCACGTGA
CTGATCATGCACTGATCACGTGGTTATCATGCACTGATCACGTGGCTGATCATACACTGA
TCGTGTGCCTGATCATTCACAGATCACGTGATTAATCATGAACTGATCACGTGGCTATCC
TGCACTGATCACGTGGATATCACACACTGATCACGTGGATGATCATACCCCTATCACGTG
ACTGATCATGATAATGCACTGATCACTTGGCTGATCCTACACTGATCATATGGCTGATTA
TGCACTGATCACGTGGCTGATCATGCACTGATCACATGGCTGATCATACACTGATCGCGT
GCCTGATCATTCACAGATCACGTGATTAATCATGAACTGATCACGTGGCTATCCTGCACT
GATCACGTGGATATGACACACTGATCACGTGGATGGTCATACCCCTATCACGTGACTGAT
CATGATAATGCACTGATCACGTGGTTGATCCTACACTGATCATATGGCTGATTATGCACT
GATCACGTGGCTGATCATGCACTGATCACATGACTGCGCATGAACTGATCACGTGGATAT
CATACACTGATCTAGTGACAGATCATGCACTGATCAGTTGACTGATCATGCACTGATCAC
GTGGCTATCATGCACTGACCACGTGCCTGATCATGCACTAATCAGGTTGTGGATCATGCA
CTGATCACGTGGCTGATCATACACAGCTCAAGGAAGTGATCATGCAATGATCACGTGGCT
ATCATGCACTGATCACGTGGCTGATCCTACACTGATCATATGGCTGATTATGCACTGATC
ACGTGGCTGATCATGCACTGATCACATGACTGCGCATGAACTGATCACGTGGATATCATA
CACTGATCAAGTGACAGATCATGCACTGATCACGTGGTTATCATGCACTGATCACGTGGC
TGATCATACACTGATCACGTGCCTGATCATTCACAGATCACGTGATTAATCATGAACTGA
TCACGTGACTATCCTGCACTAATCACGTGGATATCACACACTGATCACTTGGATGATCAT
ACCCCTATCACGTGACTGATCATGTTAATGCACTGATCACGTGGCTGATCATGCACTGAT
CACGTGGCTCATCATGCACTGATCACGTGGCTGATCCTACACTGATCATATGGCTGATCA
TGCACTGATCACGTACATGATCATGCACTGATCATTTGGCTGATCATACACTGATCTTGT
GACTGCGCATGCACTGATCACGTGACTAATCTTTCACTGATCACATGGCTATCATGCACT
GATCATGTGTCTATCATGCACTGATCACGTGACTGCACATGAACTGATCACTTACCTTTT
CATGCACTGATTACCTGGCTATCATGCACTGATCACGTGGATGATCATGCACTGATCACA
TGACTGATTCGGCAATGATCACGTAGCTATAATGCACTGATCACATGACTGCGCATGCCA
TGATCATGTGACTCATCATGCACTGATCACGTGCCTATCATGCACTGATAACGTGGCTGA
TCATGCACTGATCACGTGACTGATCATGCACTGATCGCGTGGCTATCATGGACTGATCAT
GTGGCTAATCATACATTGATCACCTAAATAATCATGCACTGATCACGGGGCGATATTGCA
CTGATCACGTGGCTTATCAGGCACTGATAACTTACCTATCATGCACTGATCACATGACTG
GGCAAGAACTTATCACGTGGATATCATACACTGGACATGTGACAGATAACGCACTGACCA
CGTGACTGATCATGCACTGATCACGTGGCTATCATGCACTGATCCCTTGGCTATCATGCA
CTGATCACCTGACTGATCATGCACTGATCAAGTGGCTATCATGCACTGATCACGTGGCTA
GCATGCAATGATCACCTGAAGGATCATGCAGTAATCACGTCGCTATCATGCACGGATGTC
GAGATTGGGCATGCACTGGTCATGAGGATGATCATACACTGGTCACGTACAGATCATGCA
CTGATTACGTGTCTATCATGCACTGATCACGTGGCTGATCCTGCAATGATCACGTGACTG
AATATGAACTGATTGCGTAGCTATCATGCACTGATCGCATGACTTCGAATGCCATGATCA
CGTGACTGATCATGCACTGATCAGGTGGCTATCATGCACTGATCACGTGGCTAATCATAC
ATTGATCACGTAACTAACCATGCACTGATCACTTGACAATCTTGCACTGATCACGTGGCT
GATCACGCACTGATCACGTAGTTATCATGCACTGATCACATGACTGCGCATGAACTGATC
ACGTGGATATCATACACTGATCAAGTGACAGATCATGCACTGATCAGTTGTCTGATCATG
CACTGATCACGTGGCTATCATGCACTGATCACGTGCCTGATCATGCACTAATCAGGTTGT
GGATCATGCACTGATCACGTGGCTGATCATACACAGCTCAAGGAAGTGATCATGCAATGA
TCACGTGGCTATCATGCACTGCTCACGTGGTTGATCCTGCAATGGTCACGTAGCTACAAT
GTACTGGTCACGTGACTGATCATGCACTGATCACGAAATTGATCATGCACTGATCACGTG
ACTGATCATGCACTGATCACGTGACTGTTCATGCACTGATCACGTGACTGATCATACACT
GATCACGTGCCAGGTCATGCACAGATCACGTGACTAATCATGAACTGATCACGTGGCTAT
AATGCAATGATCACGTGGATATCATACACTGATCCCGTGCCTGTCATGCACAGATCACGT
GACTAATCATGAACTGATCACGTGGGTATCAGGCACTGATCACGTGGATATCATGCACTG
CTCACGTGGCTGAACATGCAATGATCACGTAGCTACCATGTACTGGTCACGTGACTGATC
ATGCACTGATCACGTAATTGATCATGCACTGACCACGTGACTGATCATGCACTGATGACG
TGGCTATCATGCCCTGCTCACTAGGCTGATCATGCAATGATCACATAGCTACCATGTACT
GGTCACGTGACTGATCATGCAATGATCACGTAATAGATCATGCAATGAGCACGTGGCTGA
TCATACACTGATCGCGTGCCTGATCATTCACAGATCACGTGATTAATAATGAACTGATCA
CGTGGCTATCCTGCACTGATCACGTGGATATCACACACTGATCACGTGGATGATCATACC
ATTATCACGTGACTGATCATGATAATGCACTGGTCATATGGCTGATTATGCACTGATCAC
GTGGCTGATCATGCACTGATCACGTGACTGATCATGCACTGATCACGTGGTTATCATGCA
CTGATCACGTGGCTGATCATACACTGATCGCGTGCCTGATCATTCACAGATCACGTGATT
AATCATGAACTGATCACGTGGCTATCCTGCACTGATCACGTGGATATCACACACTGATCA
CGTGGATGATCATACCCCTAACACGTGACTGATCATGATAATGCACTGATCACGTGGCTG
ATCCTACACTGATCATATGGCTGATTATGCACTGATCACGTGGCTGAACATGCACTGATC
ACGTGGCTGATCATGCACTGATCACGTGGCTGATCCTACACTGACCATATGGCGGATTAT
GCACTGATCACATGGCTGATCACGCACTGATCACGTAGTTATCATGCACTGATCACATGA
CTGCGCATGAACTGATCACGTGGATATCATACACTGATCAAGTGACAGATCATGCACTGC
TCAGTTGACTGATCATGCACTGATCACGTGGCTATCATGCACTGATCACGTGCCTGATCA
TGCACTAATCAGGTTGTGGATCATGCACTGATCACGTGGCTGATCATACACAGCTCAAGG
AAGTGATCATGCAATGATCACGTGGCTATCATGCACGGCTCACGTGGTTGATCCTGCAAT
GGTCACGTAGCTACAATGTACTGGTCACGTGACTGATCATGCACTGATCACGAAATTGAT
CATGCACTGTTCACGTGGATCATCATGCACTGATCACGTGACTGTTCATGCACTGATCAC
GTGACTGGTCATGGACTGATCACGTGGCTATCATGCACTGATCACGTGGCTGATCATACA
CTGATCACGTGCCTGGTCATGCACAGATCACGTGACTAATCATGAACTGATCACGTGGCT
ATAATGCAATGATCACGTGGATATCATACACTGATCACGTGCCTGTCATGCACAGATCAC
GTGACTAATCATGAACTGATCACGTGGGTATCAGGCACTGATCACGTGGATATCATGCAC
TGCTCACGTGGCTGAACATGCAATGATCACGTAGCTACCATGTACTGGTCACGTGACTGA
TCATGCACTGATCACGTAATTGATCATGCACTGATCACGTGGCTGATCATGCGCTGATCG
TGTGACTGATCATGCACTGATCACTTGACTGATCATGCACTGATCACGTGTCTGATCATG
CACTACTCACGTGACTGATCATGGACTGATCACGTGACTGATCATGCACTGATCATGAGC
CTGATCATGCACTGATCACGGGCCTGTTCATGCACTGATCACGTGGCTGATCCTGCACTG
ATCTCGAGGCTGATCATACACTGATCACGTGACTGTGCATGCAATGATTACTTGGCTGAT
CATGTACTGATCACGTGGCTGATCATGCACTGATCACGTGACTGATTATGCACTGATCAC
ATAGCTATCATGCACTGATCACATGACTTCGCATGCCATGATCACGTGACTGATCATGCA
CTGGTCCCATGGCTATCATGCACTGATAATGTGGCTTATCATACATTGATCACCTAAATA
ATCATGCACTGATCACGTGGCAATCTTGCTCTGATCACGTGGTTGATCAGGCACTGATCA
CTTAGCTATCATGCACTGATCACATGACTGCGCAAGAACTGATCACTTAGATATCATACA
CAGGACACGTGACAGATCATGCACTGATCACGTGACTGATCATGCACTGATCTGGTGGCT
ATCATGCATTGATCACGTGGTTGATCATACACTGATCACGTGACTGATCATGCACTGATC
ACCTGGCTATCGTGCACTAATCACGTAGCTGATCTGGAACGGATCACGTGACTAATCATG
CAGTGATCACGTCGCTATCATGCAATGATCTCGAGATTGCGCATGCACTGATCATATGGA
TGATCACACACTGATCACGTGACAGATCATGCACTGAACACGTGACTTACCATGCACTGA
TCTCGTGACTGATCATGCATTCCTCACGTGCATGATCATGCACTGAACACGTGGCTGATA
CTGCACTGATCACGTGGCTGATAATGCACTGATCACTTGACTGATCATGCACTGATCACG
TCTCTGATCATGCACTACTCACGTGACTGATCATGGACTGATCACGTGACTGATCATGCA
CTGATCATGAGCCTGATTATGCACTGATCACGGGCCTGTTCATGCACTGATCACGTGGCT
GATCCTGCCCTGATCACGAGGCTGATCATACACTGATCACGTGACTGTGCATGCAATGAT
CACTTGGCTGATCATGTACTGATTACGTGGCTGAACTTGCACTGATAACCTGGCTATCAT
CCACTGATCACGTGAGTGATCATGCACTCTTCACGTGCATGATCATGCACTGATCACGTG
TCTTAGCATGCACTAACCATGTTGCTGATCATGCAATGGTCAGGTGGCTATCATGCACTG
TTTACCTGGCTGATCATGCACTGATCACATGGCTGTAATACACTGACCACTTGACTGTGT
ATGCACTGATCATGTGGATGATTATACACTGATCACGTGACTGATCATGCACTGATCATG
TGTCTGATCATGCACTGATAAAGTGGTTGATCATGCACTGATCACGTGGCTGAGCATACA
GTGATTACATGACTGATCATGCACTAATCACGTTGTGCATCATGCACTGATCACGTGACT
GATCATGCACTAGTCACGCGGCTATCATGCACTGATCACGTGGCTGATCATACACTGATC
ACGTGCCTGATCATGCACTGATTGCATAACTTAGCATGCAGTGATCTCGTGTCTGAAATA
TGCTGATCATGTGACTAATCAAGAACTGATCACGTGGCTATAATGCACTGATCACGTGAC
TGCACATGCACTGATCACGTGGCTGATCATACTGTGATCAAGTGGCTGATAATGCACTGA
TTACGTGGCTGATCATGCACAGATCACGTAGCTATCATGTGCCGATCACATGGCGATCAT
GCCCTGTCCCGTGGCTGATCATGCACTGATCGCGTGACTGATCATGCACTAGTCACTAGG
CTATCATGCACTGATCAGGTGGCTGATATGCACTGATCACGTGGCTGATATGCACTGATC
ACGAGGCTGATCATGCACTGATCACGAAGCTGATCATGCACTGATCACGTGTCTTAGCAT
GCACTAACCATGTTGCTGATCATGCAATGGACAGGTGGCTATCATGCACTGTTTACCTGG
CTGATCATGCACTGATCACATGGCTGTAATACACTGGCCACTTGACTGTGCATGCACTGA
TCATGTGGATGATTATACACTGATCACGTGACTGATCATGCACTGATCATGTGTCTGATC
ATGCACTGATAAAGTGCTTGATCATGCACTGATCACGGGGCTGAGCATACAGTGATTACA
TGACTGATCATGCACTAATCACGTTGTGGATCATGTACTGATCACGTGACTGATCATGCA
CTAGTCACGTGGCTATCATGCACTGATCACGTGGCTGATCATACACTGATCACGTGGCTG
ATCATGCACTGATCACGTGCCTGATCATGCACTGATTGCGTAATTTAGCATGCAGTGATC
TCGTGTCTGAATTGTGCTGATCATGTGACTAATCAAGAACTGATCACGTGGCTATAATGC
ACTGATCACGTGACTGCGCACGCACTGAAAATATGGATGACCATACACTGATCACGTCAC
TGATCAGGCACTGATCACGTGACTGATCATGCACTGATCACGTGGCTGATCATGCACTGA
TCACCAAGCTGATCATACTCTGATCACGTGACTGATCATGCACTGATCACATGGCTGATC
ATGCACTGATCACGTGGCTGATCATGCACTGATCACGTGGGTGATCATGAACTGATCACG
TGGCTTATCATACACTGCTCACGTGGCTGATCATGCACTAATCACGTTGTGGATGATGCA
CTGATCACATGGCTGATCATACACTGATCACGTGGGTGATCATGAACTGATCAAGTGGCT
GATCATACACTGATCACATGAATGATCATGCACTAATCACGTTGTGGACCATGCACTGAT
CACTTGGCTGATCAGGCACTGATCACGTGGCTGATCATACTCTGAACACGAAGCTGAAAA
TACAGTGATCACGTGACTGCATGCACTGATCACATTGCTATCATGCACTGATCACGTGTC
TATCATGGACTGATCACGTGACTGGGCATTAACTGAACACATACCTGTTCATGCACTGTT
TACGTGGCTTTCATGCACTGATCACGTAGCTTAACATGCATTGGTCACGTGACTGATCAT
GCACTGATCACGTTGCGTATCATGCACTGATCACATGACGGCGCATGAACTGATCACGTG
GATATTATACACTGATCAAGCGACAAATCATGCACTAATCACGTGACTGATCATGCACTG
ATCACGTGGCTGATCATGCACTGATCACGTGGCTGTTCATACAGTGATCACGTGACTGAT
CATGCACTGATCACGTGCCTGATCATGCACTGATCACGAAGCTGATCATACTCCAATCAC
GTGAGTGTGCATGCACTGATCACGTGGCTGATCATGCACTAATCACGTTGTGGATGATGC
ACTGATCACGTGGCTGATCATACACTGATCACATGACTGATCATGAACTAATCACGTTGT
GGATCATGCACTGATCACGTGGCTGTTCTTGCACTTATCACGTGGCTGATCATACAGTGA
TTACATGACTGATCATGCACTAATCACGTTGTGGATCATGCACTGATCACATGAATGTGC
ATGCATTGATCATGTGGCTGATCATGCACTGATCACGTGGCTGATCATGCACTGATCACG
AAGCTGATATTACACTGATCACAGGACTGTGCATGTACTGATCATGTGGCTGATCATGCA
CTGATCATGTGGCTGATGATACACTGATCACGTGGCTGATCAGGCACTGATCACGTGGCT
GATCGTACTCTGAACATGAAGCTTAAAATACAGTGATCACGAGACTGCATGCACTGATCA
CTTGACTGCGCATGCACTGATCACGTGGATGATAATACGCTGATCACTTGACTGCTTATG
CACTAAAAAAATGGCTGATCATGCACTGATCACATGACTGATCATGCACTGATCACGTGA
CTGATCATGCATAGATCACGTGACTACCATGCACTGATCACTTGATTGTGCATGCAATAA
TCACGTGGATGATCACGCATTTATCATGTGGCTGATCATGCACTAATCACATGGCGGAAC
ATGAACTGATCACGTGACTTAGCATGCAGTGATCTCGTGTCTGAATGGTGCTGATCATGT
GACTAAACAAGAACTGATCACGTGGCTATAATGCACTGATCACGTGACTGCGCATGCACT
GATCATGTGGATGATAATACACTGATGACGTTACTGATGAGGCACTGATCACGTGACTGA
TCATTCACTGATCACGTGGCTATTATGCACTGATCACGGGACTGCACATGCAGTGTTCAC
GTAATTGTAGACAATGATCACGTGGCTATCATGCACTGATAACGTGTCTATCATGCACTG
AACACGTGGCTGATCAAATACTGATCACGTGGCTGATCGTGCACTGAACACGTGGCTGAT
CAAACACTGATCACGTGGCTGATCATGCACTCATCACGTGGCTGATCATACAATGATCAC
GTGGCTGATCATGCACTGATCACATGTATGATCGTACACTGATCACGTGGCTGATCATGC
ACAAATCCCATTGCATATCATGCTCTGATCAGGTTGCTATCATGTACTGATCACGTGGCT
GAGCATACAGTGATCACGTGACTGACCATGCACTGATTACGTGGCTATCATGCACTGAAC
ACGTGGCTGATCATGCACTGTTAACCTGGCTATAATACACTGATCTCTTGACTGATCATG
CATTCTTCACATGCCTGATCATGCACTGATCACGTGGCTGATCTTGCACTGATCACGTGG
CTGATAATGCACTGATCACTTGACTGATCATGCACTAATCTCGTTGTGTATCATGCACTG
ATCACATGACGGTGCATGAACTGATCACGTGAACATTATACACTGATCAAGTGACAGATC
ATGTACTAATCACGTGACTGATCATGCACTGATCACGTGGCTATCATGCACTGATCACGT
GGCTGATAATGCACTGATCACTTGACTGATCATGCACTGATCACGTGTCTGATCATGCAC
TACTCACGTGACTGATCATGGACTGATCACGTGACTGATCATGCACTGATCATGAGCCTG
ATCATGCACTGATCACGGGCCTGTTCATGCACTGATCACGTGGCTGATCCTGCACTGATC
TCGAGGCTGATCATACACTGATCACGTGACTGTGCATGCAATGATTACTTGGCTGATCAT
GTACTGATCACGTGGCTGATCATGCACTGATCACGTGACTGATTATGCACTGATCACATA
GCTATCATGCACTGATCACATGACTTCGCATGCCATGATCACGTGACTGATCATGCACTG
GTCCCATGGCTATCATGCACTGATAATGTGGCTTATCATACATTGATCACCTAAATAATC
ATGCACTGATCACGTGGCAATCTTGCTCTGATCACGTGGTTGATCAGGCACTGATCACTT
AGCTATCATGCACTGATCACATGACTGCGCAAGAACTGATCACTTAGATATCATACACAG
GACACGTGACAGATCATGCACTGATCACGTGACTGATCATGCACTGATCTGGTGGCTATC
ATGCATTGATCACGTGGTTGATCATACACTGATCACGTGACTGATCATGCACTGATCACC
TGGCTATCGTGCACTAATCACGTAGCTGATCTGGAACGGATCACGTGACTAATCATGCAG
TGATCACGTCGCTATCATGCAATGATGTCGAGATTGCGCATGCACTGATCATATGGATGA
TCACACACTGATCACGTGACAGATCATGCACTGAACACGTGACTTACCATGCACTGATCT
CGTGACTGATCATGCATTCCTCACGTGCATGATCATGCACTGAACACGTGGCTGATACTG
CACTGATCACGTGGCTGATAATGCACTGATCACTTGACTGATCATGCACTGATCACGTCT
CTGATCATGCACTACTCACGTGACTGATCATGGACTGATCACGTGACTGATCATGCACTG
ATCATGAGCCTGATTATGCACTGATCACGGGCCTGTTCATGCACTGATCACGTGGCTGAT
CCTGCCCTGATCACGAGGCTGATCATACACTGATCACGTGACTGTGCATGCAATGATCAC
TTGGCTGATCATGTACTGATTACGTGGCTGAACTTGCACTGATAACCTGGCTATCATCCA
CTGATCACGTGAGTGATCATGCACTCTTCACGTGCATGATCATGCACTGATCACGTGTCT
TAGCATGCACTAACCATGTTGCTGATCATGCAATGGTCAGGTGGCTATCATGCACTGTTT
ACCTGGCTGATCATGCACTGATCACATGGCTGTAATACACTGACCACTTGACTGTGTATG
CACTGATCATGTGGATGATTATACACTGATCACGTGACTGATCATGCACTGATCATGTGT
CTGATCATGCACTGATAAAGTGGTTGATCATGCACTGATCACGTGGCTGAACATACAGTG
ATTACATGACTGATCATGCACTAATCACGTTGTGCATCATGCACTGATCACGTGACTGAT
CATGCACTAGTCACGCGGCTATCATGCACTGATCACGTGGCTGATCATACACTGATCACG
TGCCTGATCATGCACTGATTGCATAACTTAGCATGCAGTGATCTCGTGTCTGAAATATGC
TGATCATGTGACTAATCAAGAACTGATCACGTGGCTATAATGCACTGATCACGTGACTGG
GCACGCACTGAAAATATGGATGACCATACACTGATCACGTCACTGATCAGGCACTGATCA
CGTGACTGATCATGCACTGATCACGAAGCTGATCATACTCTGATCACGTGAGTGTGCATG
CACTGATCACGTGGGTGATTATGAACTGATCACGTGGCTTATCATACACTGCTCACGTGG
CTGATCATGCACTAATCACGTTGTGGATGATGCACTGATCACGTGGCTGATCATACACTG
ATCACGTGGGTGATCATGAACTGATCACGGGGCTGATCGTACACTGATCACATGAATGAT
CATGCACTAATCACGTTGTGGATCATGCACTGATCACATGGCTGATCATGCACTGATCAC
GTGGCTGATCTTGCACTTATCACGTGGCTGATCGTACAGTGATTACATGAATGATCATGC
ACTAATCACGTTGTAGATTATGCACTGATCACATGACTGTGCATGTATTGATCACGTGGC
TGATCATGCAATGAACACGTGGCTGATCATACACTGATCACATTACTGATCATGCACTAT
TCACGTGCCTGATCATTCACTGATCACGTGGCTGATCATGCACTGATCACGAAGCTGATC
ATACCCTGATCACATAACTGTGCATGCACTGATCACGTGGGTGATCATGCACTGATCATG
TGGCTGATCATACACTGGGCACGTGGCTGAACATATTCTGATCACGTGGCTGATCAGGCA
CTGATCACGTGGCTGATCATACTCTGAACATGAAGCTGAAAATACACTTATCACGTGACC
GCATGCACTGATCACATGGCTATCATGCACTGATCACGTGTTTATCATGCACTGATCACG
TGACTGCACATTAACTGAACACATACCTGTTCATGCACTGTTTACGTGGCTATCATGCAC
TGATCACATGGCTGATCATGCACTGATCACAAAGCTGATCATACTCTGATCACGTGAGTG
TGCATGCACTGATCACGTGGCTGATCATGCATTAATCACGTGACTGATCATGCACTAATC
TCATTGCGTATCATGCACTGATCACATGACGGTGCATGAACTGATCACGTGAATATTATA
CACTGATCAAGTGACAGATCATGTACTAATCACGTGACTGATCATGCACTGATCACGTGG
CTATCATGCACTGATCACGTGGCTGATAATGCACTGATCACTTGACTGATCATGCACTAA
TCACATGTCTGATCATGCACTACTCACGTGACTGATCATGGACTGATCACGTGACTGATC
ATGCACTGATCATGAGCCTGATCATGCACTGATCACGGGCCTGTTCATGCACTGATCACG
TGGCTGATCATGCACTAATCACGTTGTGGATGATGCACTTATCACGAGGCTGATCATACA
CTGATCACGTGACTGTGCATGCAATGATCACTTGGCTGAACATATACTGATCACGTGGCC
GATCATGCACTGATAACCTGGCTATCATCCACTGATCACGTGAGTGATCATGCACCCTTC
ACATGCATGATCATGCACTGATCACGTGTCTTAGCATGCACTAACCATGTTGCTGATCAT
GCAATGGTCAGGTGGCTCTCATGCACTGTTTACCTGGCTGATCATGCACTGATCACATGG
CTGTAATACACTGGCCACTTGACTGTGCATGCACTGATCATGTGGATGATTATACACTGA
TCACGTGACTGATCATGCACTGATCATGTGTCTGATCATGCACTGATAAAGTACTTGATC
ATGCACTGATCACGTGGCTGAGCATACAGTGATTACATGACTGATCATGCACTAATCACG
TTGTAGATCATGCACTGATCACGTGACTGATCATGCACTAGTCACGTGGCTATCATGCAC
TGATCACGTGGCTGATCATACACTGATCACGTGGCTGATCATGCACTGATCACGTGCCTG
ATCATGCACTGATTGCGTAATTTAGCATGCAGTGATCTCGTGTCTGAATTGTGCTGATCA
TGTGACTAATCAAGAACTGATCACGTGGCTATAATGCACTGATCACGTGACTGCACACGC
ATTGAAAATACGGATGACCATACACTGATCACGTCACTGATCAGGCACTGATCACGTGAC
TGATCATGCACTGATCACGTGGCTGATCATGCACTGATCACAAAGCTGATCATACTCTGA
TCACGTGAGTGTGCATGCACTGATCACGTGGCTGATCATGCACTGATCACGTGGCTGATC
ATGCACTGATCACGTGGGTGATCATGAACTGATCACGTGGCTTATCATACACTGCTCACG
TGGCTGATCATGCACTAATCACGTTGTGGATGATGCACTGATCACATGGCTGATCATACA
CTGATCACGTGGGTGATAATGAACTGATCAAATGGCTGATCATACACTGATCACATGAAT
GATCATGCACTAATCACTTTGTGGACCATGCACTGATCACTTGGCTGATCAGGCACTGAT
CACGTGGCTGATCATACTCTGAACACGAAGCTGAAAATACAGTGATCACGTGACTGCATG
CACTGATCACATGGCTATCATGCACTGATCACGTGTCTATCATGGACTGATCACGTGACT
GCGCATTAACTGAACACATACCTGTTCATGCACTGTTTACGTGGCTTTCCTGCACTGATC
ACGTGGCTTATCATGCATTGGTCACGTGACTGATCATGCACTGATCACGTTGCGTATCAT
GCACTGATCACATGACGGCGCATGAACTGATCACGTGGATATTATACACTGATCAAGCGA
CAAATCATGCACTAATCACGTGACTGATCATGCACTGATCACGTGGCTATCATGCACTGA
TCACGTGGCTGATCATGCACTGATCACGTGGCTGTTCATACAGTGATCACGTGGCTGATC
ATGCACTGATCACAAAGCTGATCATACTCTGATCACGTGACTGATCATGCCCTGATCATG
AGCCTGATCATGCACTGATCACGTGGCTGATCATGCACTGATAACGTGGCTTATCATACA
CTGCTCACGTGTCTGATCATGCACTAATCACGTTGTGGATGATGCACTAATCACGTTGTG
GATGATGCACTGATCACTTGGCTGATCAGGCACTGATCACGTGGCTGATCATACTCTGAA
CACGAAGCTGAAAATACACTGATCACGTGACTGCATGCACTGATCACATGGCTATCATGC
ACTGATCACGTGTCTATCATGGACTGATCACGTGACTGCGCATTAACTGAACACATACCT
GTTCATGCACTGTTTACGTGGCTTTCATGCACTGATCACCTGGCTTATCATGCATTGGTC
ACGTGACTGATCATGCACTGATCACGTTGCGAATCATGCACTGATCACATGACGGTGCAT
GAACTGATCACGTGGATATTATACACTGATCAAGCGACAAATCATGCACTAATCACGTGA
CTGATCATGCACTGATCACGTGGCTATCATGCACTGATCACGTGGCTGATCATGCACTGA
TCACGTGGCTGTTCATACAGTGATCACGTGACTGATCATGCACTGATCACGTGCCTGATC
ATGCACTGATCACGAAGCTGATCATACTCCAATCACGTGAGTGTGCATGCACTGATCACG
TGGCTGATCATGCACTAATCACGTTGTGGATGATGCACTGATCACGTGGCTGATCATACA
CTTATCACATGACTGATCATGAACTAATCACGTTGTGGATCATGCACTGATCACATGAAT
GTGCATGCATTGATCATGTGGTTGATCATGCACTGATCACGTGGCTGATCATGCACTGAT
CACGAAGCTGATATTACACTGATCACAGGACTGTGCATGCACTGATCATGTGGCTGATCA
TGCACTGATCATGTGGCTGATGATACACTGATCACGTGGCTGATCAGGCACTGATCACGT
GGCTGATCGTACTCTGAACACGAAGCTTAAAATACACTGATCACGAGACTGCATGCACTG
ATCACTTGACTGCACATGAACTGATCACGTGGATATCATACACTGATCAAGTGACAGATC
ATGCACTGATCAGTTGACTGATCATGCACTGATCACGTGGCTATCATGCACTGATCACGT
GCCTGATCATGCACTAATCAGGTTGTGGATCATGCACTGATCACGTGGCTGATCATACAC
AGCTCAAGGAAGTGATCATGCAATGATCACGTGGCTATCATGCACTGCTCACGTGGTTGA
TCATGCAATGTTCACGTAGCTACAATGTACTGGTCACGTGACTGATCATGCACTGATCAC
GAAATTGATCATGCACTGTTCACGTGGATCATCATGCACTGATCACGTGACTGTTCATGC
ACTGATCACGTGACTGATCATGCACTGATCACGTGGCTATCATGCACTGATCACGTGGCT
GATCATACACTGATCACGTGCCTGGTCATGCACAGATCACGTGACTAATCATGAACTGAT
CACGTGGCTATAATGCAATGATCACGTGGATATCATACACTGATCCCGTGCCTGTCATGC
ACAGATCACGTGACTAATCATGAACTGATCACGTGGGTATCAGGCACTGATCACGTGGAT
ATCATGCACTGCTCACGTGGCTGAACATGCAATGATCACGTAGCTACCATGTACTGGTCA
CGTGACTGATCATGCACTGATCACGTAATTGATCATGCACTGATCACGTGGCTGATCATG
CACTGATCATGTGACTGATCATGCACTGATCACGTGACTGATCATGCACTGATCACGTGG
TTATCATGCACTGATCACTTGGCTGATCATACACTGATCGCCTGCCTGATCATTCACAGA
TCACGTGATTAATCATGAACTGATCACGTGGCTATCCTGCACTGATCACGTGTATATGAC
ACACTGATCACGTGGATGATCATACCCCTATCACGTGACTGATCATGATAATGCACTGAT
CACGTGGCTGATCCTACACTGACCATATGGCGGATTATGCACTGATCACGTGGCTGATCA
TGCACTGATCACGTGGCTGATCATGCACTGATCACGTGGCTGATCATGCACTGATCACGT
GGATGATCCTGCAATGATCACGTGACTGAATATGAACTGATTGCGTAGCTATCATGCACT
GATCGCATGACTTCGCATGCCATGATCACGTGACTGATCATGCACTGATCAGGTGGCTAT
CATGCACTGATCACGTGGCTAATCATACATTGATCACGTAACTAACCATGCACTGATCAC
TTGACAATCTTGCACTGATCACGTGGCTGATCACGCACTGATCACGTAGTTATCATGCAC
TGATCACATGACTGCGCATGAACTGATCACGTGGATATCATACACTGATCAAGTGACAGA
TCATGCACTGCTCAGTTGACTGATCATGCACTGATCACGTGGCTATCATGCACTGATCAC
GTGCCTGATCATGCACTAATCAGGTTGTGGATCATGCACTGATCACGTGGCTGATCATAC
ACAGCTCAAGGAAGTGATCATGCAATGATCACGTGGCTATCATGCACGGCTCACGTGGTT
GATCCTGCAATGGTCACGTAGCTACAATGTACTGGTCACGTGACTGATCATGCACTGATC
ACGAAATTGATCATGCACTGTTCACGTGGATCATCATGCACTGATCACGTGACTGGTCAT
GCACTGATCACGTGACTGGTCATGCACTGATCACGTGGCTATCATGCACTGATCACGTGG
CTGATCATACACTGATCACGTGCCTGGTCATGCACAGATCACGTGACTAATCATGAACTG
ATCACGTGGCTATAATGCAATGATCACGTGGATATCATACACTGATCACGTGCCTGTCAT
GCACAGATCACGTGACTAATCATGAACTGATCACGTGGGTATCAGGCACTGATCACGTGG
ATATCATGCACTGCTCACGTGGCTGAACATGCAATGATCACGTAGCTACCATGTACTGGT
CACGTGACTGATCATGCACTGATCTCGTAATTGATCATGCACTGACCACGTGACTGATCA
TGCACTGATGACGTGGCTATCATGCCCTGCTCACTAGGCTGATCATGCAATGATCACATA
GCTACCATGTACTGGTCACGTGACTGATCATGCAATGATCACGTGGTTATCATGCACTGA
TCACGTGGCTGATCATGCGCTGATCGTGTGACTGATCACGCACTGATCAAGTGACTGATC
ATGCACTGATCACGTGGTTATCATGCACTGATCACGTGGCTGATCATACACTGATCGAGT
GCCTGATCATTCACAGATCACGTGATTAATCATGAACTGATCACCTGGCTATCCTGCACT
GATCACGTGGATATCACACACTGATCACGTGGATGATCATACCCCTATCACGTGACTGAT
CATGATAATGCACTGATCACTTGGCTGATCCTACACTGATCATATGGCTGATTATGCACT
GATCACGTGGCTGATCATGCACTGATCACATGGCTGATCATACACTGATCGCGTGCCTGA
TCATTCACAGATCACGTGATTAATCATGAACTGATTACATGGCTATCCTGCACTGATCAC
GTGGAAATGACACACTGATCACGTGGATGGTCATACCCCTATCACGTGACTGATCATGAT
AATGCACTGATCACGTGGTTGATCCTACACTGATCATATGGCTGATTATGCACTGATCAC
GTGGCTGATCATGCACTGATCACATGACTGCGCATGAACTGATCACGTGGATATCATACA
CTGATCAAGTGACAGATCATGCACTGCTCAGTTGACTGATCATGCACTGAACACGTGGCA
ATCATGCACTGACCACGTGCCTGATCATGCACTAATCAGGTTGTGGATCATGCACTGATC
ACGTGGCTGATCATACACAGCTCAAGGAAGTGATCATGCAATGATCACGTGGCTATCATG
CACTGATCACGTGGCTGATCCTACACTGATCATATGGCTGATTATGCACTGATCACGTGG
CTGATCATGCACTGATCACATGACTGCGCATGAACTGATCACGTGGATATCATACACTGA
TCAAGTGACAGATCATGCACTGATCACGTGGTTATCATGCACTGATCACGTGGCTGATCA
TACACTGATCACGTGCCTGATCATTCACAGATCACGTGATTAATCATGAACTGATCACGT
GACTATCCTGCACTAATCACGTGGATATCACACACTGATCACTTGGATGATCATACCCCT
ATCACGTGACTGATCATGTTAATGCACTGATCACGTGGCTGATCATGCACTGATCACGTG
GCTGATCATGCACTGATCACGTGGCTGATCCTACACTGATCATATGGCTGATCATGCACT
GATCACGTACATGATCATGCACTGATCATTTGGCTGATCATACACTGATCTTGTGACTGC
GCATGCACTGATCACGTGACTAATCTTTCACTGATCACATGGCTATCATGCACTGATCAT
GTGTCTATCATGCACTGATCACGTGACTGCACATGAACTGATCACTTACCTTTTCATGCA
CTGATTACCTGGCTATCATGCACTGATCACGTGGATGATCATGCACTGATCACATGACTG
CGCATGCCATGATCATGTGACTCATCATGCACTGATCACGTGCCTATCATGCACTGATAA
CGTGGCTGATCATGCACTGATCAGGTGACTGATTATGCACTGATCGCGTAGCTATCACGC
ACTGATCACGTGACTGATCATGCACTGATCACGTGGCTATCATGGACTGATCATGTGGCT
AATCATACATTGATCACCTAAATAATCATGCACTGATCACGGGGCGATATTGCACTGATC
ACGTGGCTTATCAGGCACTGATAACTTACCTATCATGCACTGATCACATGACTGGGCAAG
AACTTATCACGTGGATATCATACACTGGACATGTGACAGATAACGCACTGACCACGTGAC
TGATCATGCACTGATCACGTGGCGATCATGCACTGATCCCGTGGCTATCATGCACTGATC
CCTTGGCTATCATGCACTGATCACCTGACTGATCATGCACTGATCAAGTGGCTATCATGC
ACTGATCACGTGGCTAGCATGCAATGATCACCTGAATGATCATGCAGTGATCACGTCGCT
ATCCTGCACGGATGTCGAGATTGGGCATGCACTGGTCATGAGGATGATCATACACTGGTC
ACGTACAGATCATGCACTGATTACGTGTCTATCATGCACTGATCACGTGGCTGATCCTGC
AATGATCACGTGACTGAATATGAACTGATTGCGTAGCTATCATGCACTGATCGCATGACT
TCGCATGCCATGATCACGTGACTGATCATGCACTGATCAGGTGGCTATCATGCACTGATC
ACGTGGCTAATCATACATTGATCACGTAACTAACCATGCACTGATCACTTGACAATCTTG
CACTGATCACGTGGCTGATCACGCACTGATCACGTAGTTATCATGCACTGATCACATGAC
TGCGCATGAACTGATCACGTGGATATCATACACTGATCAAGTGACAGATCATGCACTGCT
CAGTTGACTGATCATGCACTGATCACGTGGCTATCATGCACTGATCACGTGCCTGATCAT
GCACTAATCAGGTTGTGGATCATGCACTGATCACGTGGCTGATCATACACAGCTCAAGGA
AGTGATCATGCAATGATCACGTGGCTATCATGCACGGCTCACGTGGTTGATCCTGCAATG
GTCACGTAGCTAAAATGTACTGGTCACGTGACTGATCATGCACTTATCACGAAATTGATC
ATGCACTGTTCACGTGGATCATCATGCACTGATCACGTGACTGGTCATGCACTGATCACG
TGACTGGTCATGCACTGATCACGTGGCTATCATGCACTGATCACGTGGCTGATCATACAC
TGATCACGTGCCTGGTCATGCACAGATCACGTGACTAATCATGAACTGATCACGTGGGTA
TCAGGCACTGATCACGTGGATATCATGCACTGCTCACGTGGCTGAACATGCAATGATCAC
GTAGCTACCATGTACTGGTCACGTGACTGATCATGCACTGATCACGTAGTTATCATGCAC
TGATCACATGACTGCGCATGAACTGATCACGTGGATATCATACACTGATCAAGTGACAGA
TCATGCACTGCTCAGTTGACTGATCATGCACTGATCACGTGGCTATCATGCACTGATCAC
GTGCCTGATCATGCACTAATCAGGTTGTGGATCATGCACTGATCACGTGGCTGATCTTAC
ACAGCTCAAGGAAGTGATCATGCAATGATCACGTGGCTATCATGCACGGCTCACGTGGTT
GATCCTGCAATGGTCACGTAGCTAAAATGTACTGGTCACGTGACTGATCATGCACTTATC
ACGAAATTGATCATGCACTGTTCACGTGGATCATCATGCACTGATCACGTGACTGGTCAT
GCACTGATCACGTGACTGGTCATGCACTGATCACGTGGCTATCATGCACTGATCACGTGG
CTGATCATACACTGATCACGTGCCTGGTCATGCACAGATCACGTGACTAATCATGAACTG
ATCACGTGGGTATCAGGCACTGATCACGTGGATATCATGCACTGCTCACGTGGCTGAACA
TGCAATGATCACGTAGCTACCATGTACTGGTCACGTGACTGATCATGCACTGATCACGTA
ATTGATCATGCACTGACCACGTGACTGATCATGCACTGATGACGTGGCTATCATGCCCTG
CTCACTAGGCTGATCATGCAATGATCACATAGCTACCATGTACTGGTCACGTGACTGATC
ATGCAATGATCACGTAATTGATCATGCACTGATCACGTGGCTGATCATGCGCTGATCGTG
TGACTGATCATGCACTGATCACGTGACTGATCATGCACTGATCACGTGGTTATCATGCAC
TGATCACGTGGCTGATCATACACTGATCGTGTGCCTGATCATTCACAGATCACGTGATTA
ATCATGAACTGATCACGTGGCTATCCTGCACTGATCACGTGGATATCACACACTGATCAC
GTGGATGATCATACCCCTATCACGTGACTGATCATGATAATGCACTGATCACTTGGCTGA
TCCTACACTGATCATATGGCTGATTATGCACTGATCACGTGGCTGATCATGCACTGATCA
CATGGCTGATCATACACTGATCGCGTGCCTGATCATTCACAGATCACGTGATTAATCATG
AACTGATCACGTGGCTATCCTGCACTGATCACGTGGATATGACACACTGATCACGTGGAT
GGTCATACCCCTATCACGTGACTGATCATGATAATGCACTGATCACGTGGTTGATCCTAC
ACTGATCATATGGCTGATTATGCACTGATCACGTGGCTGATCATGCACTGATCACATGAC
TGCGCATGAACTGATCACGTGGATATCATACACTGATCTAGTGACAGATCATGCACTGAT
CAGTTGACTGATCATGCACTGATCACGTGGCTATCATGCACTGACCACGTGCCTGATCAT
GCACTAATCAGGTTGTGGATCATGCACTGATCACGTGGCTGATCATACACAGCTCAAGGA
AGTGATCATGCAATGATCACGTGGCTATCATGCACTGATCACGTGGCTGATCCTACACTG
ATCATATGGCTGATTATGCACTGATCACGTGGCTGATCATGCACTGATCACATGACTGCG
CATGAACTGATCACGTGGATATCATACACTGATCAAGTGACAGATCATGCACTGATCACG
TGGTTATCATGCACTGATCACGTGGCTGATCATACACTGATCACGTGCCTGATCATTCAC
AGATCACGTGATTAATCATGAACTGATCACGTGACTATCCTGCACTAATCACGTGGATAT
CACACACTGATCACTTGGATGATCATACCCCTATCACGTGACTGATCATGTTAATGCACT
GATCACGTGGCTGATCATGCACTGATCACGTGGCTGATCATGCACTGATCACGTGGCTGA
TCCTACACTGATCATATGGCTGATCATGCACTGATCACGTACATGATCATGCACTGATCA
TTTGGCTGATCATACACTGATCTTGTGACTGCGCATGCACTGATCACGTGACTAATCTTT
CACTGATCACATGGCTATCATGCACTGATCATGTGTCTATCATGCACTGATCACGTGACT
GCACATGAACTGATCACTTACCTTTTCATGCACTGATTACCTGGCTATCATGCACTGATC
ACGTGGATGATCATGCACTGATCACATGACTGATTCGGCAATGATCACGTAGCTATAATG
CACTGATCACATGACTGCGCATGCCATGATCATGTGACTCATCATGCACTGATCACGTGC
CTATCATGCACTGATAACGTGGCTGATCATGCACTGATCACGTGACTGATCATGCACTGA
TCGCGTGGCTATCATGGACTGATCATGTGGCTAATCATACATTGATCACCTAAATAATCA
TGCACTGATCACGGGGCGATATTGCACTGATCACGTGGCTTATCAGGCACTGATAACTTA
CCTATCATGCACTGATCACATGACTGGGCAAGAACTTATCACGTGGATATCATACACTGG
ACATGTGACAGATAACGCACTGACCACGTGACTGATCATGCACTGATCACGTGGCTATCA
TGCACTGATCCCTTGGCTATCATGCACTGATCACCTGACTGATCATGCACTGATCAAGTG
GCTATCATGCACTGATCACGTGGCTAGCATGCAATGATCACCTGAAGGATCATGCAGTAA
TCACGTCGCTATCATGCACGGATGTCGAGATTGGGCATGCACTGGTCATGAGGATGATCA
TACACTGGTCACGTACAGATCATGCACTGATTACGTGTCTATCATGCACTGATCACGTGG
CTGATCCTGCAATGATCACGTGACTGAATATGAACTGATTGCGTAGCTATCATGCACTGA
TCGCATGACTTCGAATGCCATGATCACGTGACTGATCATGCACTGATCAGGTGGCTATCA
TGCACTGATCACGTGGCTAATCATACATTGATCACGTAACTAACCATGCACTGATCACTT
GACAATCTTGCACTGATCACGTGGCTGATCACGCACTGATCACGTAGTTATCATGCACTG
ATCACATGACTGCGCATGAACTGATCACGTGGATATCATACACTGATCAAGTGACAGATC
ATGCACTGATCAGTTGTCTGATCATGCACTGATCACGTGGCTATCATGCACTGATCACGT
GCCTGATCATGCACTAATCAGGTTGTGGATCATGCACTGATCACGTGGCTGATCATACAC
AGCTCAAGGAAGTGATCATGCAATGATCACGTGGCTATCATGCACTGCTCACGTGGTTGA
TCCTGCAATGGTCACGTAGCTACAATGTACTGGTCACGTGACTGATCATGCACTGATCAC
GAAATTGATCATGCACTGATCACGTGACTGATCATGCACTGATCACGTGACTGTTCATGC
ACTGATCACGTGACTGATCATACACTGATCACGTGCCAGGTCATGCACAGATCACGTGAC
TAATCATGAACTGATCACGTGGCTATAATGCAATGATCACGTGGATATCATACACTGATC
CCGTGCCTGTCATGCACAGATCACGTGACTAATCATGAACTGATCACGTGGGTATCAGGC
ACTGATCACGTGGATATCATGCACTGCTCACGTGGCTGAACATGCAATGATCACGTAGCT
ACCATGTACTGGTCACGTGACTGATCATGCACTGATCACGTAATTGATCATGCACTGACC
ACGTGACTGATCATGCACTGATGACGTGGCTATCATGCCCTGCTCACTAGGCTGATCATG
CAATGATCACATAGCTACCATGTACTGGTCACGTGACTGATCATGCAATGATCACGTAAT
AGATCATGCAATGAGCACGTGGCTGATCATACACTGATCGAGTGCCTGATCATTCACAGA
TCACGTGATTAATAATGAACTGATCACGTGGCTATCCTGCACTGATCACGTGGATATCAC
ACACTGATCACGTGGATGATCATACCATTATCACGTGACTGATCATGATAATGCACTGGT
CATATGGCTGATTATGCACTGATCACGTGGCTGATCATGCACTGATCACGTGACTGATCA
TGCACTGATCACGTGGTTATCATGCACTGATCACGTGGCTGATCATACACTGATCGCGTG
CCTGATCATTCACAGATCACGTGATTAATCATGAACTGATCACGTGGCTATCCTGCACTG
ATCACGTGGATATCACACACTGATCACGTGGATGATCATACCCCTAACACGTGACTGATC
ATGATAATGCACTGATCACGTGGCTGATCCTACACTGATCATATGGCTGATTATGCACTG
ATCACGTGGCTGATCATGCACTGATCACATGACTGCGCATGAACTGATCACGTGGATATC
ATACACTGATCAAGTGACAGATCATGCACTGATCACGTGGTTATCATGCACTGATCACGT
GGCTGATCATACACTGATCGAGTGCCTGATCATTCACAGATCACGTGATTAATCATGAAC
TGATCACCTGGCTATCCTGCACTGATCACGTGGATATCACACACTGATCACGTGGATGAT
CATACCCCTATCACGTGACTGATCATGATAATGCACTGATCACTTGGCTGATCCTACACT
GATCATATGGCTGATTATGCACTGATCACGTGGCTGATCATGCACTGATCACATGGCTGA
TCATACACTGATCGCGTGCCTGATCATTCACAGATCACGTGATTAATCATGAACTGATTA
CATGGCTATCCTGCACTGATCACGTGGAAATGACACACTGATCACGTGGATGGTCATACC
CCTATCACGTGACTGATCATGATAATGCACTGATCACGTGGTTGATCCTACACTGATCAT
ATGGCTGATTATGCACTGATCACGTGGCTGATCATGCACTGATCACATGACTGCGCATGA
ACTGATCACGTGGATATCATACACTGATCAAGTGACAGATCATGCACTGCTCAGTTGACT
GATCATGCACTGAACACGTGGCAATCATGCACTGACCACGTGCCTGATCATGCACTAATC
AGGTTGTGGATCATGCACTGATCACGTGGCTGATCATACACAGCTCAAGGAAGTGATCAT
GCAATGATCACGTGGCTATCATGCACTGATCACGTGGCTGATCCTACACTGATCATATGG
CTGATTATGCACTGATCACGTGGCTGATCATGCACTGATCACATGACTGCGCATGAACTG
ATCACGTGGATATCATACACTGATCAAGTGACAGATCATGCACTGATCACGTGGTTATCA
TGCACTGATCACGTGGCTGATCATACACTGATCACGTGCCTGATCATTCACAGATCACGT
GATTAATCATGAACTGATCACGTGACTATCCTGCACTAATCACGTGGATATCACACACTG
ATCACTTGGATGATCATACCCCTATCACGTGACTGATCATGTTAATGCACTGATCACGTG
GCTGATCATGCACTGATCACGTGGCTGATCATGCACTGATCACGTGGCTGATCCTACACT
GATCATATGGCTGATCATGCACTGATCACGTACATGATCATGCACTGATCATTTGGCTGA
TCATACACTGATCTTGTGACTGCGCATGCACTGATCACGTGACTAATCTTTCACTGATCA
CATGGCTATCATGCACTGATCATGTGTCTATCATGCACTGATCACGTGACTGCACATGAA
CTGATCACTTACCTTTTCATGCACTGATTACCTGGCTATCATGCACTGATCACGTGGATG
ATCATGCACTGATCACATGACTGCGCATGCCATGATCATGTGACTCATCATGCACTGATC
ACGTGCCTATCATGCACTGATAACGTGGCTGATCATGCACTGATCAGGTGACTGATTATG
CACTGATCGCGTAGCTATCACGCACTGATCACGTGACTGTTCATGCACTGATCACGTGGC
TATCATGGACTGATCATGTGGCTAATCATACATTGATCACCTAAATAATCATGCACTGAT
CACGGGGCGATATTGCACTGATCACGTGGCTTATCAGGCACTGATAACTTACCTATCATG
CACTGATCACATGACTGGGCAAGAACTTATCACGTGGATATCATACACTGGACATGTGAC
AGATAACGCACTGACCACGTGACTGATCATGCACTGATCACGTGGCGATCATGCACTAAT
CACGTGGATATCACACACTGATCACTTGGATGATCATACCCCTATCACGTGACTGATCAT
GTTAATGCACTGATCACGTGGCTGATCATGCACTGATCACGTGGCTGATCATGCACTGAT
CACGTGGCTGATCCTACACTGATCATATGGCTGATCATGCACTGATCACGTACATGATCA
TGCACTGATCATTTGGCTGATCATACACTGATCTTGTGACTGCGCATGCACTGATCACGT
GACTAATCTTTCACTGATCACATGGCTATCATGCACTGATCATGTGTCTATCATGCACTG
ATCACGTGACTGCACATGAACTGATCACTTACCTTTTCATGCACTGATTACCTGGCTATC
ATGCACTGATCACGTGGATGATCATGCACTGATCACATGACTGATTCGGCAATGATCACG
TAGCTATAATACACTGATCACATGACTTCGCATGCCATGATCATGTGACTCATCATGCAC
TGATCACGTGCCTATCATGCACTGATAACGTGGCTGATCATGCACTGATCAGGTGACTGA
TTATGCACTGATCGCGTAGCTATCACGCACAGATCACGTGACTGATCATGCACTGATCAC
GTGGCTATCATGGACTGATCATGTGGCTAATCATACATTGATCACCTAAATAATCATGCA
CTGATCACGGGGCGATCATGCACTGATCCCGTGGCTATCATGCACTGATCCCTTGGCTAT
CATGCACTGATCACCTGACTGATCATGCACTGATCAAGTGGCTATCATGCACTGATCACG
TGGCTAGCATGCAATGATCACCTGAATGATCATGCAGTGATCACGTCGCTATCCTGCACG
GATGTCGAGATTGGGCATGCACTGGTCATGAGGATGATCATACACTGGTCACGTACAGAT
CATGCACTGATTACGTGTCTATCATGCACTGATCACGTGGCTGATCCTGCAATGATCACG
TGACTGAATATGAACTGATTGCGTAGCTATCATGCACTGATCGCATGACTTCGCATGCCA
TGATCACGTGACTGATCATGCACTGATCAGGTGGCTATCATGCACTGATCACGTGGCTAA
TCATACATTGATCACGTAACTAACCATGCACTGATCACTTGACAATCTTGCACTGATCAC
GTGGCTGATCACGCACTGATCACGTAGTTATCATGCACTGATCACATGACTGCGCATGAA
CTGATCACGTGGATATCATACACTGATCAAGTGACAGATCATGCACTGCTCAGTTGACTG
ATCATGCACTGATCACGTGGCTATCATGCACTGATCACGTGCCTGATCATGCACTAATCA
GGTTGTGGATCATGCACTGATCACGTGGCTGATCATACACAGCTCAAGGAAGTGATCATG
CAATGATCACGTGGCTATCATGCACGGCTCACGTGGTTGATCCTGCAATGGTCACGTAGC
TACAATGTACTGGTCACGTGACTGATCATGCACTTATCACGAAATTGATCATGCACTGTT
CACGTGGATCATCATGCACTGATCACGTGACTGGTCATGCACTGATCACGTGACTGGTCA
TGCACTGATCACGTGGCTATCATGCACTGATCACGTGGCTGATCATACACTGATCACGTG
CCTGGTCATGCACAGATCACGTGACTAATCATGAACTGATCACGTGGGTATCAGGCACTG
ATCACGTGGATATCATGCACTGCTCACGTGGCTGAACATGCAATGATCACGTAGCTACCA
TGTACTGGTCACGTGACTGATCATGCACTGATCACGTAGTTATCATGCACTGATCACATG
ACTGCGCATGAACTGATCACGTGGATATCATACACTGATCAAGTGACAGATCATGCACTG
CTCAGTTGACTGATCATGCACTGATCACGTGGCTATCATGCACTGATCACGTGCCTGATC
ATGCACTAATCAGGTTGTGGATCATGCACTGATCACGTGGCTGATCATACACAGCTCAAG
GAAGTGATCATGCAATGATCACGTGGCTATCATGCACGGCTCACGTGGTTGATCCTGCAA
TGGTCACGTAGCTAAAATGTACTGGTCACGTGACTGATCATGCACTTATCACGAAATTGA
TCATGCACTGTTCACGTGGATCATCATGCACTGATCACGTGACTGGTCATGCACTGATCA
CGTGACTGGTCATGCACTGATCACGTGGCTATCATGCACTGATCACGTGGCTGATCATAC
ACTGATCACGTGCCTGGTCATGCACAGATCACGTGACTAATCATGAACTGATCACGTGGG
TATCAGGCACTGATCACGTGGATATCATGCACTGCTCACGTGGCTGAACATGCAATGATC
ACGTAGCTACCATGTACTGGTCACGTGACTGATCATGCACTGATCACGTAATTGATCATG
CACTGACCACGTGACTGATCATGCACTGATGACGTGGCTATCATGCCCTGCTCACTAGGC
TGATCATGCAATGATCACATAGCTACCATGTACTGGTCACGTGACTGATCATGCAATGAT
CACGTAATTGATCATGCACTGATCACGTGGCTGATCATGCGCTGATCGTGTGACTGATCA
TGCACTGATCACGTGACTGATCATGCACTGATCACGTGGTTATCATGCACTGATCACGTG
GCTGATCATACACTGATCGTGTGCCTGATCATTCACAGATCACGTGATTAATCATGAACT
GATCACGTGGCTATCCTGCACTGATCACGTGGATATCACACACTGATCACGTGGATGATC
ATACCCCTATCACGTGACTGATCATGATAATGCACTGATCACTTGGCTGATCCTACACTG
ATCATATGGCTGATTATGCACTGATCACGTGGCTGATCATGCACTGATCACATGGCTGAT
CATACACTGATCGCGTGCCTGATCATTCACAGATCACGTGATTAATCATGAACTGATCAC
GTGGCTATCCTGCACTGATCACGTGGATATGACACACTGATCACGTGGATGGTCATACCC
CTATCACGTGACTGATCATGATAATGCACTGATCACGTGGTTGATCCTACACTGATCATA
TGGCTGATTATGCACTGATCACGTGGCTGATCATGCACTGATCACATGACTGCGCATGAA
CTGATCACGTGGATATCATACACTGATCTAGTGACAGATCATGCACTGATCAGTTGACTG
ATCATGCACTGATCACGTGGCTATCATGCACTGACCACGTGCCTGATCATGCACTAATCA
GGTTGTGGATCATGCACTGATCACGTGGCTGATCATACACAGCTCAAGGAAGTGATCATG
CAATGATCACGTGGCTATCATGCACTGATCACGTGGCTGATCCTACACTGATCATATGGC
TGATTATGCACTGATCACGTGGCTGATCATGCACTGATCACATGACTGCGCATGAACTGA
TCACGTGGATATCATACACTGATCAAGTGACAGATCATGCACTGATCACGTGGTTATCAT
GCACTGATCACGTGGCTGATCATACACTGATCACGTGCCTGATCATTCACAGATCACGTG
ATTAATCATGAACTGATCACGTGACTATCCTGCACTAATCACGTGGATATCACACACTGA
TCACTTGGATGATCATACCCCTATCACGTGACTGATCATGTTAATGCACTGATCACGTGG
CTGATCATGCACTGATCACGTGGCTGATCATGCACTGATCACGTGGCTGATCCTACACTG
ATCATATGGCTGATCATGCACTGATCACGTACATGATCATGCACTGATCATTTGGCTGAT
CATACACTGATCTTGTGACTGCGCATGCACTGATCACGTGACTAATCTTTCACTGATCAC
ATGGCTATCATGCACTGATCATGTGTCTATCATGCACTGATCACGTGACTGCACATGAAC
TGATCACTTACCTTTTCATGCACTGATTACCTGGCTATCATGCACTGATCACGTGGATGA
TCATGCACTGATCACATGACTGATTCGGCAATGATCACGTAGCTATAATGCACTGATCAC
ATGACTGCGCATGCCATGATCATGTGACTCATCATGCACTGATCACGTGCCTATCATGCA
CTGATAACGTGGCTGATCATGCACTGATCACGTGACTGATCATGCACTGATCGCGTGGCT
ATCATGGACTGATCATGTGGCTAATCATACATTGATCACCTAAATAATCATGCACTGATC
ACGGGGCGATATTGCACTGATCACGTGGCTTATCAGGCACTGATAACTTACCTATCATGC
ACTGATCACATGACTGGGCAAGAACTTATCACGTGGATATCATACACTGGACATGTGACA
GATAACGCACTGACCACGTGACTGATCATGCACTGATCACGTGGCTATCATGCACTGATC
CCTTGGCTATCATGCACTGATCACCTGACTGATCATGCACTGATCAAGTGGCTATCATGC
ACTGATCACGTGGCTAGCATGCAATGATCACCTGAAGGATCATGCAGTAATCACGTCGCT
ATCATGCACGGATGTCGAGATTGGGCATGCACTGGTCATGAGGATGATCATACACTGGTC
ACGTACAGATCATGCACTGATTACGTGTCTATCATGCTCTGATCACGTGGCTGATCCTGC
AATGATCACGTGACTGAATATGAACTGATTGCGTAGCTATCATGCACTGATCGCATGACT
TCGAATGCCATGATCACGTGACTGATCATGCACTGATCAGGTGGCTATCATGCACTGATC
ACGTGGCTAATCATACATTGATCACGTAACTAACCATGCACTGATCACTTGACAATCTTG
CACTGATCACGTGGCTGATCACGCACTGATCACGTAGTTATCATGCACTGATCACATGAC
TGCGCATGAACTGATCACGTGGATATCATACACTGATCAAGTGACAGATCATGCACTGAT
CAGTTGTCTGATCATGCACTGATCACGTGGCTATCATGCACTGATCACGTGCCTGATCAT
GCACTAATCAGGTTGTGGATCATGCACTGATCACGTGGCTGATCATACACAGCTCAAGGA
AGTGATCATGCAATGATCACGTGGCTATCATGCACTGCTCACGTGGTTGATCCTGCAATG
GTCACGTAGCTACAATGTACTGGTCACGTGACTGATCATGCACTGATCACGAAATTGATC
ATGCACTGATCACGTGACTGATCATGCACTGATCACGTGACTGTTCATGCACTGATCACG
TGACTGATCATACACTGATCACGTGCCAGGTCATGCACAGATCACGTGACTAATCATGAA
CTGATCACGTGGCTATAATGCAATGATCACGTGGATATCATACACTGATCCCGTGCCTGT
CATGCACAGATCACGTGACTAATCATGAACTGATCACGTGGGTATCAGGCACTGATCACG
TGGATATCATGCACTGCTCACGTGGCTGAACATGCAATGATCACGTAGCTACCATGTACT
GGTCACGTGACTGATCATGCACTGATCACGTAATTGATCATGCACTGACCACGTGACTGA
TCATGCACTGATGACGTGGCTATCATGCCCTGCTCACTAGGCTGATCATGCAATGATCAC
ATAGCTACCATGTACTGGTCACGTGACTGATCATGCAATGATCACGTAATAGATCATGCA
ATGAGCACGTGGCTGATCATACACTGATCGAGTGCCTGATCATTCACAGATCACGTGATT
AATAATGAACTGATCACGTGGCTATCCTGCACTGATCACGTGGATATCACACACTGATCA
CGTGGATGATCATACCATTATCACGTGACTGATCATGATAATGCACTGGTCATATGGCTG
ATTATGCACTGATCACGTGGCTGATCATGCACTGATCACGTGACTGATCATGCACTGATC
ACGTGGTTATCATGCACTGATCACGTGGCTGATCATACACTGATCGCGTGCCTGATCATT
CACAGATCACGTGATTAATCATGAACTGATCACGTGGCTATCCTGCACTGATCACGTGGA
TATCACACACTGATCACGTGGATGATCATACCCCTAACACGTGACTGATCATGATAATGC
ACTGATCACGTGGCTGATCCTACACTGATCATATGGCTGATTATGCACTGATCACGTGGC
TGATCATGCACTGATCACATGACTGCGCATGAACTGATCACGTGGATATCATACACTGAT
CAAGTGACAGATCATGCACTGATCACGTGGTTATCATGCACTGATCACGTGGCTGATCAT
ACACTGATCGAGTGCCTGATCATTCACAGATCACGTGATTAATCATGAACTGATCACCTG
GCTATCCTGCACTGATCACGTGGATATCACACACTGATCACGTGGATGATCATACCCCTA
TCACGTGACTGATCATGATAATGCACTGATCACTTGGCTGATCCTACACTGATCATATGG
CTGATTATGCACTGATCACGTGGCTGATCATGCACTGATCACATGGCTGATCATACACTG
ATCGCGTGCCTGATCATTCACAGATCACGTGATTAATCATGAACTGATTACATGGCTATC
CTGCACTGATCACGTGGAAATGACACACTGATCACGTGGATGGTCATACCCCTATCACGT
GACTGATCATGATAATGCACTGATCACGTGGTTGATCCTACACTGATCATATGGCTGATT
ATGCACTGATCACGTGGCTGATCATGCACTGATCACATGACTGCGCATGAACTGATCACG
TGGATATCATACACTGATCAAGTGACAGATCATGCACTGCTCAGTTGACTGATCATGCAC
TGAACACGTGGCAATCATGCACTGACCACGTGCCTGATCATGCACTAATCAGGTTGTGGA
TCATGCACTGATCACGTGGCTGATCATACACAGCTCAAGGAAGTGATCATGCAATGATCA
CGTGGCTATCATGCACTGATCACGTGGCTGATCCTACACTGATCATATGGCTGATTATGC
ACTGATCACGTGGCTGATCATGCACTGATCACATGACTGCGCATGAACTGATCACGTGGA
TATCATACACTGATCAAGTGACAGATCATGCACTGATCACGTGGTTATCATGCACTGATC
ACGTGGCTGATCATACACTGATCACGTGCCTGATCATTCACAGATCACGTGATTAATCAT
GAACTGATCACGTGACTATCCTGCACTAATCACGTGGATATCACACACTGATCACTTGGA
TGATCATACCCCTATCACGTGACTGATCATGTTAATGCACTGATCACGTGGCTGATCATG
CACTGATCACGTGGCTGATCATGCACTGATCACGTGGCTGATCCTACACTGATCATATGG
CTGATCATGCACTGATCACGTACATGATCATGCACTGATCATTTGGCTGATCATACACTG
ATCTTGTGACTGCGCATGCACTGATCACGTGACTAATCTTTCACTGATCACATGGCTATC
ATGCACTGATCATGTGTCTATCATGCACTGATCACGTGACTGCACATGAACTGATCACTT
ACCTTTTCATGCACTGATTACCTGGCTATCATGCACTGATCACGTGGATGATCATGCACT
GATCACATGACTGCGCATGCCATGATCATGTGACTCATCATGCACTGATCACGTGCCTAT
CATGCACTGATAACGTGGCTGATCATGCACTGATCAGGTGACTGATTATGCACTGATCGC
GTAGCTATCACGCACTGATCACGTGACTGTTCATGCACTGATCACGTGGCTATCATGGAC
TGATCATGTGGCTAATCATACATTGATCACCTAAATAATCATGCACTGATCACGGGGCGA
TATTGCACTGATCACGTGGCTTATCAGGCACTGATAACTTACCTATCATGCACTGATCAC
ATGACTGGGCAAGAACTTATCACGTGGATATCATACACTGGACATGTGACAGATAACGCA
CTGACCACGTGACTGATCATGCACTGATCACGTGGCGATCATGCACTAATCACGTGGATA
TCACACACTGATCACTTGGATGATCATACCCCTATCACGTGACTGATCATGTTAATGCAC
TGATCACGTGGCTGATCATGCACTGATCACGTGGCTGATCATGCACTGATCACGTGGCTG
ATCCTACACTGATCATATGGCTGATCATGCACTGATCACGTACATGATCATGCACTGATC
ATTTGGCTGATCATACACTGATCTTGTGACTGCGCATGCACTGATCACGTGACTAATCTT
TCACTGATCACATGGCTATCATGCACTGATCATGTGTCTATCATGCACTGATCACGTGAC
TGCACATGAACTGATCACTTACCTTTTCATGCACTGATTACCTGGCTATCATGCACTGAT
CACGTGGATGATCATGCACTGATCACATGACTGATTCGGCAATGATCACGTAGCTATAAT
ACACTGATCACATGACTTCGCATGCCATGATCATGTGACTCATCATGCACTGATCACGTG
CCTATCATGCACTGATAACGTGGCTGATCATGCACTGATCAGGTGACTGATTATGCACTG
ATCGCGTAGCTATCACGCACAGATCACGTGACTGATCATGCACTGATCACGTGGCTATCA
TGGACTGATCATGTGGCTAATCATACATTGATCACCTAAATAATCATGCACTGATCACGG
GGCGATCATGCACTGATCCCGTGGCTATCATGCACTGATCCCTTGGCTATCATGCACTGA
TCACCTGACTGATCATGCACTGATCAAGTGGCTATCATGCACTGATCACGTGGCTAGCAT
GCAATGATCACCTGAATGATCATGCAGTGATCACGTCGCTATCCTGCACGGATGTCGAGA
TTGGGCATGCACTGGTCATGAGGATGATCATACACTGGTCACGTACAGATCATGCACTGA
TTACGTGTCTATCATGCACTGATCACGTGGCTGATCCTGCAATGATCACGTGACTGAATA
TGAACTGATTGCGTAGCTATCATGCACTGATCGCATGACTTCGCATGCCATGATCACGTG
ACTGATCATGCACTGATCAGGTGGCTATCATGCACTGATCACGTGGCTAATCATACATTG
ATCACGTAACTAACCATGCACTGATCACTTGACAATCTTGCACTGATCACGTGGCTGATC
ACGCACTGATCACGTAGTTATCATGCACTGATCACATGACTGCGCATGAACTGATCACGT
GGATATCATACACTGATCAAGTGACAGATCATGCACTGCTCAGTTGACTGATCATGCACT
GATCACGTGGCTATCATGCACTGATCACGTGCCTGATCATGCACTAATCAGGTTGTGGAT
CATGCACTGATCACGTGGCTGATCATACACAGCTCAAGGAAGTGATCATGCAATGATCAC
GTGGCTATCATGCACGGCTCACGTGGTTGATCCTGCAATGGTCACGTAGCTACAATGTAC
TGGTCACGTGACTGATCATGCACTTATCACGAAATTGATCATGCACTGTTCACGTGGATC
ATCATGCACTGATCACGTGACTGGTCATGCACTGATCACGTGACTGGTCATGCACTGATC
ACGTGGCTATCATGCACTGATCACGTGGCTGATCATACACTGATCACGTGCCTGGTCATG
CACAGATCACGTGACTAATCATGAACTGATCACGTGGGTATCAGGCACTGATCACGTGGA
TATCATGCACTGCTCACGTGGCTGAACATGCAATGATCACGTAGCTACCATGTACTGGTC
ACGTGACTGATCATGCACTGATCACGTAGTTATCATGCACTGATCACATGACTGCGCATG
AACTGATCACGTGGATATCATACACTGATCAAGTGACAGATCATGCACTGCTCAGTTGAC
TGATCATGCACTGATCACGTGGCTATCATGCACTGATCACGTGCCTGATCATGCACTAAT
CAGGTTGTGGATCATGCACTGATCACGTGGCTGATCATACACAGCTCAAGGAAGTGATCA
TGCAATGATCACGTGGCTATCATGCACGGCTCACGTGGTTGATCCTGCAATGGTCACGTA
GCTAAAATGTACTGGTCACGTGACTGATCATGCACTTATCACGAAATTGATCATGCACTG
TTCACGTGGATCATCATGCACTGATCACGTGACTGGTCATGCACTGATCACGTGACTGGT
CATGCACTGATCACGTGGCTATCATGCACTGATCACGTGGCTGATCATACACTGATCACG
TGCCTGGTCATGCACAGATCACGTGACTAATCATGAACTGATCACGTGGGTATCAGGCAC
TGATCACGTGGATATCATGCACTGCTCACGTGGCTGAACATGCAATGATCACGTAGCTAC
CATGTACTGGTCACGTGACTGATCATGCACTGATCACGTAATTGATCATGCACTGACCAC
GTGACTGATCATGCACTGATGACGTGGCTATCATGCCCTGCTCACTAGGCTGATCATGCA
ATGATCACATAGCTACCATGTACTGGTCACGTGACTGATCATGCAATGATCACGTAATTG
ATCATGCACTGATCACGTGGCTGATCATGCGCTGATCGTGTGACTGATCATGCACTGATC
ACGTGACTGATCATGCACTGATCACGTGGTTATCATGCACTGATCACGTGGCTGATCATA
CACTGATCGTGTGCCTGATCATTCACAGATCACGTGATTAATCATGAACTGATCACGTGG
CTATCCTGCACTGATCACGTGGATATCACACACTGATCACGTGGATGATCATACCCCTAT
CACGTGACTGATCATGATAATGCACTGATCACTTGGCTGATCCTACACTGATCATATGGC
TGATTATGCACTGATCACGTGGCTGATCATGCACTGATCACATGGCTGATCATACACTGA
TCGCGTGCCTGATCATTCACAGATCACGTGATTAATCATGAACTGATCACGTGGCTATCC
TGCACTGATCACGTGGATATGACACACTGATCACGTGGATGGTCATACCCCTATCACGTG
ACTGATCATGATAATGCACTGATCACGTGGTTGATCCTACACTGATCATATGGCTGATTA
TGCACTGATCACGTGGCTGATCATGCACTGATCACATGACTGCGCATGAACTGATCACGT
GGATATCATACACTGATCTAGTGACAGATCATGCACTGATCAGTTGACTGATCATGCACT
GATCACGTGGCTATCATGCACTGACCACGTGCCTGATCATGCACTAATCAGGTTGTGGAT
CATGCACTGATCACGTGGCTGATCATACACAGCTCAAGGAAGTGATCATGCAATGATCAC
GTGGCTATCATGCACTGATCACGTGGCTGATCCTACACTGATCATATGGCTGATTATGCA
CTGATCACGTGGCTGATCATGCACTGATCACATGACTGCGCATGAACTGATCACGTGGAT
ATCATACACTGATCAAGTGACAGATCATGCACTGATCACGTGGTTATCATGCACTGATCA
CGTGGCTGATCATACACTGATCACGTGCCTGATCATTCACAGATCACGTGATTAATCATG
AACTGATCACGTGACTATCCTGCACTAATCACGTGGATATCACACACTGATCACTTGGAT
GATCATACCCCTATCACGTGACTGATCATGTTAATGCACTGATCACGTGGCTGATCATGC
ACTGATCACGTGGCTGATCATGCACTGATCACGTGGCTGATCCTACACTGATCATATGGC
TGATCATGCACTGATCACGTACATGATCATGCACTGATCATTTGGCTGATCATACACTGA
TCTTGTGACTGCGCATGCACTGATCACGTGACTAATCTTTCACTGATCACATGGCTATCA
TGCACTGATCATGTGTCTATCATGCACTGATCACGTGACTGCACATGAACTGATCACTTA
CCTTTTCATGCACTGATTACCTGGCTATCATGCACTGATCACGTGGATGATCATGCACTG
ATCACATGACTGATTCGGCAATGATCACGTAGCTATAATGCACTGATCACATGACTGCGC
ATGCCATGATCATGTGACTCATCATGCACTGATCACGTGCCTATCATGCACTGATAACGT
GGCTGATCATGCACTGATCACGTGACTGATCATGCACTGATCGCGTGGCTATCATGGACT
GATCATGTGGCTAATCATACATTGATCACCTAAATAATCATGCACTGATCACGGGGCGAT
ATTGCACTGATCACGTGGCTTATCAGGCACTGATAACTTACCTATCATGCACTGATCACA
TGACTGGGCAAGAACTTATCACGTGGATATCATACACTGGACATGTGACAGATAACGCAC
TGACCACGTGACTGATCATGCACTGATCACGTGGCTATCATGCACTGATCCCTTGGCTAT
CATGCACTGATCACCTGACTGATCATGCACTGATCAAGTGGCTATCATGCACTGATCACG
TGGCTAGCATGCAATGATCACCTGAAGGATCATGCAGTAATCACGTCGCTATCATGCACG
GATGTCGAGATTGGGCATGCACTGGTCATGAGGATGATCATACACTGGTCACGTACAGAT
CATGCACTGATTACGTGTCTATCATGCTCTGATCACGTGGCTGATCCTGCAATGATCACG
TGACTGAATATGAACTGATTGCGTAGCTATCATGCACTGATCGCATGACTTCGAATGCCA
TGATCACGTGACTGATCATGCACTGATCAGGTGGCTATCATGCACTGATCACGTGGCTAA
TCATACATTGATCACGTAACTAACCATGCACTGATCACTTGACAATCTTGCACTGATCAC
GTGGCTGATCACGCACTGATCACGTAGTTATCATGCACTGATCACATGACTGCGCATGAA
CTGATCACGTGGATATCATACACTGATCAAGTGACAGATCATGCACTGATCAGTTGTCTG
ATCATGCACTGATCACGTGGCTATCATGCACTGATCACGTGCCTGATCATGCACTAATCA
GGTTGTGGATCATGCACTGATCACGTGGCTGATCATACACAGCTCAAGGAAGTGATCATG
CAATGATCACGTGGCTATCATGCACTGCTCACGTGGTTGATCCTGCAATGGTCACGTAGC
TACAATGTACTGGTCACGTGACTGATCATGCACTGATCACGAAATTGATCATGCACTGAT
CACGTGACTGATCATGCACTGATCACGTGACTGTTCATGCACTGATCACGTGACTGATCA
TACACTGATCACGTGCCAGGTCATGCACAGATCACGTGACTAATCATGAACTGATCACGT
GGCTATAATGCAATGATCACGTGGATATCATACACTGATCCCGTGCCTGTCATGCACAGA
TCACGTGACTAATCATGAACTGATCACGTGGGTATCAGGCACTGATCACGTGGATATCAT
GCACTGCTCACGTGGCTGAACATGCAATGATCACGTAGCTACCATGTACTGGTCACGTGA
CTGATCATGCACTGATCACGTAATTGATCATGCACTGACCACGTGACTGATCATGCACTG
ATGACGTGGCTATCATGCCCTGCTCACTAGGCTGATCATGCAATGATCACATAGCTACCA
TGTACTGGTCACGTGACTGATCATGCAATGATCACGTAATAGATCATGCAATGAGCACGT
GGCTGATCATACACTGATCGCGTGCCTGATCATTCACAGATCACGTCATTAATAATGAAC
TGATCACGTGGCTATCCTGCACTGATCACGTGGATATCACACACTGATCACGTGGATGAT
CATACCATTATCACGTGACTGATCATGATAATGCACTGGTCATATGGCTGATTATGCACT
GATCACGTGGCTGATCATGCACTGATCACGTGACTGATCATGCACTGATCACGTGGTTAT
CATGCACTGATCACGTGGCTGATCATACACTGATCGCGTGCCTGATCATTCACAGATCAC
GTGATTAATCATGAACTGATCACGTGGCTATCCTGCACTGATCACGTGGATATCACACAC
TGATCACGTGGATGATCATACCCCTAACACGTGACTGATCATGATAATGCACTGATCACG
TGGCTGATCCTACACTGATCATATGGCTGATTATGCACTGATCACGTGGCTGAACATGCA
CTGATCACGTGGCTGATCATGCACTGATCACGTGGCTGATCCTACACTGACCATATGGCG
GATTATGCACTGATCACATGGCTGATCACGCACTGATCACGTAGTTATCATGCACTGATC
ACATGACTGCGCATGAACTGATCACGTGGATATCATACACTGATCAAGTGACAGATCATG
CACTGCTCAGTTGACTGATCATGCACTGATCACGTGGCTATCATGCACTGATCACGTGCC
TGATCATGCACTAATCAGGTTGTGGATCATGCACTGATCACGTGGCTGATCATACACAGC
TCAAGGAAGTGATCATGCAATGATCACGTGGCTATCATGCACGGCTCACGTGGTTGATCC
TGCAATGGTCACGTAGCTACAATGTACTGGTCACGTGACTGATCATGCACTGATCACGAA
ATTGATCATGCACTGTTCACGTGGATCATCATGCACTGATCACGTGACTGTTCATGCACT
GATCACGTGACTGGTCATGGACTGATCACGTGGCTATCATGCACTGATCACGTGGCTGAT
CATACACTGATCACGTGCCTGGTCATGCACAGATCATGTGACTAATCATGAACTGATCAC
GTGGCTATAATGCAATGATCACGTGGATATCATACACTGATCACGTGCCTGTCATGCACA
GATCACGTGACTAATCATGAACTGATCACGTGGGTATCAGGCACTGATCACGTGGATATC
ATGCACTGCTCACGTGGCTGAACATGCAATGATCACGTAGCTACCATGTACTGGTCACGT
GACTGATCATGCACTGATCACGTAATTGATCATGCACTGATCACGTGGCTGATCATGCGC
TGATCGTGTGACTGATCATGCACTGATCACGTGACTGATCATGCACTGATGACGTGGCTA
TCATGCCCTGCTCACTAGGCTGATCATGCAATGATCACATAGCTACCATGTACTGGTCAC
GTGACTGATCATGCAATGATCACGTAATTGATCATGCACTGATCACGTGGCTGATCATGC
ACTGATCACGTGGTTATCATGCACTGCTCACGTGGCTGAACATGCAATGATCACGTAGCT
ACCATGTACTGGTCACGTGACTGATCATGCACTGATCACGTAATTGATCATGCACTGACC
ACGTGACTGATCATGCACTGATGACGTGGCTATCATGCCCTGCTCACTAGGCTGATCATG
CAATGATCACATAGCTACCATGTACTGGTCACGTGACTGATCATGCAATGATCACGTAAT
TGATCATGCACTGATCACGTGGCTGATCATGCGCTGATCGTGTGACTGATCATGCACTGA
TCACGTGACTGATCATGCACTGATCACGTGGTTATTATGCACTGATCACGTGGCTGATCA
TACACTGATCGCGTGCCTGATCATTCACAGATCACGTGATTAATCATGAACTGATCACGT
GGCTATCCTGCACTGATCACGTGGATATCACACACTGATCACGTGGATGATCATACCCCT
ATCACGTGACTGATCATGATAATGCACTGATCACTTGGCTGATCCTACACTGATCATATG
GCTGATTATGCACTGATCACGTGGCTGATCATGCACTGATCACATGGCTGATCATACACT
GATCGCGTGCCTGATCATTCACAGATCACGTGATTAATCATGAACTGATCACGTGGCTAT
CCTGCACTGATCACGTGGATATGACACACTGATCACGTGGATGGTCATACCCCTATCACG
TGACTGATCATGATAATGCACTGATCACGTGGTTGATCCTACACTGATCATATGGCTGAT
TATGCACTGATCACGTGGCTGATCATGCACTGATCACATGACTGCGCATGAACTGATCAC
GTGGATATCATACACTGATCAAGTGACAGATCATGCACTGATCAGTTGACTGATCATGCA
CTGATCACGTGGCTATCATGCACTGACCACGTGCCTGATCATGCACTAATCAGGTTGTGG
ATCATGCACTGATCACGTGGCTGATCATACACAGCTCAAGGAAGTGATCATGCAATGATC
ACGTGGCTATCATGCACTGATCACGTGGCTGATCCTACACTGATCATATGGCTGATTATG
TACTGATCACGTGGCTGATCATGCACTGATCACATGACTGCGCATGAACTGATCACGTGG
ATATCATACACTGATCAAGTGACAGATCATGCACTGATCACGTGGTTATCATGCACTGAT
AACGTGGCTGATCATACACTGATCACGTGCCTGATCATTCACAGATCACGTGATTAATCA
TGAACTGATCACGTGACTATCCTGCACTAATCACGTGGATATCACACACTGATCACTTGG
ATGATCATACCCCTATCACGTGACTGATCATGTTAATGCACTGATCACGTGGCTGATCAT
GCACTGATCACGTGGCTGATCATGCACTGATCACGTGGCTGATCCTACACTGATCATATG
GCTGATCATGCACTGATCACGTACATGATCATGCACTGATCATTTGGCTGATCATACACT
GATCTTGTGACTGCACATGCACTGATCACGTGACTAATCTTTCACTGATCACATGGCTAT
CATGCACTGATCATGTGTCTATCATGCACTGATCACGTGACTGCACATGAACTGATCACT
TACCTTTTCATGCACTGATTACCTGGCTATCATGCACTGATCACGTGGATGATCATGCAC
TCATCACATGACTGATTCGGCAATGATCACGTAGCTATAATGCACTGATCACATGACTGC
GCATGCCATGATCATGTGACTCATCATGCACTGATCACGTGCCTATCATGCACTGATAAC
GTGGCTGATCATGCACTGATCACGTGACTGATCATGCACTGATCGCGTGGCTATCATGCA
CTGATCCCTTGGCTATCATGCACTGATCACCTGACTGATCATGCACTGATCAAGTGGCTA
TCATGCACTGATCACGTGGCTAGCATGCAATGATCACCTGAATGATCATGCAGTAATCAC
GTCGCTATCATGCATGGATGTCGAGATTGGGCATGCACTGGTCATGAGGATGATCATACA
CTGGTCACGTACAGATCATGCACTGATTACGTGTCTATCATGCACTGATCACGTGGCTGA
TCCTGCAATGATCACGTGACTGAATATGAACTGATTGCCTAGCTATCATGCACTGATCGC
ATGACTTCGCATGCCATGATCACGTGACTGATCATGCACTGATCAGGTGGCTATCATGCA
CTGATCACGTGGCTAATCATACATTGATCACGTAACTAACCATGCACTGATCACTTGACA
ATCTTGCACTGATCACGTGGCTGATCACGCACTGATCACGTAGTTATCATGCACTGATCA
CATGACTGCGCATGAACTGATCACGTGGATATCATACACTGATCAAGTGACAGATCATGC
ACTGCTCAGTTGACTGATCATGCACTGATCACGTGGCTATCATGCACTGATCACGTGCCT
GATCATGCACTAATCAGGTTGTGGATCATGCACTGATCACGTGGCTGATCATACACAGCT
CAAGGAAGTGATCATGCAATGATCACGTGGCTATCATGCACTGCTCACGTGGTTGATCCT
GCAATGGTCACGTAGCTACAATGTACTGGTCACGTGACTGATCATGCACTGATCACGTGA
CTGTTCATGCACTGATCACGTGACTGATCATGCACTGATCACGTGACTGTTCATGCACTG
ATCACGTGACTGATCATACACTGATCACGTGCCAGGTCATGCACAGATCACGTGACTAAT
CATGAACTGATCACGTGGCTATAATGCAATGATCACGTGGATATCATACACTGATCCCGT
GCCTGTCATGCACAGATCACGTGACTAATCATGAACTGATCACGTGGGTATCAGGCACTG
ATCACGTGGATATCATGCACTGCTCACGTGGCTGAACATGCAATGATCACGTAGCTACCA
TGTACTGGTCACGTGACTGATCATGCACTGATCACGTAATTGATCATGCACTGACCACGT
GACTGATCATGCACTGATGACGTGGCTATCATGCCCTGCTCACTAGGCTGATCATGCAAT
GATCACATAGCTACCATGTACTGGTCACGTGACTGATCATGCAATGATCACGTAATAGAT
CATGCAATGAGCACGTGGCTGATCATACACTGATCGCGTGCCTGATCATTCACAGATCAC
GTGATTAATAATGAACTGATCACGTGGCTATCCTGCACTGATCACGTGGATATCACACAC
TGATCATGTGGATGATCATACCATTATCACGTGACTGATCATGATAATGCACTGGTCATA
TGGCTGATTATGCACTGATCACGTGGCTGAACATGCACTGATCACGTGGCTGATCATGCA
CTGATCACGTGGCTGATCCTACACTGACCATATGGCGGATTATGCACTGATCACATGGCT
GATCACGCACTGATCACGTAGTTATCATGCACTGATCACATGACTGCGCATGAACTGATC
ACGTGGATATCATACACTGATCAAGTGACAGATCATGCACTGCTCAGTTGACTGATCATG
CACTGATCACGTGGCTATCATGCACTGATCACGTGCCTGATCATGCACTAATCAGGTTGT
GGATCATGCACTGATCACGTGGCTGATCATACACAGCTCAAGGAAGTGATCATGCAATGA
TCACGTGGCTATCATGCACGGCTCACGTGGTTGATCCTGCAATGGTCACGTAGATACAAT
GTACTGGTCACGTGACTGATCATGCACTGATCACGAAATTGATCATGCACTGTTCACGTG
GATCATCATGCACTGCTCACGTGACTGTTCATGCACTGATCAAGTGACTGGTCATGCACT
GATCACGTGGCTATCATGCACTGATCACGTGGCTGATCATACACTGATCACTTGCCTGGT
CATGCACAGATCACGTGACTAATCATGAACTGATCACGTGGCTATAATGCAATGATCACG
TGGATATCATACACTGATCACGTGCCTGTCATGCACAGATCACGTGACTAATCATGAACT
GATCACGTGGGTATCAGGCACTGATCACGTGGATATCATGCACTGCTCACGTGGCTGAAC
ATGCAATGATCACGTAGCTACCATGTACTGGTCACGTGACTGATCATGCACTGATCACGT
AATTGATCATGCACTGACCACGTGACTGATCATGCACTGATGACGTGGCTATCATGCCCT
GCTCACTAGGCTGATCATGCAATGATCACATAGCTACCATGTACTGGTCACGTGACTGAT
CATGCAATGATCACGTAATTGATCATGCACTGATCACGTGGCTGATCATGCGCTGATCGT
GTGACTGATCATGCACTGATCACGTGCCTGTCATGCACAGATCACGTGACTAATCATGAA
CTGATCACGTGGGTATCAGGCACTGATCACGTGGATATCATGCACTGCTCACGTGGCTGA
ACATGCAATGATCACGTAGCTACCATGTACTGGTCACGTGACTGATCATGCACTGATCAC
GTAATTGATCATGCACTGATCACGTGGCTGATCATGCGCTGATCGTGTGACTGATCATGC
ACTGATCACGTGACTGATCATGCACTGATGACGTGGCTATCATGCCCTGCTCACTAGGCT
GATCATGCAATGATCACATAGCTACCATGTACTGGTCACGTGACTGATCATGCAATGATC
ACGTAATTGATCATGCACTGATCACGTGGCTGATCATGCACTGATCACGTGGTTATCATG
CACTGCTCACGTGGCTGAACATGCAATGATCACGTAGCTACCATGTACTGGTCACGTGAC
TGATCATGCACTGATCACGTAATTGATCATGCACTGACCACGTGACTGATCATGCACTGA
TGACGTGGCTATCATGCCCTGCTCACTAGGCTGATCATGCAATGATCACATAGCTACCAT
GTACTGGTCACGTGACTGATCATGCAATGATCACGTAATTGATCATGCACTGATCACGTG
GCTGATCATGCGCTGATCGTGTGACTGATCATGCACTGATCACGTGACTGATCATGCACT
GATCACGTGGTTATTATGCACTGATCACGTGGCTGATCATACACTGATCGCGTGCCTGAT
CATTCACAGATCACGTGATTAATCATGAACTGATCACGTGGCTATCCTGCACTGATCACG
TGGATATCACACACTGATCACGTGGATGATCATACCCCTATCACGTGACTGATCATGATA
ATGCACTGATCACTTGGCTGATCCTACACTGATCATATGGCTGATTATGCACTGATCACG
TGGCTGATCATGCACTGATCACATGGCTGATCATACACTGATCGCGTGCCTGATCATTCA
CAGATCACGTGATTAATCATGAACTGATCACGTGGCTATCCTGCACTGATCACGTGGATA
TGACACACTGATCACGTGGATGGTCATACCCCTATCACGTGACTGATCATGATAATGCAC
TGATCACGTGGTTGATCCTACACTGATCATATGGCTGATTATGCACTGATCACGTGGCTG
ATCATGCACTGATCACATGACTGCGCATGAACTGATCACGTGGATATCATACACTGATCA
AGTGACAGATCATGCACTGATCAGTTGACTGATCATGCACTGATCACGTGGCTATCATGC
ACTGACCACGTGCCTGATCATGCACTAATCAGGTTGTGGATCATGCACTGATCACGTGGC
TGATCATACACAGCTCAAGGAAGTGATCATGCAATGATCACGTGGCTATCATGCACTGAT
CACGTGGCTGATCCTACACTGATCATATGGCTGATTATGTACTGATCACGTGGCTGATCA
TGCACTGATCACATGACTGCGCATGAACTGATCACGTGGATATCATACACTGATCAAGTG
ACAGATCATGCACTGATCACGTGGTTATCATGCACTGATAACGTGGCTGATCATACACTG
ATCACGTGCCTGATCATTCACAGATCACGTGATTAATCATGAACTGATCACGTGACTATC
CTGCACTAATCACGTGGATATCACACACTGATCACTTGGATGATCATACCCCTATCACGT
GACTGATCATGTTAATGCACTGATCACGTGGCTGATCATGCACTGATCACGTGGCTGATC
ATGCACTGATCACGTGGCTGATCCTACACTGATCATATGGCTGATCATGCACTGATCACG
TACATGATCATGCACTGATCATTTGGCTGATCATACACTGATCTTGTGACTGCACATGCA
CTGATCACGTGACTAATCTTTCACTGATCACATGGCTATCATGCACTGATCATGTGTCTA
TCATGCACTGATCACGTGACTGCACATGAACTGATCACTTACCTTTTCATGCACTGATTA
CCTGGCTATCATGCACTGATCACGTGGATGATCATGCACTCATCACATGACTGATTCGGC
AATGATCACGTAGCTATAATGCACTGATCACATGACTGCGCATGCCATGATCATGTGACT
CATCATGCACTGATCACGTGCCTATCATGCACTGATAACGTGGCTGATCATGCACTGATC
ACGTGACTGATCATGCACTGATCGCGTGGCTATCATGCACTGATCCCTTGGCTATCATGC
ACTGATCACCTGACTGATCATGCACTGATCAAGTGGCTATCATGCACTGATCACGTGGCT
AGCATGCAATGATCACCTGAATGATCATGCAGTAATCACGTCGCTATCATGCATGGATGT
CGAGATTGGGCATGCACTGGTCATGAGGATGATCATACACTGGTCACGTACAGATCATGC
ACTGATTACGTGTCTATCATGCACTGATCACGTGGCTGATCCTGCAATGATCACGTGACT
GAATATGAACTGATTGCCTAGCTATCATGCACTGATCGCATGACTTCGCATGCCATGATC
ACGTGACTGATCATGCACTGATCAGGTGGCTATCATGCACTGATCACGTGGCTAATCATA
CATTGATCACGTAACTAACCATGCACTGATCACTTGACAATCTTGCACTGATCACGTGGC
TGATCACGCACTGATCACGTAGTTATCATGCACTGATCACATGACTGCGCATGAACTGAT
CACGTGGATATCATACACTGATCAAGTGACAGATCATGCACTGCTCAGTTGACTGATCAT
GCACTGATCACGTGGCTATCATGCACTGATCACGTGCCTGATCATGCACTAATCAGGTTG
TGGATCATGCACTGATCACGTGGCTGATCATACACAGCTCAAGGAAGTGATCATGCAATG
ATCACGTGGCTATCATGCACTGCTCACGTGGTTGATCCTGCAATGGTCACGTAGCTACAA
TGTACTGGTCACGTGACTGATCATGCACTGATCACGTGACTGTTCATGCACTGATCACGT
GACTGATCATGCACTGATCACGTGACTGTTCATGCACTGATCACGTGACTGATCATACAC
TGATCACGTGCCAGGTCATGCACAGATCACGTGACTAATCATGAACTGATCACGTGGCTA
TAATGCAATGATCACGTGGATATCATACACTGATCCCGTGCCTGTCATGCACAGATCACG
TGACTAATCATGAACTGATCACGTGGGTATCAGGCACTGATCACGTGGATATCATGCACT
GCTCACGTGGCTGAACATGCAATGATCACGTAGCTACCATGTACTGGTCACGTGACTGAT
CATGCACTGATCACGTAATTGATCATGCACTGACCACGTGACTGATCATGCACTGATGAC
GTGGCTATCATGCCCTGCTCACTAGGCTGATCATGCAATGATCACATAGCTACCATGTAC
TGGTCACGTGACTGATCATGCAATGATCACGTAATAGATCATGCAATGAGCACGTGGCTG
ATCATACACTGATCGCGTGCCTGATCATTCACAGATCACGTGATTAATAATGAACTGATC
ACGTGGCTATCCTGCACTGATCACGTGGATATCACACACTGATCATGTGGATGATCATAC
CATTATCACGTGACTGATCATGATAATGCACTGGTCATATGGCTGATTATGCACTGATCA
CGTGGCTGAACATGCACTGATCACGTGGCTGATCATGCACTGATCACGTGGCTGATCCTA
CACTGACCATATGGCGGATTATGCACTGATCACATGGCTGATCACGCACTGATCACGTAG
TTATCATGCACTGATCACATGACTGCGCATGAACTGATCACGTGGATATCATACACTGAT
CAAGTGACAGATCATGCACTGCTCAGTTGACTGATCATGCACTGATCACGTGGCTATCAT
GCACTGATCACGTGCCTGATCATGCACTAATCAGGTTGTGGATCATGCACTGATCACGTG
GCTGATCATACACAGCTCAAGGAAGTGATCATGCAATGATCACGTGGCTATCATGCACGG
CTCACGTGGTTGATCCTGCAATGGTCACGTAGATACAATGTACTGGTCACGTGACTGATC
ATGCACTGATCACGAAATTGATCATGCACTGTTCACGTGGATCATCATGCACTGATCACG
TGACTGTTCATGCACTGATCAAGTGACTGGTCATGCACTGATCACGTGGCTATCATGCAC
TGATCACGTGGCTGATCATACACTGATCACTTGCCTGGTCATGCACAGATCACGTGACTA
ATCATGAACTGATCACGTGGCTATAATGCAATGATCACGTGGATATCATACACTGATCAC
GTGCCTGTCATGCACAGATCACGTGACTAATCATGAACTGATCACGTGGGTATCAGGCAC
TGATCACGTGGATATCATGCACTGCTCACGTGGCTGAACATGCAATGATCACGTAGCTAC
CATGTACTGGTCACGTGACTGATCATGCACTGATCACGTAATTGATCATGCACTGACCAC
GTGACTGATCATGCACTGATGACGTGGCTATCATGCCCTGCTCACTAGGCTGATCATGCA
ATGATCACATAGCTACCATGTACTGGTCACGTGACTGATCATGCAATGATCACGTAATTG
ATCATGCACTGATCACGTGGCTGATCATGCGCTGATCGTGTGACTGATCATGCACTGATC
ACGTGACTGATCATGCACTGATCACGTGGTTATTATGCACTGATCACGTGGCTGATCATA
CACTGATCGCGTGCCTGATCATTCACAGATCACGTGATTAATCATGAACTGATCACGTGG
CTATCCTGCACTGATCACGTGGATATCACACACTGATCACGTGGATGATCATACCCCTAT
CACGTGACTGATCATGATAATGCACTGATCACTTGGCTGATCCTACACTGATCATATGGC
TGATTATGCACTGATCACGTGGCTGATCATGCACTGATCACATGGCTGATCATACACTGA
TCGCGTGCCTGATCATTCACAGATCACGTGATTAATCATGAACTGATCACGTGGCTATCC
TGCACTGATCACGTGGATATGACACACTGATCACGTGGATGGTCATACCCCTATCACGTG
ACTGATCATGATAATGCACTGATCACGTGGTTGATCCTACACTGATCATATGGCTGATTA
TGCACTGATCACGTGGCTGATCATGCACTGATCACATGACTGCGCATGAACTGATCACGT
GGATATCATACACTGATCAAGTGACAGATCATGCACTGATCAGTTGACTGATCATGCACT
GATCACGTGGCTATCATGCACTGACCACGTGCCTGATCATGCACTAATCAGGTTGTGGAT
CATGCACTGATCACGTGGCTGATCATACACAGCTCAAGGAAGTGATCATGCAATGATCAC
GTGGCTATCATGCACTGATCACGTGGCTGATCCTACACTGATCATATGGCTGATTATGTA
CTGATCACGTGGCTGATCATGCACTGATCACATGACTGCGCATGAACTGATCACGTGGAT
ATCATACACTGATCAAGTGACAGATCATGCACTGATCACGTGGTTATCATGCACTGATAA
CGTGGCTGATCATACACTGATCACGTGCCTGATCATTCACAGATCACGTGATTAATCATG
AACTGATCACGTGACTATCCTGCACTAATCACGTGGATATCACACACTGATCACTTGGAT
GATCATACCCCTATCACGTGACTGATCATGTTAATGCACTGATCACGTGGCTGATCATGC
ACTGATCACGTGGCTGATCATGCACTGATCACGTGGCTGATCCTACACTGATCATATGGC
TGATCATGCACTGATCACGTACATGATCATGCACTGATCATTTGGCTGATCATACACTGA
TCTTGTGACTGCACATGCACTGATCACGTGACTAATCTTTCACTGATCACATGGCTATCA
TGCACTGATCATGTGTCTATCATGCACTGATCACGTGACTGCACATGAACTGATCACTTA
CCTTTTCATGCACTGATTACCTGGCTATCATGCACTGATCACGTGGATGATCATGCACTG
ATCACATGACTGATTCGGCAATGATCACGTAGCTATAATGCACTGATCACATGACTGCGC
ATGCCATGATCATGTGACTCATCATGCACTGATCACGTGCCTATCATGCACTGATAACGT
GGCTGATCATGCACTGATCACGTGACTGATCATGCACTGATCGCGTGGCTATCATGCACT
GATCCCTTGGCTATCATGCACTGATCACCTGACTGATCATGCACTGATCAAGTGGCTATC
ATGCACTGATCACGTGGCTAGCATGCAATGATCACCTGAATGATCATGCAGTAATCACGT
CGCTATCATGCATGGATGTCGAGATTGGGCATGCACTGGTCATGAGGATGATCATACACT
GGTCACGTACAGATCATGCACTGATTACGTGTCTATCATGCACTGATCACGTGGCTGATC
CTGCAATGATCACGTGACTGAATATGAACTGATTGCGTAGCTATCATGCACTGATCGCAT
GACTTCGCATGCCATGATCACGTGACTGATCATGCACTGATCAGGTGGCTATCATGCACT
GATCACGTGGCTAATCATACATTGATCACGTAACTAACCATGCACTGATCACTTGACAAT
CTTGCACTGATCACGTGGCTGATCACGCACTGATCACGTAGTTATCATGCACTGATCACA
TGACTGCGCATGAACTGATCACGTGGATATCATACACTGATCAAGTGACAGATCATGCAC
TGATCAGTTGACTGATCATGCACTGATCACGTGGCTATCATGCACTGATCACGTGCCTGA
TCATGCACTAATCAGGTTGTGGATCATGCACTGATCACGTGGCTGATCATACACAGCTCA
AGGAAGTGATCATGCAATGATCACGTGGCTATCATGCACTGCTCACGTGGTTGATCCTGC
AATGGTCACGTAGCTACAATGTACTGGTCACGTGACTGATCATGCACTGATCACGTGACT
GTTCATGCACTGATCACGTGACTGATCATGCACTGATCACGTGACTGTTCATGCACTGAT
CACGTGACTGATCATACACTGATCACGTGCCAGGTCATGCACAGATCACGTGACTAATCA
TGAACTGATCACGTGGCTATAATGCAATGATCACGTGGATATCATACACTGATCCCGTGC
CTGTCATGCACAGATCACGTGACTAATCATGAACTGATCACGTGGGTATCAGGCACTGAT
CACGTGGATATCATGCACTGCTCACGTGGCTGAACATGCAATGATCACGTAGCTACCATG
TACTGGTCACGTGACTGATCATGCACTGATCACGTAATTGATCATGCACTGACCACGTGA
CTGATCATGCACTGATGACGTGGCTATCATGCCCTGCTCACTAGGCTGATCATGCAATGA
TCACATAGCTACCATGTACTGGTCACGTGACTGATCATGCAATGATCACGTAATAGATCA
TGCAATGATCACGTGGCTGATCATACACTGATCGCGTGCCTGATCATTCACAGATCACGT
GATTAATAATGAACTGATCACGTGGCTATCCTGCACTGATCACGTGGATATCACACACTG
ATCATGTGGATGATCATACCATTATCACGTGACTGATCATGATAATGCACTGGTCATATG
GCTGATTATGCACTGATCACGTGGCTGATCATGCACTGATCACGTGACTGATCATGCACT
GATCACGTGGTTATCATGCACTGATCACGTGGCTGATCATACACTGATCGTGTGCCTGAT
CATTCACAGATCACGTGATTAATCATGAACTGATCACGTGGCTATCCTGCACTGATCACG
TGGATATCACACACTGATCACGTGGATGATCATACCCCTAACACGTGACTGATCATGATA
ATGCACTGATCACGTGGCTGATCCTACACTGATCATATGGCTGATTATGCACTGATCACG
TGGCTGAACATGCACTGATCACGTGGCTGATCATGCACTGATCACGTGGCTGATCCTACA
CTGACCATATTGCGGATTATGCACTGATCACATGGCTGATCACGCACTGATCACGTAGTT
ATCATGCACTGATCACATGACTGCGCATGAACTGATCACGTGGATATCATACACTGATCA
AGTGACAGATCATGCACTGCTCAGTTGACTGATCATGCACTGATCACGTGGCTATCATGC
ACTGATCACGTGCCTGATCATGCACTAATCAGGTTGTGGATCATGCACTGATCACGTGGC
TGATCATACACAGCTCAAGGAAGTGATCATGCAATGATCACGTGGCTATCATGCACTGCT
CACGTGGTTGATCCTGCAATGGTCACGTAGCTACAATGTACTGGTCACGTGACTGATCAT
GCACTGATCACGAAATTGATCATGCACAGTTCACGTGGATCATCATGCACTGATCACGTG
ACTGTTCATGCACTGATCACGTGACTGGTCATGGACTGATCACGTGGCTATCATGCACTG
ATCACGTGGCTGATCATACACTGATCACGTGCCTGGTCATGCACAGATCACGTGACTAAT
CATGAACGGATCACGTGGCTATAATGCAATGATCACGTGGATATCATACACTGATCACGT
GCCTGTCATGCACAGATCACGTGACTAATCATGAACTGATCACGTGGGTATCAGGCACTG
ATCACGTGGATATCATGCACTGCTCACGTGGCTGAACATGCAATGATCACGTAGCTACCA
TGTACTGGTCACGTGACTGATCATGCACTGATCACGTAATTGATCATGCACTGATCACGT
GGCTGATCATGCGCTGATCGTGTGACTGATCATGCACTGATCACGTGACTGATCATGCAC
TGATGACGTGGCTATCATGCCCTGCTCACTAGGCTGATCATGCAATGATCACATAGCTAC
CATGTTCTGGTCACGTGACTGATCATGCAATGATCATGTAATTGATCATGCACTGATCAC
GTGGCTGATCATGCGCTGATCGTGTGACTGATCATGCACTGATCACGTGACTGATCATGC
ACTGATCACGTGGTTATCATGCACTGATCACGTGGCTGATCATACACTGATCGCGTGCCT
GATCATTCACAGATCACGTGATTAATCATGAACTGATCACCTGGCTATCCTGCACTGATC
ACGTGGATATCACACACTGATCACGTGGATGATCATACCCCTATCACGTGACTGATCATG
ATAATGCACTGATCACTTGGCTGATCCTACACTGATCATATGGCTGATTATGCACTGATC
ACGTGGCTGATCATGCACTGATCACATGGCTGATCATACACTGATCGCGTGCCTGATCAT
TCACAGATCACGTGATTAATCATGAACTGATCACGTGGCTATCCTGCACTGATCACGTGG
ATATGACACACTGATCACGTGGATGGTCATACCCCTATCACGTGACTGATCATGATAATG
CACTGATCACGTGGTTGATCCTACACTGATCATATGGCTGATTATGCACTGATCACGTGG
CTGATCATGCACTGATCACATGACTGCGCATGAACTGATCACGTGGATATCATACACTGA
TCAAGTGACAGATCATGCACTGATCAGTTGACTGATCATGCACTGATCACGTGGCTATCA
TGCACTGACCACGTGCCTGATCATGCACTAATCAGGTTGTGGATCATGCACTGATCACGT
GGCTGATCATACACAGCTCAAGGAAGTGATCATGCAATGATCACGTGGCTATCATGCACT
GATCACGTGGCTGATCCTACACTGATCATATGGCTGATTATGTACTGATCACGTGGCTGA
TCATGCACTGATCACATGACTGCGCATGAACTGATCACGTGGATATCATACACTGATCAA
GTGACAGATCATGCACTGATCACGTGGTTATCATGCACTGATAACGTGGCTGATCATACA
CTGATCACGTGCCTGATCATTCACAGATCACGTGATTAATCATGAACTGATCACGTGACT
ATCCTGCACTAATCACGTGGATATCACACACTGATCACTTGGATGATCATACCCCTATCA
CGTGACTGATCATGTTAATGCACTGATCACGTGGCTGATCATGCACTGATCACGTGGCTG
ATCATGCACTGATCACGTGGCTGATCCTACACTGATCATATGGCTGATCATGCACTGATC
ACGTACATGATCATGCACTGATCATTTGGCTGATCATACACTGATCTTGTGACTGCACAT
GCACTGATCACGTGACTAATCTTTCACTGATCACATGGCTATCATGCACTGATCATGTGT
CTATCATGCACTGATCACGTGACTGCACATGAACTGATCACTTACCTTTTCATGCACTGA
TTACCTGGCTATCATGCACTGATCACGTGGATGATCATGCACTGATCACATGACTGATTC
GGCAATGATCACGTAGCTATAATGCACTGATCACATGACTGCGCATGCCATGATCATGTG
ACTCATCATGCACTGATCACGTGCCTATCATGCACTGATAACGTGGCTGATCATGCACTG
ATCACGTGACTGATCATGCACTGATCCCGTGGCTATCATGCACTGATCCCTTGGCTATCA
TGCACTGATCACCTGACTGATCATGCACTGATCAAGTGGCTATCATGCACTGATCACGTG
GCTAGCATGCAATGATCACCTGAATGATCATGCAGTAATCACGTCGCTATCATGCACGGA
TGTCGAGATTGGGCATGCACTGGTCATGAGGATGATCATACACTGGTCACGTACAGATCA
TGCACTGATTACGTGTCTATCATGCACTGATCACGTGGCTGATCCTGCAATGATCACGTG
ACTGAATATGAACTGATTGCGTAGCTATCATGCACTGATCGCATGACTTCGAATGCCATG
ATCACGTGACTGATCATGCACTGATCAGGTGGCTATCATGCACTGATCACGTGGCTAATC
ATACATTGATCACGTAACTAACCATGCACTGATCACTTGACAATCTTGCACTGATCACGT
GGCTGATCACGCACTGATCACGTAGTTATCATGCACTGATCACATGACTGCGCATGAACT
GATCACGTGGATATCATACACTGATCAAGTGACAGATCATGCACTGATCAGTTGTCTGAT
CATGCACTGATCACGTGGCTATCATGCACTGATCACGTGCCTGATCATGCACTAATCAGG
TTGTGGATCATGCACTGATCACGTGGCTGATCATACACAGCTCAAGGAAGTGATCATGCA
ATGATCACGTGGCTATCATGCACTGCTCACGTGGTTGATCCTGCAATGGTCACGTAGCTA
CAATGTACTGGTCACGTGACTGATCATGCACTGATCACGAAATTGATCATGCACTGATCA
CGTGACTGATCATGCACTGATCACGTGACTGTTCATGCACTGATCACGTGACTGATCATA
CACTGATCACGTGCCAGGTCATGCACAGATCACGTGACTAATCATGAACTGATCACGTGG
CTATAATGCCATGATCACGTGGATATCATACACTGATCCCGTGCCTGTCATGCACAGATC
ACGTGACTAATCATGAACTGATCACGTGGGTATCAGGCACTGATCACGTGGATATCATGC
ACTGCTCACGTGGCTGAACATGCAATGATCACGTAGCTACCATGTACTGGTCACGTGACT
GATCATGCACTGATCACGTAATTGATCATGCACTGACCACGTGACTGATCATGCACTGAT
GACGTGGCTATCATGCCCTGCTCACTAGGCTGATCATGCAATGATCACATAGCTACCATG
TACTGGTCACGTGACTGATCATGCAATGATCACGTAATAGATCATGCAATGATCACGTGG
CTGATCATACACTGATCGCGTGCCTGATCATTCACAGATCACGTGATTAATAATGAACTG
ATCACGTGGCTATCCTGCACTGATCACGTGGATATCACACACTGATCACGTGGATGATCA
TACCATTATCACGTGACTGATCATGATAATGCACTGGTCATATGGCTGATTATGCACTGA
TCACGTGGCTGATCATGCACTGATCACGTGACTGATCATGCACTGATCACGTGGTTATCA
TGCACTGATCACGTGGCTGATCATACACTGATCGCGTGCCTGATCATTCACAGATCACGT
GATTAATCATGAACTGATCACGTGGCTATCCTGCACTGATCACGTGGATATCACACACTG
ATCACGTGGATGGTCATACCCCTATCACGTGACTGATCATGATAATGCACTGATCACGTG
GTTGATCCTACACTGATCATATGGCTGATTATGCACTGATCACGTGGCTGATCATGCACT
GATCACATGACTGCGCATGAACTGATCACGTGGATATCATACACTGATCAAGTGACAGAT
CATGCACTGATCAGTTGACTGATCATGCACTGATCACGTGGCTATCATGCACTGACCACG
TGCCTGATCATGCACTAATCAGGTTGTGGATCATGCACTGATCACGTGGCTGATCATACA
CAGCTCAAGGAAGTGATCATGCAATGATCACGTGGCTATCATGCACTGATCACGTGGCTG
ATCCTACACTGATCATATGGCTGATTATGTACTGATCACGTGGCTGATCATGCACTGATC
ACATGACTGCGCATGAACTGATCACGTGGATATCATACACTGATCAAGTGACAGATCATG
CACTGATCACGTGGTTATCATGCACTGATAACGTGGCTGATCATACACTGATCACGTGCC
TGATCATTCACAGATCACGTGATTAATCATGAACTGATCACGTGACTATCCTGCACTAAT
CACGTGGATATCACACACTGATCACTTGGATGATCATACCCCTATCACGTGACTGATCAT
GTTAATGCACTGATCACGTGGCTGATCATGCACTGATCACGTGGCTGATCATGCACTGAT
CACGTGGCTGATCCTACACTGATCATATGGCTGATCATGCACTGATCACGTACATGATCA
TGCACTGATCATTTGGCTGATCATACACTGATCTTGTGACTGCACATGCACTGATCACGT
GACTAATCTTTCACTGATCACATGGCTATCATGCACTGATCATGTGTCTATCATGCACTG
ATCACGTGACTGCACATGAACTGATCACTTACCTTTTCATGCACTGATTACCTGGCTATC
ATGCACTGATCACGTGGATGATCATGCACTGATCACATGACTGATTCGGCAATGATCACG
TAGCTATAATGCACTGATCACATGACTGCGCATGCCATGATCATGTGACTCATCATGCAC
TGATCACGTGCCTATCATGCACTGATAACGTGGCTGATCATGCACTGATCACGTGACTGA
TCATGCACTGATCGCGTGGCTATCATGCACTGATCCCTTGGCTATCATGCACTGATCACC
TGACTGATCATGCACTGATCAAGTGGCTATCATGCACTGATCACGTGGCTAGCATGCAAT
GATCACCTGAATGATCATGCAGTAATCACGTCGCTATCATGCATGGATGTCGAGATTGGG
CATGCACTGGTCATGAGGATGATCATACACTGGTCACGTACAGATCATGCACTGATTACG
TGTCTATCATGCACTGATCACGTGGCTGATCCTGCAATGATCACGTGACTGAATATGAAC
TGATTGCGTAGCTATCATGCACTGATCGCATGACTTCGCATGCCATGATCACGTGACTGA
TCATGCACTGATCAGGTGGCTATCATGCACTGATCACGTGGCTAATCATACATTGATCAC
GTAACTAACCATGCACTGATCACTTGACAATCTTGCACTGATCACGTGGCTGATCACGCA
CTGATCACGTAGTTATCATGCACTGATCACATGACTGCGCATGAACTGATCACGTGGATA
TCATACACTGATCAAGTGACAGATCATGCACTGATCAGTTGACTGATCATGCACTGATCA
CGTGGCTATCATGCACTGATCACGTGCCTGATCATGCACTAATCAGGTTGTGGATCATGC
ACTGATCACGTGGCTGATCATACACAGCTCAAGGAAGTGATCATGCAATGATCACGTGGC
TATCATGCACTGCTCACGTGGTTGATCCTGCAATGGTCACGTAGCTACAATGTACTGGTC
ACGTGACTGATCATGCACTGATCACGTGACTGTTCATGCACTGATCACGTGACTGATCAT
GCACTGATCACGTGACTGTTCATGCACTGATCACGTGACTGATCATACACTGATCACGTG
CCAGGTCATGCACAGATCACGTGACTAATCATGAACTGATCACGTGGCTATAATGCAATG
ATCACGTGGATATCATACACTGATCCCGTGCCTGTCATGCACAGATCACGTGACTAATCA
TGAACTGATCACGTGGGTATCAGGCACTGATCACGTGGATATCATGCACTGCTCACGTGG
CTGAACATGCAATGATCACGTAGCTACCATGTACTGGTCACGTGACTGATCATGCACTGA
TCACGTAATTGATCATGCACTGACCACGTGACTGATCATGCACTGATGACGTGGCTATCA
TGCCCTGCTCACTAGGCTGATCATGCAATGATCACATAGCTACCATGTACTGGTCACGTG
ACTGATCATGCAATGATCACGTAATAGATCATGCAATGATCACGTGGCTGATCATACACT
GATCGCGTGCCTGATCATTCACAGATCACGTGATTAATAATGAACTGATCACGTGGCTAT
CCTGCACTGATCACGTGGATATCACACACTGATCATGTGGATGATCATACCATTATCACG
TGACTGATCATGATAATGCACTGGTCATATGGCTGATTATGCACTGATCACGTGGCTGAA
CATGCACTGATCACGTGGATGATCATGCACTGATCACGTGGCTGATCCTACACTGACCAT
ATGGCGGATTATGCACTGATCACATGGCTGATCACGCACTGATCACGTAGTTATCATGCA
CTGATCACATGACTGCGCATGAACTGATCACGTGGATATCATACACTGATCAAGTGACAG
ATCATGCACTGCTCAGTTGACTGATCATGCACTGATCACGTGGCTATCATGCACTGATCA
CGTGCCTGATCATGCACTAATCAGGTTGTGGATCATGCACTGATCACGTGGCTGATCATA
CACAGCTCAAGGAAGTGATCATGCAATGATCACGTGGCTATCATGCACGGCTCACGTGGT
TGATCCTGCAATGGTCACGTAGATACAATGTACTGGTCACGTGACTGATCATGCACTGAT
CACGAAATTGATCATGCACTGTTCACGTGGATCATCATGCACTGATCACGTGACTGTTCA
TGCACTGATCACGTGACTGGTCATGCACTGATCACGTGGCTATCATGCACTGATCACGTG
GCTGATCATACACTGATCACGTGCCTGGTCATGCACAGATCACGTGACTAATCATGAACT
GATCACGTGGCTATAATGCAATGATCACGTGGATATCATACACTGATCACGTGCCTGTCA
TGCACAGATCACGTGACTAATCATGAACTGATCACGTGGGTATCAGGCACTGATCACGTG
GATATCATGCACTGCTCACGTGGCTGAACATGCAATGATCACGTAGCTACCATGTACTGG
TCACGTGACTGATCATGCACTGATCACGTAATTGATCATGCACTGACCACGTGACTGATC
ATGCACTGATGACGTGGCTATCATGCCCTGCTCACTAGGCTGATCATGCAATGATCACAT
AGCTACCATGTACTGGTCACGTGACTGATCATGCAATGATCACGTAATTGATCATGCACT
GATCACTTGGATATCATGCACTGATCACGTGGCTGATCATACACTGTTCACGTGTCTGAC
CATGCACTGATCACGTGGCTGATCATACACAGCTCACGTAACTGATCATGCACTGATCAC
GTGGCTATCATGCACTGATCACGTGACTGATCATGCACTGATCACGTGACTGACCATGCA
CTGATCACGTGACTGATCATGCACTGATGAGTTGGCAATCATGCACTGATTACTTGGCTG
ATCATACACTGATCACGTGACTGATAATGCACTGATCATCTGGCTATCGTGCACTCATTA
CCTGGCTATCGTGCACTGATCACGTGGTTGATCATACACTGTTCACGAGACTGATCTTGC
ACTGATCACGTCTGTATCATTCACTGATCACCTGACTGCCCATGCACTGATCACGTGGAT
AAACATACACTGATCATGTCACAGATCATGCAGTGATCACGCGGCTATCATGCACTGCTC
ACGTGGCTGATCATGCAATGATCACGTAGCTACCATGTACTGGTCACGTGACTGATCATA
CACCCATCAGGTGGCTATCATGCACTTCTCACCTGGCTGGTCATGCAATGTTCACGTAGC
TACCATATACTGGTCACGTGACTGATCATGCACAGATCACGTAAATGATCATGCACTGTT
CACGTGACTGATCATGTACTGATCACGTGACTGATCACGCACTGATCACGTGGCTTTCAT
GCACTGCTCACGTGGCTGATCATGCAATGATCAGGTAGCAACCATGTACTGGTCCGTGAC
TGATCATGCACTGATCACGTAATTAATCCTGCACTGATCACCTGACTCATCATGCACTGA
TCACGTGGCTGATCACACATGTATCACGTGACTGATCATGCACTGATCACGTGGCTATCA
TGCACTGATCACGTGGCTATCATGCACTGATCACGTGCTGATCATGCAATGATCACGTAG
CTACCATGTACTGGTCACGTGACTGATCATGCACTGATCATGAAATTGATCATGCACTGT
TCACGTGGATCATCATGCACTGATCACGTGACTGTTCATGCACTGATCACGTGACTGATC
ATGCACTGATCACGTGGCTATCATGCACTGATCACCTGGCTGATCATACACTGATCACGT
GCCTGGTCATGCACAGATCACGTGACTAATCATGAACTGATCACGTGGCTATAATGCAAT
GATCACGTGGATATCATACACTGATCCCGTGCCTGTCATGCACAGATCACGTGACTAATC
ATGAACTGATCACGTGGGTATCAGGCACTGATCACGTGGATATCATGCACTGCTCACGTG
GCTGAACATGCAATGATCACGTAGCTACCATGTACTGGTCACGTGACTGATCATGCACTG
ATCACGTAATTGATCATGCACTGATCAGGTGACTTATCATGCACTGTTCACGAGACTGAT
CATGCACTGATCACGCGGCTATCATGCACTGCTCACGTGGCTGATCATGCAATGATCATG
TAGCTACCATGTACGGGTCACGTGACTGATCATAAACCCATCAGGTGGCTATCATGCACT
TCTCACCTGGCTGGTCATGCAATGTTCACGTAGCTACCATATACTGGTCACGTGACTGAT
CATGCACAGATCACGTAAATGATCATGCACTGTTCACGTGACTGATCATGTACTGATCAC
GTGACTGATCACGCACTGATCACGTGGCTTTCATGCACTGCTCACGTGGCTGATCATGCA
ATGATCAGGTAGCAACCATGTACTGGTCCGTGACTGATCATGCACTGATCACGTAATTAA
TCCTGCACTGATCACCTGACTCATCATGCACTGATCACGTGGCTGATCACACATGTATCA
CGTGACTGATCATGCACTGATCACGTGGCTATCATGCACTGATCACGTGGCTATCATGCA
CTGATCACGTGCTGATCATGCAATGATCACGTAGCTACCATGTACTGGTCACGTGACTGA
TCATGCACTGATCATGAAATTGATCATGCACTGTTCACGTGGATCATCATGCACTGATCA
CGTGACTGTTCATGCACTGATCACGTGACTGATCATGCACTGATCACGTGGCTATCATGC
ACTGATCACCTGGCTGATCATACACTGATCACGTGCCTGGTCATGCACAGATCACGTGAC
TAATCATGAACTGATCACGTGGCTATAATGCAATGATCACGTGGATATCATACACTGATC
ACGTGCCTCTCATGCACAGATCACGTGACTAATCATGAACTGATCACGTGGGTATCAGGC
ACTGATCACGTGGATATCATGCACTGCTCAAGTGGCTGAACATGCAATGATCACGTAGCT
ACCATGTACTGGTCACGTGAGTAATCATGCACTGATCACGTAATTGATCATGCACTGATC
ACGTGGCTGATCATGCACTGATCATGTGACTGATCATGCACTGTTCACGTGACTGATCAT
GCACTGATCACGTGGTTATCGTGCACTGATCACGTGGCTGATCATACACTGATCGCATGC
CTGATGATTCACAGATCAAGTGATTAATCATAAACTGATCACGTGGCTATCCTGCACTGA
TCACGTGGATATCACACACTGATCACGTGGATGATCATACCCCTATCACGTGACTGATCA
TGATAATGCACTGATCACGTGGCTGATCCTACACTGATCATATGGCTGATCATGCACTGA
TCACGTGGCTGATCATGCACTGATCACGTGGCTGATCCTACACTGATCATATGGCTGATC
ATGCACTGATCACGTGGCTGATCCTACACTGATCATATGGCTGATCATGCACTGATCACG
TACATGATCATGCACTGATCATTTGGCTGATGATACACTGATACCGTGACTGCGCATGCA
CTGATCACGTGACTAATCTTTCACTGATCACATGGCTATCATGCACTGATCATGTGTCTA
TCATGCACTAATCACGTGACTGCACATGAACTGATCACTTACCTTTTCATGCACTGATTA
CCTGGCTATCATGCACTGATCACGTGGATGATCATGCACTGATCACATGACTGATTCGGC
AATGATCACGTAGCTATAATGCACTGATCACATGACTGCGCATGCCATGATCATGTGACT
CATCATGCACTGATCACGTGCCTATCATGCACTGATAACGTGGCTGATCATGCACTGATC
ACGTGGCTGATCCTACACTTATCATATGGCTGATCATGCACTGATCACGTGGCTGACCAT
GCACTGATCACGAAACTGATCATACACTGATCACGAGACTGTGCATGCACTGATAACGTG
GGTGATCATGTACTGATCACGTGGCTGATCTTGCATTGTTCACGTGACTGATTATGCACT
GATTGCGTTGCTGTCATGCACTGATCACATGACTGAGCATGCCATTATCACGTGACTGGT
CATGCACTGATCACGTGGCTATCATGCACTGATCACATGGCTAATCATACATTGATCACG
TAACTAATCATGCACTGATCACGAAGCTGATCATACACTGATCACGTAACTAATCATGCA
CAGATCACGTGGCTATCATGCACTGATCACTTGATTGTGCATGCAATAATCACGTGGATG
ATCATGAATTTATCACGTGGCTGATCATGCACTAATCACATGGATGATCATGAACTGATC
ACATGACCTAGCCTGCAGTGATCTCGTGTCTGAATGGTGCTGATCATGTGACTAATCAAG
AACTGATCACCTGGCTATAATGCACTGATCACGTGACTTCGCATGCACTGATCATGTGGA
TGATCATACACTGATCACGTTACTGATCACGAACTGATCATATGACTGATCATGCACTGA
TCACGTGACTATCATGCACTGCTCATGTGACTGCACATGCACTGCTCATGTGACTGAGCA
TGCACTGATAACGTAGCTATCATGCATTGATCACTTGTCTATCATGCACTGAACACATGG
CTGATCATACACTGATCACATGACTGCACATGCACTGATCACGTGGATGATCATACAGTG
ATCAAGTGGCTGATCATGCACTGATCACGTAGCTATCATTCACTGATCACATGGCTATCA
TGCACTGATCCCGTGGCTGATCATGCACTGATCACGTGACTGATCATGCACTAGTCACGT
GGCTATCATGCCCTGATCAGGTGGCTGATCATACACTGATCACGTGACTGATCATGCACT
GATCACGTGCCTGATCATGCACTGATCACGTGCCTGATCGCGCACTGATCAGCTGACTGA
TCATGCACTGATCACGTGCCTGATCATGCACTGATCACGTGACTGATCGTGCACTGATCA
CGTGCCTGATCATGCACTGATCACGTGCCTGATCGTGCACTGATCAGCTGACTGATCATG
CACTGATCACGTTGCTGATCATACACTGATCACGTGGCTGATCATGCACTAATCACGTTA
CTTTTCATGCACTGATCAGGTTGCTATCATGCACTGATCACGTGGCTGATCATACACTAA
TCACGTGACTGCACATGCACTGATCACGTGACTGATCATGCACTGATCACGTGGCTATCA
TGCACTGATTACGTGTCTATCATGCACTGATCACGTGACTGCACATGCACTGATCACCTA
ATTGTAGGCAATAATCACGTGAATATCATGCACTGATCACGTGGCTGATCATGAAGTTCT
CATGTGACTGAGCATGCACTGAGCACGTTGCTATCATGCATTGATCACTTGGCTATCATG
CACTGACCACGTGGCTGATTATACACTGATCACGTGACTGATCATGCACTGGTCACGTGG
CTATCATGCACTGATCATGTGGCTGATAATACAGTGATCACGTGGCTAGTCATGAACTGA
TCACGTGGATATAATACACTGATCACGTGGCAGATCATGCACTGATCACGTGACTGATCA
TGCACTGATCTGGTGACTATCATGCATTGATAACTTGGTTGATCATACACTGATTACGTG
ACTGATCATTCACTGATCACGTGGCTATCAGGCAATCATCACGTGGCTGGTCATACATTG
AACACGTGACTGATCATGCACTGATCACGTGGTTACCATGCACTGATCACGTGGCTGATC
ATACATTGAACACGTGACTGATCATACACTGATCACGTGGCTGAACAGGAACTGATCACG
TGACTGAGCATACAGTGATCACGTGTCTGAATATTGCTGATCATGTTATTGATCATGCGC
TGATCACTTGGGTGTCATGCACTGATGACCTGACTGCTCATGCACTGATCATGTAACTGT
AGGCAATGATCACATGGCTATCATGCAGTGATCACCTGGCGGATCATGCACTGATCATGT
GACTGATCATGTACTGATCACGTATCTATCATGCATTCATAACTTGGCTATCATGCACTG
ATCACGTGGCTAATCATACATTGATCACGTAACTAATCACGCACTGATCACGAAGCTGAT
CAGACACTGATCACATAACTAATCATGCACTGATCACTTGGCAATCTTGCACTGATCACG
TGACTGTACATGCACTGAACATGTGGCTGATCATGCAACTGATCAATTGGCTGATCAAAC
ACTGATCACATGGCTGATCATGCACTAATCACGTGGCTAATAATACATTGATCCCGTAAC
TAATCATGCACTGATCACTTGGCAATCTTGCACTGATCACGTGGCTGATCATGCACTGAT
CATGAAGTTATCATGCACTGATCACATGAGAGCGCATGAACTGATCACGTGGATATTATA
CACTGATCAAGTGACATATCATTCACTGATCACGTGGCTATCATGCACTCATCACGTGGC
TGATCATACACTGTTCATGTGCCCGATCATGCACTAAACATGTTGCGGATCATGTACTGA
TCACGTGGCTGATCATACACTGATCACTTGACTGACAATCCTCTGATCACGAGGCTGATC
AAGCACTGATCACGTGGCTGATCATACTCTGAACACGAAGCTGATCATACACTGATTACG
TGACTGCATGCACTGGTCACTTGACTGCGCATGCACTGATCACGTGACTGATCATGCACA
AAAAAATGGCTGATCATGCACTGATCACATGACTGATCATTCACTGATCACGTGACTGAT
CATACTGATTAATCATGTACTGGTCACGTGGCTATCATGCACTGATCACGTGGCTATCAT
GTACTGATCACTTGATTGTGCATGCAATAATCACGTGGATGATCATGAATTTATCACGTG
GCTGATCATGCAGTAATCACATGGCTGATCATGAACTGATCACGTGACTTAGCAGGCAGT
GATCTCGTGTCTGAATGGTGCTGATCATGTGACTAATCAAGAACTGATCACCTGGCTATA
ATGCACTGATCACGTGACTTCGCATGCACTGATCATGTGGATGATCATACACTGATCACG
TTACTGATCACGAGCTGATCATGTGACTGATCATGCACTGATCACGTGACTATCATGCAC
TGATCACGTGACTGCACATGCACTGCTCATGTGACTGAGCATGCACTGATAACATAGCTT
TCATGCATTGATCACTTGTCGGTCATGCACTGAACACATGGCTTATCATACACTGATCAC
GTGACTGCACATGCACTGATCACGTGGATGATCATACAGTGATCAAGTGGCTGATCATGC
ACTGATTACGTGGCTGATCATGCACTGATCACGTAGCTATCATTCACTGATCACATGGCT
ATCAAGCACTGATCCCGTGGCTGATCACGCACTGATCACGTGACTGATCATGCACTGATC
ACGTGCCTGATCATGCACTGATCACCTGCCTGATCGTGCACTGATCAGCTGACTGATCAT
GCACTGATCACGTGCCTGATCGTGCACTGATCACGTGACTGACCATGCCCTGATCACGTG
GCTGATCATGCACTGATCATGAAGCTGATCATACACTGATCACATGATTGTGCATTCACT
GATCACGTGGCTGATATTGCACTGATCACTTGGCTCATCATGCACTGATCATGAAGCTGA
TCATACACTGATCACATGGCTGTGCATTCACTGATCACGTGACTGTGCATGCACTGATCA
CGTGCCTGATCGTGCACTGATCACGCGACTGATCATGCACTGATAACGTGGATGATCATA
CATGATCACATGACTGATCATGCACTGATCACATGCCTGACCATGCCCTGATCACGTGGC
TGATCATGCACTGATCATGAAGCTGATCATACACTGATCACATGATTGTGCATTCACTGA
TCACGTGGCTGATATTGCACTGATAACGTGGCTGATCATACACTAATCACGTGGCTGATC
ATGCACTGATCACGTGTTTGATTTTACACTGATCACGTGGCTTATCATGCACTAATCACA
TTACTTTTCATGCACTGATCAGGTTGCTATCATGCACTGATCACGTGGCTGATCATACAC
TAATCACGTGACTGCACATGCACTGATCACGTGACTGATCATGCACTGATCACGTGCCTG
ATCGTGCACTGATCAGCTAATTGTAGGCAATGATCTCGTGAATATCATGCACTGATCACG
TGGCTGATCATGCAGTGCTCATGTGACTGAGCATGCACTGAGCACGTTGCTATCATGCAT
TGATCACTTGGCTATCATGCACTGAACACGTGGCTGATTATACACTGATCACATGACTCA
TCATGCACTGATCAAGTGGCTCATCATACTCTGATCACGTGGCTGATCATGCACTGATCA
CGTGGATGATCATACGCTGATCACCTGAGAGATCATGCACTGAACACGTGCCTGATCATA
CACTGATCACGTGGCTGATCATGCACTGATCCCGTAGATATCATGCACTGAACACATGAC
TGCGCATGAACTGATCACGTGAATATCATACACTGATCACGTGACAGTTCATGCACTGAT
CTGGTGGCTATCATGCATTGATAACGTGGTTGATCATACACTGATTACGTGACTGATCAT
GCACTGATCACTTGGCTATCAGGCAATGATCACGTGGCTGATCATACATTGAACACCTGA
CTGATCATGCACTGATCACGTGGTTATCATGCACTGATCATATGACTGCGCATGCAATGA
TCTCGAGGATGATAATACACTGATCACGTGGCTGATCAGGAACTGATCACGTGACTGAGC
ATACACTGATCACGTGTCTGAATATTGCTGATCATGTTATTGATCATGCCCTGATCACGT
GTGTATCATGCACTGATGACCTGACTGCCCATGCACTGATCATGTAACTGTAGGCAATGA
TCACATGGCTATCATGCAGTGATCACGTGGCTAATCATGCACTGATCATGTGACTGATCA
TGCACTGATCACGTAGCTATCATGCATTCATAACTTGGCTATCATGCAATCATCACGTGG
CCGATCATACACTGATCACGTGACTGCACATGCTCTGATGACGTGGCTGATCATACAGTG
ATCACGTTGCTGATCATGCACTGGTCAGGTGGCTATCATGCACTGATTACGTGGCTGATC
ATGCACTGATCACTAACCTGATCATACACTGATCATGTGACTGCATGCACTGATCAAGGG
GCTGATCATGCACTGATCACGTGGCTGATCATGCACTGATCACGTGGCTGATCATGCACT
GATCACGAACCTGATCATGCACTGATAACGAACCTGATCATACACTGATCACGTGACTGC
ATGCACTGATCATTTGGCTGATCACGCACCGATCAAGTGGCTGATCATGCACTGATCACG
TGGCTGACCATGCACTGATCACGAAGCTGATCATACACTGATCACGAGACTGTGCATGCA
CTGATAACGTGGGTGATCATGCACTGATCACGTGGCTGATCTTGCATTGTTCACATGACT
GATTATGCACTGATTGCGTAGCTCTCATGCACTGATCACATGACTGCCCATGCCATGATC
ACGTGATTGGTCATGCACTGATCACGTGGGTATCATGCACTTATCACGTGGCTAATCATA
CATTGATCACGTAAATAATCATGCACTGATCACGAAGCTGATCATACACTGATCACATAA
CTAATCATGCACTGATCACTTGGCAATCTTGCACTGATCACGTGACTGTACATGCACTGA
TCAATTGGCTGATCATGCACTAATCACGTGGCTAATCATACACTGGTCACGTAACTAATC
ATGCACTGATCACTTGGCAATCTTGCACTGATCACGTGGCTGATCATGCACTGATCATGA
AGCTATCATGCACTGATCACATGACAGCGCATGAACTGATCACGTGGATATTATACACTG
ATAAAGTGACAGATCATTCACTGATCACGTGACTATCATGCACTGATCACGTGGCTGATC
ATGCACTGATCACATGGCTGATCATGCACTGACAAGCTGGCTAACATACACTGATCACGT
GACTGTGCATGCACTGATCACGTGGCTGAACATGCACTGATCACTAAGCTGATCATACAC
TGATCACGTGACCGTGCATGCACTGATAACGTGGGTGATCATGCACTGATCCCGTGGCTG
ATCATGCACTGATCACGTGGCTGATCATACACTGTTCATGTGCCCGATCATGCACTAAAC
ATGTTGCGGATCATGCACTGATCACGTGGCTGATCATACACTGATCACTTGACTGATAAT
CCTATGATCACGAGGCTGATCAAGCACTGATCACGTGGCTGATCATACTCTGAACACGAA
GCTGATCATACACTGATTACGAGACTGCATGCACTGATCACTTGACTTCGCATGCACTGA
TCACGTGACTGATCATGCACAAAAAAAATGGCTGATTATGCACTGATCACATGACTGATC
ATTCACTGATCACGTGACTGATCATACTGATTAATCATGTGCTGGTCACGTGGCTATCAT
GCACTGATCACGTCGCTAATCATACATTGATCACGTGACTGATCATGCACTAATCACATG
GCTGATCATGAACTGATCACGTGACTTAGCATGCAGTGATCTCGTGTCTGAATGATGCTG
ATCATGTGACTAATCAAGAACTAATCACCTGGCTATAATGCACTGATCACGTGACTTCCC
ATGCATTGATCTTGTGGATGATCATACACTGATCATGTTACTGATCAAGAACTGATCATG
TGACTGATCATGCACTGATCACGTGACTATCATGCACTGATCACGTGACTGCACATGCAC
TGCTCATGTGACTGAGCATGCACTGATAACGTAGCTTTCATGCATTGATCACTTGTCTAT
CATGCACTGAACACATGGCTGATCATACACTGATCACGTGACTGCACATGCACTGATCAC
GTGGCTGATCATACAGTGATCACTTGGCTGATGATGCACTGATTCCGTGGCTGATCATGC
ACTGATCACGTAGCTATGATGCACTGATCACATGGCTATCATGCACTGATCGCATGGCTG
ATCAGGCACTGATCTCGTGAAAGATCATGCACTCGTCACATGGCTATCATGCACTGATCA
CGTGGCTGATCATACACTGATCACGTGACTGATCATGCACTGATCACGTTCCTGATCCTG
CACTTATCACGTGACTGATCATGCACTGATCTCGTGACTGATCATGCAGTGATCACCTGG
CTATCATGCACTGATAACGTAGCTGATCATGCACTGATCACGTGACTGATCATGCACTGA
ATACGTGACTGATCATGCACTGATCACGTTGCTATCATGCACTGATCATGTGGCTGGGCA
TGCACTGATCTCGAGGATGATCATACACTGATCACGTGGCTGATCAGGAACTGATCACGT
GACTGAGCATACAGTGATCACGTGTCTGAATATTGCTGATCATGTTATTGATCATGCGCT
GATCATGTGGGTATCAAGCACTGATGACCTGACTGGGCATGCACTGATCATGTAACTGTA
GGCAATGATCACATGTCTATCATGCAGTGATCACGTGGCTGATCATACACTGATCACGTG
ACTGCACATGCTCTGATGACGTGGCTGATCATACAGTGATCACGTGGCTCATCATGCACT
GACCATGTGGCTGATCATGCACTAATCACGTTGCTGATCATGCACTGGTCAGGTGGCTAT
CATGCACTGATTTCGTGGCTGATCATGCACTGATCACGAACCTGATCATACACTGATCAC
GTGACTGCATGCACTGATCATTTGGCTGATCAAGGGGCTGATCATGCACTGATCACGTGG
CTGATCATGCACTGATCACGTGGTTGATCGTGCACTGATCACAAACCTGGTCATACACTG
ATCACGTGACTGCATGCACTGATCATTTGGCTGATCATGCACTGATAAAGGGGATGATCA
TGCACTGATCACGTGGCTGACCATGCACTGATCACTAAGCTGATCATACACTGACCACGT
GACTGTGCATGCACTGATAACGTGGATGATCATGCACTGATCACTGGTGATCATGCACTG
GTCACGTGGCTGATCATACACTGATGACGTGGCTTATCATGCACTAATCACTTTGTGGAT
CATGCTTTGATCACTTGGCTATCATGCACTGATCACGTGACTGCACATGCACTGATGACG
TGGCTGATCATACAGTGATCACGTGGCTGATTATGCTCTGATCATGTGGCTGATCCTGCA
CTAATCACGTTGCTGATCATGCACTGCTCATGTGGCTATCATGCACTGATTACGTGGCTG
ATCATGCACTGATCACACGGCAATCATGCACTGATCACGTGTCTTATCATACACTGATCA
CGTGACTGATCATGCACTGATCACGAACCTGGTCATACACTGATCACGTGACTGCATGCA
CTGATCATTTGGATGATCATGCACTGATCAAGGGGCTGATCATGCACTGATCTTGTGCCT
GAACATACACTGATCACGTACCTGATCATGCACTGATTATTTGGCTGATCATGCACTGAT
CACATGGCTGATAATGCACTGATCACGTGGCTGATCATGCACTGATCACGTGGCTGATCA
TACACTGATCACGTGACTGATCATACACTGATCACGTGCCTGATCATGCACTTATCACGT
GACTGATCATGCACTGATCTCGTGACTGATCAAGCACTGATCACCTGGCTGATCATGCAC
TGATCACGAATCTGATCATACATTGATCACGTGACTGTGCATGCACTGATCACATTGGTG
ATCATGCACTGATCACGTGGTGATCATGCACAGATCACCTGGCTGACCACGCACTGATCA
TGTTGCTGATCATGCACTGACCACGTGTTTGATCATACACTGATCACGTGGCACATCATA
CACTGATCACGTGGCTGATCATGCACTAATCACGTTGCTTAACATGCACTGATCAGGTGG
CTATCATGCAGTGATCACATGGCTGATCATTAACTGATCACGTGTCTGATCATACACTGA
TCACGTGGCTGACCCTGCACTAATCACGTTGCTTATCATGCACTGATCATGTTGCTATCA
TGCACTGATCCCATGGCTGATCATACACGGATCACGTGCCTGTGCATGCACTGATCACGT
GGCTGATCATACACTGATCACGTGACTGTGCATGCACTGATCTCGTGGCTGATCATGCAT
GGATCACGTCTCTGATCATGCACTTATCACGTGGCTGATCATGCACTGATCATGTAGCTG
ATCATACACTGATCAAGTGACTGTGCATGCACTGATAAGGTGTCTGATCATTCACTGATC
ACGTGGGTGATCATGCACTGATCACGTGACTGATTATGCACTAATCACGTTGTGGATCAT
GAACTGATCATGTGGCTGATTATACACTGATCACGTGGCTGATCATGCCCTGATACCCTA
GCTATCATACACAGATCTCATGACTCATAGTGCACTCTTCACCTTCCTGATCATGCACTG
ATCACGTGGCTGATCATGAACAGATCAGGTGGCTATCATGCACTGATCACTTGATTGTGC
ATGCAATAATCACTTGAATGTTCATGCACTGATCACGTGGCTGATCATGCACTGATCACA
TGACTGATCATGCACTGATCACGTGCCTGATCATGCACTGATCACGTGGCTGATCATACA
CTGATCACGTGACTGTGCATGCACTGATCTCGGGGCTGATCATGCACTGATCTCGTGACT
GATCATGCCCTTATCACGTGGCTGATCATGCACTGATCATGTGGCTGATCATACACTGAT
CAAGTGACTGTGCATGCACTGATAAGGTGTCTGATCATTCACTGATCACGTGGCTGATCA
TGCACTGATCACATGGCAATCATGCACTGATCACGTGTCTTATCATGCACTGATCACGTG
GCTGATCATACAATGATAAGGTGGCTGATCATGCACTAATCACTTTGCTTATCATGCACT
GATCAGGTGGCTATCATGCACTGATCACATGGCTGATCATACACTGATCACGCGGCTGAT
CATGCACTAATCACGTTGCTTATCATACACTGATCAGGCGGCTATCATGCACTGATGATG
TGCCTCAGGAGGCAATAACCAAAGATCTGAACACACACGAATCACGCAATCAGCAGGCAA
TAATCATGGACCTCACCTGTGATGAATCATCCTGCTCAGCTGGCAATCATCAAGCAGCTG
AATAGGCAGGAATCAGACAGCTCAGATGGCAATTGTCAAGAGATGAGCAGGCAGGAATCA
CGCAGCTCAGTAGGCCCTGATCAAGTGACTGAGCACGCACTGTTCACGTGGCTGGTCATG
CACTGATCATGTGGCTGATCATGCTCTGATAACCTGGCTATCATTCACTGATCACATGAC
TGATCATGCACTCTTCACGTGCCTGATCATGCACTGATTACGTGGCTGATCATGCATTGA
TGGCGAAGCTGATCATACACTCATCACGTGACCGTGCATGCACTGATCACGTGGCTGATC
TTGCACTGATCACGTGGGTGATCTTGCACTGATCACGTGGCTGATCATACAGTAATCACG
TGACAGATCATGCACTAATCACGTTGCGGATCATGCACTGATCACGTGGCTGATAATGCA
CTGATCACTTGGCTCATCATGCACTGATCACGAAGTTGATCATACACTGATCACGTGACT
GTGCATGCCCTGATCACGTGGCTGATCATGCACTGATCATGTGGCTCATCACACACTGAT
CACGTGGCTGATCTTGCACTAATCACGTTGCTTATCATGCACTGAACAGGTAGCTATCAT
GCACTGATCACGTGGCTCATCACGCACTGATCCCTTGGCTGATCTTGCACTAATCACGTT
GCTTATCATGCACTGAACAGGTAGCTATCATACACTGATCACGTGCCTGTGCATACACTG
ATCACGTGGCTGATCATACACTGATCACGTGATTGTGCATGCACTGATCTCGTGGCTGAT
CATGCATTGATCACGTCTCTGATCATGCACTTATCACGTGGCTGATCTTGCACTGATCAC
GTGGCTGATCATACAGTAATCACGTGACAGATCATGCACTAATCACGTTGTGGACCATGC
ACTGATCACGTGGCTGATAATGCACTGATCACATGGCTCATCATGCACTGATCACGAAGT
TGATCATACACTGATCACGAAGTTGATCATACACTGATCACGTGACTGTGCATGCCCTGA
TCACGTGGCTGATCATGCACTGATCACGTGGTGATCATGCACAGATCACCTGGCTGACCA
CGCACTGATCATGTTGCTGATCATGCACTGACCACGTGTTTGATCATACACTGATCACGT
GGCACATCATACACTGATCACGTGGCTGACCCTGCACTAATCACGTTGCTTATCATGCAC
TTATCATGTTGCTATCATGCACTGATCCCATGGCTGATCATACACGGATCACGTGCCTGT
GCATACACTGATCACGTGGCTGATCATACACTGATCACGTGATTGTGCATGCACTGATCT
CGTGGCTGATCATGCACTGATCACGTCTCTGATCATGCACTTATCACGTGGCTGATCTTG
CACTGATCACGTGGCTGATCATACAGTAATCACGTGACAGATCATGCACTAATCACGTTG
TGGACCATGCACTGATCACGTGGCTGATAATGCACTGATCACATGGCTCATCATGCACTG
ATCACGAAGTTGATCATACACTGATCACGAAGTTGATCATACACTGATCACGTGACTGTG
CATGCCCTGATCACGTGGCTGATCATGCACTGATCACGTGGTGATCATGCACAGATCACT
TGGCTGACCACGCACTGATCATGTTGCTGATCATGCACTGACCACGTGTTTGATCATACA
CTGATCACGTGGCACATCATACACTGATCACGTGGCTGACCCTGCACTAATCACGTTGCT
TATCATGCACTGATCATGTTGCTATCATGCACTGATCCCATGGCTGATCATACACGGATC
ACGTGCCTGTGCATACACTGATCACGTGGCTGATCATACACTGATCACGTGATTGTGCAT
GCACTGATCTCGTGGCTGATCATGCACTGATCACGTCTCTGATCATGCACTTATCACGTG
GCTGATCTTGCACTGATCACGTGGCTGATCATACAGTAATCACGTGACAGATCATGCACT
AATCACGTTGTGGACCATGCACTGATCACGTGGCTGATAATGCACTGATCACATGGCTCA
TCATGCACTGATCACGAAGTTGATCATACACTGATCACGAAGTTGATCATACACTGATCA
CGTGACTGTGCATGCCCTGATCACGTGGCTGATCATGCACTGATCACGTGGTGATCATGC
ACAGATCACCTGGCTGACCACGCACTGATCATGTTGCTGATCATGCACTGACCACGTGTT
TGATCATACACTGATCACGTGGCACATCATACACTGATCACGTGCCTGACCCTGCACTAA
TCACGTTGCTTATCATGCACTGATCATGTTGCTATCATGCACTGATCCCATGGCTGATCA
TACACGGATCACGTGCCTGTGCATGCACTGATCACGTGGCTGATCATACACTGATCACGT
GATTGTGCATGCACTGATCTCGTGGCTGATCATGCACTGATCACGTCTCTGATCATGCAC
TTATCACGTGGCTGATCATGCACTGATCATGTAGCTGATCATACACTGATCAAGTGACTG
TGCATGCACTGATAAGGTGTCTGATCATTCACTGATCACGTGGGTGATCATGCACTGATC
ACGTGACTGATTATGCACTAATCACGTTGTGGATCATGCACTGATCATGTGGCTGATTAT
ACACTGATCACGTGGCTGATCATGCCCTGATACCCTAGCTATCATACACAGATCTCATGA
CTCATAGTGCACTCTTCACCTTCCTGATCATGCACTGATCACGTGGCTGATCATGCACTG
ATCACGTGGCTGATCATACATTGATCACGTGCCTGATCATGCACTAATCACGTTGCGGAT
CATACACTGATCATATGGCTGCTCATATACTGATCACGTGGCTGATCATGAACAGATCAG
GTGGCTATCATGCACTGATCACTTGATTGTGCATGCAATAATCACTTGAATGTTAATGCA
CTGATCACGTGGCTGATCATGCACTGATCACATGACTGATCATGCACTGATCACGTGCCT
GATCATGCACTGATCACGTGGCTGATCATACACTGATCACGTGACTGTGCATGCACTGAT
CTCGTGGCTGATCATGCACTGATCACGTCTCTGATCATGCACTTATCACGTGGCTGATCA
TGCCCTGATCATGTGGCTGATCATACACTGATCAAGTTACTGTGCATGCACTGATAAGGT
GTCTGATCATTCACTGATCACGTGGCTGATCATGCACTGATCATATGGCAATCATGCACT
GATCACGTGTCTTATCATGCACTGATCACGTGGCTGATCATACAATGATAAGGTGGCTGA
TCATGCACTAATCACTTTGCTTATCATGCACTGATCAGGTGGCTATCATGCACTGATCAC
ATGGCTGATCATACACTGATCACGTGGCTGATCATGCACTAATCACGTTGCTTATCATAC
ACTGATCAGGCGGCTATCATGCACTGATGATGTGCCTCAGGAGGCAATAACCAAAGATCT
GAACACACACAAATCACGCAATCAGCAGGCAATAATCATGAACCTCAGCTGTGATGAATC
ATCCTGCTCAGCTGGCAATCATCAAGCAGCTGAATAGGCAGGAATCAGACAGCTCAGATG
GCAAATGTCAAGCAGATGAGCAGGCAGGAATCACGCAGCTCAGTAGGCCCTGATCAAGTG
ACTGAGCACGCACTGTTCACGTGCCTGATCATGCACTGATCACGTGGCTGATCATACACT
GATCACGTGACTGTGCATGCACTGATCTCGTGGCTGATCATGCACGGATCACGTCTCTGA
TCATGCACTTATCACGTGGCTGATCATGCACTGATCATGTAGCTGATCATACACTGATCA
AGTGACTGTGCATGCACTCATAAGCTGTCTGATCATTCACTGATCACGTGGGTGATCATG
CACTGATCACGTGACTGATTATGCACTAATCACGTTGTGGATCATGAACTGATCATGTGG
CTGATTATACACTGATCACGTGGCTGATCATGCCCTGATACCCTAGCTATCATACACAGA
TCTCATGACTCATAGTGCACTCTTCACCTTCCTGATCATGCACTGATCACGTGGCTGATC
ATGAACAGATCAGGTGGCTATCATGCACTGATCACTTGATTGTGCATGCAATAATCACTT
GAATGTTCATGCACTGATCACGTGGCTGATCATGCACTGATCACATGACTGATCATGCAC
TGATCACGTGCCTGATCATGCACTGATCACGTGGCTGATCATACACTGATCACGTGACTG
TGCATGCACTGATCTCGTGGCTGATCATGCACTGATCTCGTGACTGATCATGCCCTTATC
ACGTGGCTGATCATGCACTGATCATGTGGCTGATCATACACTGATCAAGTGACTGTGCAT
GCACTGATAAGGTGTCTGATCATTCACTGATCACGTGTCTTATCATGCACTGATCACGTG
GCTGATCATACAATGATAAGGTGGCTGATCATGCACTAATCACTTTGCTTATCATGCACT
GATCAGGTGGCTATCATGCACTGATCACATGGCTGATCATACACTGATCACGCGGCTGAT
CATGCACTAATCACGTTGCTTATCATACACTGATCAGGCGGCTATCATGCACTGATGATG
CTATGAAAAGAAGAGAAGTAAAAAAGCAAAAGAGAAAAAGAGAGATAT
ACACATTTGAAAGCAGTGTTCCAAAGAATAGCAAGGAGAGATAAAAAAGCCTTTCTCAGT
GATCAATGCAAAGAAATAGCAGAAAACAATAGAATGGAAAAGACTAGAGATCTCTTCAAG
AAAATTAGAAATACCAAGGGAACATTTCATGCAAAGATGGGCACAATAAAGGACAGAAAT
GGTATGGACCTAACACAAGCAGAAGATATTAAGAAGAGGTGGCGAGAATAGACAGAAGAA
CTGTACAAAAAGCATCTTCACGACCCAGATAATCACAATAATCACTAACCTAGACCAGAC
ATCCTAGAATGTGAAGTCAAATGGGCTTTCAGAAGCATCACTACAAACAAAGCTAGTGGA
GGTGATGGAATTCCAGTTGAGCTATTTCAAATACTAAAAGACAATGCTGTGAAAGTGCTG
CACTGAATATGCCAGCAAAATTGGAAAACTCAGCAGTGGCCACAGGACTAGAAAAGGTCA
GTTTTCATTCCAATCCCAAAGAAAGACAATGCCACAGAATGCTCAAACTACCAGACAATT
GCACACATATCACACGCTAGTAAAGTAATGCTCAAAATTCTCCAAGCCAGGCTTCAGCAA
TACATGAACTGTGAACTTCCAGATGTTCAAGCAGGATTTAGAAAAGTCAGAGGAACCAGA
GATCAAATTGCCAACAACCACAGGATCATCAAAAAATCAAGAGAGTTCCAGAAAAAACAT
CTATTTCTGCTTTATCGACTATGCCAAAGAATTTGACTGTGTGGATCACTTAAACTGTGG
AAAATTCTGAAAGTGATGGGAATATCAGACCACCTGACCTTCCTCTTGAGAAACCTGTAT
ACAGGTCAGGAAGCAAAGTTAGAACTGGACGTGGAACAACAGACTGCTTCCAAGTCCAGA
AAGGAGTACATCAAGGCTGTATATTGTCATCATGATTATTAACTTATATGCAGAGTACAT
CATGAAAAATGCTGGGTTCGATGAAGCACAAGCTGGAATCAAGATTGTTGGGAGAATTAT
CATTAACCTCAGTTATGCAGATGACACCACCCTTATGGAAGAAAGTGAAGAAGAACAAAA
GAGCCTCTTGATGAAAGTGAAAGAAGAGTGAAAAAGTTGGCTTAAAGCTCAACATTCAGA
AAACTAAAATCATGGCGTCTGGTCCCATCACTTCACGGCAAATAGATGGGGAAACAGTGG
AAACAATCACAGACTATTTTGGTGGGCTCCAAAGTCACTGCAGATGGTGACTCAGCCATG
AAATTAAAAGACACTTTCTCATTGGAAGCAAAGTTATGACCAAATTAGACAGCATATTAA
AAAGCAGAGACATTACTTTGCTAACAAAGGTCCATTTAATCAAGGCTATGGTTTTTCCAG
TAGTCATGTATGGATGTAAGAGTTGGACTATAAAGAAAGCTGAGCATCGAAGTATTGATG
CTTTTGAACTGTAGTGTTGGAGAAGACTCTTGAGAGCCCCTTGGACCTCAAGGAGATCCA
ACTAGTCCATCCTAAAGGAGATCAGTCCTGAGTGTTCATTGGAAAGACTGATGTTGAAGC
TGAAACATCAATACTTTGGCCACCTGAACCAAACAGCTGGCTCATTTGAAAAGGCCCTGA
TGCTGGGAAAGATTGAGGGGAGGAAGAGAATGGGATGACAGAGGATGAGGTGGTTGGATG
GTATCACGGACTCAATGGACATGAGTTTGGGTATATTCCGGGAGTTGGTGATAGACAGGG
AGGCTTTGTGTGCTGTGGTCCATGGGGTACGAAGAGTCAGACACAACTGAACTGAACTGA
ACTGAATATATCTTTTAGTTCTTCTGCTGATCTTGGGATGTTCTTCTTGAAGGACTGGAT
TAACACAAGCAATGGATGACTTCTCTTCCCCAGGTGGAATATGAGACATGTTTGTCAGAT
AAAGGTGAATAGGTGATTGCTTTGAATTTCAGAAGACAGGTGTTTGAAACTTAGAACATG
ACAATAGGGCCTTGACAATGATTGTGTATAACAATGTCATACTTAATGCATACCTACCTG
GGAGAGCAGAGGAACTTTGATATTCCTTAGTTTAAACTTTTTTAGTTGTGTAATGGAGAT
ATTCACTTGTAAGCTAACCACCCTGGCACACTAAGGAGTATCATATATATATGTATGAGA
TACATATATGATATATATATATATATATGAGATATATATATGAGATATCATATCATATGA
TATATATGTATATATGTATATATGATATACATATATACATATACGTATATGTATATATAT
GTATATATGATATATACATATCATATATATATATCTCATATATACACACACACACACACA
CACACATATATATATATATATATACATACAGTATGCCACGGTGTGTGCTTGTAGAAACAT
GAATAGGGACAATACTAACACAAAATTTTTATATGGAATGCAATGTAATCTTCCAAAGAT
TTGTTTTATTCTCAATATCTGAGGTTAAGCATAGATTTTTTTAAGCTAAGTGCTGGTTCT
TGTATAAACAGTTCAAGAGCAGAGAAAGCTTATAAAAGAAACACTGTTAACCCCAGGTAG
GACATTATCATTATTAGTGCTGTGAACAGTAGAAATAGGCTTCCATTTGCTATCAATGTT
TCTTTTCTCCATAAATATATTCTCCTACAAACCCTTGATTTTATGCAGATGCAAACGCTA
AAATGGGACAGGAAAAAGCAGCCATTCATCAAACACATAGATTTTGGAATGTAATTACTT
TTTAAATATTTTCCATAATTATTGTTCTGTTACAGATGTCTAGTTTTCCCTTCACTTACA
CTAGAGATTTTTGCAACATTTATAGTAAATTGTAAAATTCTTAGATTAACTTAGAGCTTG
AAGAGTTTGTGAACTCATTTATTATAGGCCTATTTTTCTCATGACCTCATTTTTAAATGA
TTATTTAAGAATTTAGTAGCAAGAATTAAAAATTTTGAATTGACCATTCGTGGGGAAAAT
GAAAGTATGTTATTTGGTTATCAGAGATGCATAAATGCAGCAAGCTGAATTTCCTAGCTT
CATAACTCAACGTTTAATTCTTAGCATACTTTTCATGAAGAGTGTAGTAATCTGTTAATT
GCCAATCTTTAGATTTAGTATAAAGAAGCTCATGCAAGAAAGAGGAACATTAAAATAGAA
TGAGGATGATAATAAGTGCTCTAGATGCAGTCTGAATTTTTCTGTTTGTTTCATAAAGAA
TGACATTAAAATAAAAATCAAAGAAATAAACTCAAAAGCTCTAATTCCTTGCCACCTAGA
TATTTCAGTGGTATTATTTTCCTCCAATTTGTGTATCCTTCTAGTTCTACTGTACTCTCT
AAAATATTTACTTAGAAGTAAAGAAAGACATATCAAAAATTTATTTGACATTCCTTAAGG
GAAAAAGCAAAATTTTAAGATGTTTTCCTAATACCTTCTTTGTATTACTGGCACTGATGT
TGCTCACTGGAAGCATTGGTGGCATCTGCCTAGGTGGAAGGGGTATTTTATTAAGCTCTG
TCATTCAACTTAAAGAATTCTTCAAGATTTAGTAAAGTAAACAGCAATACAAGGATAATT
CTCTCAAACATGAATCTTAAGTGAGATTACAGTAGAAGAGCCTAGGAAGGTATTTCCCCA
TATATAGGAAAGAAAAAAAATAATAACAGCCAAAAAGCAAAATAGCTAATCAGGGTGAAC
AAAAAGAAAAGTAATGTAATGGGAGAGAAAAGTCAGAGGAGTTACTAGTCACCAGATCAT
GTATGGCCTTTTAAGTCATAATAAGAATTTTGCTTTTTTTCTCAGAGATATGAGAAGTCA
TTAGGAGATTTAGACCAAAAGAGTGATGTCAGATTTACATCTGAAAAAGATTATTCTGGT
TACTATACTAAAGATTATCTTCTAGAAACTAGAAAGTGGGGGATGCTAGTGGTTTTGACC
AAGCTGGTGACAGAGGTCTAATTAGAAGTGAAAAATTCTGAATATATTAAAGCTAAAATA
GACAGGATTTCTGACTGATCAGAGTGAAGTTAGAGCTTTAAAGAGAACTTGAATTTGGCA
CCAATATGTTGGCCCCCACAACCAGAATAGAGTTATTATTAACTGAGATGGGATAAATTA
AAAAAAAAAAAAAAAAAGTCAGTTTGGGACATAAAAATTTTGAAATCTGTATTGGGTATC
CAAATGGGAAATGTTGAGTAAATAGTTGGATTCTTGGTGCTGGAAATAAGGAATGATGTA
AAGATGGGGGTTATTATTAATATAATGTAGAAGGTGTTTAAAGACATGAACTTGATAGAG
AAAAAGGGTCCAAGGATCGACAGTTGAGGCAACTCAACTATTAGAGGTCTGGAGAAATCA
AAAGAGGAGAGTGTTTTATGGAGAAAAAATTGACCAATGCCAAATGTTGATGAGGTCAAA
TAAAATAAAGACTGAGAAGTAACTATTAGATCTATTATATTTGAAACATGAATTTTTTTT
GTTCAGCATATAATGGTTTATAAATCTTATCTTAAAAGGGGAAATTCTCATTATTAAAAT
TATATTAATATGGCTTGATTTAATTATATTTAATTAATATAATATTGATGCTTTTGAACT
GTAGTGTTGGAGAAGATTCTTGAGAGTCCCTTGAACCTCAAGGAGATCCAACTAGTCCAT
CCTAAAAGAGATCAGTCCTGAGTGTTCTTTGGAAAGACTGATATTGAAGCTGAAACATCA
ATACTTTGGCTACCTGATGCAAACGGCTGACTTATTTGAAAAGGCCCTGATGCTGGGAAA
GATTGAGGGGAGGAAGAGAATGGGATGACAGAGGATGAGATGGTTGGATGGTATCACGGA
CTCAATGGACATGAGTTTGGGTATATTCCGGGAGGTGGTGATAGACAGGGAGGCTGTTAT
TATTAAAATTATATTATAAAAATTATTAAATTATTATTAAAATTTAAAATTATTAAAATT
ATATTAATATGGCTTGATTTAAGTTTTCATTTAGTGATTAATTAGCTCATATACAGGAAG
ATATAGGCTTATGCAATTAAAAAGTGACAGACAAGATCAACTTTTGGCCTTTTGTATAAT
ACTTAGGCATGACTGAATTAAAAAATAATATACAACAATGTAAAATAGCAGAATAAAAAG
AGAAAATTATATACTCTTAATAATTTTCCCTATCTAGATATATAAATATTTAAAAGTTTT
GTATGCCTGTGTGAAAACAATCTCAAAATTCATCTATTTTGTCAAAGCTAACACCTGGAA
ATATTGTTATTGGTTTTAATTTTCTGTTTTGTTTTTTTCAACTATTTTATTGTGATGTGA
AAGGCATTTTATTTGCTATATTAGATAATTCAAAGCCTTCCTAGAATCCTATTTGTTACC
AAGCATAAAAGGTCATCATGAATGTCATTTGCTGTATTAAGCACAGCAACATGCACCATT
GAGGAAAATAATCTCATATTTAGAGTATAAATTTTTTCTGGGACTGTCACCCAGCTGTCT
GCTTCTAACTGTGACATTAAAAGAAAACTGAATTAGAAGAATCATGAACAATGCTAGAAA
TATTTAAGTAGCATTAGATAAAATTGGGGGATATTGAAAGTTTAAGATCAATTTCCAAGT
CATTATACACACATACACAAAACACCTTAACTTCTAGTCTCATTCCAGCCTCTTAAAAAC
AGAAAAAAACTTAGCATTTTGATGCCCTTATTGTCTCAATCAGAGAGAAAGAAATAATTG
CTCTTACAGTGCCTTTCATTCTGTGACCTCTGGAGTCAAAGCCAGAGTCATATATAACTG
GTATTCTTTTGCAAAGTTACCTGGCTAATTGCTTAACAATATATTTAACTTAGGCAAGAT
AAAATAGGCTGGAGAGAGAAGAGGATTACAAAAAGCTTTACTAACAAATATTCCCTTTTT
AAAAAATTTATTTAACTAGAGGCTAATTACTTTACAATATTGTAGTGGCTTCTACCATGC
ACTGACATGAATCAGCCATTGGTATACATGTGTTCCCCATCCTAGAATTTAGGTGTCAAT
ATAAAGAGGTTTTACTGTATCAAAATGTATTTAGGAGCATTCCTTTGGCTCTGGTTTACA
GATAGTCACTATCTTGATTCATAAATGAAGGTAAAGTTGATATCATATTCCATGTCACTG
AACACTCTGAAAGAAAAAAAAATTATAAAACTAAGAAAAATATAAAATTGATACCAATGA
TTTTTAATTAGATAGAAATAATTATTCCTGAAGATAACATGCTGCATTTTGAGTTTATTT
TAGGACGTAGTTCAGTTCAGTTTAGTTCAGTTGCTCAGTCGTGTCCAACTCTTTGCGACC
CCACGAATTGTAGCATGCCAGGCCTCCCTGTCCATCACCAACTCCCAGAGTTTACCCAAA
TGCATGTCCATTGAGTTGGTGGTGCCATACAACCATCTCATCCTCTGTTGTCCCCTTCTC
CTCCTGCCCTCAATTTTTCCCAGCATCAGGGTCTTTTCAAATGAGACAGCTCTTCACATC
AGGTGGCCAAATATTGATGTTTCAGCCTCAAAATCAGTCCTTCCAATGAATACCCAGGAC
TGATCTCCTTTAGGATGGGCTGGTTGGATCTCCTTGCAGTCCAAGGGACTCTCAAGAGCC
TTCTCCAACACCACAGTTCAAAAACATCAATTCTTCTGCACTCAGCTTTCTTTATAGTCC
AACTCTCACATCCATACATGACCACTGGAAAAACCATAGCCTTGACTAGACAGACCTTTG
TTGACAAAGTAATGTCTCTGCTTTTTAATATGCTGTCTAGGTTGGTCATAACTTTCCTTA
CAAGGAGTAAGTGTCTTTTAATTTCATGGGTGCAGTCACCATCTGCAGTGAGTTTGGAGC
CCCTCAAAATAAGGTAAGCCACTGTTTCCCCTGTTTCACCATCTATTTGCCATGAAGTGA
TGGGATAGATGCCATGATCTTAGTTTTCTGAATGTTGAGTTTTAAGCCAACTTTTTCACT
CTCCTCTTTCACTTTCATCAAAAGGCTCTTTAGTTCTTCCCTTTTGCCATAAGGGTGGTG
TCATCTGCATATCTGAGGTTATTGATATTTCTTCCGGCAATCTTGATTCCAGATTGTGTT
TCATCCAGCCCAGCATTTCTCATGATATATTCTGCATATAAGTTAAATAAGCAGAGTGAC
GATATACAGCCTTGACGTACTCCTTTTCCTATTTGGAACCAGTCTGTTGTTTCATGTCCT
GACCTAGAAAGCATTTAAAGCAGACTGTTTTTAAATTGCTTCATTTTTGGTAGTTTTTAG
TTACATACACATTTCATACCACGTTTTTAAAGATAGTCTATTACCATATAGTTTATTATT
GTGGTAACTGAAAGTAGCAAGGGTGTGTTACTGTATTTTATTTTTTTTTCTAGCTTTGGA
AAATGAAGGAAGTGCTAACTAAAAATCTAACACACACTCATATACAAACCCATGCATGAT
ATTATGATTGAATACATTAGTGGACTGATATGTAGATATTCATTTATATGTTATAGATAA
TATTTTGTTGAAGTAAATTATTTTTATCTCAAAATATATATTTTGCCTGGCTTTTACCAA
AAGTTTTATCATTAGTGGATTATTCAGCTTGTTATATTAGTCATTATCATTAAAGCACAA
ATCAAATTGTTAGAGGCTATGTAGTCACTTCAGTAGTAAAGGATCTGCCTCCATTACAGA
GGATGCAGGTTGGATCCCTGGGTCAGAAAGATCACTTGGAGAAGGGAATGGCAACCCATT
CCAGTATTCTTGCCTGGAAAATTCTATGAATGGAGGAGCCTCATGGGCTATAGCCCATGG
GGTTGTAAAGAGTCGGAAATGACTGAGCCACTAACACTTTCACGCTATTAAGTCACTTAA
TAGGGCTTTGGTATAGTGAGATAAGAATCACGTAAAGTTTATTTCAGAGTCACAGAGGTC
ATAATTACTATTCATTTTCTCAGTGATTGCCCTAAATATAAGCCCTCTGTTGAATCTAGA
AAAAATAATCTGATTGATTTCACTCACATTATAATTTTAACTTTTGTTGTTCAGTGCCTA
AGTTGCATCTGACTATTTGCAACCCCATGGGCACTTCTATAACTATGAGTGAGGTTGAAA
ATGTTCATGTGTTTGAAGGTTATTCATATCTCTTTCTGAGAGTTAGGTGTTTTTATCTTT
CAGTCTCCTTTCCTATGAAATTCTTGGTCATTATTTTTCTTAATTTCTAGAAGTACTGTA
CATATTTAGGGAGGGGGTGAAAATTTTATCTGCAATATAAACTGAAAAAACTTTTCCCCA
TTAATTTTTTGTCTTTGAACTTTGTGTTTTTTTTCGTATATCAAAGTTTGTTTTCTTTAA
TGTCACAATTATTAATATTTCATTTTAGGAATTCTAATTCTGAGTCATAGAAAAAACTTC
CATGTTTTGAGGTTCCATGGGAATTCGCCCATGTATTCTTTTGGTATATTTATGAGTTAA
ATTTTTTAATTTATTTGTAATTGTGGAAAAATATTAAAAAATTATCATTTTAGCTAGTTC
TAAGGATATTATGCAATGGTGTTAAGTATATTCCACTGTTGTGCAGCCAGTCTCTGAACA
CTAAGAAACAGACACATCATTTTCAAGCCTCTTTAGACTTTGGAGATAGTATGCACCAGA
CTTAAGAATATAGTAAAAATTACTTGTTAGGTATCTTAGAAGGACCATAGCTTTGAAAGG
GGCTCAGAGTATAAGATGAGGCTTTGTAAAAAGCTGGTCTACAATACAAGTGGACTCTGA
TTCTAGGGACATGTGACCCAACAGATCACATGTGTTATACATATCTATGGTATATGAGGA
CTTTCTCTGAATATCTAAAGTCCTATTGGAAGTATTTGTTTATTTATTTATTTTTCTTTT
TTTTATTATTGGAAGTATTTGAAGCACAAAAGGCTAAAGGTTCTGGAAAAATGCTATAAT
ACCTTCACCAGATAAAGATTTACCATCTGAAAAGCAGCTTCTTTTATGGCCCTAGTCCCT
AAGCACGTGCTGAACACCTGACATGAGACATCAAATAATTATGTGGTCAGAGATGGTCTG
CCAAGTCATAAAGCCAGGTGAGGACAAAGGTAACCATAGTATGGTAGAGTGGTTTATTCA
GGATTGGCTCTGAGCTGACTCAGAGGACTTAAGTAAATTAAAAGAGAAATGGCCACAGAA
CTCCAAACTACCTACCACTGTTTGAGCCTCTTGTTCAATATACACCTTATAGCATATGGA
GTGTAGTGTACAACCAAACTGTCAGTTGATGGATTTGGGATAAAAATCTAAACCTGCTTC
ATGTTTTAGATGGCTTGATATATTGGTGACAGCTGAAAATGGACTGTTGCTGTACCACAG
CCTCACAAAAAAAAATGGTCCTAAAAGATAGCATTGTCTTTGAGTAATTTATGGGGTCGT
AACTTGGTATGAAAGGAGAAGTGCCCCCAATTAACTGAACTTCTGGGCAGTTAAAAGAGC
TTAGCTGATGTATCAAGAATTTGGATGGAGGAACAATGGAAGATTGAAGGCAAAGAAGCT
TGGGAATCTGTAGAGTAGTAGTGGGCAAAAAGTGTGTAGATTGTTATTTCTCAGGTCAAT
GACCACCTACAGGCTGCTCTTTGAAAAGACACCTATACATAAGTTTTAGAACCTTGCGTA
TAAATTGAGATTGGGTTTGTGGGAACTTATAGACAGGGGGGCCTGGTGTGCTGCTATTCA
TGGGGTTGCAAAGAGTTGGACACTACTGAGTGACTGAACTGAACTGAACTGAAAGACCTA
TATATCAAGATCTCTCTTTTCCGAGTAGTATAGCAAGTAATGGCCTTAACCCCTTCCTTT
GATGTGTGTCAAAAGTACAATCAAAATGTTTTGCTTGTTTTTTAATTGGTCCAAATATGA
CTGACTCAGCTCCTTTGTATATTTCTCTTTTCATGCCCACCTTTCCTTTAAAAAATCTAT
TTTGGAAAACATTTATAGCTTGCTGATGTTGCCTTGTGGACTATCATGCTATATTGGTCA
GGTCACCCTAAACTTGTCTATAGCTGAATAACAGATAAGTGACAGAATGCTTATGTCAAT
CAGTAATAACTTGGGGGTGTATAATCAGTATACAATACTCTGAACTCAATAAGCAATCTT
GAGATAACTCAATATGCTGAATTGCCCACATGTGTACTGGGCTTGTGATGCTGCTCAAAT
TCCAGAAGAAACGATGAAAAAAAAAATAAGGCTCACATTGGCATGGTCAAAGAATGAGCA
GATGGATTCCTATTGCCAGTCATGGTTTGTCTAATATCTTGTTTCCTTCTTTAGGGACTG
ACGGTGTTTGAGGATGTTAGCCATGAGAATGAGTAAAACTTGGAGCTGGATGTGGGACAA
ATTTTTAAAGCATCTGCCAATTTTGATATAATCAAAAATTATATCTGTGAAAGCACAAAC
ATAACAAATTTTCTACAGAACATCTTGCACTCTTCCTTATGAAAATAATTCTTTTAGGAG
TTCGTTCTTACTCACCTTTGCAAATGTGTTCTCCCAGGTTGGAAACAACAGGTTCTCTGA
AACCTGATCACCACTCCTCCCCCACTGCCACAGCCTTGAACATTTGCATTAGTGCTTCTG
TTAAAATTTGGTTCTAAAAGCAATCTTCACTTTGAATGCTGTATAGATGGCCCCATTTTT
CTTAGATTCCCAAGGCATAGGTCACTCCACTCTGCTAAAAACCAACTCAGCCTCCCATTT
TTCCAGCCAGGCTCAGTACCCTAGAGGCTTTTCTTGCTGGGAGAGAATTTTTAACACAAA
GAAAGTCTTTGTGTTATAAGTCTATTTATTTCTGTTGCCTAGAATTGCTAGCACAAAAAT
AGTGGGCAGTAAATATTTGCTATGTGACTAAATAAATAAACAGAGGAATGAATTATTCAG
CTGGAAGTGTAACATTATTCTTCTGGAATAATGCTATTAATTTTGGTGACATGATCTTTA
GGCTGTAAGTGGTTCTTTTACCATTATGCCATGGAAGCCAGAGTATGTACATTCCATTAG
AATTAAAGCTGAGGAAAAAACTGTTTTAGAAACAGCAAAATATGAAGATCAGGGTATTCT
ATAGTACATAACTGTAGTCTTAGAAAAAATATAGAACTCAGAACTTAGAAAAAATCTGGA
ACTCAGATTCTGTCTCCTTTCAACCCACCTTGAACCCCTTTTCTCCCTTTACTCAAAGAA
GGAGAAAAACACTAGTGAGCAGGTAAAGCTAAGGACATCAATGGGGTCTACTGGTTGGAT
CTATCAGTGTGCTGAGGGTTGAGATTAAAGATTTTATTCACTGTGTGAGTTGGCCTACTC
GGATGAATGGATTTATCAAAAAGGCTGAAACACTAGATTCAAAAAAGATGGTGCCTATTC
AGAATCCTCTATGCCTTGAAAGTCCCAGGGGGAAATACTGGGGCCACTCTGGACAGAGGA
GCCTGGTAGGCTACAATCCATGGGGTCGCAAGAGTCAGACATGACTTAGCGACTAAACCA
CCACCATGACTCCAAAACTTATAGTTGTTTTTTTTTTTTTTTTCCCTAGCTGCTCCTTCT
GTGGCTTTAAGGTCTGTGTCTCTAAGCACCCTCAAACTCTTCCTTTACACAGTCAGAAAG
TTAGTCTGAAATTCAGGTGGGGGCTAGAAAGGAAGGGTGATAAGGAAGCTATCTGACCTA
CTTTTAGTTTGTAAATTCTTTGTGTCACTAATGACACATGTCAGATAAGTTCTCCATGCG
GGTTAGCACAGCACACTATGGGACACAGTTTGGAAAAGCTCTTATGGAAATAAATAGCAT
TAGTGAACATTTATAAAGGATATTATGTATGTGCTTTATATTTATTGATGTAATGTTATC
TCACAATGTACCTATGGACAAAAGTTCTATTATCATCATCATCCTTATTTTGAGTATTTT
GAGACAGAAAATAAAGAAATGTGCTCAATTTCACAAAACTGTTAAGATGAGTAACTTGAA
TAACAGAACAAGTAGTCTGACTCCTCATTCCATGCTCTTAATTTCTTCACTGTAATCCTT
CTCCATAATTTGTTTATGGAGACCTTGATTTCTGGGTAAACTTATCTCAGGTATGTTAAA
AGTGGGGAATGCATATGAAATTACCAGATAAAAATAATTAAGTCATTTACTTTACAAATA
CCTGTTTATTGCTTGTTTTATGTTTCATTAGTGGCCTATATTTCTGGCCAATAATCTATA
CAAATAAATGTCCTATACAAACAATAATCAGAATGATAATATAAGACAACAATAACTTTG
TCTTTTTTAATGTTTAAGTAAAACAATTGAAGAAACATTAAACATGTAAATTAGTAAAAT
ATAATTTTGGATATAGCTATTAATACACATTCAAGAGGTAAATTAGAGAATTGGAGTCAA
ATTGTATTTCTAAGCTAGAAAGTAGTATAAGAAGTTGAGATTTATGAAAGTAGAACAAAA
TCACTTTTTGATGTATGCTTTAGTGGTGCATGCATGCATGCTGAGTCTCTTCAGTTGTGT
CCAACTCTTTGCAACCCCGCCAAGCTCCTCTGTCCAAGGGATTCTCCAGGCAAGAATTCT
GGAATGGGTTGCCATTTCCTTCTCTACGGGATCTTTGGGACCCAGGGATTGGACCAGCAT
CTCCTGAGTCTCCTGGATGGACAGGCAGATTATTTATCACTGAGCCATGTGGGAAACCGA
TTACTCTTTTTTTGAATCCCTGATGCCATTTGATGAAATCTGACCTTTGTCCCTTCCACC
CAAGAGTCCTAAACTAAAAGGTTCTATTTCTTTGTACATGGATAGCAATATTTATCTCTC
AACCAAAGTTTCTGCACTGCAAAACTGAAAATAAGTACTTTAAGCAAAACGTTTAGTTAC
TACACTTGTTCCATCTTAGAACATCTTTGACAGCTTAGCATTTATTTACTCTGAGTTCTG
CAGTGAATTCTTATTTGGTTCTAAGAATCATAAAAGAATGGTTCTCCCCAAAGAACTCTC
TCTCCAGACTCCTTACCATAGTAATTCCCAAAGTATGGTCTCTGGACCAGCAACTTTGCA
ATACCTGGAAAGTTGTTAAAAATGAAATTTTGTGTTTTAGTTTACTGAAGCAGAAACTCT
GGGTTAGTAGCTGGAGTTAAAAAAAAAAACAAACAACTCTATGTATTAATAATCCTGATG
CAGTTTGGGAACCAGTGACGTAAATTATGTATTTTAACTCCTTTATGTTCTAGTATTTCC
ATGTGTATATTTCACTTATCATATTTAATATAATTCATTTATAATAGCTGTTTATTTAAT
CTAAATTTACCAATCAATCCTCCTGTACCTTTTTAAAATTTTTTTTCTTTTTTTTATTTT
ATTTTTAAACTTTATATAATTGTATTAGTTTTGCCAAATATCAAAATGAATCCGCCACAG
GTATACATGTGTTCCCCATCCTGGACCCTCCTCCCTCCTCCCTCCCCATACCATCCCTCT
GGGTCATCCCAGTGCTCTAGCCCCAAGCATCCAGTATCGTGCATCGAACCTGGACTGGCA
TCTCGTTTCTTACATGATATTTTACGTGTTTCAATGTCATTCTCCCAAATCTTCCCACCC
TCTCCCTCTCCCACAGAGTCCATAAGACTGTTCTATACATCAGTGTCTCTTTTGCTGTCT
CGTACACCGGGTTATTGTTATCATCTTTCTAAATTCCATATATATGCATTAGTATCCTGT
ATTGATGTTTTTCTTTCTGGCTCACTCTGTATAATAGGCTCCAGTTTCATCCACCTCATT
AGAACTGATTCAAATGTATTCTTTTTTAATGGCTGAGTAATACCCTTTTTTTTTTTAAGG
GAAATAATCATGTATTCTGTAATTTATATATTCCATAGTGACTAGTAGATTTTCTGTCAA
ATCTAGGGGAGATATTTGTCTAAGATAAATTTTTTTTAATTAATTTTATTTTATTTTTAA
ACTTTACATAATTGTATTAGTTTTGCCAAATATCAAAATGAATCCGCCACAGGTATACAT
GTGTTCCCCATCCTGGACCCTCCTCCCTCCTCCCTCCCCATACCATCCCTCTGGGTCATC
CCAGTGCACCAGCCCCAAGCATCCAGTATCGTATCGTGCATCGAACCTGGACTGGCATCT
CGTTTCATGTCTAAGATAAATTTTTAAAGTGATGTTCTTATCTCTATTTTCTGTATAAAT
GATTCTAACACTTGCTTCTCAAGTTATGTCTTAAAGGATTAAAAAATCTGATGACTTAGA
AAAATGTGCTAGATTTACTAGAAAAACAATGCATAAAAGTTGGTGTGACTTGTTTTTTTT
TTTTTTTTTAAAGTACGTGCTGACTTCCAGTAATAAACAAAATGGAGTAGACACACCGTT
CCTTAGTCCTGCCAATAAGTACAGCTAAAAACCCTTGACATCATATACAAAACTAACTTA
AGGTGGCTATAAAAAAGAAGGATAAGAAGGCATAACAGCTAATTCCCTGGGTCCTGGATA
TTTTTCTTTATATTTCATTGGGTGCTGGAGAACTAGGCAAACTGGGAATAGCAGTGAATG
TAGACCAAAACACATTCTTAAGAATTGCCTGTTCTCAAAAGCCAAAGACAAGGAAAAGTA
CATCCTAAACAATAACCATTCAGATCTAAAAAAACACCATAGAAAAAATCATGGACCTCA
TACTTTCAATTTACAAACAAAAGGAGAAGGGTAACCTAGACTTTCACACTGTCTTGGCTA
TTGTAAGTCACTCCTCTTCATCACAGTAAAGTCACAGAAGATCAGGTAGGGAGCTAAGAC
TTTTATCCCTTCCTTACTTGTTCAATGTTTGAAACTCCATGCAACTCATCATATTAACAC
AGGCTAAAAATTGCATGATAATATTAACTGACACAAAAAGTACTGAATAAATTTTACCAG
TCATAATAAAAACTATTAAAAACTCTAGGAACAGAGAGAACATCTTCAATTTGATAATGC
ACTTTTAAAGAAAAAACTTACTTCTAAACTTGTACTTAATGGTATAAGATTGAATGTTTT
CCTTATAAAATTGGGAACAAGCAAGCATGCCAACATTTACCAATCTTATTAAATATAGTA
GTGATGTTCTAAACAGAGAGTAAAGCAAGAAGAATAAGTAAAATGTATACATCTCCAAAA
TGAAGAAATGACACTTTATATATTTGCAAGTATAGAAATGAAATTCTCTGTATTTGCAAA
TGAAATGCTGCTATATGTACAAAATCCAAAGAATCTATGAAAAAAAAAATCACAGAACTA
ATTGAGTTCAACAAGATCACAGATATAAAATAAAAATTAAACCAATTGTGTATCTATATA
TTAGTAATGAATATGTGGGGAAAAAAATTAAAATACAGTACCATTTATCAGTTCAGTTCA
GTCACTCAGTCGTGTCTGACTCTTTGTGACCCCATGACTGCAGCACGCCAGGTTTCCCTG
CGCATCACCAACTCCTGGAGCTTACTCAAACTCATGTCTATTGAGTTGGTGATGTCATCC
AACCATCTCATCTTCTGTTGTCCTCTTCTCCTCCTGCCTTCGATCTTTCCCAGCATCAGG
GTCTTTTCCAGTGTGTCAGTTCTTTGCATCATGTGGCCAAATTATTGGAGTTTCAGCTTC
AACATCAGTCTTTCCAATGAGTACTCAGGACTGATCTCATTTAGGATGGACTGGTTGGAT
CTCCTTGCAGTCCAAGGGACTCTCAAGAGTCTTCTCCAACACCACAGTTCAAAAGCATCA
ATTCTTCTGCACTCAGCTTTCTTTATAGTCCAACTCTCACATCCATACATGACTACTGGA
AAAACCATAGCCTTGAGTAGCCAGGCCTTTGTTGGGAAAGTAATGTCTCTGATTTTTAAT
ATGCTGTCTAGGTTGGTCATAACTTTCTTTCCAAGGAGTAAGTGTCTTTTAATTTCATGG
CTGCAGTCACCATGTGCAGTGATTTTGGAGCCTCCCAAAATAAAGTCTGACATGGTTTCC
ACTGTTTCCCCATCTATTTGCCATGAAGTGATGGGACCGGCTGCCATGATCTTAGTTTTC
TGAATGTTGAGCTTTAAGCCAACTTTTTCACTCTCCTCTTTTACTTTCATTAAGAGGCTC
TTTAGTTCCTCTTCACTTTCTGCCATAACGGTGGTGTCATCTGCATATGTGAGGTTACTG
AATATTTGTCCCAGCAATCTTGATTCCAGCTTGTGTTTCATCCAGCCCAGCATTTCTCAT
GATGTACTCTGTGTATAAGTTAAATAAGCACAGTACAATATACAGCCTTGACGTACTCCT
TTTCCTATTTAGAAACCAGTCTGTTGTTCCATGTCTAGTTCTAACTGTTGCTTCCCGACT
CTTTGCGACCCCATGAATTGCAGCATGCCAGGCCTCCCTGTCCATCACCAACTCTGGAGT
TCACTCAGACTCATGTCCATTGAGTCAGTGATGCCATCCAGCCATCTCATCCTCTGTCGT
CCCCTTCTCCTCTTGCCCCCAATCCCTCCCAGCATCAGTCTTTTCCAATGAGTCAACTCT
TCAAATGAGGTGGCCAAAGTACTGGAGTTTCAGCTTCAGCATCATTCCTTCCAAAGAAAT
CCCAGGGCTGATCTTCAGAATGGACTGGTTGTCTTTTCCAATGAGTCAACTTTTTGCATG
AGGTGGCCAAAGTACTGAAGTTTCAGCTTTAGCATCATTCCTTCCAAAGAAATCCCAGGG
CTGATCTTCAGAATGGAGTAGTTGGATCTCCTTGCAGTCCAAGGGACTCTCAAGAGTCTT
CTCCAACACCACAGTTCTAAAGCATCAATTCTTCGGCGTTCAGCTTTCTTCACAGTCCAA
CTCTCACATCCATACATGACCACTGGAAAAACCATAGCCTTGACTAGATGGACCTTTGTT
GGCAAAGTATTGTTTCTAGGTTGGTCATAACTTTTCTTCCAAGGAGTAAGCGTACATCAT
GAGAAATGCTGGGCTGGATGAAGCACAAGCTAGAATCAAGATTGCCAGGAGAATTATTAA
TAACCTCAGATATGCAGATAACACCACCCTTATGGCAGAAAGCAAAGAAGAACTAAAGAA
CCTCCTGCTGAAAGTGAAAGAGGAGAGTGAAAAAGTTGGCTTAAAACTCAACATTCAGAA
AACTAAGATTATGGCATCTTATGATGCTATGAGAGTTGATCATAAAGAAGGCTGAGTGCG
AAGGAGTGATGCTTTTGAACTTTGGTGTTGGAGAAGACTCTTTAGAGTCCTTTGGAGTTC
AAGGAGATCAAACCGGTCTTCCCTAAATGAAATCAATGCTGAATAGTCATTGGAAGAACT
GATGCTGAGCTGCAACTTCAATACTTTGGCCACCTGATGCGAAGAACTGACTCATTGGAA
AGGATCCTGATGCTGGGTAAGACTGAAGGCAGGAGGAGAAAGGGATGACAGAGGTTGAGA
TGGTTAAATGTCATCATCAACTCAAAGGACATGAGTTTGAGTTAGCTCTGGGAGATGGTG
AAAGACAGGAAGGCCTGGTGTTCTACAGTCCAGGGGGTCGCAGATTTGGACACGAATGAG
CAACTGAACTGAACTAACAGGGTAGCTGGAGTGGCATAAAGTTGTAGTGAAAAAAAATAG
TTTTGTTGTTGAAACAGTTCTGTGTCTTGATTTCAATGGTGGCTGCATGCAGCTACACAT
GCATTTTAATGTAGTGGCGCAGAAATAAGCAAACTCATCGCAGTACTGTAACTTCATCTT
CTGATATCAATCTATAATTACTGAAGTGTAACCATTTGGGGAATCTGGGTGAAGGGTAAA
GAGTACCTCTCCAGTATTTTTCAGAACTTTCTGTGAATATAAGAAAAACATAAAATAATA
ACATAAAAATAATAAAAATATATGTTAGGAAGATGGACAACTGAACTGGTCTTCTGGGCA
CAGTGACTGTGAAAGTCTATGAAGAGATGAAAGGTAAATGACACTTAAAAATGCCTGGTT
TTTTCATTAGTCAAGAGTGTGCTTTGCTCCAGTTTGAACAAGAAAGTGACTTGCACATCA
GATAAATACAGGGCATAAAAGACAAACATTTTTAGGATCATATTTGAATAAAAAGATAAG
AGCCTGAGAAGAGATGATAGTCTTTAAGTCAGAAATTATTTCAGGGAAATGCTACCAAGC
TCTAGAAGAATTCCTGAACAGAAAAGTTAAGAAGGTTCTCACACTTGCTCCTATCTTATT
TAGCCACGACTGCTATTTTTAAGACACTCTGACTACAAACAGACAATATCTTATTCCTTC
AGACTTGAAGGAGTCAAGGGATAGCCCCCAGATCTCAGCTCCTTCCCTACATGGATTTAG
GGAAAGGCTGACTTGTCATAACTCATTTGTGCTTCCAAGGGTAATGACACCTGTTGGACT
ATCAGAGAAGATCTTGGTGGAATCTTGAACCCCTCTCACACATTAATTTAACTTTTAAAG
ATCCCTTTCCCTTTGAATGAAGACTATGTGAATTAAAGAGGCATTTAATGAAAATCAAGC
AAAATGTTCATTCCTAAGCATTTTATTTCCTCTAACCTTGTTTGTTATGCTGCCTGTCTG
GAGCAGATGGCTGGATGACTGGTACCTTCTCACAATGTTAATAGTCATTATCACTGTGTC
ATCTGAAGTGTTGCTTCCATCCTGTTTATGTCTTCTGCTTTCTCTCTTATGTGCATTTTC
CTTTCATGTGTGCCACAGATCCCTGATATTCTTTTATACCCGTTTTCACTTGCTATGGAA
ATCTTTCTAGATATGGAAAGAAAGTGATAATAAACCTGTGATGTATGAGGTGACTAATGA
AGTGTTAAACTCAACAACTGCTTTCTTTAAAATTCTGGAGGCATGAAATTTGTATTTTTC
TCATCAGCAGTCATACCAGCAGGATTACTGCATGGAAAAATTAAGATACTCAGAACAACC
TTCCATTTTATGACACTTAAAGAAGTTGGCATTAAGATGTGTATTCTGTGACTTGTGCTG
CACCTAAAATGTAAAGGTGATTTATGTAATTAAGTGATACTGAATCAATGCTAATTCATA
AATAAAATTGCTAATTTATGGATGCTTCTTGAATCTTCCATGAACCTGTCAAATCATCAT
TTTAAAAAGCACTATTTGGTACTAAACCTTATTTTCTTATACATTTTCCTACTCTTCAGT
CCCTCTGTTAAAAAAATCTGACAAATAAGGAAAGTATAATTTTCACCACTAGTGAAATTT
ACATGTTCTTTTGTGGCAGAATATTCTTCAAAAAATGGCAGGCCTAATACACAGTGTCAT
TTTAAAGGGAAAATGTAGTCAATTTGGGAAGAAATGCTCAGTGTACAGGACTAGAATATG
TGTGCTAGAAAGCAGAAAGAAGTGTGGACGATAATGAATGCACCCTATAGGCCAGTGGAA
TAAGATAAAAAGAACACGTTGTGGATAGAACTTTTCCTTCTCCTGAGAACATTTAAAATT
CACAAATCCTATCATTTAACTTTCCCTCTAATGCTAAGCGTAGGGTGGTATGCCAAGGCA
GTTTTAAATATAAATACCTGAGCTTATCTCTAACAGTCATTTGTATTATACACAGATCAT
TGTGCTATTTTTAAAATTTTCTATGGGATTCTAAAACAATTTCTATGTGTTTTTTCAAAT
ATAAAGAGCTTTAATATGAATAATATTATCTGTGAATCCCCATAATTTGCAAGTACTTTA
TGGTTTTATTTTAAATAATCATAAAATAACTTAAAGTTTTAAGTATTGTTATAAAATTTT
CAATCTCTAAGTCACAGAAAATGTTACAACTTGGCAAATCATAGTTCTTTTCTTCTGTGT
GATTAGCATCCATAGCAGTTTTACAAGGTATGCTCTGTGTGTAACACAAAAAGATACATA
GTGGAATTTTAAAAATCCATACAAAATATTTAAAATGTCAGGCTTGAATTATAGTTTGGA
AGAAATTCCATTTACACAGGTAGCATGACTGCTTAGCAAAGTAAAATTAAATGTGAATAA
TTTATTTCTTAAAAGCAGTTTAGAACATTCTTCTAGCCATGTTTCACAACATTGACTGAT
TGATTTCTATCTATGATTCTCTTAATAAAAAGTAAAGTCTGTAATGAACTACATTTTAAT
AAGTTATATTAGAAATAACAACTGTGAAAAAAGATACATGTAGGTATTAATTGTCTTTAA
AATCAGGCACACTAAGACAAATTAAGAATTGTTTATTCATTTAAATGCTACAAAATATAG
TATTTAACTTGAAAATCAATTCTACATCCAGAAACAGAAATGATATTCTAATACATCTAT
CAAATTCAATCTAAAATGCATTGATAAACCTGTTTAGACAATTCATATAACTCTCCCAGT
TTTCCAATTTAAAAAGTATGTATATAACTTTTGTGGAAAGATATATCAAGGTCTTTTTTT
TTTTTATTGGATTGCTTTCATTTTTTTTACTCATATAATACTACTTAAGTAGGTAGTTAG
ACATTAACAAGGAGGTGATGGAAGCAAACAACAACAACAACAAGAGAGGAATAATCAAGC
TAAGCTCCACCTTTCTGGGGATTCTCCCTTGACAGAAGCAGCAAAGAAGTGATGTGGGCT
AAAAACAAGAGGGAACAGTCCAGCTAGGCTCCAACTATCTGAGGACCCTCCCCTGACCTT
ACCCAGAACCAGCGAAACTAAGATCAGGTGCTGAGCAACTTATCCTGATAAAGAGGCAAC
ACAGGGACATGAGAGAACTTGCCTGGGCTGTGCATGCCCAGACTGGACAGGTGTGAAACC
TCTGGGAAGCTCAAACTCATAGCAACATTATAGTAAAAACTACAGGTGGTTTTGTCCTCG
CCCAGGTGGGTGTTTCTCAGCAACTCAAGGGTGAGGGCATGCACAATAATAATAACTTGT
TACATAACTCTGGGCAGTCAATCAAATAGCAATCTCTTGTCACTCCCCCGTGATGGCACC
CTGCCTCCACCCCCTGTCGCTCATCCAGGATCCTACTCTGCCTCCTTGCAGAACAACTCC
TTAAAAACACCCTTAAGTCTGTATGGGAAAGTCAGTTTCATTTCACAGAATCAGCCCACT
CTCCCTCTGTGAATGTATCTATGCTTTAATAAACGTTGCTTTGTGTATAAGCCTGAAGTT
TGCAATTTTTTTGCTTGCTATTCTGCATGGCCTAAATTGCTCCTCAGGGTCTGCCATTGA
CCTCCTAAGTTTCAGTTCCCTGACAAAATGCATGCCAAACTGGTAACACTACTACTTTCA
TATAAAAAATTTACTGGGATTTTTGCAGTCTCACAGTTTTCCCTTTGCCAATTAGCAAAT
TCTTCATCATAGAATTAGTGATAATATCACTACAAATTTTTTCTTGTTAGAAACGTGTTA
TATGAAGTTAACATACAATAGCTGTGAAAATAAGAGAAGTGAAAAGCAAAGGAGAAAAGG
AAAGATATAAGCATATGAATTCAGAGTTCCAAAGAATAGCAAGGAGAGATGAGAAAGCCT
ACCTCAGTGATCAATGCAAAGAAATAGAGGAAAACAATAGAATGGGAAAGACTAGAGATC
TCTGCAAGAAAATTAGAGATACCAAGGGAATATTTCATGCAAAGATGGGCTCAATAAAGC
ACACAAATTGTATGGACCAAACAGAAGCAGAAGATATTAAGAAGAGGTGGCAAGAATACA
CAAAAGAACTGTACAAAAAAGATCTTCATGACCCAGTTAATCATGATGGTGTGATCATTC
ACCTAGAGCCAAACATCCTGGAATGTGAAGTTAAGTGGGCCTTAGGAAGCATCACTATGA
ACAAAGCTAGTGAAGGTGATGGAATTGCAGTTGAGCTATTTCAAATTTCTAAAATATGAT
GCTGTGAAAGCACTGCACTCAATATGGCAGCAAATTTGGAAACTCAGCAGTGGCCACAGG
ACTAGAAAAGGACAGTTTTCATTCCAATCCCAAAGAAAGGCAATGCCAAAGAATGTTCAA
ACTACTGCACAATTGTACTCATCTCATATGCTAGCAAAGTGATGATCAAAATTCTCCAAG
CCATGCTTTAGCAATATGTGGGTGAAACACAAGCTGGAATCAAGATTGCCAGGAGAATTA
TCAATAACCTCAGATATGCAGATGACACCACCCTTATGGCAGAAAGTAAAGAAGAACTGA
AGAGCATCTTGATGAAAGAAGAGAGTGAAAAAGTTGGCTTAAATCTCAACATTCAGAAAA
TTTAGATCATGGCATCTGGTCCCATCACTTCATGGCAAATAGATGGGGAAACAGTGGAAA
CCGTGGCTGACTTTATTTTGGGGGGCTCCAAAATCACTGAAGATGGTGATTGCAGCCATG
AAATAAAAAGCCTCTTACTTCTTGGAAGGAAAGTTATGACCAACCTAAACAGCATATTAA
AAGGCAGAGACATTACTTTGTCAACAAAGGTCTGTCTAGTCAAGGCTATAGTTTTTCCAG
TAGTCATGTATGGATGTGAGAGTTGGACTATAAAGAAAGCTGAGGGCCAAAGAATTGATG
CTTTAGAACTGTGGTGTTGGAGAAGACTCTTGAGAGTCTCTTGGACTGCAAGGAGATCCA
ACCAGTCCATCCTAAAGGAAATCAGTCCTGGTGTTTCATTGGAAGGACTGATGTTGAAGT
TGAGACTCCAGTACTTTGGCCACCTGATGTGAAGAGCTGACTCATTTGAAAAGACTCTGA
TGCTGGGAAAGATTGAGGGCAGGAGGAGAAGTGGACGACAGAGGATAAGATGGTTGCATG
GCATCACCGACTCAATGGACATGAGTTTGGGAAAACTATGGGAGTTGGTGATGGACAGGG
AGGCCTGGAATGCATCAGTTCATGGGCTTGCAAAGAGTCAGACACAACTGAGTGACTGAA
CTGAACTGAACTGAATGTATAAGGTGAAGATATTTTAATGCTTTGGAGAGAACAAGACCT
AAACAGAAAGAAGAATGATGGGAAAAATTATAAATCACAAGTGGGCACCAACATAAACAG
CATGACTTTGCCAGTGATAAAAACGGATAATGAATTGTAAAGAAATGATTTCAAAAGAGA
ACAGCTATATAGACGATTTCATGTAGGCATCAGGTTGGATCACAGAAAAAAAGAAGAAAG
AACGGACACAGGGAGGGCAGGTGATATTTCTTGGAGAGTTATCTTGGGCCTAAGAAATAT
CTTAGACCGAAGACGTTTAGCAGGTCAGGTCCTTTCTGACCTGCTTCTTTTAAATCATCA
TTAACTCACTGTCAATATATGCTACCTGATTAAAAAATAACATTTTTCTTCCTCTTCCAA
TTTTTATCTGAAATTTTTGTACTTTGCAAATTTTGTTCTTTCTGGGACAAAGCTTAGATA
TTACAAAGTGAAATAAGTGACTTTCTGTAGCTTGTGGTACTTTTAATAGAGACTCATGGA
GGTTTTACAGGGGGTCTTCTCAACATGGGAGACTAATGCTGGGGTGTGCTGTGTGTTTAG
TTGCTCAGTCTCTTCCAGCTCTATGAGACCCCATGGACTGTAGCCCACCAGGCTCCTCTG
TCCATGGGGATTCTTCAGGCAAGAATACTGGAGTGGGTAGCCATGTCCTCCTTCAAGGTA
TCTTCCCAACCCAGGGATCAAACCCAGGTCTCCCACTTTGCAGGTAGATTCTTTACCATC
TGAGCCATCCCTTGGGTGCTTTTACTCAACTATGACTGTGAAAGTGAAGTCTCTCAGTCG
TTTCTGACTCTTTGTGACCCCATAGACAGTAGCCTGCACCAGGCTCCTCCGTCCATGGGA
TTTTCTAGGCAAGAGTACTGGAGTGGGTTGCCATTTCCTTCTCCAGGGAATCTTGCCGAC
TTAGGGATCAAACCCAGGTCTCACATTGTAGACAGACACTTTACCATCTGAGCCACCAGG
GAAGTCCAGCTATGACTGTAAATTCTGGTAAATCTATTGAAAATGGATGCTCTGTCTTGT
GAGAATATATGTCTTGAACATAAGAGGGCAAATAAAACGTTCTCCTTATTACATCTCTTC
TAGAATATGATATTTTTGAAAAATAACTCCTTTTCTATCATCTCCCATATAAATTAATCT
CATTTTTAAAAAATTATTTGGCTTAAAAAGGTCTGAAGTGAATTTGTTTTTTCTATATCA
ACAAAAACAACAAATAATCAGTCAGTGGAAATATTTCCAGTACATTTCTTTCTTGATGGA
GAAGTCACTGTAAACTGCTTCCATAAATTGTTTCAAACTGAGCTTAAATTTTATCAGTAT
AGTTTTCAAGATCATAATCATCATACACTTCCATTGGTTTTGTCTTTATTTTTTCATTTG
CTTGTATATTTTCATATACAAAACATAAATTTAATCCAAATCAGTTTTCAATATCAGGAC
CAAAGCAATGGAATTTAATTCAATCAAAATAGTTCATCTCTGACTGCCATTTTGAATTAT
CTTCACAACTGTTCTCAATCAGAATATGATAATACCATAAAATACCAGGGCAGAAAAAAA
GAACTAATCCTGTTCTAACCCCACAGAGGACTCCATAAAACGCCATTATACACCTGGTTT
TGTGTATTCTTGTCCGTACACGGAATAACCTGCTTTTGCGATCTAACAAATCATCACAAA
TATAGTGACTTAAAACAAACAAACAGAGAACCTATCTCACTGTTCTGTAGGTCAGATATC
CAACCCAGGACTCACTAGGCTAAAATCAACACTCCTTTGGAGGCTCTAAATAAGAATCTC
TTTCTATGTTTTTCAAATACTTTAGAGGCTGCCCACATTCCTTGGTTCTTGGTGACCTTC
CTCTATCATTAAACACAGTAGCATCACAAGTTCTAAATGGAAAGGCTGGTTAGGACTCAC
ATAATTAGATTAGGCCCATCATGAAAATTCCAGGATAATACGCCTATTTCAAATTTCTTA
ACCAAATTGGCATCTGCAAAAGCTTCTTTTATCATGTAAAATAACTCACAGGTTCTGGAG
GAATAGGACGTGAATGTCTCTGGATGGCAATTATTCTTTCTACCACAGTAGAATACATCA
AATCCCAGAATGTTTGTGTAGTGATAATTTAGAGTATTTAGCAAAAAATTTTATTTCTAA
AGTAAAAAGCTGTGTTGAAAATCTTACAGTTTATAATAAAGGAATATTCAAATTACTAGA
TGCTATATAAATATTTCTCTAACCCTGTGAAAGCCATAGACTAGGTGGTTATATAGTACA
ACTTTTTAATGTCACATTTAAAAATGAATAAAAATATGCAAAATGGACCAATTAAAATTT
CATTTCTGACACTAAAATGATTAGTGATTGCCAGGTATTTGGGGGTAGGAAGGGATGAAT
AGGCAGGGATAGAGGATTTTTAGGTCAGTGAAAGTATTCTGATGTTATTCTTCTATTAGA
GTTGATAGTTTTAATAGCAACAAAGTACACAGTGGTGGAAAACTGGCACAGAACCTACAA
GAATTTCAATCACAATAAGGCTCTATCTGTTCAAACTTGATGTCCATTTTCTACTGACCA
TTTTGGGAAAAAACCCTATTCAGACCTTAAAACACACATACTCTTTCATACACACAGAGA
CACACTAAAATCTCTCCTTTTGTTTACAGTATGTTGAGAACAGTACATTTTGCTTATTCA
AATTGATTGCACCCCATCTGTTTATTTCCAGTTAGAAGTGGGAAGAAACAATTCAATTAT
AAAGAATATGGTAGATACCCATCATTATATATTTCTCAAAACCTACAGAATTCACAACAC
CCAAAGTAAACCCTAATGTAAACTATATTGGTTCATTGTTCTAACGAATGCACTTTGGTT
TGGGACCTTGATAGTGGAGGAAGCTATGCATGGACAAGAGCAGTGGATACAAGGTAACTC
TGTATTTTTCACTCAATTTTGCTGTGTACCTAAAATCGCTCAAAAAAATAAAACCTATTC
AAAAAGAAAAAGTAATCACTGTTTGATTCCATCTTTTATCACTTATTAAAGAAAATACAA
TTAAATATTCCTGCCTCCCTAATAACCTCTTCTACCCTTCTTTCTATATACTCTTTTAAC
TTGCATGCCTCCTACACTGCATAAATTCTTGTTCACCATTTCAGCCCTTGAAACAAAACA
AACTCCTTCTCTGCCCAGCCTGTTAGATTTTACTCTTTTCTTCATAGATTAACTCTTTTT
ACAAGGTCATTTGTTCTTTATCTCATATTCTATTCTTTTTTTGTCTAATATATACAATCA
AGACAGGGACTTCCCAGGTGGCACAGTGGTAAAGAATCTGCCTGCCAATGCAGATGACCC
AGGTTCAATCCCTGGGTTGGGGAGATATCCAGAGTAAGAAATGGCAACCTTTTCAAATAT
TCTTGCCTGGAAAATTCCATGGACGGAGTTTCCTGGCAGGCTACAATCCATAGGGTTGCA
AAGAGTCAGACACGACTGAAGCAACTTAGCTTGCACACATCCACACACGAAAGGTGCAAG
TGGGGGAAAAGATTGAATTGGTCAGGTAAATTGCTAGTCGCTGTGTTCTCTTTGGACCAG
TGAGGGAGACTGGTGGAGAGGAGATTTTTGCAGCTATTATCATGGTAATGTATTTATCTA
TATTTATCTCATTACACAATGAACTGGGTCTAATTGTTAGTCAAAGCAATGGTGAAAATC
CTTTCCTGAAGTGGTAAGAATAGTAGTTCCTCATTAGGAAATTCTTTCCTCTCTTTGTTG
CATATTGAAATTTGTCCTATCTTTTGCATCAGAGTATGGCTCTTAAGAATACATAACTGA
ATTCACTGGAAAGCTTTTCAGTCTTTTCTCAAACATGCTTCTCTATTTTGTTTTCTTTGT
ACAGTAGCCCTCTGATGCTGTATCTCTTGTTCTAAACCCAACATCCACAATCCAATTCTG
TCTTTTTTCATAACTATCTTTTATTTCCCCACTAGACTGCTGTTTTCTGCACATTGTGGT
GCAGAAAAAAGCTGTTTTTAAGCAGTTAATTTGAAGGAAAGGCCCTTATTACTGAGTCTA
ATGGAGAAAAATGGATCTTCCAATGCAGATAAACAGACATCATGTTATTTTTTAAAACAA
AACATCATTACATATTGTCCAGGCAACAGTATTTGAAGAGAAGTTCAAACTTCATCGTCT
TTGATATACTATTCAATAATGTAAAAGAGGGGACTGTCAACCTGCAGCAAATATTTTAGA
AGAACATTGCAAAATGTTAGAGTAGATGGAGGATCTTTTAAAGGGAGGAAGAGTGGGGTA
AACTCTTTGCAACAAGGAAAGAAATAGAATACAAGAGAACACCATAGAATACAGACATGA
TAAACGGTTTTACAATAGGTAGGTGGATAGATAGACAGATAACTCTACCCTAAAGTTTCC
TTACACACAAATAAGATGGATAACTGGCTGAATTATGTATTTATTTAGGAGAATTAATTG
AGTAGGTAGGTCTTGAGAACCTACCTAAACTAGTCATTTTGTCAGAATTTCTTGAGAAAA
AAACAAAATGAATTGGATACAGATCCTGCTTTAAGAAATATATAATGTATTGGAAGAAAA
TGCTGCACATAATAATTAATACTCTTGACTTTCTAAATGTTATATAGTCTAGAGTGGGAA
AGGATTCTGCCTGGGAAGATCAAGAAAATCAGTGAATTGACAAGCTTTGAATTAACAGGA
CTGGAACATCAGAGGTAGTGAGGGAACAATTTAGAAGGGAGTAAAAGTAGTAATACCAAT
CACAGCCAAGAGTTTACCTGCATATATGAATAAGAGGTATCTATGAGGATGCTTCAAGCT
GTGGTAACAGAAAACTATATTGAAGCTGACTAAACCATAAGGGGATTTGCTGTTTCATGT
ATTAAACTGTCCACTGGTAAGCAGGCTCCAGTCAGAGCAATTTCAAGTTTCAGTTAAATT
TCTTTGCAAGTTTTTCAGCTCTTTTTTTTTTTTTTTTTTTTCCAGATGCTAAAACTCCAT
TATGGCTACAAAGTGGCAGCTATAATCCACTGGGATATTAAATATGTTTGTTATTTACCT
CTGGAAGAAGTAGGGTAGAAAACGTCACACTTAACCATGAAATACAAACCTTTCCCCTCT
AGTCCTCTTGATTTACTTTACATCTCTTGACTTTCCAAGGATAGTAAATGCTGTTGAGCT
ATTACCACAGTGATTTGCTTAGTCTAAAATGCACCGTGCTCTCAAGACAGGAAAAAGTTA
GGCACTAGATAAAAAACAGAGTTTTGTCAGGAAGGTGGTATGACAGGACATAAACACTGT
CCTCTCCCAGGATATTCAGAGCTATACTATGGCTTCATGAAACATCAAGAAACGGAATTA
GGATGTATTATTAAATACTATTTTTCAGTTTTTTGAGAATGGAATAACAAAAGTTGAATG
GTATTTTGAAAACAGTAAAACAGCCAGAGGTGTATAATGAATTATAACTGGTGGCAGGAG
GAGAGCTGGGATATTAAAAAAAGAAAAAAAAGAAAGAAACATTGATACAGTAATGAAGGA
AACAGATTGATTCAAGTGGCTATGAAAGTGGAGAAGATATGATGAATGCAATACATTTTA
TGGAAAAAGAATGAGAGGATTTTTAAACCAATTTAATTTAAGGGCAAGGGAAAATAAAAG
TTAACTGCATCACCATCCTGTTAGTCAAACATTATCTAAGATGGGTGCCATTGAAAAGTA
GGGTATGTGGGCAGCAGGGGAGATAATGAGTTCCTCTTCAACTCAGTGAATGGAAGGAAT
TAAAGGGCATCCTTCTGGCATTCTGGTGGAGAGTCCATAGACTCTTGGAAAATGAAGAAT
GGGAAAAAAAAAAAAGAATGAAGGGGAAAGACCATCAGGGTGTGATGATTTTGAAAGAAA
AATCTGAAAGAGAATCTTTCACAGAAATATGGAGAAAGAGAAATATGGAGAGGGGGAAAT
AGTTCATAAAAGATTTATTAAATACATTCTTTAGTATTTTTATTAATGGTGACGTTAGAT
GTATAAAGGTCTTCCCTGGTGGCTGAGACAATAAAGAACCTGCCTGCAATGTAGCAGACC
CAGGTTCGATCCCTGGGTTGGGAAGATCCCCTAGAACAGAAAATGGCTACCCACTCCAGT
ATTCTTGCCTGGAGACTTCCATGGACAAAGGAGCCTGGCAGGCCACAGTCCATGGGGTCA
AACAGAGTCAGACACGACTGAGCAACTAACACATAGACGTATATAACATATGCACATACA
TATTTTTAAATATTCATTTTATACTGGGGTATAGTTGATTAACAATGTTGTGTTAGTTTC
AGTTGTACAGTAAAGTGATTTAGTTATACATACACATGTATCTATTCTCTTTCAATACTT
TGGCCACCTTATGTGAAGAGTTGACTCATTGGAAAAGACCCTGATGCTGGGAGGGATTGG
GGGCAGGAGGAGAAGGGGATGACAGAGGATGAGATGGCTGGATGGCATCATGTCAACTCG
ATGGACATGAGTTTGAGTAAACTCCGGGAGTTGGTGATGGACAGGGAGGCCTGGTGTGCT
GTAGTTCATGGGGTGGCAAAGAGTCAGACATGACTAAGCAACTGAACTGAATTGATTCTC
TTTCAAATTCTTTCCCCATTTAGCTTATTACAGAATACTCAACAGTGTTCCTTGTGCATT
ACACTAGGTCTTTATTGCTTATCTATTTAAATAAAGCACTATGTACATGTCAATTCCAAA
CTCCAATTTATCCCTTCTAACCACCCTTCCTCTGTGGTAATCATAAGTTTGTTCTCTAAG
TCTGTGAGTCTGTTTCGTAAATAACTTCATTCGTATCATTTTTTTTAGAGTCCACATATA
AGTGATATTATATATTGTCTTTCTTGCTCTGACTTACTTCACTTAGTTGTTTTTCTGGGG
CAAGACATTTCTCCACTGTTTCATTTTGTCTAACTTTCTGTGACTGTGGTTTCTGTTCTG
TGGGTGGCAGGATTGTATTTCTTCATGCTTCTGCTATCTGCCCTCTGGTGGATGAAGCTA
TCTGACAGTTTTCGATGAAAGCCTCCAAATGTCTTTTTTTTCCCCAGAAACAACTTAGAA
CTGAGGTTCAAGATACTTTCGCACTGACTGATTTGAAGTGTGAACAAATCAAGAAAATGC
CCATGACAGATGTCTTATTGGGGCCCCAGGTTCAGCTCCAGAAGCCTACATTGCTGCAAG
TAGGCAGCCTCTGGGATGGCCTCTAGGGCAAGGCACCGCTCCACTATGCCTCTGAACAGG
GAGAGAAGCAAGTCATCCATATCAGGTGGAGTTTGCTCCTACATATATACTTTAATAAAA
ATAAGTATGGGATAGCATGTACTAAATTTAGAGACAACTTGGAAGTTTATACTCTGCTTT
CCAAATGAAAATTAAGATTGCAGTTTTACTACTTAACTTTGATGTTGTCCTTGTTCAGTT
GCTCAGTAGTGTCTGACTCTCTGTGACCTCATGGATGGCAACACGCCAGCCCTCTCTGTC
CTTCACCACCTCCCGAAATTTGTGTAAACGTCTGTCCATTGAGTCAGTGATACCATCCTA
CAATCTCATCCTCTGTCATCCCCTTCTACTCGTGCCTTCTGTCTTTACCAGCATCAGGGT
CTTTTCCATTGAGTCAGTTCTTTGCATCAGATGGCCAAAGTAATGGAACTTCAACCAGCA
TCAGTCCTTCTAATGAATATTCAGGGTTGGTTTCCTTTAGGATTGACTGGTTTGAACTCC
TTGTGGTCCCAGGGACTCTCAAGAATCTTCTCTAACACCACAGTTCAAAAACATCAATTC
TCTGGCGCTCAAGCTTTGTTAGGGTCCAACTCCCTCACCCATACATGACTACTGAAAAAA
CCATAGCTCTGACTCAGATGGACATTTATCAGCAAAGTAATGCCTCTGCTTTAGAATACA
ATGTCTAGGTTTGCCATAGCTTTTCTTTCAAGAGCAAGATTCTTTTAATTTCACGGCTGC
AGTCACCATCTGCAGTGATTTTGGAGCCTCCAAAAATAGTCTGTCACTGTTTCTATTGTT
TCCCCATCTATTTGTCGTGAAGTGATGGGACCGGATGCCATGATCTGTGCTTTTTGAATG
TTCATTGTTAAACCAGCTTTTTCACTCTCTTCTTTTCACCCTCATCAAGAGGTTCTTCAG
TTCCTCTTCACTTTCTGCCATAAGGGTGGTGTCATCTGAGTTTCTAAGGTAACTGATATT
TTTCACCACTGTCTTGATTCCAGATTGTGCCTCATCCAGCCCAGCATTTCACATGATGTA
ATCTGCATAGAAGCTAAATAATCAGGGTGACAAATCACAGCCTTGAGGTATTGTATCCCA
ATTTGGAACCAGTCAGCTGTTCCATGTCTGGTTCTAACTGCTGCTATTTGACCTGCATAG
AGGTTTCTCAGGAGGCAGGTAAGGCGGACTGGTAGTCCCATCTCTTAAAGAATTTTCCAA
ATTTTGCTGTGATCCATGCTGTCAAAGGCTTTAGTGTAGTGAAGCAGAAGTAGATATTTT
TCTGGAATTCTCTTGCTTTTTCTATGATACAACGAATGTTAGAAATTTGATGTATGGTTC
CTCTGCCTTTTATAAATCCAGCTTGTACATCTGGAAGTTCATGGTTCATGCACTGTTGAA
GCCTAGCCTGGAGGATTTTTAGCATAACTTTCTAGCATGTGAAACAAGTGCATTTATGCA
GTAGTTTGAACATTCCTTGGCATTGCCTTTCTTTGTTATTGGAATGAAAACTGACCTTTT
TTGGTCCTGTGGCCACTGCTGAATTTTCCAAATTTGCTGACATATTGAGCACAGTACTTT
AACAGCATCATATTTTAGTATTGAAATAGCTCAGCTAGAATTCCATCACCTCCACTAGCT
TTGTTCGTAGTGATGCTTCCTAAGGCCCCCTTGAGTTTGCACTCCAGGATATCTGACTTT
AGGTGAGTGATTACATCATTATGGTTATCTGAGTGATTAATACCTTTTTTGTATAATTCT
TTAATGTATCCTTGCCACTTCTTAAAATCTTCTGCTTCTGTTAGGTCCATATCCCTTCTC
TCCTTTATTGTACCCATCTTTTCATGAAATATTCTTTTGTTATCTCTAATTTTCTTGAAG
ATCTCTCTAGTCTTTCCTATTCTGTTGTTTTCCTCCATTTCTTGACATTGTTCTGTTAGG
AAGGCTTTCTTATCTCTCCTTGCTATTCTTTGGAATTCTGCATTCGGATAAGTACTACTT
TCCTTTTCTTTTCCATTCTCTTCTTTTCTTAGGTATTTGTAACTCTTCCTCAGACCACCA
TTTTGCCTTTTGGGATTTATTTTTCTTGGGGATGGTTTTGATCACTGCCTCCTGTACAAT
GTTACCAGCCTCTGTCCGTAGTTCTTCAGGTGCTCTATCAGATCTAATCCCTTGAATGTA
TTTGTCACTTACTGTATAATCAAAGGGATTTGATTTATGTCATATCTAAATAGCCTAGTG
GTTTTCCCCACTTTCTTCAATTTAAGTCTGAAATTTGCAATTAAGAATTTGTGATCTGAG
CATCCCTTAGTGCCCAGTCTTGTTTTTGCTGTCTGTATAGAGCTTCTCCATCTTTGGCTG
CAAAAATATAATCCATCTGATTTCATTATTGACACTCTGGTGATGTCCATGTGTAGAGTT
GTCTCTCGTGTTGTTGGAAGAGGGTGTTTGCTATGACCACTGCATTCTCTTGACAAAACT
CTGGTAGCTTTTGCCCTGCTTCATTTTGTACCCCAATGCCAAACTTGCCTGTTACTCCAT
GTATTTCTTGACTTCCTAATTTTACATTTCAGTAAGTAAATTACTAAGTAATTTACTTAG
CTTCACTTTCAAAGAATGTCTTGATTCTAATCACCATAGTAAAATTATCTACTTCTTTTA
TACTCAAGATGAATATACTAATTTCAAATATCAATATCAATTTTACCATTAATAAAAAGA
GATACAGCTTGGGCTGTCCTTGTCATTAGTATTTGTCTAAAAATGTATAATTATAAAGTC
TTTGTCTTGAGACCTAAAACTTTCCCTTAGAATTTCCTTTCAGATATATTTATCATACAA
TTTGTAGATGGAAGCATAAAGGTCCTTTGAGAAAAATGGTCAAGATGTTTTCATTTTTTA
ATTTTGTAGGACTATAAAGTACTATAATGCTAAAGATCAAGATGAACTAAGATAACACAG
TTTGCTTCCTAATGTTTCTGTAATCCATAGTAGAAATTGTGAAAGCATTGGCAAATACAA
AAATCTGTTTTTTTAAAGTGAAAGAAATAAGAATTGAGTCAAACAAACTGTCAACATAAA
AATGCCTGTCATTCACTATCCTTTTTTTTTTTTTTCCTTTTTGGACCAAAAGAGAATATT
TTAGATGAGAGATTGAGACACTAAGGCATTGCCATCATGACTGTTAACTTCTTGTTATAA
TTCATTCTCCTTATCAGAAGTTAAGCCTGAAAATCAGAAACAGAAACAATCTTCTCTTTT
GGGTGACTATGATTGCCAATCTAATTCTTTCTCTGCTCCAGTGAACCTAAATTACTAAAA
GTAATATAATGGGATGAGTAATTCAATAGGTGTGAACAAATGTATCCCAATGCAAATGGT
TTCACATTATGAGGTGACTTTTTCAAACCCCTGTAAGTATCATTTGATTAATACTTGGCC
TGGGTTCAATTGCTCCCATTGCAGTCTTCTACATGTTGCAATCTGAAGTTTTCTTTCTAA
CTTGAAAATAATACAGAATAAGCAGTCTACTTAAAATTTGACTCACTACTAATATTTAAT
AGGTCATAAAATAAGAAATGGATGCTGCTTGTTTTATGGAAACTGTTACCTTTTAAAGCC
ATCATTAGGGCTATGTTTTTGACCATAACATATAAAACTCAATCTTTTCTCACCATGATA
GTTTTGTTAATGGTGAATCTATAGAGTGGTTTAAGTGCAAAGAAATTGCTGTTCAACAGT
TGATGACTTTATGTCTCTGCCTCCTACAGTCTCTGCCTCTCTCTTATAATTTCCTGTTTT
TGTCCTTTTTTCTTTTTCTTCTTTTTTCTCCTCTCTTTATGTCTTTTTTTAAAATCTTCT
CAACTTATTTAATGTTTATCTTCATTTCTGTAGTAAATGATTTTGAAACACTATGATGAG
AGATATGACTTAAGGTTCATTAAGGAAAAAGAATCAATAGTAACAGTGACATATAAATGA
AAGAAAAAGGATAACCAAGCAAAGGCATGCTTGTGGTAAGGAAGCAGGGCAAAGATACGA
ACACAGGTGAAATTAAATCATCGAAATGGTGCAAGGGGTTGACAAAATCTCTAATGAATA
TTGGCTTAAATTGTTAAGAATTTCATGGATTTGAAGTATACTATACATTTGTATGTTAAA
ACAGAGATTCCATCTGTTACTTTGTTGAGGAAAGAGCAGCACTTATACCAAGGGTGTAGT
GCTTCCATCAATAATGTATTGGTATTCTAATTAACCTACTCTTTAGCTTAAGTTTTGATA
GTTTCTGTATTTGTTATAATAGAGAGACACAAGAAACATTAAAGAGTCTTCAGTAGTGTT
TATATAAATACATGAATGAATAAAAAAAGAATCTGAAAAGTCATTGTCAACAGAGGTTTC
ATAACTCTGAAAATGGCTACAGAGTAAAACTAGAACACTTTGAGGTAGCTCTGGGTAGTT
AGAAAAAACTGAGTTTATACAACTTGATGTGCAGAAATTAGGAATTAGCATTTATAACTG
ACTATTGAATGCAATGAATATCTCAAATGCATTATATCTCACCTGTAAATGCTTTATGCT
TTTTATTTTTATTCTATAATTCTTCATTTATTAAACTGATTTTACCTCAAATGTTATATA
ACAAGAATATGCTAACCTATGAATGTGTTGGGGACTTTATAGAAGGTAAAATCAATATGT
AGAGGGCTTCAAGACAATTTATTAATTGTTTAGCCATTAAGAATTTCACATTAAGCTAAT
GAAGAGAAATAAAATGTAAATGATTAAGGGGGTGGAGAAAAAATATTAGTAAAAATTAAA
TACAGCAAAAGAAAATATTTTTAAAAAATTAAAGATTGCTCTTGATAACAATCTAATCAC
ATTTTTAACAAAAATTATGAGCATGAAAATATGTTTAATTATGCTGTGAAATATTTGTCA
TGCTATTTTCTATACATTTTTCTAGGTTATAATCAACTTATTGTCAGTCAAGTTTTCAAG
TGTTCTAAAGCACACTGAATAGCATTTTATGTGTTTGCTTTCTTATGCTTCCTTTCTTTT
TTTGAAACTTTTGCTCACTTATAGGAGGACTAACTTCATGCCTATTGAGCCTAAACTATT
TTAAGTCAAAATTGATAGATGATAAAAATATGTGCTGATAGTAAACCCTAGCCACTGGTT
ACATAATAATGGAGTGCGCAATGGCACCCCACTCCAGTACTCTTGCCTGGAAAATCCCAT
GGATGGAGGAGCCTGGTGGGCTGCAGTTCATGGGGTGGCTAGAGTTGGACACGACTGAGA
GACTTCACTTTCATTTCTCACTTTCATGCATTGGAGAAGGAAATGGTGACCCACTCCAGT
GTTATTGCCTGGAGAATCCCAGGGACGGGGGAGCCTGGTGGGCTGCCGTCTGTGGGGTCG
CACAGAGTCGGACACGACTGAAGTGACTTAGCAGCAACAATGTAAGTACTGCTCTCTGGA
TTTATCACAGTTACACAGTAATGAATCAAAATGTTTAGAACTGTTTTTGGTGTAAACAAA
TATCGCATTCCACATTTTCCTATTCTCAAACTCACTCCAGACTATCACATTTTTTTTCAA
AAAATTCAAAATTCCATATAAAGTACTGCTGCTGTTGCTGCTAAGTCGCTTCAGTCGTGC
CCAACTCTGTGCGACCCCCATAGATGGCAGCCCCACAGGTTCCCCCGTCCCTGGGATTCT
CCAGGCAAGAACACTGGAGTGGGTTGCCATTTCCTTCTCCAATGCATGAAAGTGAAAAGT
GAAAGTGAAGTCGCTCAGTCGTGTCCGACTCTAGCCATCCCATGAACTGCAGCCCACCAG
GCTCCTCTGTCCATGGGGTTTTCCAGGCAAGAGTACTGGAGTGGGGTGCCATTGCATTCT
CTGATATAAAGTACTATATTTTATTTATTGATTCATCAACTATAGAAAATATTCATTTAC
TCTCCAATGTGCAAATAGTGTTTTATCTCATTCCTCTCTCTTCTCTTCTATACAATGTAT
GAGATTGTATATTTATTTTATTTTTCTATTCTCTTTGAATTATTGTCACTATTATTATCA
ATTTTTATGTCTTTGTGGTTTTCTGTTTTCAAGGCCAAAATTCTGTTGGTGGAAAAACAA
AAATACTTTCTAAGTTTTGACCATAAAATGGCTTAAATTCTTAAATATTTTTTTTTTGTA
TTAATGTGGGAGAATTACATTTTGTTTGCTAAAAGTCTCTTATGGACTAAATTTTGTTAC
CCCCAAAATATATGTGTTGAAGCCTTAGTATATACCCTGTTACTATATATGCAAATATTT
GCTTATCATTATCATACTGTTGTCATGATTTTCTCCTTAAACTAGGTTCAGCTGCTAAGT
CACTTCAGTCGTGTCTGACTCTGTGCGACCCCATAGACGGCAGCCCATCAAGCTCCCCCA
TCCCTGGGATTCTCCAGGCAAGAACACTGGAGTGGGTTGCCATTTCCTTCTCCAATGCAG
GAAAGTGAAAAGTGAAAGTGAAGTCGCTCAGTAGTGTCCGACTCTTAGCGACCCCATGGA
CTGCAGCCTACCAGGCTCCTCCGTCCATGGGATTTTCCAGGCAAGAGTACTGGAGTGGGG
TGCCATCGCCTTCTCCGTAAATTAGGTTCATTAAACCCTAATTCAATAATACTCTTTCTG
TGGCCTAATGTCACTGGATCTTATGGAATTTTAGATCTGAAAAGAACTCAGAGATGCAAA
TACTTGACAAAAGTATAATCAGGAATTTGAAAGTATAGCTCACCCAAATTCTCAAACATT
AGACAAATAATGTCAATGTAAATATATTTGAGTTTTAACCAAAGAATCATAACTTGGGTA
GTGAAAAATATGTTGTAGAAGAAATTACAAGAGAAAGAGAAACATAATGAAGTAAACAAG
TCGTAGACTTGATAACATGCTTTTTCCCTCTTTTTATGGTGTTTTGAATTTTATTTATGG
CAACAAAGATAACCCTTACTCTATCCAGAATTTCCATAGGTGCCTTTAGAGTGGTAATTA
ATTGCCTCTATGGCAAATGAAACCTATACAGGTTAATAATATTGATCACATTTATTTTAT
TTACTAACATAAGGATTAAAACAACAAAAAGTACCCAAACTAAATTCTCTCTCCCACTGT
GAAACTTTCCCAATGAAACCTAAACCAATAAGGAATCAATAGAAGGAAAATCATGCCAGC
TGCCTTTATATTCACTATCAATTACTAGCTTCTGTCTATCTATTTTCATGCTTTAAGAAT
TTTGACATTGCTATCTTAAATAAGTTTTTTTTTTGGGGGGGGTAAGAGCATTAAAATATC
TAATAATGAGAAGTATCTTGAATCATTATAACAATACTATTCTGGCAGGCTGACAGGCTT
GATTTCACTGTTGCAGTGTAGTGAAGTGCAAACCTTTACAAGACCTGCTTCACCTGAATT
CTAGGGCAGGCTTAGGACTGTCTATTTCTGCTGACCTTGGGCAAAGCTTATACATTCTGT
GAGACTCATTCAGTTATTTCATCAGAATATTTAGGAGTTTAGCAAACTAAGTCCTGTACT
TAATAGAAAGCTTGTAAACTATTATTACCATTTAAATTTTTGTTGGATTAGATCATTTTT
ACTGTTCTCTATAACTCTATACATCTTATCATTTCCTTAAAGATTGGTGCCAGGATTTCT
TACTGATAAACCTAAGAAAGAATAAAAATAATATAGCCTCCTTTATGAGGAACTTTCAGT
CTCTTAGACTTCAGAAAATAGTTAATAATGTGTTCAAATTCTATTAAAATGAGCTTTCAG
CTCATAATCTTACTCTCCAATTTAGAATATGTAATATTGCTTAATGATGAGGGTGTTTGT
ATTTCTCTATTAGCATAAAAATAATGATTTTTCATTATAATAAAATATTCTTCTATTGCA
TATCTATGTCTTATGAATTACTGTACACATATTTTGTGTCAATTATAGACTGCAGAATAA
AAGGTAACACTTCAGCCTTCAGGCTGAATCATTTATTTGGAGCTCACTGATGTGTTCTTA
ATTCAATTTGGAATCTCTCCCCACCCACAGTGTGTGGAGAAAGAGATGCAAACATTTTTC
TTCATTGGCAGTGGCTTGAGAATGCATCAACATGACAAATATTTTCCAGGAGAGGGGGGA
AAAAAAGGTATACTCTGTGAATAACAATTTCCCTGTCTCTCTCAAAGAAAAAAGAAAGAT
AATCATAGCAATTTGTATAACATTTCTTTTATTTCAAAAGAGGCTCCAAGCATTTTAGAA
ATGTTAACGACAAACTGGTTCTGTGGGATTCACACCTTCTCTCACTGAAATGGATTCATG
TTTAACAGTGCATGGGGATGACAGGCCTTGAAGAAATCTCTCCTGGATTTATGATCACAT
CTGTAAGGCTGAAAGGAGAGCACTACTTATTCCAAAGTGCCCATGCTAGGATGTGTATCC
ATCACATAATCAAAGGCATGGCCTCCCTGCACATGCAAAATGTAACAGATAACATAATAT
TCACCTCCTCTTGGATAAAAGTATTGATGTGGCATCACATGATACTTTGTGCATCACTGT
CTAGTAATGGAAATGTCATTATACCTGTTAATAAGAGCATTAATAGTCATTTAAGAATAT
TTAATGTTTTCATGTGAATTAACATTATTATTGCCTCTTTTTAAAATGTATTAAATTCAG
AATCCCATAATAGTACACCCATAGAATAATCTAAGTGAAAATGAAAGTATTAGTAGCTCA
ATCATGTCCACCTTTTGCTACCCCATGGACTATAGCCTGCTAGGCTCCTCTGTCTGTGGA
ATTCTCCAGGCCAGAATACTGGAGTGGGTTGCCATTCCCTTCTCCAGGGGATCTTCCTGA
CCATGGATTGAACCTGAGCCTCCTGCACTGCAGGCAGATTCTTTACCATCTGAGCTGCCA
AGGATATGAATATTTATCTGTTGTTTCTTAATTCCTTTATATACACTATATGGCTGACCT
AAACAATGATGATATGCTATAAATTCTAAATAATGTGGAACATCACTTGCACAATTACTA
ACAGGTTTTGAGACTTTATAAATACAAACATACATACCTACACACATGTGTAATCATATA
TCTGTGCATATTTAATATATATTAGTGTCACAAGGCTTTGATTTAGACCATGTGCTATTA
ATTGGGCTTCCCAAGTGGAGCTAGTGGTCAAGAACCCACCTGCCAATGCAGGACACATAA
GAGATGTGGGTTTGACCCCTGGGTCAGGAAGATCCCCTGGAGGAAGATTCCTGGAGAATC
CCATGAATGGAGGAGCCTGGAGGGCTACAGTCCATAGAGTTGCAAAGACTTGGATATGAC
TGAAGCAACTTAGCATGCATGCATACTATTATTTATCTTACAGCTACTAATAGTTAAAAA
AGGAAAGAAAAAATATATGTAACTATATTCCAGTTTTTACATTCTATCATTATTCATGCT
ATTTTGGACAAATTTTATTCATTCATATTTTCATTCATCATATCGAAGTCTTACTCATTA
TATATAGAAAACATTTATTCAGTTAGTTCAGTTCAGTTCAGTTGCTCCATCATGGTCTTC
AGGAAGATCATATTCTTCTGGGAGAGATACATATGAAAACAGTAAATAGAGCACCATAAG
TATATCAAACAGGCGGCTCATAACTCTGTAATTCAGAAATGAGGCAGGGGTGATTTTATA
AAGAAGCCAACATTTGATTTGAGTCTTGAAGACTGAGTAGAGGATGCCAGCCAAAGGAAG
CATTTTGTCAGGGTTCTAACTGTAAAATTAAAACAAACTTCTAGCATTGACTGTGGTAAA
GATATAACCCCAGCCATATCAATGTCAAGTGAGTAAAAGATAAGTAGTTGTTACGAGTTG
CATTGTATCTCTCCAAAAAGTTATGTTGCAATCCAAGTTGCCAGGGCTTCAGAATGTGGC
TCTATTTGGAAATAGGATGTTCTTAGAGGTAATCAATTTAAAATGAGGTCATTAAAGTGG
GTCCTAAACTATGACTCCTGTCTTTATGAAAAGAGAAAATTTGTACAGAGATAGACATGT
GCAGAGGGAGGATGATATGAAAAGATACAAGGAAAATACCATGTAAAGATCAAGACAGAG
ATTACAGTGATGCTGCATCTACTACCAAAGATTGTCAGCAAGCTATCAGAAGTTAGAGGG
AGGCAAGAAACTGATTATCTCTCCCAGCACTCAGAATTCATCACCCTGCCAACACTGTGA
TCTGGAATGTCTAGCCTCCAAAACTGTGAGCCAGTAAATTTCTGTGGTTCATAGCTATCT
AGTTTATGTCAACTGGGTCACAGCAGCCTCAGTTCAGGTCAGTCACTCAGTCGTGTCTGA
CTCTTTGCGACCCCATGAATTGCAGCATGCCAGGCCTCCCTGTCCATCACCAACTCCCAG
AGTTCACTCAGACTCACGTCCGTCGAGTCAGTGATGCCATCCAGTCATCTCATCCTCTGT
CGTCCCCTTCTCCTCCTGCTCCCAATCCCTCCCAGAATCAGAGTCTTTTCCAATGAGTCA
ACTCTTTGCATGAGGTGGCCAAAGTACTGGAGTTTCAGCTTTAGCATCACTCCTTCCAAA
GAAATCCCAGGACTGATCTCCTTCAGAATGGACTGGTTGGATCTCCTTGCAGTCCAAGGG
ACTCTCAAGAGTCTTCTCCAACACCACAGTTCAAAAGCATCAGTTCTTCGGTGCTCAGCC
TTCTTCACAGTCCAACTCTCACATCCATACGTGACCACAGGAAAAACCATAGCCTTGACT
AGACGGACCTTTGTTGGCAAAGGAATGTCTCTGCTTTTGAATATGCTATCTAGGTTGCTC
ATAACTTTCCTTCCAAGGAGTAAGCGTCTTTTAATTTCATGGCTGCAGTCACCATCTGCA
GTGACTAGCAAACTAGAACAGATGCTTTCCAGTTTCACTTCCTCTTCTTAGATGTGGTTC
ACCACCCTGCATTATGGAAATGAATGCCTTCTTCCCTACTAGATGTAAGAATTAGAAGTG
GCAGGTAGTGTGTCTTATAAATTTATATTTCTTTGAAGCTATAGCCTATTGTTTTGCACA
CTACAGAAATGGAATTAATTTGGGCTAAATATATTTTAAAATGGGAAAATACAATGAAGC
TATTGAATAAAAGAACTCAGTTTCACCGAGAGGGGAAAGAAAACAAGGATAAATGGATGT
GAATAGTCATGGAAAAACAAAATTATTTCCTTCATTTTGTTTAATATATATATACCTACA
TATATATGCGTATTTTCTAAAAAATCATTAGTATTTATGACTATGAACTTTCAGTGAAAG
CAGATATATTTTGCAGAAATACTCTAATGCCATATATTTATGATTTTATGAGAACTTGTT
TATTTCATGAATATTAATTATGATTTTAATCTCACTCTATATGAATGCAAGTGAAAATAC
AGTGTTGATTATTACATTGTTTTGTATTATATCATAATACTGTTTTAGCATCAATGAATC
TAGCCTTATTTAGAATACATTAATGTAAGCAGAACCACAAATTAATTTGAAGGTTAGTAG
TTAAATATATCAAAACTACAATGCTACAGACTAATTGGCCCTCTATAGTATGAATTGTCT
GTATTATTATTATTACTGAGACTTTTATTAGCTCTCTTTTAAGCATACTTATTTGACTGG
AAAATTGGTTCAGTACTAATGTATCACCTATTATGTTGTACTTTAAGGAAAGTAATGTCA
TACTGGTATAGGGCCCTTGTGAATAATAAAGATGGAATATATGATTTCTTATAGGAAGTC
TGAGGTGATATAGAAAGTTAATTTTTCTCTTACCGTAAGTAAAAACATTATTGTATGGTG
TCTATGATAACAACTGCTTTAGCCAAATTCACTTAAAAAAATAAAAGCAAAATCTACTTA
AAACATAGAATTATATGTCTTGAAAGAGATTTTAGAGAACAATTTAAAAACAAATCTTAA
GCCATTCAATCAAACAGAATAATTTGTCTAAACTTAATTCCAGGCTATTCCATTTTGACA
TTATTTAGACACATCTGAAGAAATAGATACATTATAATGCATGATGGTGGAAAGCAGTAG
AGGATGAATATTATATGGAGATAATTTTTTGCTGTATGATCCTGTTTTTTTTCTTAGTAC
AAGATCAAATATTCAGTTACTGTTGTTGAATTTGAAGTTCAAATTGAACATTAGCTGAAA
GAAAGGCCTGAATTCATATTGGAAAATCTTTACTCTATTCATATAATTAAGAAAAAGTCA
TAAAGATCAATTTAATTATTAATAAATCTAATTGTGTAAAATTAAAACAAAAGTAAAAAT
CCTTTAAACTACTTTTTGCATGAAATAAATTTGGAAGTAAAATAATTTGATTTCTTATTG
GAGATAACAAAGGGAAGAAATCAAATTGACTAAGGTTGACTGCTGATTACTTTTTTGGAA
ATTATTAATATAGTTTCCTGAAAAATGAACATATACTCCACTTAATTGAACATCTAGTCC
AAGAGCTGTTATGATACATGACTTGGACATACAAGACAGGTAACTGGGATGTATTCTATA
CAAATGCAATTATTATAAAACAGGACAAGTCAGTGTATAAATTAGAGCTGACTTATGTAC
CAATAGTTCATACTTAGGTAGATTAGACTATAAGTGTTTTGGAAGTGTATTCCTCCATTA
AATTCTCATAGAACTTCCACCTCTGTAAGGAGGGATGAGTTCCATCCTATATAAGTACAT
AAAGGTTAACCACACTCACTCTTCTCAAGGATCTTACACACTATGAGGGCTTCCCCCGTG
GCTCAGTGGTAAAGAGTTCTCCTGCAATGAAGCAGATGCAGATTTGATCCCTGGGTCAGA
AAGATTCCCTGGGGAAGGAAATGGCAACCCACTCCAGTGTTCTTGCCTGGAGAAAGGCCA
TCCAAAGAGGAGCCTGGGTGGGTTACAGTCCAAGGGGTCACTAAAGAGTTAGACACAACT
TAGACTAAATAGCAACAAGCTTTATATGTAGACAAAATTACAAAAGGAAGTGGCAAATTG
CATATTTCACAAGAAATGTAGAAGAGTGAAAAAGGAATTTTAAAAAGTAAGAGGTCAATA
CCGACTGGGATAATGATACAAGTTTCTTAGAAGATACAATAATTATATGTACTATCTGTT
TTTATATTTCTTTCAAGTCTGTGCTATGTGACTTTGAGGAAAGTCCCTTCAAAACTGTGG
CTTATGGTTTTCTCAAATATCTGAGGTAGTCTGAATGATTTCTGCAATTCCTATTTAGCT
CTGAATGTCATATGCTAAATCACCTTCTTTCCAAAGCAGTGAGATATAGACTGTTTACCA
TCAAAAGGAGGAAGAACATAATGTCATAGTGGGTTCTAGGTATGGAGCCAGGAAAAGGGG
AACTCAGAGAGTGCTGACTCCTAGAGACTGTTACAATGTGTAAGGATTAATCCTATCTTT
TAGACCAGTATACAGATTTTCAGTGAGATTTTATCTAATTCCCAAATCTGTTATTTTCTC
ATTTTACTTGACGGATTTTATTAAACAAGTACTGTTTAATAAACTGATGCTCAAATAAAC
AAAAAAACTGCTATAAATAATCTGACAAAATATAATTCAAGTATAATAGTTTATGTTATT
TGGTTTCTATGTTTTATCTGTTAATTTTATTGAGTTTTCAGCTATTATACTTGTAAGCAC
TTTGAATTATTCTCTTTGTACATGTTTCACAGTGAAATATTTTACCTATCAGTACTCCCA
GAGTCACATGCTGATGTGTTAAACAAAATAGGGTAGCTAAAGCTAACTTTTGGTAAAGTT
TTTATAAATTCCATTCTTTAGAAGCTAAGATTTAAATCATGGTTTGACACTGAATAATTT
ATGTCTATAGTTATAAAATTCAGAGTTTAATAAACTGGCTTTGAACAACAAATTATTAAT
AGTAAATCACTCAGTGTAACACAAACTAATTTTTGCTGTTCAGTTGGTAAGTCGTGTTTG
ACTCTTTGCAACCCCATGGATTGCAGCATGCCAGGCTTCATTGTCCTTCACTGTTTCCCA
GAGTTTGGTCAAATTCATGCTCATTGAGTTGGTAATGCTATCTATCTCATCCTCTGCCAA
CCCCTTTTCCTTGTGCCTTCATTCTTTCCCAGCATCAGGGTCTATTCTAAAGAGTAGGCT
CTTCACATCAGGTGGCCAAAGAATTGGGAGTTTCAGCTTCAGCATCAATCCTTCCAATGA
ATGTTCAGGGTTGATTTCATTTAAGGAGTGATTGATTGATTTGATTTCCTTGCAGCCCAA
AGGATTCTCAAGCATTTTCTCCACAATTCAAAACCATCAATTCTTTAGTGCTCAGCCTCT
GTAGTCCAACTCTCACATCCATACATGACCACTGGAAAAACCATAGCTTTGACTATATGG
GCCTTCACTAGCAAAGTGATGTCTCTGATTTTTAATATGCTGTCTAGTTTGTCATAGCTT
TCCTTCAAGGAGCAAGCATCTTTGAATTTCATGGCTACAGTCACCATCTGCAGTGATTTT
GGAGCTGAACAAAATGAAATCTGTCAGTTTGCATTTTTTTTCCCCTTCTATTTGCCATGA
AGTAATGGGACTGGATGCCATGATCTTAGTTTTTTGAATGTTGAGTTTCAAGCCAGCTTT
TATACTCTTCTCTTTCACTCTCATTGAGAGGCTCTTTAGTTCCTCTTCATTTTATGCCAT
TATAATGGTATATGATATGTATATATGAGGTTGTTAATATTTCTTCTGACAATTTGATTC
CAGCTTGTGATTCATCCAGCCCAGCATTTCACATGATGTACTCTGCATATGAGTTGAATA
AGCAGGGTGATGATATAAAACCTTGTACTCCTTTACAAATTTTGAGGCAGTCTGTTATTC
CATGTCATTTTAACTGTTGCTGTTTGACCTGCATACAGGTTTCTCAGGAGACAGGTAAGG
TGGTCTGGTAATCCCATCTCTTTAAGAGTTTTCTGCAGTTTGTTGTGATCCACACAATCA
AAGACTTTAGTGTGACAAGTGAAGCAGAAGTATATATTTTTTGGAATTCCCATGCTTTCA
CTATGATGCAGCAGATTTTAGCAATTTGATCTCTGGTTTCCTCTTCCTTTCCTGAATCCA
GCTTGTACACCTCGAATTTCTTGGTTCACATAATGCTGAAGCCTAGCTGGAAGGATTTTG
AGCATAACCTTGCTAGCAAATTAATAAGAAAACTGAAAAACTCAAGTAAAAGCTCAAATT
ATTTCAAAATTATCTTTTTTATATAATATTTATTTTGTATATGTAAGAAATAGAAACTTG
ATGTGGCCGGTTTTCAAGACAAAATTGAAGCCTGGACTCTTTAGATAAAGTTAGGATTGG
TGAGAGAGATTAGACTGGATCCTAAAGAGATAGGACTCCATCCTTTGCCTGTTCCCTGGT
TCTAAACTTGCTAAGGACTTGCAGACCTGACATAGTTCATGTACCTGGAGGTTCCTTAGG
CAAACAAGATGTTGGGGGAAGGGATACATTAGCAAGAAAGTCTTTTTTGAAAAATGTGGA
TGCAAGTTAGGAAGGGAGAAAGAAGGATACTCTATAAGAAAATAATGAAACTTAGGCGAC
CTCCAGGAAGATTGCACACCCCATAGTATTCAGCAATGAGGAACCAGGGGGAAGGACCTG
AGTGTTAGGGAATAAATTGCTGTTGTAACTGCCCTGGGTTTACCTGCCCATCGGACACCT
GATCTTGCAAGACTGTCATTAAAAGTTTCACTTTCACTGTGCTTTGTGTCTCAGAGTCCA
TCCTTTGGTTTTGGGCTGGTGAGCGTGTTTTTCACAGTATATCTATCTATAAGAATTTCT
CCTTAGGATAAGTTACTGCTTTCTTAAAAATAAAAAAAAAATCTGTGAATTTTCTCAGCA
CAATGAAGCCTTGTTATCTAATACCTCCATCTACCTCTAAAAGGGAAAATAAAACAAGAA
AATATATCATGAGACCACTACTAACAAGTTTTGTTGGAACATCCAAAATATGAGTATAAA
AATAATTTATACATCAACACAGTAATTGCTTTCTCAAGCCAACCTCCTAAAAGTTTCATG
TTTAGAAACTACATGATGAGTACTATTTAAATTGAATAAAATGTTGCTTTTCATTATGAA
CAATTTGAAAAAAACAACAGATGGATATTCCCTAGCCATGAGAGAAAGAACAGATATTTA
AATATGAATCATGCTTTATTTGCTATTCAATAGGCACTATTTACTGGAGATAGAGCCTAA
GTTACATTAATGTATATATAATAGATTCCCTTTCTGCCTTACAAATGATAAAATGTTTCT
ACATGCAAACCTATAAAAATGTGCAACACATACACACACAAATCTACCTGTCTTTATGAA
CTTAAGCTGTAATTATGACTTTATATTTTGTACTAACAACATCAATATGTGTATTTGGGT
GTGTAATATCTCATCTTACATTATAATTGGATATTAAGAAAACTACTTTCTTTAAATAGC
TATATATCATATTAATTGCATTTTTTTAAGTTACATCTGATTGGGCTAATAAATTTTAAT
CTTTAGGAGTCACACTAAAAAGTCATGAGATTAAGAATTTTAGGCCTGAGTGAGTTAATT
GGGGTTATCTGAGGCAGAGCTGATTATATTTCATAGTAAATTATAATGAGTCTGTCAATA
ATTTCATGTAGACAAATCCATTTTTTTTTAAAGAGGATCAAAGGAGAAGTGGCAAAGTAG
AGAGAAAAAATAAAGGGGGAGAAGAAAAATGTAAACACAACAAACAATCAAGGAGTGGTA
GCTTCTTGCCTGCATTCACTGCCCTTGATTCTCTGTTTCTAATTTTGTCCAAATATTTCT
TTAACCATCTTTATTCAGTTCAGTTCAGTTGCTCAGCTGTGTCCAACTCTTTGTGACCTC
ATGGACTGCAGCACGCCAGGCTTCCATGTCCATCACCAAATCCTAGAGTTTACTCAAACT
CATGTCCATCAAGTTGGTGATGCCATCCAACCACCTCATCCTCTGTCGTCCCCTTCTCCA
CCCACCTTCAATCTTTTCCAGCATTGGGGTCTTTTCAAATGAGTCAGTTCTTCGCATCAG
GTGGCCAAAGTATTAGTTTCAGCTTCAGCATAAGTCCTTGCAGTGATTATTCAGGACTGA
TTTCCCTTAGGATGGGCTGGTTGGAAATTCTGCTGTCCAAGGGATTCTCAAGAGTCTTCT
CCAACAGCACAGTTCAAAAGCATCAACTCTTCAGTGCTCAGCTTTCTTTATTGTCCAACT
CTCACATCCATACATGACTACTGGAAAAACCATAGCTTTGACTAGACGGACTCTTGTTGG
CAAAGTAATGTCTCTGCTTTTCAACATGCTGTCCAGGTCTATCATAGCTTTTCATGCAAG
GAGCAAGTGTCTTTTAATTTCATGGCTGCGGTCACCATCTGCAGTTATTTTGGAGCCCAA
GAAAATACAGTCTGTCACCGTTTCCATTGACTCTCCATCTATTAGTCATGAAGCAATGGG
ACCAGATGCCATGATCTTAGTTTTTTGAATGTTGAGTTTTAAGCCCGCTTTTTTCACTCT
TCTCTTTCACAATCCTCAAGAAGGCCTTTAGTTCCTCTTTGCTTTCTGCCATAAGAATTG
TATCATCTGCATTTCTGAGGTTATTGATATTTCTCCCAGCAGTCTTGATTCCAGCTTGTG
ATTCATCCAGCCTGGCCTTTCATATGATGTACACGGCATATAAGTTAAATAAGCAGGGTG
ACAATATACAGCCTTGATGTACTCCTTTCCCAATTTGGAACCAGTCTGTTCTTCCATGTT
CAGGTCTAACTCTTGCTTTTTGACCTGCATACAGATTTCTCAGGAGGCAGATAAGGTGGT
CTGGCATTCCTATCACTTTAAGAGGTTTCCATAGTTTGCTGTGATCCACAAAGTCAAAGG
CTTTGGTATAGTCAATAAAGCAGAAGTAGATGTTTTTTCTGGAACTCTCTTGCATTTTCT
ATGATCCAGTGGATGTTGGCAATTTGATCTCTGGTTCCTCTGCCTTTTCTAAATCCAGCT
TTAACATCTGGAAGTTCATGAGTCATGTACTGTTGACACCTGGCTTGAAGAATTTTGAGC
ATTACTAGCGTGTGAGAAGAGTGCAAGTGTACAGTAGGTTGAACATCCTTTGGTATTGCC
TTTCTTTGGGATTGGAATTAAAACTGACCTTTTCCAGTCCTGTGGCCACTGCCAAATTTT
CCAAATTTTCCAAATTTGCTGATGTATTGAGTGCAGCTTTTTAACAGCATCATCTTTTAG
GATTTGAAATAGCTTAACTGGAATTCCATCACCTCCACTAGCTTTGCTCTAGTGATGCTT
CCTAAGGCCCATTTGACTTCACATTCCAGAATGTCTGGCTCTTCGTGAGTGATGACACCA
TCATGGTTATCTGAGTCATGAAGATATTTTTGTATAATTCTTCTGTGTATTCTTGCCACC
TCTTCTTAATATATTCTGCTTCTGTTTGGTCGATACCATTTCTGTCCTTTACTGTGTCCA
TCTTTGCATGAAGTCTTCCCTTGGTAGCTCTAATTTCCTTGAAGAGATCTCTAGTCTTTC
CCATTCTATTGTTTTCCTCTATTTCTTTGCATTCATCACTGAGGAACACTTTTCTTATCT
CTCCTTGCTATTCTTTGGAATTCTGCAGTCAAATGGATATACATTCCTTTTCTTCTTTGC
CTTTAGCTTGTCTTCTTTTCTCAGCTATTTGTAAGGCCTCCTCAAACAACCATTTTGCCT
TTTTCCATTTCTTTTTCTTGGGGATGGTCTTAATCACTGCCTCCTGTACAAAGTCATGAA
CCTCCGTCCATAGTTCTTCAGGTACTATGTCTATCAGATCTAATCCCTTTAATCTACTGG
TCACTTCCACTGTATGATTATAAGGGATTTGATTTAGGTCTTCCTGAATGGTCTAGTAGT
GTTCCCTACTTTCTTCAGTTTAAGTCTAACTTTGGCAATAGGGAGTCCATGATCTGAGCC
ACAGTCAGCTCCCAGTCTTGTTTTTGCTGACTGTATAAAGATTCTCCATCTTCAGCTGCA
AAGTATATAATCAATCTGATTTTGGTTTGACCATCTGATGATGTCCATGTGTAGAGTCTT
CTCTTGTATTGTTGGAAGAGGGTATTTGCTATGACCAGTGCATTCTCTTGGCAAAACTCC
ATTAGCCTTTGACCTGCATCTATTTGTACACCAAAGCCAAATTTGCCTGTTACTCCAGGT
GTTTCTTTACTTCCTACTTTTGCATTCCAGTCCCCTAAAATGAAAAGGATATCTTTTTTG
GGTATTAGTTCCAAAAGGTCTTGTAGGTGTTCATATAACTGTTAAACTTCAGGTCCTTCA
GCATTACTGGTCAGGACATAAACTTGGATTACTGTGATATTGAATAGTGTTCCTTGGAAA
CTAACAGAGATCATTCTGTCATTTTTGAGACTGCATCCAAGTACTGCAACTCAGACTCTT
TTGTTGACTATGATGGTCACTCCTACTTCTAAGGGATTCTTGTCCACACTAGTAGATGTA
ATAGTCATCTGAGTTAAATTCACCCATTTCAGTCCATTTTAATTCACTGATTCCTAAAAT
ATCGATGTTTACTCTTGCCATCTCCGTTTGACCACTTCCCATTTGCCTTGGTTCATGGAC
CTAACATCCCAGGTTCCAATGTGATATTGTTCTTGACAGCATTGGACTTTACTTCCATTT
GCAGTCACACCCACAACTGGGTGTTGTTTTTGCTTTATCTTCATTTCTTCATTCCTTCTG
GAGTTATTTCTCCTCTGATCCCCAGTAGCATATTAGGCACCTACCAACCTGGGGAGTTCA
TCTTTCAGTGTCCTATCTTTTTGCCTTTTCATACTGTTCACGGGGCTCTCAAGGCAAGAA
TACTGAAGTGGCTTGCCAGTCCCTTCTCCAGTGGGCCATATTTTGTCAAAACTCCCTACC
ATGACCCATCCATCTTGGGTGACCCTATAGGGCATCACTCATAGTTTCACTGAGTTACAC
AAGTCTGTGTCCATGTGATTAGTTTGGTTAGTTTTCTGTGATCGTGGTTTTCATTCTGTC
TACCCTCTGATGGATACAGATAACAGGCTTATGGAAGATTCCTGAATAAAACTTACATCT
TTATTACTATCACCTATTTAATGCATGGTTATTTTTCTTTTTTCATTAAAGAGTTTCCCC
TCTTTCACAGTCTACACTTCAAGTTCTATAAATCTGTTAGGTAACTTTGACATGCAAGTG
GATACAACATTGCATAATAGCCTCATATCCTGCTTCTACAAATCTGGCAATTTTCACTGC
CCTCTTCCTTCAATTTCTTTGACAAAATAACCCTGGGGGTCTATTTTATAATTATTTACT
CTTACTGTTTAACTTGCTTTTCTGCATGCTGTTAAATGACATCCTACTGTGCTTATCTCT
TCACAGGTGGTTGGGATTTTGTTTTTGGATGCTCTAAACACAGGTACACCAACAGCTCTG
TTTCAGCTGAACTTTTAAAACATTAAAAAAAAAATTGTGAATCTTTAGAATAGCAACTTT
ATAACTACATTTCAATTATCTCTAATTGCTATGTCTGTATTTTCCTATGCCAGCATCACA
TTGTTATAATTATTGAGAAAAATAAATACTGTCCCTCGAATTTTAATTGTTTTTTAAATT
TTCTGGTTATTTTTATACATTTATTCATCCTGATTAGTTTTAGAAAGTTTTGGCATGTTG
CAACATTATCTTAAAGAAATTTCAAATGAAATTGCATTTTACCTATATATAGAAAATTTG
GAGTAAGTGACATCCCTTAGACAGTGATTCTTCCAATTTAATAATAATATGTTTTTCTAT
GTATTAAATACTTCATTTATGCTACGCATTTTATTACTTTTATATAGGTTTTGCACTTAT
TTTCTTAAACTAATTCCTAGACACATACTTGCTGTAGGAAATGTCATATGTTTCCATGTT
ATATTCTCAAAGGCCTAATTTTTCTTATAGGGTAGAAAAATATTTCTGTATATTTATTTC
TAACTACCTTACTAAATTTTCATAATACCTCTAGTAATAAAACATTAGCAATTGCAGCAT
CTGCAAGGAATACTGTTTTTCTCTTTCAGAAGTAATACCATAATATCTGTGTTTTGATTT
AATGTCATATTGATTAGAAATATCAAATAATGTCAATGTCAGCAATCATAATTGAAAATT
TATTTTGTTGCTGATAGTAACTGAAATATTTTCAGATATTTACTGTAAAGCAAATATACA
CTGATTTAATTTTATTCCTTTTATTTGGAATTATTAATGCTTATTTTATTGCTTTTGTTG
TTAGTCTTATAAGACAAGTAAATTTTATATTTCATTAAATACTTTTTCAGGAATTACTGA
GATGGTTCATTTTTTACTTTGATATCACTGGCTGTGAAATATATTTATAAATTTCCTAAA
ATTGAACAATCTTTGAATTTCTTAAATATATTTTATAACTTTTGAATATTTTTGTTAGTT
TTTATTTTCTAATGTATGTAATATTTCAGTTCAGTTCAGTTCAGTTGCTCAGTCATGCCC
GACTCTTTGCGACCCCATGAATTGCAGCATGCCAGGCCTCCCTGTCCATCACCAACTCCC
AGAGTTCACTCAGACTCACGTCCATCGAGTCAGTGATGCCATCCAGCCATCTCATCCTCT
GTCATCCCCTTCTCCTCCTGCCCCCAATCCCTCCTAGCATCAGAGTCTTTTTCAATGAAT
CAACTCTTTGCATGAGGTGGCCAAAGTACTGGAGTTTCAGCTTTAGCATCATTCCTTCCA
AAGAAATCCCAGGGCTGATCTCCTTCAGAATGGACTGGTTGGATCTCCTTGCAATCCAAG
GGACTCTCAAGAGTCTTCTCCAACACCAGAGTTCAAAAGCATCAATTCTTTGGCGCTCAG
CCTTCTTTACAGTCCAACTCTCACATCCATACATGACCACAGGAAAAGCTATAGCCTTGA
CTAGACGAACCGTTGTTGGCAAAGTAATGTCTCTGCTTTTGAATATGCTATCTAGGTTGG
TCATAACTTTCCTTCCAAGGAGTAAGCGTCTTTTAATTTCATGACTGTAGTTACCATCTG
CAGTGATTTTGGAGCCCCAAAAAATAAAGTCTGACACTGTTTCCACTGTTTCCCCATCTA
CTTCCCATGAAGTGATGGGACCGGATGCCATGATTTTTGTTTTCTGAATGTTGAGCTTTA
AGCCAACTTTTTCACTCTCCACTTTCACTTTCATCAAGAGGCTTTTTAGTTCCTCTTCAC
TTTCTGCCATAAGTGTGCGCCATTTGCAGCTGCCTGCCATTAGTGCGCTGGTCGCAGCCG
CCATGTAATATTTACATCAGTATTAATAAATCATATTTTCTGAGGTATATATTAATAAAT
CATATTTTCTGTGGTTTCTTTCATTCTATCTTAGAGTCTCAATTTTTTCTATAATCTGTA
AATGCATATATAACTTGAGAATTAGTCATTTTAAAAGATTAGTAACTGCATAGCCTAGAT
ATTTTTCTTGTAATAATTCTATAAGAATAATTGGTAAAAACAACTATTGGTATTACATTT
CAAGTCTATAATAACTCATACCTAGCCCTCTATCTTTTACTCACTCCAGTTATAATGGCC
TTCTTGTTATTTCTTAATATATAAGGTCACTCTATGTTATACTGTCTGCAATTGTGCTTA
CCTCTACAGGTAAATGTTATCTCTCCCTGTGTTAGAGTAGCTCACTTAACTCACCCTGTT
AGGGACCACTGTCTGAAGTCACCTGCCCTGGAGTGAAGTCCTCTCAAAACAGAAATTCTC
AATAAGGAACACAAGCTTTTTCCTGCTGTCAAAACAAACAGGAAGAATTTGGGAGGGGCC
AAAAAGAAGGATTCTCGGGTGGCACTAGAGGTAAAGAACCCACCTGCCAATGCAGGAGAG
GTATGAGATTCTGGTTCAATTCCTGGGTCAGAAATATCTCCTGGAGAAGGGCATGGCAAC
CCACTTCGGTTTTCATGCCCATGGACAGAGGAGCCTGGTAGGCTATGGTCCATAGGGTCG
CAAAGAGTCAGACACACCTGATGCAATTTAGCATGCACAAAAGGAGGAAGGAGAAGCCAA
TGGATAATACTTTCTGCCAACCTCCCAGAAACCCTTATGCTACAGTCCATGTTGACTGAA
AGACATGGGCACCACCAGGAAGGGCCCTGAGTATGACCAAATATGTGCATGAGTAAGACA
ACTGGCCAGAGACAACCCAGAAAGCTAACTTTACCACAATAAACCCTAAAACTGCAAGCT
ATGGGGCAAAGCAGTTGTCCTCGTTTCCCTTATTCTGCTGTTCTCTGCTCAAGCACCTCT
TTTCAATACATCCTTTTGCTTTGTCAGAACTGTGTCTGCTCTGATAGTGCAGTTATGAGT
GTTAGACAAGAGCTCACTCTCAGGACCTTGAAGGGGTCCCTAACCCCAGCAACAACTTCA
TTCAGAGATCTACTTTAATTTTATAATTTTAAAGGGGCCATTCTTAACCACTATCTAGAT
ATCCTGTCCTTTCTTTTCTTTCAAATCCCCTCATATTCCTTGCATATAGGGACTTTTCAT
CCATTATAAATCAGTTTAATAGTTTATATTTCTTTGAAAGTAATTCATGCTATTAATATT
TACATTTACTAACATTGTGAGTGATCTACAGTATTAAAAGTTTTATATTCTTTCTCAAAG
ATATATGTAATTGTTATAGCTTTTTTCTTACTACTAATTTAACATTTTATTTTTTAAAAT
TTTATAATTAAATGTCACATATTATTACTGTTTGTTTTCTATTTTCTTAGTCTTTTGAAT
TTCATAAATACTAAAATTTGCTATTTCTTTATCAATGTCTTCTTAATTATTTCTTTTTTC
CCCCCTGTTTATTTTGATGATTGTTTTTAAGGTATTCAAACTGACTTTTTGTTCCTGTAA
GTTGTTCTTTGTTTGAGTCTTTAACATGCAGTTTTCTGTAACAAATGCTTGCATTAGATT
ATTTGTGATATATAATAATTCTATATGATTACCATTTTCTTTTCAGAATAGTCTATAACA
TGCCACCGAATCTCCTATTTAACAGAAGATATTTAGAGAGGGTTTTATTTTTAAATTTCC
TTGTAGGTTTTATTTTACGTTTATGTTTGAGAATATGGTTGATACTACATCTATATTTTA
TGGTCTTTCTTAAAGTTTTCTTGAAGTTTATAGAGTATAATTTTCAAAGAAGATAAAAAG
CAAATATAAATAAACACTTTTCAGAAATTTTAATGAACATTCATTAGTAAGAGACCCAGG
AACATGATAAGATGATTTAAAGCATATTTTTAAAGCTAGGTATATATAGGCAATTTAATA
AAGTCATGTTCAGAAAAACATCCTGGCTTAGATATTAAACTTGTTGTTGACTAATGGACC
CAAAACCTACAATTACTGTGGTTATTTGCATCTCAACCGTACAAAGTCTACAATTTAAAC
TGTTCTTGCACATACGCATATTCACCAGGAAAAAAAAAAAAACGTCATGATGGTATCAGT
AATTTCTTTTACTTGAGTTTTGCATAATTAACATTCTTGTATGGGGAAATAGCCCCAGCC
CAGTAAAAGATTAAGATTTGATCAGATTAGAGAGTGACTATCTTCATGCACACTTTATCA
CCATGACAAAAACTCTCCCATATGACAGTGAATTACAGCTAAAAATACTGCACAACACAG
ACCCTAAAGAGGTATTCTTAGAGTAGCTCAAAGGTAGCAGGGGACACAAGAAAAAGGATA
CACCAAAATTTCTAGTCTCTGGTACCTACAGCTACATAAAATATTTAACATTGTTCAACT
CCTAGCCAGATTGGCAAGTTACCTCATATTAAGTGGATATTTATTTGGCATTCCTGATAG
CTCAGTTAATAAAGAATCTGCCTGCAATTCAGGAGACCCCAGTTTGATTCCTGGGTCAGG
AAGATCTGCTGGAGAAGAGATAGGCTACCCACTCCAGTATTCTTGGGCTCCCCTTGTGGC
TCAGCTGGTAAAGAATATTCCCACAATGCGGGAGACCTGGGTTCAATCCCTGGGTTGGGA
AGATCCCCTGGAGAAGGGAAAGGCTACCCACTCCAGTATTCTGGCCTGGAGAATTCCATA
TAGTCCATGGGGTCACAAAGAGTCAGACACGACTGAGTGACTTTCACTTACTTGTCTTCC
TATACCAAATAAATGATACATACTTTAAACAAAAAGTACAAAGCTTGCTGACAAGTAAGA
AAAATGCAGTCTATAAAGACAAAGTAAGCATCAGCATAAGGCTCAGCTATGCTACAGATG
TTGGAATTATCAGACAATGAATTTAAAATAACTTTGATATGTTAATGACTATAATAGTAG
ACAGCATGCAAGCACAAATGAACAATGAAATTAGAAATATGGAGACTCTAATAAGGATTC
AAGAGGAAACACTAGAAATCAAAACACTGTAACAGAAACTTAGACTGCCTTTGATGGGCA
CAGCTTTATACTGGACACATCAAAGAAAGAATCAGTGAGTCTGAAGATAGACAAATAGTC
ACTTTCAAACTGAAATACTAAGTGAAAACCGAATGAAAAAAGATAGCAGAGCATCAAAGA
ACTCTGGTACAATTTCAAATAATGTAACATGTACATAATCTGAATAACTGAAGGAGAAAA
TATAAAGGGCTAGAGGGAGTATTCACTTTTCACTTTCATGCATTGGAGAAGGAAATGGCA
ACCCACTCCAGTGTTCTTGCCTGGAGAATCCCAGGGACAGGAAGCCTGGTTGGCTGCCGT
CTATGGGGTCACACAGAGTTGGACACGACTGAAGCAACGCAGCAGCAGAGGGAGTATTAG
AAGCAATAATGAAAGATAACATTAAAAAATCAATGAAAGGCATGAAAACATAGGTCCAGG
AATCTCAGAGAACACCAAGTAGGATGAATGAAAAAGCGCAACTAGTCTTACCAAAGTCAA
GCTGTAGTCAAACCAAAGATGATGACAAATCTTGAAAAAAAAAATGCAGAAATAAAACCA
ATTTACTTATGGAAGAATAATGATAAAAATTACAGTGGCCATCTCAGAAAGAATGTATTA
AGAGAAAGGAGTGAACTATTTAAAGTTTTGAAAGAGAAACCCCGCCAATTTATATTCTGC
CATATGTATGTGTGTGTGTATATATATATATATATATATATAAGAAATTTGGATATACAT
AAAGAATAGAATAGTAATAAAGAAGGAATAAATATAAATTATTATACAGGTTTTTTAAAT
AATCTCTTAATAATTCCAACAGTTTTATGCTTAAATAATAGCAAAGTATTTGATGATTAT
AGTATATGGATAGTTGAAATAAATAATAATATCACAAGGGATGAGAGTGAGGAATTGGGA
GTACTCAATTATAAGGTACCTGTGGTACATATAAGTAATATAGTATTCCTTGGAAGTGGA
CTTAAATTTTTTAAAAAACACATATTGTAAAATGAAACTATGTATGTCTTAGAATTGCTT
AGATTAAAAACAAAACAAAACTGTCAGTCCAGTGTTTGGCAATGATGTGGAAAAACTGAG
TCACAGAATCATTGCTGGTGAGGATGTAAAATGATACAGACACTTTGAGAAACATTTTGG
TGGTGTCTTAGAAAGCTAAAATTTGTCTTATCCAATTATCCATTAATTGTGCTTCTAGGT
TTTACCAAAATACTTGAAACTGTATGTCTACCCCAAAACCTACACATGGATGTTTATAGC
AATTTTATTCATAACACCCTCCCCCCAAACGGGGAATACCTAAGCTGTCCTTCAATAGGC
AAGTGGATAAACTTGGTATCAAGTTTATCAATGATTTTGCTATGGTTGTTCAGTCGGTAA`

export class Prediction extends Component {

  constructor(props) {
    super(props);
    this.state = {
      filename:'',
      genome: '',
      ssrResult: '',
      isOpen: false,
      showdata: false,
      minRepeat:1,
      maxRepeat:6,
      mono:10,
      all:5


    };
    this.handleGeneChange = this
      .handleGeneChange
      .bind(this);
    this.fileSelected = this
      .fileSelected
      .bind(this);
    this.getMotif = this
      .getMotif
      .bind(this)
    this.getMono = this
      .getMono
      .bind(this)
    this.getAll = this
      .getAll
      .bind(this)
    this.runPrediction = this
      .runPrediction
      .bind(this)


  }
  openModel = () => this.setState({ isOpen: true });
  closeModel = () => this.setState({ isOpen: false });

  handleGeneChange(e) {

    this.setState({ genome: e.target.value });
  }

  fileSelected(event) {

    this.setState({filename: event.target.files[0]})
    
  }

  getMotif = (value) => {

    this.setState({ minRepeat: parseInt(value[0]), maxRepeat: parseInt(value[1]) }, () => {
        
    });
}

getMono = (value) => {

  this.setState({ mono: parseInt(value) }, () => {
      
  });
}
getAll = (value) => {

  this.setState({ all: parseInt(value) }, () => {
      
  });
}

runPrediction () {
  
  this.openModel();

 console.log(this.state.filename)
  const fdata = new FormData() 
  fdata.append('file', this.state.filename)
  fdata.append('genome', this.state.genome)
  fdata.append('minRepeat', this.state.minRepeat)
  fdata.append('maxRepeat', this.state.maxRepeat)
  fdata.append('mono', this.state.mono)
  fdata.append('all', this.state.all)
  console.log(fdata)
  fetchPrediction(fdata)
  .then(res => { // then print response status
    console.log(res)
    this.closeModel();
    window.open("/ranchsatdb/predresults", "_blank");
        localStorage.setItem('resultsp', res)
 })
   
   

  
}

  render() {

    return (
      <div>

        <Container >
          <Row className="mb-2">
            <h4>SSR Prediction</h4>
            <Divider />
          </Row>
          <div className="row">
            <div className="col-md-7">
              <div className="row justify-content-center">
                <h5>Enter or paste FASTA sequence</h5>
                <Form.Control className="kbl-form mb-4" as="textarea" rows={6} placeholder={'Paste FASTA sequence'} onChange={this.handleGeneChange}
                  value={this.state.genome} spellCheck={false} />
                <Button className="kbl-btn-1 mx-3 col-md-3" onClick={e => {
                  this.setState({ genome: seq });
                }}>Sample Data</Button>
                <Button className="kbl-btn-2 col-md-3" onClick={e => {
                  this.setState({ genome: "" })
                }}>Clear Data</Button>
              </div>
              <h5 className="mt-3">OR</h5>
              <div className="row my-3">
              <h5 > Upload FASTA file</h5>
                <div className="col-md-12">
                {/* <label for="formFile" class="form-label">Default file input example</label> */}
                <input className="form-control" type="file" name='file' onChange={this.fileSelected}/>

                  
                </div>
              </div>
            </div>

            <div className="col-md-4 mx-5 jusitfy-content-center">
              <h5>Select Options</h5>

              <label className='h6'>Min and Max length of repeat motif</label>
              <Slider range defaultValue={[1, 6]} marks={{ 1: '1', 10: '10' }} disabled={false} min={1} max={10} onChange={this.getMotif} />
              <label className='h6'>Mono repeat motif length</label>
              <Slider defaultValue={10} marks={{ 0: '0', 20: '20' }} disabled={false} min={0} max={20} onChange={this.getMono} />
              <label className='h6'>Motif repeat length</label>
              <Slider defaultValue={5} marks={{ 0: '0', 20: '20' }} disabled={false} min={0} max={20} onChange={this.getAll} />

            </div>
          </div>
          <div className="row justify-content-center">
          <div className="row flex-lg-row justify-content-center g-2 my-3">
          {this.state.isOpen && (
            <div className="col-md-8">
              <img
                src="./images/test.gif"
                className="loading"
                height="50px"
                alt=""
              ></img>
            </div>
          )}
          {this.state.isOpen === false && (
            <div className="col-md-3">
              <Button
                type="success"
                shape="round"
                size="large"
                onClick={this.runPrediction}
              >
                Run Prediction{" "}
              </Button>
            </div>
          )}
          </div>
          </div>
        </Container>

      </div>
    )
  }
}